// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseURL: 'http://localhost/' | (string & {});
};

export type AcceptRequestResponse = {
    friendClientId: string;
};

export type AcceptedClubDocument = {
    kind: ConsentType;
    version: string;
};

export type AccessControlStatusDto = {
    active: boolean;
};

export enum AccessDecisionType {
    GRANTED = 'granted',
    DENIED = 'denied'
}

export type AccessDeviceDto = {
    id: string;
    name: string;
    deviceType: DeviceType;
    zoneId: string;
    status: DeviceStatus;
    vendor: string;
    lastSeenAt?: null | string;
    externalAccessPointId?: null | number;
};

export enum AccessDirection {
    IN = 'in',
    OUT = 'out'
}

export type AccessEventDto = {
    id: string;
    clientId: string;
    clientName?: null | string;
    zoneId: string;
    zoneName?: null | string;
    deviceId?: null | string;
    decision: AccessDecisionType;
    denialReason?: null | string;
    method: AccessMethod;
    bookingId?: null | string;
    direction?: null | AccessDirection;
    occurredAt: string;
    shadowDecision?: null | AccessDecisionType;
    shadowDenialReason?: null | string;
    grantBasis?: null | AccessGrantBasis;
};

export enum AccessGrantBasis {
    SUBSCRIPTION = 'subscription',
    BOOKING = 'booking',
    OPEN_ZONE = 'openZone',
    MANUAL = 'manual'
}

export enum AccessMethod {
    QR = 'qr',
    CARD = 'card',
    MANUAL = 'manual',
    CONTROLLER = 'controller'
}

export type AccessZoneDto = {
    id: string;
    name: string;
    zoneType: string;
    requiresBooking: boolean;
    requiresMembership: boolean;
    requiresSubscription: boolean;
    maxCapacity?: null | number;
    accessWindowBeforeMinutes: number;
    accessWindowAfterMinutes: number;
    isActive: boolean;
    externalZoneId?: null | number;
};

export type AccrualOverrideDto = {
    targetKind: AccrualTargetKind;
    targetCategory?: null | BonusSpendCategory;
    targetId?: null | string;
    rateBasisPoints?: null | number;
};

export enum AccrualScope {
    ALL = 'all',
    SELECTED = 'selected'
}

export enum AccrualTargetKind {
    CATEGORY = 'category',
    COURT = 'court',
    TRAINER = 'trainer',
    PRODUCT = 'product',
    SUBSCRIPTION_TEMPLATE = 'subscriptionTemplate',
    FITNESS_CLASS = 'fitnessClass',
    SPORT = 'sport'
}

export type AchievementDto = {
    code: string;
    label: string;
    subtitle: string;
    icon: string;
    rarity: string;
};

export type AcquisitionPoint = {
    month: string;
    newClients: number;
};

export type ActivityBucket = {
    bucket: string;
    count: number;
};

export enum ActivityCategory {
    SALE = 'sale',
    SHIFT = 'shift',
    EXPENSE = 'expense',
    GROUP_SESSION = 'groupSession',
    PAYMENT = 'payment',
    REFUND = 'refund',
    ORGANIZATION = 'organization',
    SPLIT = 'split',
    MATCH = 'match',
    SUBSCRIPTION = 'subscription',
    BONUS = 'bonus',
    CLIENT = 'client',
    BOOKING = 'booking',
    TRAINER = 'trainer',
    TOURNAMENT = 'tournament'
}

export enum ActivityDirection {
    SPORT = 'sport',
    FITNESS = 'fitness'
}

export type ActivityDto = {
    at: string;
    kind: ActivityKind;
    text: string;
    amountKopecks?: null | number;
};

export type ActivityEntryDto = {
    id: string;
    occurredAt: string;
    category: ActivityCategory;
    eventType: string;
    summary: string;
    actorUserId?: null | string;
    entityId?: null | string;
    amountKopecks?: null | number;
};

export type ActivityItemDto = {
    id: string;
    kind: string;
    direction: ActivityDirection;
    sport: string;
    title: string;
    subtitle: string;
    at: string;
    placement?: null | number;
    durationMin?: null | number;
};

export enum ActivityKind {
    BOOKING_CREATED = 'bookingCreated',
    SALE_CONFIRMED = 'saleConfirmed',
    CLIENT_REGISTERED = 'clientRegistered'
}

export type ActivityLeaderboardEntryDto = {
    rank: number;
    clientId: string;
    name: string;
    avatarUrl: string;
    points: number;
    matchesCounted: number;
    isMe: boolean;
};

export type AddChildRequest = {
    firstName: string;
    lastName: string;
    birthDate?: null | string;
    phone?: null | string;
    allowedCategories?: null | ChildCategoriesDto;
};

export type AddEmployeeBody = {
    phone: string;
    monthlyLimitKopecks: number;
};

export type AddEmployeeResponse = {
    memberId: string;
    clientId: string;
    firstName: string;
    lastName: string;
};

export type AddRoundResponse = {
    roundId: string;
    roundNumber: number;
    matchCount: number;
};

export type AddTenantMemberRequest = {
    email: string;
    role: string;
};

export type AdminCorrectFioPayload = {
    firstName?: null | string;
    lastName?: null | string;
    patronymic?: null | string;
    gender?: null | ClientGender;
    phone?: null | string;
    reason?: null | string;
};

export type AdminOpenMatchSummaryDto = {
    id: string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sport: string;
    courtId: string;
    courtName: string;
    scheduledAt: string;
    durationMinutes: number;
    totalSpots: number;
    joinedCount: number;
    spotsLeft: number;
    minLevel?: null | number;
    maxLevel?: null | number;
    comment?: null | string;
    status: OpenMatchStatus;
    organizerId: string;
    organizerName: string;
    organizerRating: number;
    organizerReliabilityPct: number;
    organizerIsUnreliable: boolean;
    cancelledAt?: null | string;
};

export type AdvanceCorrectionPayload = {
    amountKopecks?: null | number;
    reason?: null | string;
    idempotencyKey: string;
};

export type AdvanceCorrectionResult = {
    newBalanceKopecks: number;
    at: string;
};

export type AlertDto = {
    kind: AttentionKind;
    count: number;
    title: string;
    subtitle?: null | string;
};

export type AnalyticsAttendanceResponse = {
    byDirection: Array<AttendanceDirectionRow>;
    byClass: Array<AttendanceClassRow>;
};

export type AnalyticsClientsResponse = {
    totalClients: number;
    activeLast30: number;
    activeLast90: number;
    newLast30: number;
    churnedLast30: number;
    avgLtvKopecks: number;
    acquisition: Array<AcquisitionPoint>;
    byCategory: Array<CategoryBucket>;
    byActivity: Array<ActivityBucket>;
    ltvDistribution: Array<LtvBucket>;
    topSpenders: Array<TopSpenderDto>;
};

export type AnalyticsRevenueResponse = {
    totalKopecks: number;
    refundedKopecks: number;
    saleCount: number;
    refundCount: number;
    avgCheckKopecks: number;
    series: Array<RevenueSeriesPoint>;
    byPaymentMethod: Array<RevenueByMethod>;
    byProductKind: Array<RevenueByKind>;
    byDirection: Array<RevenueByDirection>;
};

export type AnalyticsTrainersResponse = {
    activeTrainersCount: number;
    totalSessionsCount: number;
    totalHours: number;
    averageRating: number;
    leaderboard: Array<TrainerRow>;
};

export type ApproveChildChargeResponse = {
    paymentId: string;
    status: string;
};

export type ApproveRefundResponse = {
    refundId: string;
    status: RefundStatus;
};

export type AssignClientCategoryPayload = {
    category?: null | string;
    pinned: boolean;
    reason?: null | string;
};

export type AssignClubJoinCodeRequest = {
    code: string;
};

export type AssignTournamentCoachBody = {
    trainerId?: null | string;
};

export type AssignableClubRoleDto = {
    code: string;
    label?: null | string;
    baseRole: string;
};

export type AssignedCourtDto = {
    id: string;
    name?: null | string;
    sport?: null | string;
    type?: null | string;
};

export type AssignedTrainerDto = {
    id: string;
    name: string;
};

export type AssistanceListResponse = {
    items: Array<AssistanceRequestDto>;
};

export type AssistanceRequestDto = {
    id: string;
    clientId: string;
    courtId?: null | string;
    courtName?: null | string;
    note?: null | string;
    status: string;
    createdAt: string;
    acknowledgedBy?: null | string;
    acknowledgedByName?: null | string;
    isEscalated: boolean;
};

export type AttendanceClassRow = {
    direction: string;
    sport?: null | string;
    sessions: number;
    attended: number;
    noShow: number;
    cancelled: number;
    awaiting: number;
};

export type AttendanceDirectionRow = {
    direction: string;
    sessions: number;
    attended: number;
    noShow: number;
    cancelled: number;
    awaiting: number;
};

export type AttentionClubDto = {
    id: string;
    name: string;
    slug: string;
    reason: string;
    since: string;
};

export enum AttentionKind {
    UNPAID_BOOKINGS = 'unpaidBookings',
    PENDING_REFUNDS = 'pendingRefunds',
    EXPIRING_SUBSCRIPTIONS = 'expiringSubscriptions',
    CLIENT_HOLDS_EXPIRED = 'clientHoldsExpired'
}

export enum AudienceActivity {
    NEWCOMER = 'newcomer',
    REGULAR = 'regular',
    SLEEPING = 'sleeping',
    CHURNED = 'churned'
}

export enum AudienceGender {
    MALE = 'male',
    FEMALE = 'female'
}

export type AudiencePreviewResponse = {
    recipients: number;
    sample: Array<string>;
    missingData: number;
    noRecipient: number;
    optedOut: number;
    overDailyLimit: number;
    audience?: null | AudienceSpec;
    draftTitle?: null | string;
    draftBody?: null | string;
};

export enum AudiencePurpose {
    MARKETING = 'marketing',
    SERVICE = 'service'
}

export type AudienceRatingCondition = {
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sport: string;
    levelFrom?: null | number;
    levelTo?: null | number;
};

export type AudienceReason = {
    kind: AudienceReasonKind;
    id?: null | string;
    ids?: null | Array<string>;
};

export enum AudienceReasonKind {
    CUSTOM = 'custom',
    GROUP_SESSION = 'groupSession',
    FITNESS_SESSION = 'fitnessSession',
    TOURNAMENT = 'tournament',
    OPEN_MATCH = 'openMatch',
    BOOKING = 'booking'
}

export type AudienceSendResponse = {
    recipients: number;
    missingData: number;
    noRecipient: number;
    optedOut: number;
    overDailyLimit: number;
    repeated: boolean;
};

export type AudienceSpec = {
    gender?: null | AudienceGender;
    ageFrom?: null | number;
    ageTo?: null | number;
    childrenOnly?: boolean;
    activities?: null | Array<AudienceActivity>;
    categories?: null | Array<string>;
    rating?: null | AudienceRatingCondition;
    reliabilityFrom?: null | number;
    reliabilityTo?: null | number;
    subscriptionTemplateIds?: null | Array<string>;
    clientIds?: null | Array<string>;
    trainerClients?: null | string;
};

export type AuditEntityTypeDto = {
    type: string;
    label: string;
};

export type AuditEventDto = {
    id: string;
    occurredAt: string;
    actorId?: null | string;
    actorName: string;
    action: string;
    actionLabel: string;
    entityType: string;
    entityLabel: string;
    entityId: string;
    before?: null | string;
    after?: null | string;
};

export type AuthResponse = {
    accessToken: string;
    refreshToken: string;
    expiresAt: string;
    user: UserDto;
    isNewUser: boolean;
};

export type AutoPickCourtsPayload = {
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sport: string;
    startAt: string;
    endAt: string;
    count: number;
};

export type AutoPickCourtsResponse = {
    courtIds: Array<string>;
    rejected: Array<AutoPickRejection>;
};

export type AutoPickRejection = {
    courtId: string;
    reason: string;
};

export type AvailabilityAlternative = {
    courtId: string;
    courtName: string;
    score: number;
    sameType: boolean;
    adjacent: boolean;
};

export type AvailabilityItem = {
    bookingId: string;
    alternatives: Array<AvailabilityAlternative>;
};

export type AvailabilityResponse = {
    date: string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sportType: string;
    durationMinutes: number;
    slots: Array<AvailableSlot>;
    heldTimes: Array<HeldTime>;
    clientRestriction?: null | ClientRestriction;
};

export type AvailableSlot = {
    resourceId: string;
    resourceName: string;
    startTime: string;
    endTime: string;
    priceKopecks: number;
    isOptimal: boolean;
    wasteScore: number;
    isIndoor: boolean;
    onlyAtTheDesk: boolean;
};

export type AvailableSlotDto = {
    startTime: string;
    endTime: string;
    resourceIds: Array<string>;
};

export type AvailableTrainerDto = {
    id: string;
    firstName: string;
    lastName: string;
    ratingAvg: number;
    yearsExperience: number;
    individualRateKopecks: number;
    avatarUrl?: null | string;
    assignedPlaceIds: Array<string>;
    sports: Array<string>;
    busy: boolean;
    offSchedule?: null | AvailableTrainerOffScheduleDto;
};

export type AvailableTrainerOffScheduleDto = {
    reason: TrainerOffScheduleReason;
    dayIntervals: Array<ScheduleInterval>;
    worksPartOfTheWindow: boolean;
};

export type AvailableTrainersResponse = {
    items: Array<AvailableTrainerDto>;
};

export type AwaitingOrderDto = {
    orderId: string;
    totalKopecks: number;
    bonusDebitKopecks: number;
    advanceDebitKopecks: number;
    payableKopecks: number;
    payBy: string;
    paymentStarted: boolean;
    lines: Array<AwaitingOrderLineDto>;
};

export type AwaitingOrderLineDto = {
    bookingId: string;
    courtName: string;
    startsAt: string;
    endsAt: string;
    priceKopecks: number;
    sport: string;
    courtPassable: boolean;
};

export type AwaitingTransferInvoiceDto = {
    id: string;
    tenantId: string;
    documentNumber: string;
    documentDate: string;
    payBy?: null | string;
    amountKopecks: number;
    payerLegalName?: null | string;
    payerInn?: null | string;
    planName: string;
    numberAnnulled: boolean;
    status: string;
};

export type AwaitingTransferInvoicesDto = {
    items: Array<AwaitingTransferInvoiceDto>;
};

export type BlacklistImportPreview = {
    toAdd: number;
    alreadyListed: number;
    notAPhone: number;
    repeated: number;
    toAddPhones: Array<string>;
    alreadyListedPhones: Array<string>;
    notAPhoneEntries: Array<string>;
};

export type BlacklistImportResult = {
    added: number;
    alreadyListed: number;
    notAPhone: number;
    repeated: number;
};

export enum BlacklistSource {
    MANUAL = 'manual',
    LIST = 'list',
    CSV = 'csv',
    CLIENT_CARD = 'clientCard'
}

export type BlacklistedPhoneDto = {
    id: string;
    phone: string;
    reason: string;
    source: BlacklistSource;
    addedAt: string;
    addedByUserId?: null | string;
    addedByName?: null | string;
    clientId?: null | string;
    clientName?: null | string;
    clientCard?: null | string;
};

export type BlacklistedPhonesPage = {
    items: Array<BlacklistedPhoneDto>;
    totalCount: number;
    page: number;
    pageSize: number;
};

export type BlockBody = {
    clientId: string;
};

export type BlockSlotsPayload = {
    resourceId: string;
    date: string;
    startTime: string;
    endTime: string;
    blockType: BlockType;
    reason?: null | string;
    force?: null | boolean;
    dateTo?: null | string;
};

export type BlockSlotsResponse = {
    id: string;
    conflictingBookingIds: Array<string>;
    blockIds: Array<string>;
};

export enum BlockType {
    MAINTENANCE = 'maintenance',
    TOURNAMENT = 'tournament',
    GROUP_SESSION = 'groupSession',
    PRIVATE_EVENT = 'privateEvent',
    OTHER = 'other'
}

export type BlockedClientDto = {
    clientId: string;
    displayName: string;
    avatarUrl: string;
    blockedAt: string;
};

export type BlocksResponse = {
    blocks: Array<BlockedClientDto>;
};

export enum BonusAccrualPolicy {
    NO_RESTRICTION = 'noRestriction',
    REAL_MONEY_ONLY = 'realMoneyOnly',
    NONE_IF_BONUS_USED = 'noneIfBonusUsed'
}

export enum BonusActivityCounts {
    VISITS_AND_PURCHASES = 'visitsAndPurchases',
    VISITS_ONLY = 'visitsOnly',
    PURCHASES_ONLY = 'purchasesOnly'
}

export type BonusAdjustPayload = {
    amountKopecks?: null | number;
    reason?: null | string;
};

export type BonusAvailabilityListResponse = {
    items: Array<ClientBonusAvailabilityDto>;
};

export type BonusCreditPayload = {
    amountKopecks?: null | number;
    reason?: null | string;
    expiresOn?: null | string;
    clientMessage?: null | string;
};

export type BonusExpiryDto = {
    expiresAt: string;
    amountKopecks: number;
};

export type BonusPaymentPolicyDto = {
    maxPaymentPct: number;
};

export type BonusProgramDto = {
    enabled: boolean;
    registrationBonusKopecks: number;
    validityDays?: null | number;
    expiryWarningDays: number;
    inactivityBurnDays?: null | number;
    inactivityCounts: BonusActivityCounts;
};

export enum BonusRuleAmountMode {
    PERCENT = 'percent',
    FIXED = 'fixed'
}

export type BonusRuleDto = {
    id: string;
    kind: BonusRuleKind;
    label: string;
    amount: number;
    amountMode: BonusRuleAmountMode;
    triggerVisits?: null | number;
    minOrderAmount?: null | number;
    expiresAfterDays?: null | number;
    description: string;
    enabled: boolean;
    sortOrder: number;
};

export enum BonusRuleKind {
    CASHBACK = 'cashback',
    WELCOME = 'welcome',
    BIRTHDAY = 'birthday',
    REFERRAL = 'referral',
    VISIT_MILESTONE = 'visitMilestone',
    MANUAL = 'manual'
}

export type BonusRuleListResponse = {
    items: Array<BonusRuleDto>;
};

export enum BonusSpendCategory {
    COURT_HOUR = 'courtHour',
    TRAINER_HOUR = 'trainerHour',
    SUBSCRIPTION = 'subscription',
    INVENTORY = 'inventory',
    SERVICE = 'service',
    TOURNAMENT_ENTRY = 'tournamentEntry',
    GROUP_SESSION_SEAT = 'groupSessionSeat'
}

export type BonusTransactionDto = {
    id: string;
    clientId: string;
    amountKopecks: number;
    kind: BonusTransactionKind;
    reason: string;
    actorId: string;
    bookingId?: null | string;
    expiresAt?: null | string;
    createdAt: string;
    replayed: boolean;
    clientMessage?: null | string;
};

export enum BonusTransactionKind {
    CASHBACK = 'cashback',
    MANUAL_CREDIT = 'manualCredit',
    MANUAL_DEBIT = 'manualDebit',
    REDEEMED_AT_PAYMENT = 'redeemedAtPayment',
    EXPIRED = 'expired',
    CASHBACK_ADJUSTMENT = 'cashbackAdjustment',
    SPENT_BONUS_REFUND = 'spentBonusRefund',
    DEBT_SETTLEMENT = 'debtSettlement',
    VISIT_MILESTONE = 'visitMilestone',
    REFERRAL = 'referral',
    TRANSFER_FROM_ADVANCE = 'transferFromAdvance',
    TOURNAMENT_PRIZE = 'tournamentPrize',
    REFUND_TO_BONUSES = 'refundToBonuses',
    CASHBACK_REVERSAL = 'cashbackReversal',
    CREDIT_REVERSAL = 'creditReversal',
    REGISTRATION_GIFT = 'registrationGift'
}

export type BonusTransactionListItemDto = {
    id: string;
    clientId: string;
    clientFirstName: string;
    clientLastName: string;
    clientMemberPrefix: string;
    clientMemberNumber: string;
    amountKopecks: number;
    kind: BonusTransactionKind;
    reason: string;
    actorId: string;
    bookingId?: null | string;
    expiresAt?: null | string;
    createdAt: string;
    actorName?: null | string;
};

export type BonusTransactionListResponse = {
    items: Array<BonusTransactionListItemDto>;
    cursor?: null | string;
    hasMore: boolean;
    creditedKopecks: number;
    debitedKopecks: number;
};

export type BookPersonalTrainingBody = {
    trainerId: string;
    placeId: string;
    date: string;
    startTime: string;
    durationMinutes: number;
    useSubscriptionId?: null | string;
    clientId?: null | string;
    clientWish?: null | string;
};

export type BookableTrainerDto = {
    id: string;
    firstName: string;
    lastName: string;
    sports: Array<string>;
    ratingAvg: number;
    ratingCount: number;
    individualRateKopecks: number;
    avatarUrl?: null | string;
    groupRates: Array<BookableTrainerGroupRateDto>;
};

export type BookableTrainerGroupRateDto = {
    people: number;
    perPersonRateKopecks: number;
};

export type BookableTrainersResponse = {
    items: Array<BookableTrainerDto>;
};

export type BookingActivityItemDto = {
    id: string;
    occurredAt: string;
    kind: string;
    userId?: null | string;
    userName: string;
    description: string;
};

export type BookingClientPart = {
    id: string;
    firstName: string;
    lastName: string;
    category?: null | string;
    comment?: null | string;
    clientWish?: null | string;
};

export type BookingContactPart = {
    phone: string;
    memberPrefix: string;
    memberNumber: string;
};

export type BookingContextBonusPolicy = {
    accrualPolicy: BonusAccrualPolicy;
    maxPaymentPct: number;
    spendCategories: Array<string>;
    requiresActiveCard: boolean;
};

export type BookingContextClub = {
    name: string;
    accentColor: string;
    currency: string;
    locale: string;
    timezone: string;
    memberPrefix: string;
    logoUrl?: null | string;
    contactPhone: string;
    websiteUrl: string;
    kind: ClubKind;
};

export type BookingContextCourt = {
    id: string;
    name: string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sport: string;
    type: CourtType;
    basePricePerHourKopecks: number;
    optionIds: Array<string>;
};

export type BookingContextCourtOption = {
    id: string;
    code: string;
    label: string;
    category: CourtOptionCategory;
    icon: string;
    color: string;
    priceDelta: number;
    priceMode: CourtOptionPriceMode;
};

export type BookingContextFeatures = {
    friendsEnabled: boolean;
    courtsEnabled: boolean;
    fitnessEnabled: boolean;
    fitnessGymEnabled: boolean;
    fitnessGroupClassesEnabled: boolean;
    fitnessPersonalTrainingEnabled: boolean;
    fitnessPoolEnabled: boolean;
    fitnessSaunaEnabled: boolean;
    fitnessShowOccupancy: boolean;
    splitPayEnabled: boolean;
};

export type BookingContextGrid = {
    slotStepMin: number;
    dayStartHour: number;
    dayEndHour: number;
};

export type BookingContextResponse = {
    club: BookingContextClub;
    schedule: BookingContextSchedule;
    rules: BookingContextRules;
    courts: Array<BookingContextCourt>;
    courtOptions: Array<BookingContextCourtOption>;
    gridUi: BookingContextGrid;
    sports: Array<BookingContextSport>;
    bonusPolicy: BookingContextBonusPolicy;
    features: BookingContextFeatures;
};

export type BookingContextRules = {
    bookingHorizonDays: number;
    slotDurationMin: number;
    minLeadMin: number;
    holdWindowSec: number;
    cancellationDeadlineMin: number;
    noShowRefundTiers: Array<RefundTier>;
    groupSessionRefundTiers: Array<GroupSessionRefundTier>;
    noShowResalePartial: boolean;
    noShowResalePartialPct: number;
    waitlistMode: WaitlistMode;
    splitPayDefaultPolicy: SplitPayDefaultPolicy;
    splitPayDeadlineBufferHours: number;
    splitMaxSeats: number;
};

export type BookingContextSchedule = {
    weeklyHours: Array<DayHoursDto>;
    closedDates: Array<ClosedDateDto>;
};

export type BookingContextSport = {
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    code: string;
    label: string;
    icon?: null | string;
    color?: null | string;
    sortOrder: number;
};

export type BookingDetailDto = {
    id: string;
    courtId: string;
    trainerId?: null | string;
    startAt: string;
    endAt: string;
    status: BookingScheduleStatus;
    isTraining: boolean;
    recurrenceId?: null | string;
    pendingEndAt?: null | string;
    courtName: string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    courtSport: string;
    trainerName?: null | string;
    tenantId: string;
    createdAt: string;
    court: CourtSnippet;
    trainer?: null | TrainerSnippet;
    client?: null | BookingClientPart;
    contact?: null | BookingContactPart;
    money?: null | BookingMoneyPart;
    outsideTrainerHours?: null | TrainerOffScheduleReason;
    split?: null | BookingSplitSummary;
    training?: null | BookingTrainingPart;
    openMatchId?: null | string;
};

export type BookingListItemDto = {
    id: string;
    courtId: string;
    courtName: string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sport: string;
    clientId: string;
    clientName: string;
    clientMemberPrefix: string;
    clientMemberNumber: string;
    clientCategory?: null | string;
    trainerId?: null | string;
    trainerName?: null | string;
    startAt: string;
    endAt: string;
    status: BookingScheduleStatus;
    priceTotalKopecks: number;
    pricePaidKopecks: number;
    owedKopecks: number;
    isTraining: boolean;
    recurrenceId?: null | string;
    comment?: null | string;
    clientWish?: null | string;
    createdAt: string;
    cancelledAt?: null | string;
    cancelledInTime?: null | boolean;
    moneyChanges?: null | BookingMoneyChangesPart;
};

export type BookingMoneyChangesPart = {
    refundedOnMovesKopecks: number;
    surchargedOnMovesKopecks: number;
    refundedOnFormatSwitchesKopecks: number;
    surchargedOnFormatSwitchesKopecks: number;
};

export type BookingMoneyPart = {
    priceTotalKopecks: number;
    pricePaidKopecks: number;
    owedKopecks: number;
    pendingExtensionPriceKopecks?: null | number;
    pendingExtensionRequestedAt?: null | string;
    holdExpiresAt?: null | string;
    depositBalanceKopecks?: null | number;
    awaitingOrderId?: null | string;
    moveWaiverKopecks: number;
    changes?: null | BookingMoneyChangesPart;
};

export type BookingPlayerDto = {
    name: string;
    avatarUrl?: null | string;
};

export enum BookingScheduleStatus {
    RESERVED = 'reserved',
    PAID = 'paid',
    CONFIRMED = 'confirmed',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
    NO_SHOW = 'noShow',
    BLOCKED = 'blocked',
    HELD = 'held'
}

export enum BookingSortKey {
    START_AT = 'startAt',
    CREATED_AT = 'createdAt',
    PRICE = 'price'
}

export type BookingSplitDetailsDto = {
    splitId: string;
    bookingId: string;
    organizerId: string;
    organizerName: string;
    policy: SplitPolicy;
    status: SplitStatus;
    deadlineAt: string;
    totalAmountKopecks: number;
    finalizedAt?: null | string;
    deadlineDate: string;
    deadlineTime: string;
    seatPriceKopecks: number;
    organizerShareKopecks: number;
    totalSpots: number;
    freeSpots: number;
    inviteUrl?: null | string;
    booking: SplitBookingSummaryDto;
    participants: Array<BookingSplitParticipantDto>;
    isMine: boolean;
    unpaidSharesKopecks: number;
};

export type BookingSplitParticipantDto = {
    participantId: string;
    clientId: string;
    clientName: string;
    shareKopecks: number;
    status: SplitParticipantStatus;
    paymentMethod?: null | string;
    paidAt?: null | string;
    acceptedAt?: null | string;
    isMe: boolean;
};

export enum BookingSplitState {
    COLLECTING = 'collecting',
    PAID = 'paid',
    BURNED = 'burned',
    CANCELLED = 'cancelled'
}

export type BookingSplitSummary = {
    splitId: string;
    state: BookingSplitState;
    paidSpots: number;
    totalSpots: number;
    deadlineAt: string;
    myShareKopecks?: null | number;
    mySeat?: null | SplitSeatState;
    freeSeats: number;
    organizerPaid: boolean;
    seatPriceKopecks: number;
};

export enum BookingStatus {
    DRAFT = 'draft',
    HOLDING = 'holding',
    PENDING_PAYMENT = 'pendingPayment',
    CONFIRMED = 'confirmed',
    CHECKED_IN = 'checkedIn',
    IN_PROGRESS = 'inProgress',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
    NO_SHOW = 'noShow'
}

export type BookingSummaryDto = {
    id: string;
    resourceId: string;
    resourceName: string;
    isIndoor: boolean;
    date: string;
    startTime: string;
    endTime: string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sportType: string;
    status: BookingStatus;
    totalPriceKopecks: number;
    createdAt: string;
    reviewed: boolean;
    participants: Array<BookingPlayerDto>;
    split?: null | BookingSplitSummary;
    trainerId?: null | string;
    trainerName?: null | string;
};

export type BookingTrainingPart = {
    format: TrainingFormat;
    participants: Array<BookingTrainingParticipant>;
    pendingFormat?: null | TrainingFormat;
    switchOwedKopecks?: null | number;
    people: number;
};

export type BookingTrainingParticipant = {
    clientId: string;
    firstName: string;
    lastName: string;
};

export type BracketMatchDto = {
    id: string;
    roundId: string;
    roundNumber: number;
    resourceId: string;
    team1: Array<string>;
    team2: Array<string>;
    status: MatchStatus;
    scheduledAt: string;
    startedAt?: null | string;
    completedAt?: null | string;
};

export type BracketRoundDto = {
    id: string;
    roundNumber: number;
    status: RoundStatus;
    restingClientIds: Array<string>;
};

export type BroadcastNotificationResponse = {
    recipientCount: number;
    noRecipient: number;
    optedOut: number;
    overDailyLimit: number;
};

export type BulkBookingActionPayload = {
    ids?: null | Array<string>;
    action: string;
};

export type BulkBookingActionResponse = {
    updated: number;
    ids: Array<string>;
    failed: Array<BulkBookingFailure>;
};

export type BulkBookingFailure = {
    id: string;
    reason: string;
};

export type BulkGroupSessionActionBody = {
    action: BulkSessionAction;
    sessionIds: Array<string>;
    trainerId?: null | string;
    reason?: null | string;
};

export type BulkGroupSessionActionResponse = {
    doneCount: number;
    refusedCount: number;
    items: Array<BulkGroupSessionItemResult>;
};

export type BulkGroupSessionItemResult = {
    sessionId: string;
    done: boolean;
    code?: null | string;
    message?: null | string;
};

export enum BulkSessionAction {
    PUBLISH = 'publish',
    CANCEL = 'cancel',
    DISCARD = 'discard',
    REPLACE_TRAINER = 'replaceTrainer'
}

export type BulkUpdatePayload = {
    ids: Array<string>;
    action: string;
};

export type BulkUpdateResponse = {
    updated: number;
};

export type BuyChildSubscriptionBody = {
    templateId: string;
    idempotencyKey: string;
};

export type BuyChildSubscriptionResponse = {
    subscriptionId: string;
    paymentId: string;
};

export type BuyOwnSubscriptionBody = {
    templateId: string;
    method: PaymentMethod;
    idempotencyKey: string;
    useBonuses?: boolean;
    requestedBonusKopecks?: null | number;
};

export type CalculateSalaryRequest = {
    startDate: string;
    endDate: string;
};

export type CancelBookingResponse = {
    refundAmountKopecks: number;
    penaltyAmountKopecks: number;
    isFreeCancel: boolean;
    refundPercent: number;
    appliedTierMinHoursBefore?: null | number;
    hoursUntilBooking: number;
    bonusRefundedKopecks: number;
    friendsRefundedKopecks: number;
    refundToCardKopecks: number;
};

export type CancelBookingSplitPayload = {
    reason?: null | string;
};

export type CancelBookingSplitResponse = {
    status: SplitStatus;
};

export type CancelGroupSessionBody = {
    reason?: null | string;
    scope?: GroupSessionCancelScope;
};

export type CancelPendingChargeResponse = {
    paymentId: string;
    status: string;
};

export type CancelPreviewDto = {
    bookingId: string;
    priceTotalKopecks: number;
    refundAmountKopecks: number;
    penaltyAmountKopecks: number;
    isFreeCancel: boolean;
    refundPercent: number;
    appliedTierMinHoursBefore?: null | number;
    hoursUntilBooking: number;
    wasPaid: boolean;
    canCancel: boolean;
    bonusRefundKopecks: number;
    resalePromiseKopecks: number;
    friendsRefundKopecks: number;
    refundToCardKopecks: number;
};

export type CancelRecurringSeriesResponse = {
    seriesId: string;
    cancelledBookings: number;
    cancelledIds: Array<string>;
    notCancelled: Array<SeriesOccurrenceNotCancelled>;
};

export type CancelSplitByClubResponse = {
    splitId: string;
    status: SplitStatus;
    refundedKopecks: number;
    refundToCardKopecks: number;
    freezeReturnedKopecks: number;
};

export type CancelTournamentBody = {
    reason?: null | string;
};

export type CancelTournamentResponse = {
    tournamentId: string;
    refunded: Array<RefundedRegistrationDto>;
    totalRefundedKopecks: number;
};

export type CapabilityCatalogueEntryDto = {
    code: string;
    label: string;
    group: string;
    description: string;
    permissions: Array<string>;
};

export type CardCategoryAccrualDto = {
    code: string;
    rateBasisPoints: number;
    scope: AccrualScope;
    base?: null | BonusAccrualPolicy;
    effectiveBase: BonusAccrualPolicy;
    overrides: Array<AccrualOverrideDto>;
    version: number;
};

export type CardCategoryDto = {
    code: string;
    label: string;
    courtDiscountPct: number;
    trainerDiscountPct: number;
    cashbackPct: number;
    retentionThreshold: number;
    gradientFrom: string;
    gradientTo: string;
    enabled: boolean;
    sortOrder: number;
    builtin: boolean;
    bookingHorizonDays?: null | number;
    parallelCourts: number;
};

export type CardCategoryListResponse = {
    items: Array<CardCategoryDto>;
};

export type CardCategoryNext = {
    category: string;
    label: string;
    lookbackDays: number;
    visitsRequired: number;
    visitsDone: number;
    spentRequiredKopecks: number;
    spentDoneKopecks: number;
};

export type CardCategoryPerks = {
    courtDiscountPct: number;
    trainerDiscountPct: number;
    cashbackRateBasisPoints: number;
    cashbackScope: AccrualScope;
};

export type CashFlowPointDto = {
    date: string;
    incomingKopecks: number;
    outgoingKopecks: number;
    netKopecks: number;
};

export type CashFlowResponse = {
    from: string;
    to: string;
    totalIncomingKopecks: number;
    totalOutgoingKopecks: number;
    netKopecks: number;
    points: Array<CashFlowPointDto>;
};

export type CategoryBucket = {
    category: string;
    count: number;
};

export type ChangeBookingCommentPayload = {
    text?: null | string;
    expectedComment?: null | string;
};

export type ChangeClubStaffContactsBody = {
    firstName?: null | string;
    lastName?: null | string;
    phone?: null | string;
};

export type ChangeClubStaffRoleBody = {
    role: string;
};

export type ChangePasswordBody = {
    currentPassword: string;
    newPassword: string;
};

export type ChangePlanRequest = {
    plan: string;
};

export type ChangeSubscriptionPlanRequest = {
    plan: string;
    expectedDueNowKopecks: number;
};

export type ChatCardDto = {
    kind: ChatCardKind;
    state: ChatCardState;
    subjectKind: ChatSubjectKind;
    subjectId: string;
    title: string;
    lines: Array<string>;
    amountKopecks?: null | number;
    startsAt?: null | string;
    expiresAt?: null | string;
    openId?: null | string;
};

export enum ChatCardKind {
    PAYMENT_LINK = 'paymentLink',
    GAME_REMINDER = 'gameReminder',
    GAME_INVITE = 'gameInvite',
    WAITLIST_SEAT = 'waitlistSeat',
    GAME_RESULT = 'gameResult'
}

export enum ChatCardState {
    LIVE = 'live',
    DONE = 'done',
    EXPIRED = 'expired',
    GONE = 'gone'
}

export type ChatMessageDto = {
    id: string;
    conversationId: string;
    seq: number;
    clientMessageId: string;
    senderUserId?: null | string;
    senderIsStaff: boolean;
    body: string;
    createdAt: string;
    status?: null | string;
    senderName?: null | string;
    kind: ChatMessageKind;
    card?: null | ChatCardDto;
};

export enum ChatMessageKind {
    TEXT = 'text',
    CARD = 'card'
}

export type ChatQuickRepliesPayload = {
    items: Array<string>;
};

export type ChatReadDto = {
    conversationId: string;
    readAt: string;
    readerName: string;
    messageCount: number;
};

export type ChatRoomDto = {
    kind: ChatRoomKind;
    subjectId: string;
    title: string;
    coachTrainerId?: null | string;
    coachName?: null | string;
    myRole: ChatRoomRole;
    canWrite: boolean;
    participantCount: number;
    lastSeq: number;
    lastMessageAt?: null | string;
    lastMessagePreview?: null | string;
    unreadCount: number;
    myLastReadSeq: number;
};

export enum ChatRoomKind {
    TOURNAMENT = 'tournament',
    DIRECT = 'direct',
    OPEN_MATCH = 'openMatch',
    GROUP_SESSION = 'groupSession'
}

export type ChatRoomMessageDto = {
    id: string;
    subjectId: string;
    seq: number;
    clientMessageId: string;
    senderRole: ChatRoomRole;
    senderName?: null | string;
    isMine: boolean;
    body: string;
    createdAt: string;
};

export enum ChatRoomRole {
    PARTICIPANT = 'participant',
    COACH = 'coach',
    MEMBER = 'member'
}

export enum ChatSubjectKind {
    PAYMENT = 'payment',
    BOOKING = 'booking',
    BOOKING_PARTICIPANT = 'bookingParticipant',
    GROUP_SESSION_PARTICIPANT = 'groupSessionParticipant',
    TOURNAMENT_REGISTRATION = 'tournamentRegistration',
    TOURNAMENT_PARTNER = 'tournamentPartner',
    GAME_INVITE = 'gameInvite',
    WAITLIST_OFFER = 'waitlistOffer',
    RATING_MATCH = 'ratingMatch',
    TOURNAMENT_RESULT = 'tournamentResult',
    ORDER = 'order'
}

export type ChatTrainerDto = {
    trainerId: string;
    trainerName: string;
    canWrite: boolean;
    conversation?: null | ConversationDto;
};

export type CheckAccessPayload = {
    clientId: string;
    zoneId: string;
    deviceId?: null | string;
    method: AccessMethod;
    direction: AccessDirection;
    qrToken?: null | string;
};

export type CheckAccessResponse = {
    decision: AccessDecisionType;
    denialReason?: null | string;
    bookingId?: null | string;
    accessEventId: string;
};

export type CheckinCardDto = {
    id: string;
    fullName: string;
    memberNumber: string;
    category: string;
    note?: null | string;
    blacklisted: boolean;
    hasDebt: boolean;
};

export type CheckinCardsResponse = {
    items: Array<CheckinCardDto>;
};

export enum CheckoutSettlement {
    TILL = 'till',
    LINK = 'link',
    ORGANIZATION = 'organization',
    CLIENT_PAYS = 'clientPays'
}

export type CheckoutSubscriptionRequest = {
    method?: null | string;
    supersedeTransferDocument?: null | boolean;
};

export type ChildCategoriesDto = {
    courts: boolean;
    trainers: boolean;
    inventory: boolean;
    subscriptions: boolean;
};

export type ChildChargeRequestItem = {
    paymentId: string;
    childClientId: string;
    amountKopecks: number;
    purpose: PaymentPurpose;
    purposeRefId?: null | string;
    createdAt: string;
};

export type ChildDto = {
    id: string;
    memberNumber: string;
    firstName: string;
    lastName: string;
    birthDate?: null | string;
    phone?: null | string;
    visitsCount: number;
    allowedCategories: ChildCategoriesDto;
};

export type ChildPhoneLinkPending = {
    confirmationId: string;
};

export type ChildSocialBody = {
    socialEnabled: boolean;
};

export type ChildSocialDto = {
    clientId: string;
    socialEnabled: boolean;
};

export type ChildrenSocialResponse = {
    children: Array<ChildSocialDto>;
};

export type ClaimInviteResponse = {
    friendClientId: string;
    displayName: string;
    avatarUrl: string;
};

export enum ClientActivity {
    NEWCOMER = 'newcomer',
    REGULAR = 'regular',
    SLEEPING = 'sleeping',
    CHURNED = 'churned'
}

export type ClientAttendanceEntryDto = {
    sessionId: string;
    title?: null | string;
    date: string;
    startTime: string;
    endTime: string;
    status: ParticipantStatus;
    checkedInAt?: null | string;
    registeredAt: string;
    registeredBy?: null | SessionRegistrationBy;
    fee: SeatFee;
};

export type ClientAttendanceResponse = {
    items: Array<ClientAttendanceEntryDto>;
};

export type ClientBonusAvailabilityDto = {
    clientId: string;
    balanceKopecks: number;
    nearestExpiry?: null | BonusExpiryDto;
    expiringSoonKopecks: number;
    inactivityBurnOn?: null | string;
    burnsTodayKopecks: number;
};

export type ClientBonusesResponse = {
    balanceKopecks: number;
    expiresAt?: null | string;
    recent: Array<BonusTransactionDto>;
    nearestExpiry?: null | BonusExpiryDto;
    expiringSoonKopecks: number;
    expiryWarningDays: number;
    expiryBuckets: Array<BonusExpiryDto>;
    expiryBucketsTruncated: boolean;
    noExpiryKopecks: number;
    inactivityBurnOn?: null | string;
};

export type ClientBriefChildDto = {
    clientId: string;
    firstName: string;
    ageYears?: null | number;
};

export type ClientBriefDto = {
    clientId: string;
    name: string;
    isNewcomer: boolean;
    children: Array<ClientBriefChildDto>;
    rating?: null | number;
    ratingCategory?: null | string;
    clientWish?: null | string;
};

export type ClientBriefsResponse = {
    clients: Array<ClientBriefDto>;
};

export type ClientCategoryRuleDto = {
    id: string;
    targetCategory: string;
    minVisits: number;
    minLtv: number;
    lookbackDays: number;
    enabled: boolean;
    sortOrder: number;
};

export type ClientCategoryRuleListResponse = {
    items: Array<ClientCategoryRuleDto>;
};

export type ClientCategoryRulePayload = {
    targetCategory?: null | string;
    minVisits?: null | number;
    minLtv?: null | number;
    lookbackDays?: null | number;
    enabled?: null | boolean;
    sortOrder?: null | number;
};

export type ClientCategoryStandingDto = {
    since?: null | string;
    pinned: boolean;
    pinnedByName?: null | string;
    pinReason?: null | string;
    thresholdKopecks: number;
    periodLastDay?: null | string;
    periodTurnoverKopecks: number;
};

export type ClientDashboardResponse = {
    context: DashboardContextDto;
    upcomingBooking?: null | UpcomingBookingDto;
    wallet: WalletDto;
    upcomingTournament?: null | UpcomingTournamentDto;
    news: Array<NewsItemDto>;
};

export type ClientDetailDto = {
    id: string;
    memberNumber: string;
    memberPrefix: string;
    firstName: string;
    lastName: string;
    patronymic?: null | string;
    phone: string;
    email?: null | string;
    birthDate?: null | string;
    category: string;
    activity: ClientActivity;
    depositBalanceKopecks: number;
    bonusBalanceKopecks: number;
    bonusExpiresAt?: null | string;
    ltvKopecks: number;
    lastVisitAt?: null | string;
    visitsCount: number;
    preferredSport?: null | SportType;
    preferredTrainerId?: null | string;
    avatarUrl: string;
    blacklisted: boolean;
    createdAt: string;
    notesInternal?: null | string;
    highlight?: null | string;
    visits: Array<ClientVisitDto>;
    payments: Array<ClientPaymentDto>;
    totalVisitsCount: number;
    totalPaymentsCount: number;
    totalSpentKopecks: number;
    outstandingDefaultedSplits: Array<OutstandingDefaultedSplitDto>;
    categoryStanding: ClientCategoryStandingDto;
    parallelCourts?: null | number;
    effectiveParallelCourts: number;
    awaitsAccountLink: boolean;
};

export type ClientExtendBookingResponse = {
    id: string;
    extendedByMinutes: number;
};

export type ClientFriendsResponse = {
    friends: Array<StaffFriendDto>;
    pending: StaffPendingCounts;
};

export enum ClientGender {
    MALE = 'male',
    FEMALE = 'female'
}

export type ClientListItemDto = {
    id: string;
    memberNumber: string;
    memberPrefix: string;
    firstName: string;
    lastName: string;
    patronymic?: null | string;
    phone: string;
    category: string;
    activity: ClientActivity;
    depositBalanceKopecks: number;
    bonusBalanceKopecks: number;
    bonusExpiresAt?: null | string;
    ltvKopecks: number;
    lastVisitAt?: null | string;
    preferredSport?: null | SportType;
    avatarUrl: string;
    visitsCount: number;
    blacklisted: boolean;
    createdAt: string;
    parallelCourts?: null | number;
};

export enum ClientNoteMode {
    REPLACE = 'replace',
    APPEND = 'append'
}

export type ClientObligationView = {
    id: string;
    fund: ObligationFund;
    amountKopecks: number;
    outstandingKopecks: number;
    details: string;
    createdAt: string;
};

export type ClientOrganizationDto = {
    organizationId: string;
    organizationName: string;
    status: OrganizationMemberStatus;
};

export type ClientOrganizationResponse = {
    membership?: null | ClientOrganizationDto;
};

export type ClientPaymentDto = {
    id: string;
    amountKopecks: number;
    method: ClientPaymentMethod;
    status: ClientPaymentStatus;
    createdAt: string;
    bookingId?: null | string;
};

export enum ClientPaymentMethod {
    CARD = 'card',
    SBP = 'sbp',
    DEPOSIT = 'deposit',
    CASH = 'cash',
    CORPORATE_ACCOUNT = 'corporateAccount'
}

export enum ClientPaymentStatus {
    PENDING = 'pending',
    PROCESSING = 'processing',
    COMPLETED = 'completed',
    FAILED = 'failed',
    REFUNDED = 'refunded',
    PARTIALLY_REFUNDED = 'partiallyRefunded',
    PENDING_APPROVAL = 'pendingApproval',
    CANCELLED = 'cancelled',
    UNKNOWN = 'unknown'
}

export type ClientRatingsDto = {
    ratings: Array<ClientSportRatingDto>;
    recentHistory: Array<RatingHistoryPointDto>;
};

export type ClientRestriction = {
    code: string;
    message: string;
};

export type ClientSearchResponse = {
    items: Array<ClientSearchResultDto>;
};

export type ClientSearchResultDto = {
    id: string;
    memberNumber: string;
    memberPrefix: string;
    firstName: string;
    lastName: string;
    patronymic?: null | string;
    phone: string;
    category: string;
    activity: ClientActivity;
    depositBalanceKopecks: number;
    bonusBalanceKopecks: number;
    bonusExpiresAt?: null | string;
    ltvKopecks: number;
    lastVisitAt?: null | string;
    preferredSport?: null | SportType;
    avatarUrl: string;
};

export type ClientSeriesListResponse = {
    items: Array<ClientSeriesSummary>;
};

export type ClientSeriesSummary = {
    id: string;
    courtName: string;
    startTime: string;
    durationMinutes: number;
    daysOfWeek: Array<number>;
    seriesStartDate: string;
    seriesEndDate: string;
    waitingDates: number;
    nextDate?: null | string;
    cancelledAt?: null | string;
};

export type ClientSigurLinkDto = {
    sigurEmployeeId?: null | number;
    cardKey?: null | string;
};

export enum ClientSortKey {
    NAME = 'name',
    MEMBER_NUMBER = 'memberNumber',
    LAST_VISIT = 'lastVisit',
    LTV = 'ltv',
    DEPOSIT = 'deposit',
    CATEGORY = 'category',
    BONUSES = 'bonuses'
}

export type ClientSportRatingDto = {
    sport: string;
    level: number;
    category: string;
    provisional: boolean;
    mu: number;
    sigma: number;
    matchesPlayed: number;
    wins: number;
    losses: number;
    lastPlayedAt?: null | string;
    nextCategory?: null | string;
    progressToNext: number;
    rank: number;
    totalRanked: number;
    topPercent: number;
};

export type ClientVisitDto = {
    id: string;
    startAt: string;
    endAt: string;
    courtName: string;
    sport: string;
    status: ClientVisitStatus;
    trainerName?: null | string;
    attended: boolean;
};

export enum ClientVisitStatus {
    RESERVED = 'reserved',
    CONFIRMED = 'confirmed',
    PAID = 'paid',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
    NO_SHOW = 'noShow'
}

export type ClientsLookupItem = {
    clientId: string;
    firstName: string;
    lastName: string;
    memberNumber: string;
    memberCode: string;
    avatarUrl: string;
};

export type ClientsLookupResponse = {
    items: Array<ClientsLookupItem>;
};

export type CloseShiftPayload = {
    closingFloat?: null | number;
};

export type ClosedDateDto = {
    date: string;
    reason?: null | string;
};

export type ClubChatRoomDto = {
    kind: ChatRoomKind;
    subjectId: string;
    title: string;
    coachTrainerId?: null | string;
    coachName?: null | string;
    participantCount: number;
    lastSeq: number;
    lastMessageAt?: null | string;
    lastMessagePreview?: null | string;
};

export type ClubConsentsBody = {
    accept: Array<AcceptedClubDocument>;
    marketing?: null | boolean;
};

export type ClubDocument = {
    kind: ConsentType;
    version: string;
    title: string;
    body: string;
    publishedAt?: null | string;
    mustAccept: boolean;
};

export type ClubDocumentsResponse = {
    documents: Array<ClubDocument>;
    marketing: MarketingConsent;
    mustAccept: boolean;
};

export type ClubGameInviteDto = {
    inviteId: string;
    inviteeClientId: string;
    inviteeName: string;
    invitedByName: string;
    invitedAt: string;
    expiresAt: string;
    status: GameInviteStatus;
};

export type ClubGameInviteListResponse = {
    invites: Array<ClubGameInviteDto>;
};

export type ClubGameInvitesResponse = {
    invited: number;
    skipped: number;
};

export type ClubJoinCodeResponse = {
    code: string;
    joinUrl: string;
};

export enum ClubKind {
    BOTH = 'both',
    COURTS = 'courts',
    FITNESS = 'fitness'
}

export enum ClubNewsAction {
    NONE = 'none',
    BOOK_COURT = 'bookCourt',
    JOIN_TOURNAMENT = 'joinTournament',
    JOIN_MATCH = 'joinMatch',
    JOIN_GROUP_SESSION = 'joinGroupSession'
}

export type ClubProfileDto = {
    tenantId: string;
    legalName: string;
    publicName: string;
    inn: string;
    kpp?: null | string;
    legalAddress: string;
    contactEmail: string;
    contactPhone: string;
    websiteUrl: string;
    timezone: string;
    locale: string;
    currency: string;
    accentColor: string;
    logoUrl?: null | string;
    memberPrefix: string;
    receiptHeader: string;
    receiptFooter: string;
    manualRefundApprovalThresholdKopecks: number;
    bonusAccrualPolicy: BonusAccrualPolicy;
    bonusSpendCategories: Array<string>;
    bookingRequiresActiveCard: boolean;
    splitPayDefaultPolicy: SplitPayDefaultPolicy;
    posMaxDiscountPct: number;
    maxActiveBookings: number;
    autoRefundUnfulfilledObligations: boolean;
    kind: ClubKind;
    splitPayEnabled: boolean;
    lateBurnedSharePolicy: LateBurnedSharePolicy;
};

export type ClubProfilePayload = {
    legalName?: null | string;
    publicName?: null | string;
    inn?: null | string;
    kpp?: null | string;
    legalAddress?: null | string;
    contactEmail?: null | string;
    contactPhone?: null | string;
    websiteUrl?: null | string;
    timezone?: null | string;
    locale?: null | string;
    accentColor?: null | string;
    logoUrl?: null | string;
    receiptHeader?: null | string;
    receiptFooter?: null | string;
    manualRefundApprovalThresholdKopecks?: null | number;
    bonusAccrualPolicy?: null | BonusAccrualPolicy;
    bonusSpendCategories?: null | Array<BonusSpendCategory>;
    bookingRequiresActiveCard?: null | boolean;
    splitPayDefaultPolicy?: null | SplitPayDefaultPolicy;
    bonusMaxPaymentPct?: null | number;
    posMaxDiscountPct?: null | number;
    maxActiveBookings?: null | number;
    autoRefundUnfulfilledObligations?: null | boolean;
    kind?: null | ClubKind;
    splitPayEnabled?: null | boolean;
    lateBurnedSharePolicy?: null | LateBurnedSharePolicy;
};

export type ClubScheduleDto = {
    tenantId: string;
    weeklyHours: Array<DayHoursDto>;
    closedDates: Array<ClosedDateDto>;
    timezone: string;
};

export type ClubSchedulePayload = {
    weeklyHours?: null | Array<DayHoursDto>;
    closedDates?: null | Array<ClosedDateDto>;
};

export type ClubStaffContactsChanged = {
    fields: Array<string>;
    signedOut: boolean;
};

export type ClubStaffMemberDto = {
    userId: string;
    firstName?: null | string;
    lastName?: null | string;
    phone?: null | string;
    email?: null | string;
    role: string;
    status: string;
    isOwner: boolean;
    hasTrainerCard: boolean;
    hasPassword: boolean;
    clubRole?: null | string;
    trainerId?: null | string;
};

export type ConfirmChildPhoneLinkRequest = {
    code: string;
};

export type ConfirmFiscalNotIssuedRequest = {
    cardCharged?: null | boolean;
};

export type ConfirmLoginCommand = {
    challengeId: string;
    code: string;
};

export type ConfirmMyPhoneBody = {
    phone: string;
    code: string;
};

export type ConflictResolutionInput = {
    bookingId: string;
    action: string;
    targetCourtId?: null | string;
};

export enum ConsentType {
    PERSONAL_DATA = 'personalData',
    MARKETING = 'marketing',
    SOCIAL_VISIBILITY = 'socialVisibility',
    CLUB_RULES = 'clubRules',
    PRIVACY_POLICY = 'privacyPolicy'
}

export type ConversationDto = {
    id: string;
    subject?: null | string;
    status: ConversationStatus;
    lastMessageAt?: null | string;
    lastMessagePreview?: null | string;
    unreadCount: number;
    createdAt: string;
    clientUserId: string;
    clientName?: null | string;
    clientLastReadSeq: number;
    staffLastReadSeq: number;
    trainerId?: null | string;
    trainerName?: null | string;
    clientId?: null | string;
};

export enum ConversationStatus {
    OPEN = 'open',
    CLOSED = 'closed'
}

export type CopiedSessionDto = {
    sessionId: string;
    date: string;
    startTime: string;
    title?: null | string;
};

export type CopyGroupSessionWeekBody = {
    fromWeekStart: string;
    toWeekStart: string;
    direction?: null | ActivityDirection;
};

export type CopyGroupSessionWeekResponse = {
    created: Array<CopiedSessionDto>;
    skipped: Array<SkippedSessionDto>;
};

export type CorporateEligibilityDto = {
    eligible: boolean;
    organizationId?: null | string;
    organizationName?: null | string;
    monthlyLimitKopecks: number;
    remainingLimitKopecks: number;
    orgBalanceKopecks: number;
    orgActive: boolean;
    ineligibleReason?: null | string;
};

export type CourtDto = {
    id: string;
    name: string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sport: string;
    type: CourtType;
    basePricePerHourRubles: number;
    active: boolean;
    optionIds: Array<string>;
};

export type CourtListResponse = {
    items: Array<CourtDto>;
};

export enum CourtOptionCategory {
    SURFACE = 'surface',
    CLIMATE = 'climate',
    LIGHTING = 'lighting',
    EQUIPMENT = 'equipment',
    COMFORT = 'comfort',
    OTHER = 'other'
}

export type CourtOptionDto = {
    id: string;
    code: string;
    label: string;
    description: string;
    category: CourtOptionCategory;
    icon: string;
    color: string;
    priceDelta: number;
    priceMode: CourtOptionPriceMode;
    enabled: boolean;
    sortOrder: number;
};

export type CourtOptionListResponse = {
    items: Array<CourtOptionDto>;
};

export enum CourtOptionPriceMode {
    ADD = 'add',
    PERCENT = 'percent'
}

export type CourtSnippet = {
    id: string;
    name: string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sport: string;
    type: string;
};

export enum CourtType {
    INDOOR = 'indoor',
    OUTDOOR = 'outdoor'
}

export type CourtUtilizationDto = {
    courtId: string;
    name: string;
    sport: string;
    occupancyRatio: number;
};

export type CreateAccessDeviceCommand = {
    name: string;
    deviceType: DeviceType;
    zoneId: string;
    vendor: string;
    externalAccessPointId?: null | number;
};

export type CreateAccessZoneCommand = {
    name: string;
    zoneType: ZoneType;
    requiresBooking: boolean;
    requiresMembership: boolean;
    requiresSubscription: boolean;
    maxCapacity?: null | number;
    accessWindowBeforeMinutes?: number;
    accessWindowAfterMinutes?: number;
    externalZoneId?: null | number;
};

export type CreateAssistancePayload = {
    bookingId: string;
};

export type CreateBonusRulePayload = {
    kind?: null | string;
    label?: null | string;
    amount?: null | number;
    amountMode?: null | string;
    triggerVisits?: null | number;
    minOrderAmount?: null | number;
    expiresAfterDays?: null | number;
    description?: null | string;
    sortOrder?: null | number;
};

export type CreateBookingWithSplitPayload = {
    courtId: string;
    scheduledAt: string;
    durationMinutes: number;
    sport: string;
    trainerId?: null | string;
    totalSpots: number;
    idempotencyKey: string;
    paymentMethod?: null | string;
    requestedBonusKopecks?: null | number;
};

export type CreateBookingWithSplitResponse = {
    bookingId: string;
    splitId: string;
    deadlineAt: string;
    totalKopecks: number;
    organizerShareKopecks: number;
    policy: SplitPolicy;
    deadlineDate: string;
    deadlineTime: string;
    seatPriceKopecks: number;
    inviteUrl?: null | string;
    organizerPaid: boolean;
};

export type CreateCardCategoryPayload = {
    code: string;
    label?: null | string;
    courtDiscountPct?: null | number;
    trainerDiscountPct?: null | number;
    retentionThreshold?: null | number;
    gradientFrom?: null | string;
    gradientTo?: null | string;
    sortOrder?: null | number;
};

export type CreateClubRolePayload = {
    label?: null | string;
    baseRole?: null | string;
    capabilities?: null | Array<string>;
};

export type CreateCourtOptionPayload = {
    code?: null | string;
    label?: null | string;
    description?: null | string;
    category?: null | string;
    icon?: null | string;
    color?: null | string;
    priceDelta?: null | number;
    priceMode?: null | string;
    sortOrder?: null | number;
};

export type CreateCourtPayload = {
    name?: null | string;
    sport?: null | string;
    type?: null | string;
    basePricePerHourRubles?: null | number;
    optionIds?: null | Array<string>;
};

export type CreateDepositChargeBody = {
    clientId: string;
    amountKopecks: number;
    method: PaymentMethod;
    idempotencyKey: string;
};

export type CreateExpenseBody = {
    date: string;
    amountKopecks: number;
    category: ExpenseCategory;
    counterpartyName: string;
    description?: null | string;
    attachmentUrl?: null | string;
    idempotencyKey?: null | string;
};

export type CreateExpenseResponse = {
    expenseId: string;
    status: ExpenseStatus;
};

export type CreateFitnessClassCommand = {
    name: string;
    direction: ActivityDirection;
    defaultCapacity: number;
    sport?: null | string;
    defaultLevel?: SessionLevel;
    description?: null | string;
    sortOrder?: number;
};

export type CreateGameInvitesBody = {
    subjectKind: GameInviteSubjectKind;
    subjectId: string;
    inviteeClientIds: Array<string>;
};

export type CreateGroupSessionBody = {
    trainerId: string;
    resourceId: string;
    sessionType: SessionType;
    date: string;
    startTime: string;
    endTime: string;
    maxParticipants: number;
    pricePerPersonKopecks: number;
    title?: null | string;
    description?: null | string;
    level?: null | SessionLevel;
    direction?: ActivityDirection;
    waitlistDepth?: number;
    subscriptionTemplateIds?: null | Array<string>;
    admission?: SessionAdmission;
    classId?: null | string;
    openTrainerHours?: TrainerHoursOpening;
    publish?: boolean;
    repeat?: null | GroupSessionRepeat;
};

export type CreateGroupSessionResponse = {
    id: string;
    seriesId?: null | string;
    created: Array<string>;
    conflicts: Array<SeriesConflictDto>;
};

export type CreateGuestRequest = {
    hostClientId: string;
    firstName: string;
    lastName: string;
    phone?: null | string;
    documentId?: null | string;
    birthDate?: null | string;
    note?: null | string;
};

export type CreateInviteResponse = {
    inviteId: string;
    token: string;
    url: string;
    expiresAt: string;
};

export type CreateLineRefundBody = {
    paymentId: string;
    reasonCode: RefundReason;
    note?: null | string;
    destination: RefundDestination;
    lines: Array<RefundLineInput>;
    idempotencyKey: string;
};

export type CreateLineRefundResponse = {
    refundId: string;
    status: RefundStatus;
    totalKopecks: number;
    requiresApproval: boolean;
};

export type CreateOpenMatchPayload = {
    sport: string;
    runs: Array<MatchSlotRunPayload>;
    totalSpots: number;
    minLevel?: null | number;
    maxLevel?: null | number;
    comment?: null | string;
    organizerPaymentMethod?: null | string;
    requestedBonusKopecks?: null | number;
};

export type CreateOrganizationCommand = {
    name: string;
    legalName?: null | string;
    inn?: null | string;
    kpp?: null | string;
    contactEmail?: null | string;
    contactPhone?: null | string;
    ogrn?: null | string;
    legalAddress?: null | string;
    postalAddress?: null | string;
    bankName?: null | string;
    bik?: null | string;
    settlementAccount?: null | string;
    correspondentAccount?: null | string;
    contactPersonName?: null | string;
    contactPersonPosition?: null | string;
    invoiceEmail?: null | string;
    contractNumber?: null | string;
    contractDate?: null | string;
    vatMode?: null | OrganizationVatMode;
    paymentTermDays?: null | number;
};

export type CreateOrganizationResponse = {
    id: string;
};

export type CreatePartnerRequestPayload = {
    sport: string;
    windowFrom: string;
    windowTo: string;
    durationMinutes: number;
    totalSpots: number;
    levelMin?: null | number;
    levelMax?: null | number;
    note?: null | string;
};

export type CreatePaymentBody = {
    bookingId: string;
    method: PaymentMethod;
    returnUrl?: null | string;
};

export type CreatePaymentResponse = {
    paymentId: string;
    status: PaymentStatus;
    redirectUrl?: null | string;
};

export type CreatePlaceCommand = {
    name: string;
    type: ResourceType;
    capacity?: null | number;
    isIndoor: boolean;
    sortOrder: number;
};

export type CreatePlatformPlanRequest = {
    code: string;
    name: string;
    tagline?: null | string;
    monthlyPriceKopecks: number;
    courtsLimit: number;
    staffLimit: number;
    clientsLimit: number;
    bookingsPerMonthLimit: number;
    fitnessMembersLimit: number;
    sortOrder: number;
    isPublic: boolean;
    courtsModule?: boolean;
    fitnessModule?: boolean;
};

export type CreateProductPayload = {
    sku?: null | string;
    name?: null | string;
    kind?: null | string;
    price?: null | number;
    sport?: null | string;
    sortOrder?: null | number;
    unit?: null | string;
    includedInTraining?: null | boolean;
    tillOnly?: null | boolean;
};

export type CreatePromocodePayload = {
    code?: null | string;
    kind?: null | string;
    amount?: null | number;
    area?: null | PromocodeAreaDto;
    validFrom?: null | string;
    validUntil?: null | string;
    maxRedemptions?: null | number;
    minOrderAmount?: null | number;
    maxRedemptionsPerClient?: null | number;
};

export type CreateRecurringBookingsResponse = {
    seriesId: string;
    plannedDates: Array<string>;
    conflicts: Array<RecurringConflict>;
    estimatedOccurrencePriceKopecks: number;
    chargeDaysAhead: number;
};

export type CreateRecurringPayload = {
    courtId: string;
    clientId: string;
    trainerId?: null | string;
    startTime: string;
    durationMin: number;
    frequency: string;
    daysOfWeek?: null | Array<number>;
    seriesStartDate: string;
    seriesEndDate: string;
    note?: null | string;
    conflictResolution?: null | string;
    openTrainerHours?: TrainerHoursOpening;
};

export type CreateReminderPayload = {
    minutesBefore?: null | number;
    channel?: null | string;
    appliesTo?: null | string;
};

export type CreateRequestBody = {
    socialCode?: null | string;
    inviteToken?: null | string;
};

export type CreateSaleLinePayload = {
    productId?: null | string;
    kind?: null | string;
    qty?: null | number;
    advanceTopUpAmount?: null | number;
    discount?: null | number;
    bookingId?: null | string;
    subscriptionTemplateId?: null | string;
    extensionForBookingId?: null | string;
    groupSessionParticipantId?: null | string;
    splitShare?: null | SplitShareLinePayload;
    tournamentRegistrationId?: null | string;
};

export type CreateSalePayload = {
    clientId?: null | string;
    paymentMethod: string;
    lines?: null | Array<CreateSaleLinePayload>;
    cashGiven?: null | number;
    bonusKopecks?: null | number;
};

export type CreateSplitDebtPaymentBody = {
    splitId: string;
    method: PaymentMethod;
    returnUrl?: null | string;
};

export type CreateSplitDebtPaymentResponse = {
    paymentId: string;
    status: PaymentStatus;
    redirectUrl?: null | string;
};

export type CreateSplitRemainderPaymentBody = {
    bookingId: string;
    method: PaymentMethod;
    returnUrl?: null | string;
};

export type CreateSplitRemainderPaymentResponse = {
    paymentId: string;
    status: PaymentStatus;
    redirectUrl?: null | string;
};

export type CreateSplitSharePaymentBody = {
    bookingId: string;
    method: PaymentMethod;
    returnUrl?: null | string;
    forClientId?: null | string;
};

export type CreateSplitSharePaymentResponse = {
    paymentId: string;
    status: PaymentStatus;
    redirectUrl?: null | string;
};

export type CreateSportPayload = {
    code: string;
    label?: null | string;
    sortOrder?: null | number;
    icon?: null | string;
    color?: null | string;
    state?: null | SportState;
};

export type CreateSubscriptionChargeBody = {
    clientId: string;
    templateId: string;
    method: PaymentMethod;
    idempotencyKey?: null | string;
};

export type CreateSubscriptionChargeResponse = {
    subscriptionId: string;
    paymentId?: null | string;
    payUrl?: null | string;
    bonusKopecks: number;
};

export type CreateSubscriptionTemplatePayload = {
    name?: null | string;
    sport?: null | string;
    sessionsTotal?: null | number;
    gymVisitsTotal?: null | number;
    validForDays?: null | number;
    price?: null | number;
    transferable?: null | boolean;
    publishedInApp?: null | boolean;
    direction?: null | ActivityDirection;
    kind?: null | SubscriptionKind;
    gymVisitsKind?: null | SubscriptionKind;
    scope?: null | SubscriptionScope;
    trainerId?: null | string;
    freezeDaysAllowed?: null | number;
    guestVisitsTotal?: null | number;
    promocodeWithSubscription?: null | PromocodeWithSubscription;
};

export type CreateTaskPayload = {
    assigneeId: string;
    text: string;
    priority?: null | string;
    dueAt?: null | string;
};

export type CreateTenantRequest = {
    name: string;
    slug: string;
    ownerEmail: string;
    ownerPhone?: null | string;
    ownerFirstName?: null | string;
    ownerLastName?: null | string;
    plan: string;
    timezone?: null | string;
    locale?: null | string;
};

export type CreateTenantResult = {
    tenantId: string;
    slug: string;
    ownerUserId: string;
    ownerEmail: string;
    inviteUrl?: null | string;
};

export type CreateTournamentBody = {
    name: string;
    description?: null | string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sport: string;
    format: TournamentFormat;
    scoring?: null | ScoringMode;
    expectedParticipants: number;
    minPlayers?: null | number;
    maxPlayers?: null | number;
    startAt: string;
    endAt: string;
    courtIds?: null | Array<string>;
    entryFeeKopecks?: null | number;
    prizePoolKopecks?: null | number;
    prizeDistribution?: null | Array<PrizeShareInput>;
    pointsPerMatch?: null | number;
    note?: null | string;
    registrationOpensAt?: null | string;
    registrationClosesAt?: null | string;
    gradientFrom?: null | string;
    gradientTo?: null | string;
    conflictResolutions?: null | Array<ConflictResolutionInput>;
    levelMin?: null | number;
    levelMax?: null | number;
    hideParticipants?: boolean;
    prizeDestination?: PrizeDestination;
    awardPointsAsBonuses?: boolean;
    startAsDraft?: boolean;
};

export type CreateTournamentResponse = {
    tournamentId: string;
    status: TournamentStatus;
    tournament: TournamentBrief;
    createdBookings: Array<string>;
    rescheduledBookings: Array<string>;
    cancelledBookings: Array<string>;
};

export type CreateTrainerCommand = {
    firstName: string;
    lastName: string;
    sports: Array<string>;
    weeklySchedule: Array<WeeklyScheduleEntry>;
    bio?: null | string;
    yearsExperience?: null | number;
    individualRate?: null | number;
    groupRate?: null | number;
    baseSalary?: null | number;
    assignedPlaceIds?: null | Array<string>;
    salaryModel?: null | TrainerSalaryModel;
    phone?: null | string;
    methodology?: null | string;
    audiences?: null | Array<TrainerAudience>;
    classIds?: null | Array<string>;
};

export type CreditBody = {
    amountKopecks: number;
    description?: null | string;
    idempotencyKey: string;
};

export type CurrentShiftResponse = {
    shift?: null | ShiftDto;
};

export type DashboardBalancesResponse = {
    totalDepositsKopecks: number;
    totalBonusKopecks: number;
    paymentsTodayKopecks: number;
    refundsTodayKopecks: number;
};

export type DashboardContextDto = {
    hasUpcomingBooking: boolean;
    bookingSoon: boolean;
    inGame: boolean;
    inTournament: boolean;
    isNewUser: boolean;
};

export type DashboardKpisDto = {
    revenue: KpiValueDto;
    bookings: KpiValueDto;
    utilization: KpiValueDto;
    activeClients: KpiValueDto;
    refundedKopecks: number;
    cancelledBookings: number;
    bonusPaidKopecks: number;
};

export type DashboardLayoutDto = {
    version: number;
    widgets: Array<DashboardWidgetSlotDto>;
};

export type DashboardSummaryResponse = {
    kpis: DashboardKpisDto;
    revenueTrend: RevenueTrendDto;
    alerts: Array<AlertDto>;
    activity: Array<ActivityDto>;
    courtUtilization: Array<CourtUtilizationDto>;
};

export type DashboardTaskDto = {
    id: string;
    assignerId: string;
    assignerName: string;
    assigneeId: string;
    assigneeName: string;
    text: string;
    priority: DashboardTaskPriority;
    dueAt?: null | string;
    readAt?: null | string;
    acceptedAt?: null | string;
    completedAt?: null | string;
    isCompleted: boolean;
    status: DashboardTaskStatus;
    createdAt: string;
};

export enum DashboardTaskPriority {
    LOW = 'low',
    NORMAL = 'normal',
    HIGH = 'high'
}

export enum DashboardTaskStatus {
    NEW = 'new',
    IN_PROGRESS = 'inProgress',
    DONE = 'done'
}

export type DashboardTasksResponse = {
    items: Array<DashboardTaskDto>;
    hasMore: boolean;
};

export type DashboardWidgetSlotDto = {
    id: string;
    size: string;
    order: number;
    visible: boolean;
    settings?: null | {
        [key: string]: string;
    };
    allowed: boolean;
    category?: null | string;
};

export type DashboardWidgetSlotInput = {
    id: string;
    size: string;
    order: number;
    visible: boolean;
    settings?: null | {
        [key: string]: string;
    };
};

export type DayHoursDto = {
    dayOfWeek: DayOfWeek;
    isOpen: boolean;
    openAt: string;
    closeAt: string;
};

export enum DayOfWeek {
    SUNDAY = 'sunday',
    MONDAY = 'monday',
    TUESDAY = 'tuesday',
    WEDNESDAY = 'wednesday',
    THURSDAY = 'thursday',
    FRIDAY = 'friday',
    SATURDAY = 'saturday'
}

export type DeclineChildChargeResponse = {
    paymentId: string;
    status: string;
};

export type DeliveryPreferencesDto = {
    userId: string;
    emailEnabled: boolean;
    pushEnabled: boolean;
    emailAddress?: null | string;
    quietHoursEnabled: boolean;
    quietHoursStart?: null | string;
    quietHoursEnd?: null | string;
    timeZoneId: string;
    smsEnabled: boolean;
    phoneE164?: null | string;
    telegramEnabled: boolean;
    telegramChatId?: null | string;
    categories: Array<NotificationCategoryPreferenceDto>;
    smsOffered: boolean;
    telegramOffered: boolean;
};

export type DepositTransactionDto = {
    id: string;
    type: DepositTransactionType;
    amountKopecks: number;
    balanceAfterKopecks: number;
    referenceType?: null | DepositTransactionReference;
    referenceId?: null | string;
    description: string;
    createdAt: string;
    category: DepositTxCategory;
};

export enum DepositTransactionReference {
    PAYMENT = 'payment',
    BOOKING = 'booking',
    REFUND = 'refund',
    SALE = 'sale',
    TOURNAMENT = 'tournament',
    MATCH = 'match',
    ORDER = 'order',
    GROUP_SESSION_SEAT = 'groupSessionSeat',
    SPLIT = 'split'
}

export enum DepositTransactionType {
    TOPUP = 'topup',
    PAYMENT = 'payment',
    REFUND = 'refund',
    ADMIN_ADJUSTMENT = 'adminAdjustment',
    CANCEL_REFUND = 'cancelRefund',
    PRIZE = 'prize',
    DEBT_SETTLEMENT = 'debtSettlement',
    TRANSFER = 'transfer',
    CREDIT_REVERSAL = 'creditReversal'
}

export enum DepositTxCategory {
    OTHER = 'other',
    TOURNAMENT = 'tournament',
    SESSION = 'session',
    SUBSCRIPTION = 'subscription',
    COURT = 'court',
    TOPUP = 'topup',
    REFUND = 'refund'
}

export type DeviceListItemDto = {
    id: string;
    platform: string;
    deviceName?: null | string;
    lastSeenAt: string;
    createdAt: string;
};

export enum DeviceStatus {
    ONLINE = 'online',
    OFFLINE = 'offline',
    ERROR = 'error'
}

export enum DeviceType {
    TURNSTILE = 'turnstile',
    DOOR_LOCK = 'doorLock',
    GATE = 'gate'
}

export enum DirectMessageAudience {
    FRIENDS_AND_CO_PLAYERS = 'friendsAndCoPlayers',
    FRIENDS_ONLY = 'friendsOnly',
    NOBODY = 'nobody'
}

export type DirectRoomDto = {
    roomId: string;
    peerClientId: string;
    peerName: string;
    peerAvatarUrl: string;
    canWrite: boolean;
    lastSeq: number;
    lastMessageAt?: null | string;
    lastMessagePreview?: null | string;
    unreadCount: number;
    myLastReadSeq: number;
};

export type DirectRoomMessageDto = {
    id: string;
    roomId: string;
    seq: number;
    clientMessageId: string;
    isMine: boolean;
    body: string;
    createdAt: string;
    isHidden: boolean;
};

export type DisputeMatchPayload = {
    reason?: null | string;
};

export type EntityIdResponse = {
    id: string;
};

export type EntryPaymentPlanDto = {
    feeKopecks: number;
    bonusKopecks: number;
    remainderKopecks: number;
    bonusMaxKopecks: number;
    bonusCapBinding: boolean;
    bonusNotAllowed: boolean;
};

export type ErasureCandidate = {
    clientId: string;
    firstName: string;
    lastName: string;
    memberNumber: string;
};

export enum ErasureRequestChannel {
    IN_PERSON = 'inPerson',
    WRITTEN = 'written'
}

export type ExecuteApprovedRefundResponse = {
    refundId: string;
    status: RefundStatus;
};

export enum ExpenseCategory {
    RENT = 'rent',
    UTILITIES = 'utilities',
    EQUIPMENT = 'equipment',
    MAINTENANCE = 'maintenance',
    MARKETING = 'marketing',
    SALARY = 'salary',
    ACQUIRING = 'acquiring',
    OTHER = 'other'
}

export type ExpenseListItemDto = {
    id: string;
    date: string;
    amountKopecks: number;
    category: ExpenseCategory;
    status: ExpenseStatus;
    counterpartyName: string;
    description?: null | string;
    attachmentUrl?: null | string;
    paidAt?: null | string;
    paymentReference?: null | string;
};

export enum ExpenseStatus {
    DRAFT = 'draft',
    APPROVED = 'approved',
    PAID = 'paid',
    REJECTED = 'rejected'
}

export type ExpiringTrialDto = {
    id: string;
    name: string;
    slug: string;
    trialEndsAt: string;
};

export type ExtendPayload = {
    pendingEndAt: string;
    openTrainerHours?: TrainerHoursOpening;
};

export type ExtendToEndBody = {
    endTime: string;
};

export type ExtendTrialRequest = {
    endsAt: string;
    reason: string;
};

export type ExtensionOptionDto = {
    minutes: number;
    priceKopecks: number;
};

export type ExtensionOptionsResponse = {
    availableMinutes: Array<number>;
    conflicts?: null | string;
    options: Array<ExtensionOptionDto>;
};

export type FeatureNewsBody = {
    until: string;
};

export type FindAvailabilityPayload = {
    displacedBookingIds?: null | Array<string>;
    excludedCourtIds?: null | Array<string>;
};

export type FindAvailabilityResponse = {
    items: Array<AvailabilityItem>;
};

export type FindDeletedClubClientRequest = {
    phone: string;
};

export type FinishTournamentBody = {
    discardUnplayed?: boolean;
};

export type FinishTournamentResponse = {
    tournament: TournamentSummaryDto;
    leaderboard: Array<MatchLeaderboardEntry>;
    prizesDistributed: Array<PrizePayout>;
    ratings: Array<PlayerRatingDto>;
};

export type FiscalCommandDto = {
    service: string;
    kind: FiscalCommandKind;
    url: string;
    method: string;
    authorizationHeader: string;
    body: string;
    timeoutSeconds: number;
    answerToken: string;
};

export enum FiscalCommandKind {
    REGISTER = 'register',
    QUERY = 'query',
    WITHDRAW = 'withdraw'
}

export enum FiscalHandReason {
    DOCUMENT_NUMBER = 'documentNumber',
    AMOUNT = 'amount',
    FOREIGN_TASK = 'foreignTask',
    TASK_LOST_AT_VENDOR = 'taskLostAtVendor',
    CARD_CHARGE_CANNOT_BE_REPEATED = 'cardChargeCannotBeRepeated',
    TASK_BLOCKED_AT_KKT = 'taskBlockedAtKkt',
    TASK_UNKNOWN_TO_SERVICE = 'taskUnknownToService'
}

export enum FiscalNextStep {
    NONE = 'none',
    REGISTER = 'register',
    QUERY = 'query',
    RESOLVE_BY_HAND = 'resolveByHand',
    WITHDRAW = 'withdraw'
}

export type FiscalReceiptStateDto = {
    status: FiscalReceiptStatus;
    documentNumber?: null | string;
    fiscalSign?: null | string;
    receiptNumberInShift?: null | number;
    kktShiftNumber?: null | number;
    ofdUrl?: null | string;
    notPrinted: boolean;
    refusalText?: null | string;
    refusalCode?: null | number;
    attempts: number;
    nextStep: FiscalNextStep;
    handReason?: null | FiscalHandReason;
};

export type FiscalReceiptStateResponse = {
    state?: null | FiscalReceiptStateDto;
};

export enum FiscalReceiptStatus {
    QUEUED = 'queued',
    REGISTERED = 'registered',
    REFUSED = 'refused',
    UNKNOWN = 'unknown',
    WITHDRAWING = 'withdrawing'
}

export type FitnessClassDto = {
    id: string;
    name: string;
    description?: null | string;
    direction: ActivityDirection;
    sport?: null | string;
    defaultLevel: SessionLevel;
    defaultCapacity: number;
    isActive: boolean;
    sortOrder: number;
    inUse: boolean;
};

export type FitnessClassPayload = {
    name?: null | string;
    description?: null | string;
    direction?: null | ActivityDirection;
    sport?: null | string;
    defaultCapacity?: null | number;
    defaultLevel?: null | SessionLevel;
    sortOrder?: null | number;
    isActive?: null | boolean;
};

export type FitnessPolicyDto = {
    enabled: boolean;
    gymEnabled: boolean;
    groupClassesEnabled: boolean;
    personalTrainingEnabled: boolean;
    poolEnabled: boolean;
    saunaEnabled: boolean;
    showOccupancy: boolean;
    countGroupSessionsAsVisits: boolean;
    countEveryGymEntryAsVisit: boolean;
    subscriptionMaxFreezeDays: number;
    lateCancelledPersonalTrainerSharePct: number;
};

export type FitnessPolicyPayload = {
    enabled?: null | boolean;
    gymEnabled?: null | boolean;
    groupClassesEnabled?: null | boolean;
    personalTrainingEnabled?: null | boolean;
    poolEnabled?: null | boolean;
    saunaEnabled?: null | boolean;
    showOccupancy?: null | boolean;
    countGroupSessionsAsVisits?: null | boolean;
    countEveryGymEntryAsVisit?: null | boolean;
    subscriptionMaxFreezeDays?: null | number;
    lateCancelledPersonalTrainerSharePct?: null | number;
};

export type ForgetClientBody = {
    channel: ErasureRequestChannel;
    documentKind: IdentityDocumentKind;
    receivedOn: string;
};

export type ForgetDeletedClubClientRequest = {
    channel: ErasureRequestChannel;
    documentKind: IdentityDocumentKind;
    receivedOn: string;
};

export type FreezeMySubscriptionBody = {
    days?: null | number;
};

export type FriendDto = {
    clientId: string;
    displayName: string;
    avatarUrl: string;
    level?: null | string;
    friendsSince: string;
};

export type FriendProfileResponse = {
    clientId: string;
    displayName: string;
    avatarUrl: string;
    friendsSince: string;
    ratings: Array<FriendSportRatingDto>;
    gamesTogether: number;
    recentGamesTogether: Array<GameTogetherDto>;
};

export type FriendReportContextLineDto = {
    messageId: string;
    seq: number;
    senderClientId: string;
    senderName: string;
    body: string;
    isHidden: boolean;
    isReported: boolean;
    createdAt: string;
};

export type FriendReportListItemDto = {
    id: string;
    reporterClientId: string;
    reporterName: string;
    reportedClientId: string;
    reportedName: string;
    reason: string;
    status: string;
    createdAt: string;
    resolvedAt?: null | string;
    resolutionNote?: null | string;
    messageRoomId?: null | string;
    messageId?: null | string;
    messageHidden: boolean;
    senderRestrictedUntil?: null | string;
};

export type FriendRequestDto = {
    requestId: string;
    clientId: string;
    displayName: string;
    avatarUrl: string;
    createdAt: string;
};

export type FriendRequestsResponse = {
    requests: Array<FriendRequestDto>;
};

export type FriendSettingsResponse = {
    activated: boolean;
    socialCode?: null | string;
    qrUrl?: null | string;
    allowFriendRequests: boolean;
    shareActivityWithFriends: boolean;
    directMessages: DirectMessageAudience;
    consentVersion: string;
    consentText: string;
};

export type FriendSportRatingDto = {
    sport: string;
    sportLabel: string;
    level: number;
    category: string;
    provisional: boolean;
    matchesPlayed: number;
};

export type FriendsListResponse = {
    friends: Array<FriendDto>;
};

export type FriendsPolicyDto = {
    enabled: boolean;
    dailyRequestCap: number;
    declineCooldownDays: number;
    requestTtlDays: number;
    inviteLinkTtlHours: number;
    gameInviteTtlHours: number;
    gameInvitesPerDay: number;
    directRoomsPerDay: number;
};

export type FriendsPolicyPayload = {
    enabled?: null | boolean;
    dailyRequestCap?: null | number;
    declineCooldownDays?: null | number;
    requestTtlDays?: null | number;
    inviteLinkTtlHours?: null | number;
    gameInviteTtlHours?: null | number;
    gameInvitesPerDay?: null | number;
    directRoomsPerDay?: null | number;
};

export type GameInviteDto = {
    inviteId: string;
    subjectKind: GameInviteSubjectKind;
    subjectId: string;
    inviterName: string;
    inviterAvatarUrl: string;
    title?: null | string;
    startsAt: string;
    expiresAt: string;
    status: GameInviteStatus;
};

export enum GameInviteStatus {
    LIVE = 'live',
    ACCEPTED = 'accepted',
    DECLINED = 'declined',
    REVOKED = 'revoked',
    EXPIRED = 'expired',
    FULL = 'full',
    GONE = 'gone'
}

export enum GameInviteSubjectKind {
    SPLIT = 'split',
    OPEN_MATCH = 'openMatch',
    TOURNAMENT = 'tournament',
    GROUP_SESSION = 'groupSession'
}

export type GameInvitesResponse = {
    invites: Array<GameInviteDto>;
};

export type GameTogetherDto = {
    sport: string;
    sportLabel: string;
    playedAt: string;
    kind: GameTogetherKind;
    sameTeam?: null | boolean;
    won?: null | boolean;
};

export enum GameTogetherKind {
    RATED_MATCH = 'ratedMatch',
    OPEN_MATCH = 'openMatch',
    SPLIT_BOOKING = 'splitBooking'
}

export type GenerateBracketResponse = {
    tournament: TournamentSummaryDto;
    rounds: Array<BracketRoundDto>;
    matches: Array<BracketMatchDto>;
    totalRounds: number;
    totalMatches: number;
};

export type GetBookingActivityResponse = {
    items: Array<BookingActivityItemDto>;
};

export type GetUserPermissionsResponse = {
    roles: Array<string>;
    roleBasedPermissions: Array<string>;
    clubRolePermissions: Array<string>;
    overrides: Array<UserPermissionOverrideDto>;
    effectivePermissions: Array<string>;
};

export type GrantPayload = {
    permission: string;
    reason?: null | string;
    expiresAt?: null | string;
};

export type GrantUserPermissionResponse = {
    overrideId: string;
    created: boolean;
};

export type GridConfigDto = {
    slotStepMin: number;
    dayStartHour: number;
    dayEndHour: number;
    density: GridDensity;
    showTrainerStripes: boolean;
    tintByCourt: boolean;
};

export type GridConfigPayload = {
    slotStepMin?: null | number;
    dayStartHour?: null | number;
    dayEndHour?: null | number;
    density?: null | string;
    showTrainerStripes?: null | boolean;
    tintByCourt?: null | boolean;
};

export enum GridDensity {
    COMPACT = 'compact',
    COMFORTABLE = 'comfortable',
    SPACIOUS = 'spacious'
}

export enum GroupSessionCancelScope {
    SESSION = 'session',
    FOLLOWING = 'following',
    SERIES = 'series'
}

export type GroupSessionDetailDto = {
    id: string;
    trainerId: string;
    resourceId: string;
    sportType?: null | SportType;
    sessionType: SessionType;
    direction: ActivityDirection;
    date: string;
    startTime: string;
    endTime: string;
    maxParticipants: number;
    currentParticipants: number;
    pricePerPersonKopecks: number;
    title?: null | string;
    description?: null | string;
    level: SessionLevel;
    status: SessionStatus;
    participants: Array<SessionParticipantDto>;
    waitlist: Array<SessionWaitlistRowDto>;
    waitlistDepth: number;
    subscriptionTemplateIds?: null | Array<string>;
    admission: SessionAdmission;
    outsideTrainerHours?: null | TrainerOffScheduleReason;
};

export type GroupSessionDto = {
    id: string;
    trainerId: string;
    resourceId: string;
    sportType?: null | SportType;
    sessionType: SessionType;
    direction: ActivityDirection;
    date: string;
    startTime: string;
    endTime: string;
    maxParticipants: number;
    currentParticipants: number;
    pricePerPersonKopecks: number;
    title?: null | string;
    description?: null | string;
    level: SessionLevel;
    status: SessionStatus;
    isRegistered: boolean;
    waitlistDepth: number;
    waitlistLength: number;
    isOnWaitlist: boolean;
    seriesId?: null | string;
    admission: SessionAdmission;
    outsideTrainerHours?: null | TrainerOffScheduleReason;
    placeName?: null | string;
    classId?: null | string;
    className?: null | string;
    myWithdrawalIsFree?: null | boolean;
    mySeatBySubscription?: null | boolean;
    myPaidKopecks?: null | number;
};

export type GroupSessionMoveCheck = {
    fits: boolean;
    code?: null | string;
    message?: null | string;
};

export type GroupSessionRefundTier = {
    minHoursBefore: number;
    refundPct: number;
};

export type GroupSessionRepeat = {
    frequency: string;
    daysOfWeek: Array<number>;
    until: string;
    conflictResolution?: null | string;
};

export type GuestDto = {
    id: string;
    hostClientId: string;
    hostName?: null | string;
    firstName: string;
    lastName: string;
    phone?: null | string;
    documentId?: null | string;
    birthDate?: null | string;
    note?: null | string;
    source: GuestSource;
    status: GuestStatus;
    visitsCount: number;
    lastVisitAt?: null | string;
    convertedClientId?: null | string;
    createdAt: string;
};

export type GuestListResponse = {
    items: Array<GuestDto>;
    total: number;
    page: number;
    pageSize: number;
};

export enum GuestSource {
    STAFF_DESK = 'staffDesk',
    MOBILE_INVITE = 'mobileInvite'
}

export enum GuestStatus {
    INVITED = 'invited',
    VISITED = 'visited',
    CONVERTED = 'converted'
}

export type HeartbeatAccessDevicePayload = {
    status: DeviceStatus;
};

export type HeatCellDto = {
    dow: number;
    hour: number;
    minutes: number;
};

export type HeldDespiteRevoke = {
    capability: string;
    heldBy: Array<string>;
    fully: boolean;
};

export type HeldTime = {
    startTime: string;
    expiresAt: string;
};

export type HttpValidationProblemDetails = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<string>;
    };
};

export type IFormFile = Blob | File;

export enum IdentityDocumentKind {
    PASSPORT = 'passport',
    FOREIGN_PASSPORT = 'foreignPassport',
    DRIVER_LICENSE = 'driverLicense',
    OTHER = 'other'
}

export type ImpersonateTenantRequest = {
    reason: string;
};

export type ImpersonationExitResponse = {
    accessToken: string;
    refreshToken: string;
    expiresAt: string;
};

export type ImpersonationResponse = {
    accessToken: string;
    expiresAt: string;
    tenantId: string;
    tenantName: string;
    tenantSlug: string;
};

export type ImportBlacklistCommand = {
    text: string;
    reason: string;
    fromCsv: boolean;
};

export type IntegrationDto = {
    kind: IntegrationKind;
    label?: null | string;
    enabled: boolean;
    status: IntegrationStatus;
    configured: boolean;
    lastSyncedAt?: null | string;
    lastError?: null | string;
    fields: Array<IntegrationFieldDto>;
    idleReason?: null | string;
};

export type IntegrationFieldDto = {
    key: string;
    secret: boolean;
    value?: null | string;
    filled: boolean;
    masked?: null | string;
};

export enum IntegrationKind {
    SIGUR = 'sigur',
    SBER_KKM = 'sberKkm',
    TELEGRAM_BOT = 'telegramBot',
    MAX_APP = 'maxApp',
    SMS = 'sms'
}

export type IntegrationPayload = {
    label?: null | string;
    enabled?: null | boolean;
    settingsJson?: null | string;
};

export type IntegrationSecretDto = {
    key: string;
    value: string;
};

export enum IntegrationStatus {
    CONNECTED = 'connected',
    DISCONNECTED = 'disconnected',
    ERROR = 'error',
    SYNCING = 'syncing'
}

export type IssueMembershipCardPayload = {
    validUntil?: null | string;
};

export type IssueSubscriptionPayload = {
    templateId: string;
    idempotencyKey: string;
    reason: SubscriptionGrantReason;
    note?: null | string;
};

export type IssuedClubJoinCodeResponse = {
    issued?: null | ClubJoinCodeResponse;
};

export type JoinOpenMatchPayload = {
    paymentMethod?: null | string;
    requestedBonusKopecks?: null | number;
};

export type KpiValueDto = {
    value: number;
    ratio: number;
    deltaPct: number;
    comparedTo: string;
};

export enum LateBurnedSharePolicy {
    REFUND = 'refund',
    SETTLE_DEBT = 'settleDebt'
}

export type LeaderboardEntryDto = {
    rank: number;
    clientId?: null | string;
    points: number;
    wins: number;
    losses: number;
    matchesPlayed: number;
    pointsScored: number;
    pointsConceded: number;
    pointDifference: number;
    isMe: boolean;
};

export type LeaderboardResponse = {
    tournamentId: string;
    leaderboard: Array<LeaderboardEntryDto>;
    participantNames: Array<ParticipantNameDto>;
};

export type LeaderboardRowDto = {
    rank: number;
    clientId?: null | string;
    points: number;
    wins: number;
    losses: number;
    matchesPlayed: number;
    pointsScored: number;
    pointsConceded: number;
    pointDifference: number;
    prizeKopecks?: null | number;
    isMe: boolean;
};

export type LeaveOpenMatchResponse = {
    refundedKopecks: number;
    refundPercent: number;
};

export type LeaveSplitSeatResponse = {
    splitId: string;
    freeSpots: number;
};

export type LevelBandBody = {
    min?: null | number;
    max?: null | number;
};

export type LevelRangeDto = {
    min: number;
    max: number;
};

export type LimitBody = {
    monthlyLimitKopecks: number;
};

export type LinkChildAtDeskRequest = {
    phone?: null | string;
    allowedCategories?: null | ChildCategoriesDto;
};

export type ListActivityResponse = {
    items: Array<ActivityEntryDto>;
    total: number;
};

export type ListAuditEventsResponse = {
    items: Array<AuditEventDto>;
    nextCursor?: null | string;
};

export type ListBookingsResponse = {
    items: Array<BookingListItemDto>;
    total: number;
    page: number;
    pageSize: number;
};

export type ListClientsResponse = {
    items: Array<ClientListItemDto>;
    total: number;
    page: number;
    pageSize: number;
};

export type ListExpensesResponse = {
    items: Array<ExpenseListItemDto>;
    total: number;
    totalAmountKopecks: number;
};

export type ListMyDevicesResponse = {
    items: Array<DeviceListItemDto>;
};

export type ListOpenMatchesAdminResponse = {
    items: Array<AdminOpenMatchSummaryDto>;
    total: number;
    page: number;
    pageSize: number;
};

export type ListOpenMatchesResponse = {
    items: Array<OpenMatchSummaryDto>;
};

export type ListRefundObligationsResponse = {
    items: Array<RefundObligationDto>;
    totalOwedKopecks: number;
};

export type ListRefundsResponse = {
    items: Array<RefundListItemDto>;
    total: number;
};

export type ListSettingsAuditResponse = {
    items: Array<SettingsAuditDto>;
};

export type ListTournamentsResponse = {
    items: Array<TournamentSummary>;
};

export type ListTrainersResponse = {
    items: Array<TrainerListItemDto>;
    total: number;
};

export type ListUsersResponse = {
    items: Array<UserListItemDto>;
};

export type LoginByEmailCommand = {
    email: string;
    password: string;
    tenantSlug?: null | string;
    audience?: null | SessionAudience;
};

export type LoginChallengeResponse = {
    challengeId: string;
    channel: LoginCodeChannel;
    phoneLastDigits?: null | string;
    emailHint?: null | string;
    expiresInSeconds: number;
};

export enum LoginCodeChannel {
    SMS = 'sms',
    EMAIL = 'email'
}

export type LogoutRequest = {
    refreshToken?: null | string;
};

export type LoyaltyOverviewResponse = {
    totalSubscriptionsActive: number;
    totalSubscriptionsSold: number;
    totalCardCategories: number;
    totalBonusBalanceKopecks: number;
    totalDepositBalanceKopecks: number;
    totalPromocodesActive: number;
    totalRedemptionsLast30d: number;
    topSubscriptionTemplates: Array<TopSubscriptionTemplateDto>;
    recentTransactions: Array<RecentBonusTransactionDto>;
};

export type LtvBucket = {
    label: string;
    fromKopecks: number;
    toKopecks: number;
    count: number;
};

export type ManualPassPayload = {
    clientId: string;
    zoneId: string;
    reason: string;
    spendVisit?: null | boolean;
};

export type MarkMyBusyTimeBody = {
    date: string;
    startMin: number;
    endMin: number;
    reason: TrainerBusyReason;
    comment?: null | string;
};

export type MarkReadBody = {
    uptoSeq: number;
};

export type MarkTournamentAttendanceBody = {
    attendance: TournamentAttendance;
};

export type MarkTournamentAttendanceResponse = {
    registrationId: string;
    attendance: TournamentAttendance;
    ratingPenalty: NoShowPenaltyOutcome;
};

export type MarketingConsent = {
    version: string;
    text: string;
    granted: boolean;
};

export enum MatchConfirmation {
    PENDING = 'pending',
    CONFIRMED = 'confirmed',
    DISPUTED = 'disputed'
}

export type MatchCourtRunDto = {
    courtId: string;
    courtName: string;
    startsAt: string;
    durationMinutes: number;
};

export type MatchDto = {
    id: string;
    roundId: string;
    roundNumber: number;
    resourceId: string;
    team1: Array<null | string>;
    team2: Array<null | string>;
    status: MatchStatus;
    team1Points?: null | number;
    team2Points?: null | number;
    scheduledAt: string;
    startedAt?: null | string;
    completedAt?: null | string;
    sets: Array<TennisSetScore>;
    isMine: boolean;
    hasNoShow: boolean;
};

export type MatchLeaderboardEntry = {
    rank: number;
    clientId: string;
    points: number;
    wins: number;
    losses: number;
    matchesPlayed: number;
    pointsScored: number;
    pointsConceded: number;
    pointDifference: number;
};

export type MatchParticipantDto = {
    clientId: string;
    team: number;
    confirmation: MatchConfirmation;
    isMe: boolean;
    name?: null | string;
};

export type MatchSlotRunPayload = {
    courtId: string;
    scheduledAt: string;
    durationMinutes: number;
};

export enum MatchStatus {
    PENDING = 'pending',
    COMPLETED = 'completed'
}

export type MediaDescription = {
    id: string;
    kind: MediaKind;
    width: number;
    height: number;
    variants: Array<MediaVariant>;
    thumbHash: string;
};

export enum MediaKind {
    IMAGE = 'image'
}

export type MediaVariant = {
    width: number;
    height: number;
    url: string;
};

export type MembershipCardDto = {
    memberId: string;
    name: string;
    avatarUrl: string;
    category: string;
    categoryLabel: string;
    gradientFrom: string;
    gradientTo: string;
    depositBalanceKopecks: number;
    issuedAt?: null | string;
    validUntil?: null | string;
    status?: null | MembershipCardStatus;
    isActive: boolean;
    keepCategoryBy?: null | string;
    keepCategoryShortfallKopecks?: null | number;
    perks: CardCategoryPerks;
    next?: null | CardCategoryNext;
    isTopCategory: boolean;
    categoryEnabled: boolean;
};

export type MembershipCardPatchPayload = {
    action: string;
    validUntil?: null | string;
};

export enum MembershipCardStatus {
    ACTIVE = 'active',
    BLOCKED = 'blocked',
    EXPIRED = 'expired'
}

export type MembershipCardStatusDto = {
    clientId: string;
    issuedAt: string;
    validUntil?: null | string;
    status: MembershipCardStatus;
    priceKopecks: number;
    isActive: boolean;
};

export enum MessageChannel {
    PUSH = 'push',
    EMAIL = 'email',
    SMS = 'sms',
    TELEGRAM = 'telegram',
    MAX = 'max'
}

export type MobileGuestRequest = {
    firstName: string;
    lastName: string;
    phone?: null | string;
    documentId?: null | string;
    birthDate?: null | string;
    note?: null | string;
};

export type MyAccessEventDto = {
    id: string;
    zoneName?: null | string;
    decision: AccessDecisionType;
    denialReason?: null | string;
    method: AccessMethod;
    direction?: null | AccessDirection;
    bookingId?: null | string;
    occurredAt: string;
    grantBasis?: null | AccessGrantBasis;
};

export type MyAchievementsResponse = {
    unlocked: Array<AchievementDto>;
    nextGoal?: null | NextGoalDto;
};

export type MyActivityResponse = {
    items: Array<ActivityItemDto>;
};

export type MyAwaitingOrdersResponse = {
    items: Array<AwaitingOrderDto>;
};

export type MyBonusSpendDto = {
    maxPaymentPct: number;
    categories: Array<BonusSpendCategory>;
};

export type MyBonusTransactionDto = {
    id: string;
    amountKopecks: number;
    kind: BonusTransactionKind;
    bookingId?: null | string;
    expiresAt?: null | string;
    createdAt: string;
    clientMessage?: null | string;
};

export type MyBonusesResponse = {
    balanceKopecks: number;
    expiresAt?: null | string;
    recent: Array<MyBonusTransactionDto>;
    nearestExpiry?: null | BonusExpiryDto;
    expiringSoonKopecks: number;
    expiryWarningDays: number;
    expiryBuckets: Array<BonusExpiryDto>;
    expiryBucketsTruncated: boolean;
    noExpiryKopecks: number;
    inactivityBurnOn?: null | string;
};

export type MyBookingWindowResponse = {
    horizonDays: number;
    lastBookableDate: string;
    source: string;
    tierLabel?: null | string;
    parallelCourts: number;
};

export enum MyBookingsBucket {
    UPCOMING = 'upcoming',
    PAST = 'past',
    CANCELLED = 'cancelled'
}

export type MyBusyTimeMarkedDto = {
    interval: TrainerBusyIntervalDto;
    affectedCount: number;
    notice?: null | string;
};

export type MyContactsResponse = {
    signedOut: boolean;
};

export type MyConversationResponse = {
    conversation?: null | ConversationDto;
};

export type MyOrdersResponse = {
    items: Array<OrderDto>;
};

export type MyOverviewResponse = {
    identity: OverviewIdentity;
    balances: OverviewBalances;
    activity: OverviewActivity;
    ratings: Array<OverviewSportRating>;
    recentTournaments: Array<OverviewTournament>;
};

export type MyProfileResponse = {
    clientId: string;
    memberNumber: string;
    firstName: string;
    lastName: string;
    patronymic: string;
    birthDate?: null | string;
    avatarUrl: string;
    profileCompleted: boolean;
    gender?: null | ClientGender;
};

export type MySalaryPeriodDto = {
    id: string;
    startDate: string;
    endDate: string;
    status: SalaryPeriodStatus;
    approvedAt?: null | string;
    totalSalaryKopecks: number;
};

export type MyScheduleOverrideDto = {
    date: string;
    available: boolean;
    startTime?: null | string;
    endTime?: null | string;
    reason?: null | string;
    intervals: Array<ScheduleInterval>;
    version?: null | string;
};

export type MyScheduleTemplateDto = {
    weeklyEntries: Array<WeeklyScheduleEntry>;
    overrides: Array<MyScheduleOverrideDto>;
    templateVersion?: null | string;
};

export type MySplitDebtResponse = {
    total: number;
    debts: Array<SplitDebtItem>;
};

export type MySubscriptionDto = {
    id: string;
    name: string;
    sport?: null | SportType;
    sessionsTotal: number;
    sessionsRemaining: number;
    purchasedAt: string;
    expiresAt: string;
    status: string;
    direction: ActivityDirection;
    kind: SubscriptionKind;
    scope: SubscriptionScope;
    availableVisits: number;
    trainerId?: null | string;
    freezeDaysAllowed: number;
    freezeDaysLeft: number;
    pausedUntil?: null | string;
};

export type MySubscriptionsResponse = {
    items: Array<MySubscriptionDto>;
};

export type MyTenantDto = {
    tenantId: string;
    slug: string;
    name: string;
    role: string;
    isOwner: boolean;
    status: string;
};

export type MyTournamentResultDto = {
    clientId: string;
    rank?: null | number;
    totalParticipants: number;
    points: number;
    wins: number;
    losses: number;
    pointDifference: number;
    prizeKopecks?: null | number;
    prizeDestination?: null | PrizeDestination;
    ratingMuBefore?: null | number;
    ratingMuAfter?: null | number;
    ratingPointsBefore?: null | number;
    ratingPointsAfter?: null | number;
    ratingPlacement?: null | number;
};

export type MyTrainerDto = {
    id: string;
    tenantId: string;
    firstName: string;
    lastName: string;
    sports: Array<string>;
    ratingAvg: number;
    ratingCount: number;
    yearsExperience: number;
    bio?: null | string;
    baseSalaryKopecks: number;
    individualRateKopecks: number;
    groupRateKopecks: number;
    groupSplit2RateKopecks: number;
    groupSplit3RateKopecks: number;
    groupSplit4RateKopecks: number;
    gameRateKopecks: number;
    assignedPlaceIds: Array<string>;
    avatarUrl?: null | string;
    sessionsLast30: number;
    sessionsNext7: number;
    hoursLast30: number;
    revenueLast30Kopecks: number;
    salaryModel: SalaryModelDto;
    weeklySchedule: Array<WeeklyScheduleEntry>;
    vacationDays: Array<string>;
    isActive: boolean;
    upcomingNext: Array<UpcomingSessionDto>;
    assignedCourts: Array<AssignedCourtDto>;
    methodology?: null | string;
    audiences: Array<TrainerAudience>;
    canEditOwnSchedule: boolean;
    canOpenOwnHours: boolean;
};

export type MyWaitlistPlaceDto = {
    onWaitlist: boolean;
    status?: null | WaitlistStatus;
    position: number;
    queueLength: number;
    depth: number;
    offerExpiresAt?: null | string;
};

export enum NewsAction {
    NONE = 'none',
    BOOK_COURT = 'bookCourt',
    JOIN_TOURNAMENT = 'joinTournament',
    JOIN_MATCH = 'joinMatch',
    JOIN_GROUP_SESSION = 'joinGroupSession'
}

export type NewsAdminDto = {
    id: string;
    title: string;
    excerpt: string;
    body: string;
    status: NewsStatus;
    publishedAt?: null | string;
    archivedAt?: null | string;
    isFeatured: boolean;
    featuredUntil?: null | string;
    coverMediaId?: null | string;
    coverFocusX?: null | number;
    coverFocusY?: null | number;
    action: NewsAction;
    actionTargetId?: null | string;
    createdAt: string;
    cover?: null | MediaDescription;
    kind: NewsKind;
    audience: NewsAudience;
    topic?: null | string;
    pinnedUntil?: null | string;
    requiresAck: boolean;
    reviewState: NewsReview;
    proposedByUserId?: null | string;
};

export enum NewsAudience {
    CLIENTS = 'clients',
    STAFF = 'staff',
    ALL = 'all'
}

export type NewsContentInput = {
    title: string;
    excerpt?: null | string;
    body?: null | string;
    coverMediaId?: null | string;
    coverFocusX?: null | number;
    coverFocusY?: null | number;
    action?: null | NewsAction;
    actionTargetId?: null | string;
    kind?: null | NewsKind;
    audience?: null | NewsAudience;
    topic?: null | string;
    pinnedUntil?: null | string;
    requiresAck?: null | boolean;
};

export type NewsCoverDto = {
    variants: Array<NewsCoverVariantDto>;
    thumbHash: string;
    width: number;
    height: number;
    focusX: number;
    focusY: number;
};

export type NewsCoverVariantDto = {
    width: number;
    height: number;
    url: string;
};

export type NewsFeedPage = {
    items: Array<NewsItemDto>;
    nextCursor?: null | string;
};

export type NewsItemDto = {
    id: string;
    title: string;
    excerpt: string;
    imageUrl?: null | string;
    publishedAt: string;
    body?: null | string;
    isFeatured: boolean;
    cover?: null | NewsCoverDto;
    action: ClubNewsAction;
    actionRoute?: null | string;
};

export enum NewsKind {
    NEWS = 'news',
    ANNOUNCEMENT = 'announcement',
    ARTICLE = 'article'
}

export type NewsListResponse = {
    items: Array<NewsAdminDto>;
};

export enum NewsReview {
    NONE = 'none',
    PROPOSED = 'proposed',
    REJECTED = 'rejected'
}

export enum NewsStatus {
    DRAFT = 'draft',
    SCHEDULED = 'scheduled',
    PUBLISHED = 'published',
    ARCHIVED = 'archived'
}

export type NextGoalDto = {
    code: string;
    label: string;
    icon: string;
    rarity: string;
    hint: string;
    current: number;
    target: number;
};

export enum NoShowPenaltyOutcome {
    APPLIED = 'applied',
    ALREADY_APPLIED = 'alreadyApplied',
    LIFTED = 'lifted',
    NOTHING_TO_LIFT = 'nothingToLift',
    NOT_PENALISED = 'notPenalised'
}

export enum NotificationCategory {
    BOOKING = 'booking',
    PAYMENT = 'payment',
    SYSTEM = 'system',
    MARKETING = 'marketing',
    REMINDER = 'reminder',
    SOCIAL = 'social',
    MATCHES = 'matches'
}

export type NotificationCategoryPreferenceDto = {
    category: NotificationCategory;
    clientCanDisable: boolean;
    muted: boolean;
};

export type NotificationCategoryRuleDto = {
    category: NotificationCategory;
    clientCanDisable: boolean;
    clubMayChoose: boolean;
};

export enum NotificationChannel {
    IN_APP = 'inApp',
    PUSH = 'push',
    EMAIL = 'email',
    SMS = 'sms',
    TELEGRAM = 'telegram'
}

export type NotificationDto = {
    id: string;
    userId: string;
    title: string;
    body: string;
    category: NotificationCategory;
    isRead: boolean;
    actionUrl?: null | string;
    imageUrl?: null | string;
    createdAt: string;
    readAt?: null | string;
};

export type NotificationPolicyDto = {
    categories: Array<NotificationCategoryRuleDto>;
    quietHoursEnabled: boolean;
    quietHoursFrom: string;
    quietHoursTo: string;
};

export type NotificationTemplateDto = {
    id: string;
    eventType: string;
    channel: NotificationChannel;
    locale: string;
    titleTemplate: string;
    bodyTemplate: string;
    htmlBodyTemplate?: null | string;
    variables: Array<string>;
    isCustomized: boolean;
};

export enum ObligationFund {
    BONUS = 'bonus',
    ADVANCE = 'advance'
}

export type OccupancyHeatmapResponse = {
    fromHour: number;
    toHour: number;
    maxMinutes: number;
    cells: Array<HeatCellDto>;
};

export type OccupancyResponse = {
    zones: Array<ZoneOccupancyDto>;
    totalInClub: number;
};

export type OccupancySummaryResponse = {
    totalInFitnessZones: number;
    totalCapacity?: null | number;
};

export type OffScheduleEventDto = {
    id: string;
    kind: TrainerCalendarEventKind;
    date: string;
    startMin: number;
    endMin: number;
    reason: TrainerOffScheduleReason;
    title?: null | string;
    courtName?: null | string;
};

export type OffScheduleReport = {
    newly: Array<OffScheduleEventDto>;
    newlyCount: number;
    totalCount: number;
    hasMore: boolean;
};

export enum OnlineReceiptAttention {
    LATE = 'late',
    NO_REQUISITES = 'noRequisites',
    REFUSED = 'refused',
    UNKNOWN = 'unknown',
    NOT_ISSUED = 'notIssued'
}

export type OnlineReceiptAttentionDto = {
    paymentId: string;
    kind: OnlineReceiptKind;
    refundId?: null | string;
    clientId: string;
    clientName?: null | string;
    amountKopecks: number;
    requestedAt: string;
    attention: OnlineReceiptAttention;
    text?: null | string;
    canReissue: boolean;
    reissueCount: number;
};

export enum OnlineReceiptKind {
    INCOME = 'income',
    INCOME_RETURN = 'incomeReturn'
}

export type OnlineReceiptReissuedDto = {
    paymentId: string;
    reissueCount: number;
};

export type OpenDirectRoomBody = {
    peerClientId: string;
};

export type OpenMatchDetailDto = {
    id: string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sport: string;
    courtId: string;
    courtName: string;
    scheduledAt: string;
    durationMinutes: number;
    totalSpots: number;
    joinedCount: number;
    spotsLeft: number;
    minLevel?: null | number;
    maxLevel?: null | number;
    comment?: null | string;
    status: OpenMatchStatus;
    organizerId: string;
    participants: Array<OpenMatchParticipantDto>;
    isMine: boolean;
    isIndoor: boolean;
    cancelledAt?: null | string;
    courtRuns?: null | Array<MatchCourtRunDto>;
    seatPriceKopecks?: null | number;
    fromYourPartnerRequest: boolean;
};

export type OpenMatchParticipantDto = {
    clientId: string;
    name: string;
    rating: number;
    isOrganizer: boolean;
    isMe: boolean;
    reliabilityPct?: null | number;
    isUnreliable?: null | boolean;
    attendance?: null | ParticipantAttendanceStatus;
};

export enum OpenMatchStatus {
    OPEN = 'open',
    FULL = 'full',
    CANCELLED = 'cancelled',
    COMPLETED = 'completed'
}

export type OpenMatchSummaryDto = {
    id: string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sport: string;
    courtId: string;
    courtName: string;
    scheduledAt: string;
    durationMinutes: number;
    totalSpots: number;
    joinedCount: number;
    spotsLeft: number;
    minLevel?: null | number;
    maxLevel?: null | number;
    comment?: null | string;
    status: OpenMatchStatus;
    organizerId: string;
    organizerName: string;
    organizerRating: number;
    isIndoor: boolean;
    isJoined: boolean;
    isMine: boolean;
};

export type OpenShiftPayload = {
    openingFloat?: null | number;
};

export type OpponentCardDto = {
    clientId: string;
    name: string;
    avatarUrl: string;
};

export type OrderAddonInput = {
    productId: string;
    quantity: number;
};

export type OrderCheckoutLineDto = {
    bookingId: string;
    priceKopecks: number;
    status: OrderLineStatus;
    holdExpiresAt?: null | string;
    awaitsTheTill: boolean;
};

export type OrderCheckoutLinePayload = {
    courtId: string;
    date: string;
    startTime: string;
    durationMinutes: number;
    trainerId?: null | string;
    bookingKey: string;
    addons?: null | Array<OrderAddonInput>;
    useSubscriptionId?: null | string;
    adminComment?: null | string;
    openTrainerHours?: TrainerHoursOpening;
    people?: number;
    clientWish?: null | string;
};

export type OrderCheckoutPayload = {
    lines: Array<OrderCheckoutLinePayload>;
    useBonuses: boolean;
    useDeposit: boolean;
    method: PaymentMethod;
    idempotencyKey: string;
    returnUrl?: null | string;
    clientId?: null | string;
    promocode?: null | string;
    requestedBonusKopecks?: null | number;
    settlement?: null | CheckoutSettlement;
    guestId?: null | string;
    holdFor?: null | OrderHoldChoice;
};

export type OrderCheckoutResponse = {
    orderId?: null | string;
    status?: null | OrderStatus;
    totalKopecks: number;
    bonusDebitKopecks: number;
    advanceDebitKopecks: number;
    payableKopecks: number;
    paymentId?: null | string;
    redirectUrl?: null | string;
    lines: Array<OrderCheckoutLineDto>;
    payBy?: null | string;
};

export type OrderDto = {
    orderId: string;
    status: OrderStatus;
    paidAtCheckoutKopecks: number;
    bonusDebitKopecks: number;
    advanceDebitKopecks: number;
    payableKopecks: number;
    createdAt: string;
    paidAt?: null | string;
    lines: Array<OrderLineDto>;
};

export enum OrderHoldChoice {
    TEN_MINUTES = 'tenMinutes',
    ONE_HOUR = 'oneHour',
    THREE_HOURS = 'threeHours',
    ONE_DAY = 'oneDay',
    THREE_DAYS = 'threeDays',
    UNTIL_START = 'untilStart'
}

export type OrderLineDto = {
    bookingId: string;
    priceKopecks: number;
    status: OrderLineStatus;
};

export enum OrderLineStatus {
    RESERVED = 'reserved',
    CONFIRMED = 'confirmed',
    CANCELLED = 'cancelled',
    AWAITING_PARENT = 'awaitingParent',
    WITHDRAWN = 'withdrawn'
}

export enum OrderStatus {
    AWAITING_PAYMENT = 'awaitingPayment',
    PAID = 'paid',
    CANCELLED = 'cancelled',
    EXPIRED = 'expired'
}

export type OrganizationAdminDto = {
    userId: string;
    email: string;
    grantedAt: string;
};

export type OrganizationBalanceDto = {
    id: string;
    balanceKopecks: number;
};

export type OrganizationDetailDto = {
    id: string;
    name: string;
    legalName?: null | string;
    inn?: null | string;
    kpp?: null | string;
    contactEmail?: null | string;
    contactPhone?: null | string;
    balanceKopecks: number;
    isActive: boolean;
    activeEmployees: number;
    createdAt: string;
    ogrn?: null | string;
    legalAddress?: null | string;
    postalAddress?: null | string;
    bankName?: null | string;
    bik?: null | string;
    settlementAccount?: null | string;
    correspondentAccount?: null | string;
    contactPersonName?: null | string;
    contactPersonPosition?: null | string;
    invoiceEmail?: null | string;
    contractNumber?: null | string;
    contractDate?: null | string;
    vatMode?: null | OrganizationVatMode;
    paymentTermDays?: null | number;
};

export type OrganizationEmployeeDto = {
    memberId: string;
    clientId: string;
    firstName: string;
    lastName: string;
    status: string;
    monthlyLimitKopecks: number;
    currentPeriodSpentKopecks: number;
};

export type OrganizationListItemDto = {
    id: string;
    name: string;
    balanceKopecks: number;
    isActive: boolean;
    activeEmployees: number;
};

export enum OrganizationMemberStatus {
    ACTIVE = 'active',
    SUSPENDED = 'suspended'
}

export type OrganizationTransactionDto = {
    id: string;
    type: string;
    amountKopecks: number;
    balanceAfterKopecks: number;
    memberClientId?: null | string;
    referenceType?: null | OrganizationTransactionReference;
    referenceId?: null | string;
    description: string;
    createdAt: string;
};

export enum OrganizationTransactionReference {
    BOOKING = 'booking',
    CHARGE = 'charge',
    SALE = 'sale'
}

export enum OrganizationVatMode {
    NONE = 'none',
    RATE0 = 'rate0',
    RATE5 = 'rate5',
    RATE7 = 'rate7',
    RATE10 = 'rate10',
    RATE20 = 'rate20'
}

export type OrganizerSharePlanDto = {
    totalKopecks: number;
    seatPriceKopecks: number;
    share: SplitSharePlanDto;
    deadlineAt: string;
    freezeKopecks: number;
};

export type OutboxDeadLetterDto = {
    id: string;
    eventType: string;
    retryCount: number;
    error?: null | string;
    tenantId?: null | string;
    createdAt: string;
    deadLetteredAt: string;
};

export type OutboxDeadLettersResponse = {
    items: Array<OutboxDeadLetterDto>;
    total: number;
};

export type OutstandingDefaultedSplitDto = {
    splitId: string;
    bookingId: string;
    amountKopecks: number;
    defaultedAt: string;
    bookingLabel?: null | string;
};

export type OutstandingSeatDto = {
    participantId: string;
    sessionId: string;
    clientId: string;
    clientName: string;
    sessionTitle: string;
    date: string;
    startTime: string;
    amountKopecks: number;
    onlineLinkSent: boolean;
};

export type OutstandingSeatsResponse = {
    items: Array<OutstandingSeatDto>;
};

export type OutstandingSurchargeDto = {
    paymentId: string;
    clientId: string;
    clientName: string;
    bookingId?: null | string;
    amountKopecks: number;
    onlineLinkSent: boolean;
};

export type OutstandingSurchargesResponse = {
    items: Array<OutstandingSurchargeDto>;
};

export type OutstandingTournamentEntriesResponse = {
    items: Array<OutstandingTournamentEntryDto>;
};

export type OutstandingTournamentEntryDto = {
    registrationId: string;
    tournamentId: string;
    clientId: string;
    clientName: string;
    tournamentTitle: string;
    startAt: string;
    amountKopecks: number;
    onlineLinkSent: boolean;
};

export type OverrideAttendancePayload = {
    clientId: string;
    attended: boolean;
};

export type OverviewActivity = {
    visits: number;
    ltv: number;
    totalMatches: number;
    totalWins: number;
    currentWinStreak: number;
    tournamentsPlayed: number;
    tournamentWins: number;
};

export type OverviewBalances = {
    depositKopecks: number;
    bonusKopecks: number;
    bonusExpiresAt?: null | string;
};

export type OverviewIdentity = {
    clientId: string;
    memberNumber: string;
    firstName: string;
    lastName: string;
    category: string;
    avatarUrl: string;
    birthDate?: null | string;
};

export type OverviewSportRating = {
    sport: string;
    level: number;
    levelLabel: string;
    ordinal: number;
    matchesPlayed: number;
    provisional: boolean;
};

export type OverviewTournament = {
    tournamentId: string;
    name: string;
    sport: string;
    placement: number;
    at: string;
};

export type OwnerReportSettingsBody = {
    shiftReportByMail?: null | boolean;
    dailySummaryByMail?: null | boolean;
    recipientRoles?: null | Array<string>;
};

export type OwnerReportSettingsDto = {
    shiftReportByMail: boolean;
    dailySummaryByMail: boolean;
    recipientRoles: Array<string>;
    nameableRoles: Array<string>;
    canEdit: boolean;
};

export type PagedListOfAccessEventDto = {
    items: Array<AccessEventDto>;
    totalCount: number;
    cursor?: null | string;
    hasMore: boolean;
};

export type PagedListOfBookingSummaryDto = {
    items: Array<BookingSummaryDto>;
    totalCount: number;
    cursor?: null | string;
    hasMore: boolean;
};

export type PagedListOfDepositTransactionDto = {
    items: Array<DepositTransactionDto>;
    totalCount: number;
    cursor?: null | string;
    hasMore: boolean;
};

export type PagedListOfMyAccessEventDto = {
    items: Array<MyAccessEventDto>;
    totalCount: number;
    cursor?: null | string;
    hasMore: boolean;
};

export type PagedListOfNotificationDto = {
    items: Array<NotificationDto>;
    totalCount: number;
    cursor?: null | string;
    hasMore: boolean;
};

export type PagedListOfWalletTopupDto = {
    items: Array<WalletTopupDto>;
    totalCount: number;
    cursor?: null | string;
    hasMore: boolean;
};

export enum ParticipantAttendanceStatus {
    PENDING = 'pending',
    ATTENDED = 'attended',
    NO_SHOW = 'noShow'
}

export type ParticipantNameDto = {
    clientId: string;
    displayName: string;
};

export enum ParticipantStatus {
    REGISTERED = 'registered',
    PAID = 'paid',
    CHECKED_IN = 'checkedIn',
    COMPLETED = 'completed',
    NO_SHOW = 'noShow',
    CANCELLED = 'cancelled'
}

export type PartnerRequestDto = {
    id: string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sport: string;
    windowFrom: string;
    windowTo: string;
    durationMinutes: number;
    totalSpots: number;
    levelMin?: null | number;
    levelMax?: null | number;
    state: PartnerRequestState;
    authorClientId: string;
    authorName: string;
    isMine: boolean;
    isFriend: boolean;
    note?: null | string;
    matchId?: null | string;
};

export type PartnerRequestRespondedResponse = {
    matchId: string;
};

export enum PartnerRequestState {
    OPEN = 'open',
    MATCHED = 'matched',
    WITHDRAWN = 'withdrawn',
    EXPIRED = 'expired'
}

export type PartnerRequestsCountResponse = {
    count: number;
};

export type PartnerRequestsResponse = {
    items: Array<PartnerRequestDto>;
};

export type PatchBonusProgramPayload = {
    enabled?: null | boolean;
    registrationBonusKopecks?: null | number;
    validityDays?: null | number;
    clearValidity?: null | boolean;
    expiryWarningDays?: null | number;
    inactivityBurnDays?: null | number;
    clearInactivityBurn?: null | boolean;
    inactivityCounts?: null | BonusActivityCounts;
};

export type PatchPaymentProviderBody = {
    enabled?: null | boolean;
    credentials?: null | {
        [key: string]: string;
    };
    handlesCards?: null | boolean;
    handlesSbp?: null | boolean;
    cardFeePct?: null | number;
    sbpFeePct?: null | number;
};

export type PayChargeFromAdvanceResponse = {
    paymentId: string;
    status: string;
};

export type PayChargeFromCorporateResponse = {
    paymentId: string;
    status: string;
};

export type PayExpenseBody = {
    paymentReference?: null | string;
};

export type PayOrderPayload = {
    method: PaymentMethod;
    returnUrl?: null | string;
};

export type PayOrderResponse = {
    orderId: string;
    paymentId: string;
    redirectUrl?: null | string;
};

export type PaySplitDebtResponse = {
    splitId: string;
    paidKopecks: number;
};

export type PaySplitRemainderResponse = {
    splitId: string;
    paidKopecks: number;
};

export type PaySplitSharePayload = {
    method: string;
    forClientId?: null | string;
    requestedBonusKopecks?: null | number;
};

export type PaySplitShareResponse = {
    participantStatus: SplitParticipantStatus;
    remainingAwaiting: number;
    allPaid: boolean;
};

export type PaymentCredentialFieldDto = {
    key: string;
    label: string;
    secret: boolean;
    required: boolean;
    value?: null | string;
    filled: boolean;
};

export type PaymentDetailDto = {
    id: string;
    bookingId?: null | string;
    clientId: string;
    amountKopecks: number;
    currency: string;
    method: PaymentMethod;
    status: PaymentStatus;
    providerType: ProviderType;
    refundedAmountKopecks: number;
    createdAt: string;
};

export type PaymentIncidentDto = {
    id: string;
    tenantId: string;
    invoiceId?: null | string;
    documentNumber?: null | string;
    kind: string;
    method: string;
    providerRef?: null | string;
    amountKopecks: number;
    code: string;
    createdAt: string;
    resolvedAt?: null | string;
    resolution?: null | string;
    note?: null | string;
};

export type PaymentIncidentsDto = {
    items: Array<PaymentIncidentDto>;
};

export enum PaymentMethod {
    CARD_ONLINE = 'cardOnline',
    SBP_ONLINE = 'sbpOnline',
    DEPOSIT = 'deposit',
    CASH = 'cash',
    CORPORATE_ACCOUNT = 'corporateAccount'
}

export type PaymentProviderDto = {
    provider: string;
    displayName: string;
    enabled: boolean;
    configured: boolean;
    handlesCards: boolean;
    handlesSbp: boolean;
    supportedMethods: Array<string>;
    fields: Array<PaymentCredentialFieldDto>;
    cardFeePct?: null | number;
    sbpFeePct?: null | number;
    webhookUrl?: null | string;
    legacyWebhookCount: number;
    legacyWebhookLastAt?: null | string;
    onlineReceiptsAvailable: boolean;
    onlineReceipts: boolean;
    taxationSystem?: null | string;
    receiptWebhookUrl?: null | string;
};

export enum PaymentPurpose {
    NONE = 'none',
    DEPOSIT_TOPUP = 'depositTopup',
    SUBSCRIPTION = 'subscription',
    TOURNAMENT_ENTRY = 'tournamentEntry',
    RESCHEDULE_SURCHARGE = 'rescheduleSurcharge',
    ORGANIZATION_TOPUP = 'organizationTopup',
    SPLIT_SHARE = 'splitShare',
    GROUP_SESSION_REGISTRATION = 'groupSessionRegistration',
    ORDER = 'order',
    SPLIT_DEBT = 'splitDebt',
    TRAINING_FORMAT_SWITCH = 'trainingFormatSwitch',
    SPLIT_REMAINDER = 'splitRemainder'
}

export enum PaymentStatus {
    PENDING = 'pending',
    PROCESSING = 'processing',
    COMPLETED = 'completed',
    FAILED = 'failed',
    REFUNDED = 'refunded',
    PARTIALLY_REFUNDED = 'partiallyRefunded',
    PENDING_APPROVAL = 'pendingApproval',
    CANCELLED = 'cancelled'
}

export type PayoutLineDto = {
    trainerId: string;
    firstName: string;
    lastName: string;
    lessonsCount: number;
    baseSalaryKopecks: number;
    bonusSalaryKopecks: number;
    deductionsKopecks: number;
    totalSalaryKopecks: number;
};

export type PayoutPeriodDto = {
    periodId: string;
    startDate: string;
    endDate: string;
    status: string;
    approvedAt?: null | string;
    totalKopecks: number;
    trainerCount: number;
    lines: Array<PayoutLineDto>;
};

export type PayoutsResponse = {
    totalKopecks: number;
    periodCount: number;
    hasMore: boolean;
    periods: Array<PayoutPeriodDto>;
};

export type PendingChargeDto = {
    paymentId: string;
    amountKopecks: number;
    purpose: PaymentPurpose;
    status: PaymentStatus;
    payUrl?: null | string;
    expiresAt?: null | string;
    payableFromAdvance: boolean;
    cancellableByClient: boolean;
};

export type PendingChargeListItem = {
    paymentId: string;
    amountKopecks: number;
    purpose: PaymentPurpose;
    purposeRefId?: null | string;
    payUrl?: null | string;
    createdAt: string;
    expiresAt?: null | string;
    payableFromAdvance: boolean;
    cancellableByClient: boolean;
};

export type PendingChargeResult = {
    paymentId: string;
    payUrl?: null | string;
};

export type PermissionCatalogueDto = {
    capabilities: Array<CapabilityCatalogueEntryDto>;
    permissions: Array<PermissionCatalogueEntryDto>;
};

export type PermissionCatalogueEntryDto = {
    code: string;
    label: string;
    group: string;
};

export type PersonalTrainingBookedResponse = {
    sessionId: string;
    participantId: string;
    priceKopecks: number;
    paidBySubscription: boolean;
};

export enum PersonalTrainingPayer {
    MONEY = 'money',
    PACKAGE = 'package',
    CHOOSE = 'choose'
}

export type PersonalTrainingPlaceDto = {
    id: string;
    name: string;
    isShared: boolean;
};

export type PersonalTrainingQuotePackage = {
    subscriptionId: string;
    subscriptionName: string;
    remainingVisits?: null | number;
};

export type PersonalTrainingQuoteResponse = {
    priceKopecks: number;
    payer: PersonalTrainingPayer;
    subscriptionId?: null | string;
    subscriptionName?: null | string;
    remainingVisits?: null | number;
    packages: Array<PersonalTrainingQuotePackage>;
};

export type PersonalTrainingSlotDto = {
    startTime: string;
    endTime: string;
};

export type PersonalTrainingSlotsResponse = {
    trainerId: string;
    date: string;
    durationMinutes: number;
    priceKopecks: number;
    places: Array<PersonalTrainingPlaceDto>;
    slots: Array<PersonalTrainingSlotDto>;
};

export type PlaceDto = {
    id: string;
    name: string;
    type: ResourceType;
    capacity?: null | number;
    isIndoor: boolean;
    isActive: boolean;
    sortOrder: number;
};

export type PlanLimitDto = {
    key: string;
    limit: number;
};

export type PlanOpenMatchPayload = {
    sport: string;
    runs: Array<MatchSlotRunPayload>;
    totalSpots: number;
    bonusKopecks?: null | number;
};

export type PlanTournamentBody = {
    format: TournamentFormat;
    scoring: ScoringMode;
    pointsTarget?: null | number;
    participants: number;
    fixedTeams?: boolean;
};

export enum PlanUnitKind {
    PLAYER = 'player',
    PAIR = 'pair'
}

export type PlatformAcquiringDto = {
    enabled: boolean;
    cardProvider: string;
    tBankTerminalKey?: null | string;
    tBankPasswordFilled: boolean;
    cloudPaymentsPublicId?: null | string;
    cloudPaymentsApiSecretFilled: boolean;
};

export type PlatformAuditEventDto = {
    id: string;
    occurredAt: string;
    actorId?: null | string;
    actorName: string;
    action: string;
    entityType: string;
    entityId: string;
    before?: null | string;
    after?: null | string;
};

export type PlatformAuditResponse = {
    items: Array<PlatformAuditEventDto>;
    nextCursor?: null | string;
};

export type PlatformDashboardDto = {
    totalClubs: number;
    byStatus: {
        [key: string]: number;
    };
    byPlan: {
        [key: string]: number;
    };
    newClubsTrend: Array<TrendPointDto>;
    expiringTrials: Array<ExpiringTrialDto>;
    needsAttention: Array<AttentionClubDto>;
    topClubs: Array<TopClubDto>;
};

export type PlatformPlanDto = {
    id: string;
    code: string;
    name: string;
    tagline?: null | string;
    monthlyPriceKopecks: number;
    courtsLimit: number;
    staffLimit: number;
    clientsLimit: number;
    bookingsPerMonthLimit: number;
    fitnessMembersLimit: number;
    courtsModule: boolean;
    fitnessModule: boolean;
    sortOrder: number;
    isPublic: boolean;
    isArchived: boolean;
    isSignupDefault: boolean;
    tenantCount: number;
    pendingOfferCount: number;
    version: number;
    lastChangeReason?: null | string;
    updatedAt: string;
};

export type PlatformPlanReasonRequest = {
    reason: string;
};

export type PlatformPlansDto = {
    items: Array<PlatformPlanDto>;
};

export type PlatformReceiptDto = {
    id: string;
    tenantId: string;
    invoiceId: string;
    documentNumber?: null | string;
    amountKopecks: number;
    status: string;
    kind: string;
    refusalText?: null | string;
    createdAt: string;
    resolvedAt?: null | string;
    resolution?: null | string;
    resolutionNote?: null | string;
};

export type PlatformReceiptsDto = {
    needResolution: Array<PlatformReceiptDto>;
    awaitingTheTill: Array<PlatformReceiptDto>;
};

export type PlatformRequisitesDto = {
    sellerLegalName?: null | string;
    sellerInn?: null | string;
    sellerKpp?: null | string;
    sellerLegalAddress?: null | string;
    bankName?: null | string;
    bankBik?: null | string;
    bankAccount?: null | string;
    bankCorrAccount?: null | string;
    vatRatePercent?: null | number;
    vatBasisText?: null | string;
    contractReference?: null | string;
    taxSystem?: null | string;
    paymentTermDays: number;
    transitAllowanceDays: number;
    updatedAt?: null | string;
};

export type PlayerRatingDto = {
    id: string;
    clientId: string;
    tournamentId: string;
    muBefore: number;
    sigmaBefore: number;
    muAfter: number;
    sigmaAfter: number;
    placement: number;
};

export type PnlByDirectionDto = {
    direction: string;
    kopecks: number;
    count: number;
};

export type PnlByMethodDto = {
    method: string;
    kopecks: number;
    count: number;
};

export type PnlClientSpendingDto = {
    spentMoneyKopecks: number;
    refundedMoneyKopecks: number;
    bonusAccruedKopecks: number;
    bonusRedeemedKopecks: number;
    onBookingsKopecks: number;
    onPosKopecks: number;
    onSessionsKopecks: number;
    onTournamentsKopecks: number;
};

export type PnlDoubleCountWarning = {
    category: string;
    calculatedKopecks: number;
    expenseKopecks: number;
};

export type PnlExpenseLine = {
    category: string;
    kopecks: number;
    count: number;
    origin: string;
};

export type PnlExpensesDto = {
    totalKopecks: number;
    acquiringKopecks: number;
    salaryKopecks: number;
    operationalKopecks: number;
    byCategory: Array<PnlExpenseLine>;
    doubleCountWarnings: Array<PnlDoubleCountWarning>;
    acquiringUnknownCount: number;
};

export type PnlReceiptsDto = {
    receivedKopecks: number;
    refundedKopecks: number;
    netKopecks: number;
    receiptCount: number;
    refundCount: number;
    byPaymentMethod: Array<PnlByMethodDto>;
    byDirection: Array<PnlByDirectionDto>;
};

export type PnlResponse = {
    from: string;
    to: string;
    receipts: PnlReceiptsDto;
    clientSpending: PnlClientSpendingDto;
    expenses: PnlExpensesDto;
    netProfitKopecks: number;
    marginPct: number;
};

export type PosCorporateEligibilityDto = {
    outcome: PosCorporateEligibilityOutcome;
    organizationName?: null | string;
    message?: null | string;
};

export enum PosCorporateEligibilityOutcome {
    ELIGIBLE = 'eligible',
    INSUFFICIENT_BALANCE = 'insufficientBalance',
    LIMIT_EXCEEDED = 'limitExceeded',
    MEMBER_SUSPENDED = 'memberSuspended',
    NOT_MEMBER = 'notMember'
}

export enum PosPaymentMethod {
    CASH = 'cash',
    CARD = 'card',
    SBP = 'sbp',
    DEPOSIT = 'deposit',
    BONUS = 'bonus',
    MIXED = 'mixed',
    ADVANCE = 'advance',
    CORPORATE_ACCOUNT = 'corporateAccount'
}

export type PrepareFiscalReceiptResponse = {
    state: FiscalReceiptStateDto;
    command?: null | FiscalCommandDto;
};

export type PreviewBlacklistImportQuery = {
    text: string;
};

export type PreviewNotificationAudienceRequest = {
    audience?: null | AudienceSpec;
    reason: AudienceReason;
    purpose?: AudiencePurpose;
};

export type PreviewPromocodeResponse = {
    eligible: boolean;
    reason?: null | string;
    discountKopecks: number;
    finalAmountKopecks: number;
    promocode?: null | PromocodePreviewDto;
};

export type PreviewResponse = {
    displayName: string;
    avatarUrl: string;
};

export type PreviewTrainerSalaryRequest = {
    from: string;
    to: string;
};

export type PricingPreviewAddonPayload = {
    productId: string;
    quantity: number;
};

export type PricingPreviewLinePayload = {
    courtId: string;
    date: string;
    startTime: string;
    durationMinutes: number;
    trainerId?: null | string;
    addons?: null | Array<PricingPreviewAddonPayload>;
    useSubscriptionId?: null | string;
    people?: number;
};

export type PricingPreviewLineResult = {
    courtId: string;
    baseKopecks: number;
    trainerKopecks: number;
    equipmentKopecks: number;
    cardDiscountKopecks: number;
    promoDiscountKopecks: number;
    coveredBySubscriptionKopecks: number;
    totalKopecks: number;
};

export type PricingPreviewPayload = {
    clientId?: null | string;
    durationMin?: null | number;
    trainerId?: null | string;
    promocode?: null | string;
    useBonuses?: null | boolean;
    useSubscriptionId?: null | string;
    addons?: null | Array<PricingPreviewAddonPayload>;
    courtId?: null | string;
    useDeposit?: null | boolean;
    requestedBonusKopecks?: null | number;
    courtIds?: null | Array<string>;
    lines?: null | Array<PricingPreviewLinePayload>;
};

export type PricingPreviewResponse = {
    basePrice: number;
    trainerPrice: number;
    cardDiscountAmount: number;
    promocodeDiscountAmount: number;
    subscriptionDiscountAmount: number;
    bonusDebitAmount: number;
    finalTotal: number;
    stages: Array<PricingPreviewStage>;
    promocodeError?: null | string;
    subscriptionError?: null | string;
    bonusError?: null | string;
    bonusMaxPaymentPct: number;
    bonusCapApplied: boolean;
    depositDebitAmount: number;
    leftToPay: number;
    bonusMaxRedeemableKopecks: number;
    cashbackKopecks: number;
    lines?: null | Array<PricingPreviewLineResult>;
};

export type PricingPreviewStage = {
    stage: string;
    delta: number;
    description: string;
};

export enum PrizeDestination {
    ADVANCE = 'advance',
    BONUS = 'bonus'
}

export type PrizePayout = {
    clientId: string;
    place: number;
    amountKopecks: number;
};

export type PrizeReversalDto = {
    clientId: string;
    reversedKopecks: number;
    debtKopecks: number;
};

export type PrizeShareBody = {
    place: number;
    percent: number;
};

export type PrizeShareDto = {
    place: number;
    percent: number;
};

export type PrizeShareInput = {
    place: number;
    percent: number;
};

export type ProblemDetails = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
};

export type ProductDto = {
    id: string;
    sku: string;
    name: string;
    kind: ProductKind;
    price: number;
    sport?: null | SportType;
    enabled: boolean;
    sortOrder: number;
    unit: string;
    subscriptionTemplateId?: null | string;
    includedInTraining: boolean;
    tillOnly: boolean;
};

export enum ProductKind {
    COURT_HOUR = 'courtHour',
    TRAINER_HOUR = 'trainerHour',
    SUBSCRIPTION = 'subscription',
    INVENTORY = 'inventory',
    SERVICE = 'service',
    ADVANCE_TOP_UP = 'advanceTopUp',
    RESCHEDULE_SURCHARGE = 'rescheduleSurcharge',
    GROUP_SESSION_SEAT = 'groupSessionSeat',
    SPLIT_SHARE = 'splitShare',
    TOURNAMENT_ENTRY = 'tournamentEntry'
}

export type ProductListResponse = {
    items: Array<ProductDto>;
};

export type ProfilePhotoResponse = {
    avatarUrl: string;
};

export type PromocodeAreaDto = {
    scope: AccrualScope;
    entries: Array<PromocodeAreaEntryDto>;
};

export type PromocodeAreaEntryDto = {
    targetKind: AccrualTargetKind;
    targetCategory?: null | BonusSpendCategory;
    targetId?: null | string;
    sportCode?: null | string;
    excluded: boolean;
};

export type PromocodeDto = {
    id: string;
    code: string;
    kind: PromocodeKind;
    amount: number;
    area: PromocodeAreaDto;
    validFrom: string;
    validUntil: string;
    maxRedemptions: number;
    redemptionsCount: number;
    minOrderAmount: number;
    enabled: boolean;
    status: PromocodeStatus;
    maxRedemptionsPerClient: number;
};

export enum PromocodeKind {
    PERCENT = 'percent',
    FLAT = 'flat'
}

export type PromocodeListResponse = {
    items: Array<PromocodeDto>;
    totalCount: number;
};

export type PromocodePreviewDto = {
    id: string;
    code: string;
    kind: PromocodeKind;
    amount: number;
    area: PromocodeAreaDto;
    validFrom: string;
    validUntil: string;
    maxRedemptions: number;
    redemptionsCount: number;
    minOrderAmount: number;
};

export type PromocodePreviewLine = {
    category: BonusSpendCategory;
    kopecks: number;
    courtId?: null | string;
    trainerId?: null | string;
};

export type PromocodePreviewPayload = {
    lines?: null | Array<PromocodePreviewLine>;
};

export type PromocodeRedemptionItemDto = {
    id: string;
    createdAt: string;
    subject: PromocodeRedemptionSubject;
    subjectId?: null | string;
    discountKopecks?: null | number;
    clientId?: null | string;
    clientFirstName?: null | string;
    clientLastName?: null | string;
    clientMemberPrefix?: null | string;
    clientMemberNumber?: null | string;
    releasedAt?: null | string;
};

export type PromocodeRedemptionListResponse = {
    items: Array<PromocodeRedemptionItemDto>;
    cursor?: null | string;
    hasMore: boolean;
};

export enum PromocodeRedemptionSubject {
    BOOKING = 'booking',
    ORDER = 'order',
    UNKNOWN = 'unknown'
}

export enum PromocodeStatus {
    ACTIVE = 'active',
    SCHEDULED = 'scheduled',
    EXPIRED = 'expired',
    EXHAUSTED = 'exhausted',
    DISABLED = 'disabled'
}

export enum PromocodeWithSubscription {
    NOT_APPLIED = 'notApplied',
    APPLIES_TO_THE_REST = 'appliesToTheRest'
}

export enum ProviderType {
    CLOUD_PAYMENTS = 'cloudPayments',
    DEPOSIT = 'deposit',
    MANUAL = 'manual',
    CORPORATE = 'corporate',
    T_BANK = 'tBank',
    SBER = 'sber',
    DEV_SANDBOX = 'devSandbox'
}

export type ProvisionBody = {
    email: string;
};

export type ProvisionOrgAdminResponse = {
    userId: string;
    email: string;
    inviteUrl: string;
};

export type PublicClubResponse = {
    slug: string;
    name: string;
};

export type PublishNewsBody = {
    at?: null | string;
    sendPush?: boolean;
};

export type PutTournamentNormsBody = {
    points?: null | Array<TournamentTargetNormInput>;
    games?: null | Array<TournamentTargetNormInput>;
    setMinutes?: null | number;
    changeoverMinutes?: null | number;
};

export type QrCodeResponse = {
    qrPayload: string;
    expiresAt: string;
    refreshIntervalSeconds: number;
};

export type RangeBookingDto = {
    id: string;
    courtId: string;
    courtName: string;
    courtSport?: null | SportType;
    trainerId?: null | string;
    startAt: string;
    endAt: string;
    status: BookingScheduleStatus;
    isTraining: boolean;
    isTournament: boolean;
    recurrenceId?: null | string;
    participantsCount: number;
    client?: null | ScheduleClientPart;
    money?: null | ScheduleMoneyPart;
    block?: null | ScheduleBlockPart;
    groupSessionId?: null | string;
    outsideTrainerHours?: null | TrainerOffScheduleReason;
    split?: null | BookingSplitSummary;
};

export type RangeCourtDto = {
    id: string;
    name: string;
    sport?: null | SportType;
    sortOrder: number;
    sportSortOrder: number;
    sportIcon?: null | string;
    sportColor?: null | string;
    placeType: ResourceType;
    sportTypes: Array<string>;
};

export type RatingHistoryPointDto = {
    sport: string;
    source: RatingSource;
    occurredAt: string;
    muAfter: number;
    levelAfter: number;
    won: boolean;
};

export type RatingLeaderboardEntryDto = {
    rank: number;
    clientId: string;
    name: string;
    avatarUrl: string;
    level: number;
    category: string;
    provisional: boolean;
    wins: number;
    losses: number;
    isMe: boolean;
};

export type RatingMatchDto = {
    id: string;
    sport: string;
    source: RatingSource;
    playedAt: string;
    team1Score: number;
    team2Score: number;
    status: RatingMatchStatus;
    submittedByClientId: string;
    needsMyConfirmation: boolean;
    competitive: boolean;
    participants: Array<MatchParticipantDto>;
    levelDelta?: null | number;
    disputedByClientId?: null | string;
    disputeReason?: null | string;
    confirmBy?: null | string;
};

export enum RatingMatchStatus {
    PENDING = 'pending',
    CONFIRMED = 'confirmed',
    DISPUTED = 'disputed',
    REJECTED = 'rejected'
}

export type RatingPolicyDto = {
    enabled: boolean;
    confirmationWindowHours: number;
    decayAfterDays: number;
    decaySigmaStep: number;
    tournamentNoShowPenaltyMu: number;
};

export type RatingPolicyPayload = {
    enabled?: null | boolean;
    confirmationWindowHours?: null | number;
    decayAfterDays?: null | number;
    decaySigmaStep?: null | number;
    tournamentNoShowPenaltyMu?: null | number;
};

export enum RatingSource {
    TOURNAMENT = 'tournament',
    OPEN_MATCH = 'openMatch',
    CASUAL = 'casual',
    TOURNAMENT_NO_SHOW = 'tournamentNoShow'
}

export type RealtimeReplayEvent = {
    id: string;
    topic: string;
    payload: {
        [key: string]: unknown;
    };
    occurredAt: string;
};

export type RealtimeReplayResponse = {
    events: Array<RealtimeReplayEvent>;
    cursor?: null | string;
    truncated: boolean;
    schemaVersion: number;
};

export type ReceiptFormDto = {
    receiptHeader: string;
    receiptFooter: string;
    legalName: string;
    inn: string;
};

export type RecentBonusTransactionDto = {
    id: string;
    clientId: string;
    amountKopecks: number;
    kind: BonusTransactionKind;
    createdAt: string;
};

export type RecordFiscalResultRequest = {
    answerToken: string;
    responseBody?: null | string;
    transportError?: null | string;
    serviceHttpStatus?: null | number;
};

export type RecordedMatchDto = {
    id: string;
    confirmBy: string;
};

export type RecurringConflict = {
    date: string;
    reason: string;
};

export type RedeemPayload = {
    bookingId?: null | string;
    idempotencyKey?: null | string;
};

export type RefreshTokenRequest = {
    token?: null | string;
    refreshToken?: null | string;
    value?: null | string;
};

export enum RefundDestination {
    ORIGINAL_METHOD = 'originalMethod',
    DEPOSIT = 'deposit',
    BONUS_BALANCE = 'bonusBalance',
    ORGANIZATION = 'organization'
}

export type RefundDetailDto = {
    id: string;
    paymentId?: null | string;
    saleId?: null | string;
    amountKopecks: number;
    reasonCode: RefundReason;
    note?: null | string;
    destination: RefundDestination;
    status: RefundStatus;
    providerRefundId?: null | string;
    processedBy: string;
    approvedBy?: null | string;
    approvedAt?: null | string;
    rejectedBy?: null | string;
    rejectedAt?: null | string;
    rejectionReason?: null | string;
    lines: Array<RefundLineDto>;
};

export enum RefundDisposition {
    DISCARD = 'discard',
    KEEP_ACCESS = 'keepAccess',
    REVOKE_ACCESS = 'revokeAccess'
}

export type RefundLineDto = {
    id: string;
    sourceSaleLineId?: null | string;
    sourceProductId?: null | string;
    productName: string;
    kind: RefundLineKind;
    quantity: number;
    amountKopecks: number;
    disposition: RefundDisposition;
    lineReason?: null | RefundReason;
    note?: null | string;
    linkedEntityId?: null | string;
};

export type RefundLineInput = {
    sourceSaleLineId?: null | string;
    sourceProductId?: null | string;
    quantity: number;
    amountKopecks: number;
    disposition: RefundDisposition;
    lineReason?: null | RefundReason;
    note?: null | string;
};

export enum RefundLineKind {
    INVENTORY = 'inventory',
    SERVICE = 'service',
    SUBSCRIPTION = 'subscription',
    COURT_HOUR = 'courtHour',
    TOURNAMENT_ENTRY = 'tournamentEntry',
    OTHER = 'other'
}

export type RefundListItemDto = {
    id: string;
    paymentId?: null | string;
    saleId?: null | string;
    amountKopecks: number;
    reasonCode: RefundReason;
    status: RefundStatus;
    destination: RefundDestination;
    createdAt: string;
    approvedAt?: null | string;
    lineCount: number;
    notExecuted: boolean;
    clubMayExecute: boolean;
    clubMayResolveByStatement: boolean;
};

export type RefundObligationDto = {
    id: string;
    paymentId: string;
    clientId?: null | string;
    amountKopecks: number;
    reasonCode: string;
    details: string;
    createdAt: string;
    status: RefundObligationStatus;
    resolvedAt?: null | string;
    resolvedBy?: null | string;
    resolutionNote?: null | string;
    settledByRefundId?: null | string;
    refundedSinceOpenedKopecks: number;
};

export enum RefundObligationStatus {
    OPEN = 'open',
    RESOLVED = 'resolved'
}

export enum RefundReason {
    CUSTOMER_REQUEST = 'customerRequest',
    SERVICE_NOT_RENDERED = 'serviceNotRendered',
    DUPLICATE = 'duplicate',
    FRAUDULENT = 'fraudulent',
    OPERATOR_ERROR = 'operatorError',
    DAMAGED = 'damaged',
    TOURNAMENT_CANCELLED = 'tournamentCancelled',
    BOOKING_CANCELLED = 'bookingCancelled',
    OTHER = 'other'
}

export type RefundSalePayload = {
    reason?: null | string;
};

export enum RefundSource {
    PAYMENT = 'payment',
    SALE = 'sale'
}

export enum RefundStatus {
    DRAFT = 'draft',
    PENDING_APPROVAL = 'pendingApproval',
    REJECTED = 'rejected',
    APPROVED = 'approved',
    PENDING = 'pending',
    PROCESSING = 'processing',
    COMPLETED = 'completed',
    FAILED = 'failed'
}

export type RefundTier = {
    minHoursBefore: number;
    refundPct: number;
};

export type RefundVerdictResponse = {
    refundable: boolean;
    refusalCode?: null | string;
    refusalMessage?: null | string;
    wholeOnly: boolean;
};

export type RefundedRegistrationDto = {
    registrationId: string;
    clientId: string;
    refundedAmountKopecks: number;
    atTheTillKopecks: number;
};

export type RegenerateCodeResponse = {
    socialCode: string;
    qrUrl: string;
};

export type RegisterClubStaffBody = {
    phone: string;
    role: string;
    firstName?: null | string;
    lastName?: null | string;
    email?: null | string;
    trainerId?: null | string;
};

export type RegisterDevicePayload = {
    platform: string;
    token: string;
    deviceName?: null | string;
};

export type RegisterDeviceResponse = {
    deviceTokenId: string;
    created: boolean;
};

export type RegisterForSessionBody = {
    useSubscriptionId?: null | string;
    clientId?: null | string;
    useBonuses?: null | boolean;
    requestedBonusKopecks?: null | number;
    useAdvance?: null | boolean;
};

export type RegisterForTournamentBody = {
    clientId?: null | string;
    partnerId?: null | string;
    skipPayment: boolean;
    useDeposit?: boolean;
    useBonuses?: boolean;
    requestedBonusKopecks?: null | number;
    admitReason?: null | string;
};

export type RegisterForTournamentResponse = {
    registrationId: string;
    status: RegistrationStatus;
    spotsRemaining: number;
};

export type RegisterGuestVisitRequest = {
    idempotencyKey: string;
};

export type RegistrationDto = {
    id: string;
    clientId: string;
    partnerId?: null | string;
    status: RegistrationStatus;
    paidAmountKopecks?: null | number;
    position: number;
    registeredAt: string;
    cancelledAt?: null | string;
    sportRatingMu?: null | number;
    sportRatingMatchesPlayed?: null | number;
    isMe: boolean;
    attendance?: null | TournamentAttendance;
};

export enum RegistrationStatus {
    CONFIRMED = 'confirmed',
    PENDING_PAYMENT = 'pendingPayment',
    CANCELLED = 'cancelled'
}

export type ReissueOnlineReceiptBody = {
    noReceiptInTheCabinet: boolean;
    refundId?: null | string;
};

export type RejectExpenseBody = {
    reason?: null | string;
};

export type RejectRefundBody = {
    reason?: null | string;
};

export type RejectRefundResponse = {
    refundId: string;
    status: RefundStatus;
};

export type RemindGameInvitesBody = {
    subjectKind: GameInviteSubjectKind;
    subjectId: string;
};

export enum ReminderAppliesTo {
    ALL = 'all',
    BOOKINGS = 'bookings',
    TRAININGS = 'trainings',
    TOURNAMENTS = 'tournaments'
}

export type ReminderScheduleDto = {
    id: string;
    minutesBefore: number;
    channel: MessageChannel;
    appliesTo: ReminderAppliesTo;
    enabled: boolean;
};

export type RemoveSessionParticipantBody = {
    reason: string;
};

export type RenewOwnSubscriptionBody = {
    method: PaymentMethod;
    idempotencyKey: string;
    useBonuses?: null | boolean;
    requestedBonusKopecks?: null | number;
};

export type RentalBundleDto = {
    id: string;
    name: string;
    enabled: boolean;
    sortOrder: number;
    items: Array<RentalBundleItemDto>;
};

export type RentalBundleItemDto = {
    productId: string;
    quantity: number;
};

export type RentalBundleItemPayload = {
    productId: string;
    quantity?: null | number;
};

export type RentalBundleListResponse = {
    items: Array<RentalBundleDto>;
};

export type RentalBundlePayload = {
    name?: null | string;
    enabled?: null | boolean;
    sortOrder?: null | number;
    items?: null | Array<RentalBundleItemPayload>;
};

export type ReopenPreviewEntryDto = {
    clientId: string;
    wouldReverseKopecks: number;
    wouldBecomeDebtKopecks: number;
};

export type ReopenPreviewResponse = {
    tournamentId: string;
    entries: Array<ReopenPreviewEntryDto>;
    totalWouldReverseKopecks: number;
    totalWouldBecomeDebtKopecks: number;
    ratingMayStayUnchanged: boolean;
};

export type ReopenTournamentBody = {
    reason?: null | string;
};

export type ReopenTournamentResponse = {
    tournamentId: string;
    reversals: Array<PrizeReversalDto>;
    totalReversedKopecks: number;
    totalDebtKopecks: number;
    ratingNotes: Array<string>;
};

export type ReplaceCardCategoryAccrualPayload = {
    rateBasisPoints: number;
    scope: AccrualScope;
    base?: null | BonusAccrualPolicy;
    overrides?: null | Array<AccrualOverrideDto>;
    version: number;
};

export type ReportBody = {
    reason?: null | string;
};

export type ReportMessageBody = {
    reason?: null | string;
};

export type RequestSubstitutionBody = {
    groupSessionId: string;
    reason: SubstitutionReason;
    reasonComment?: null | string;
};

export type RequeueOutboxResponse = {
    requeued: number;
};

export type RescheduleBookingResponse = {
    penaltyChargedKopecks: number;
    isFreeReschedule: boolean;
    penaltyPercent: number;
    appliedTierMinHoursBefore?: null | number;
    hoursUntilBooking: number;
    wasCharged: boolean;
    priceDeltaKopecks: number;
    newTotalPriceKopecks: number;
    owedKopecks: number;
    refundedToAdvanceKopecks: number;
    chargeSettledFromAdvanceKopecks: number;
    movePending: boolean;
    pendingMovePaymentId?: null | string;
    pendingMovePayUrl?: null | string;
    pendingMoveExpiresAt?: null | string;
    onlineLinkSent: boolean;
    spentBonusRefundedKopecks: number;
    friendsRefundedKopecks: number;
    refundToCardKopecks: number;
    waivedKopecks: number;
};

export type ReschedulePayload = {
    courtId: string;
    startAt: string;
    force?: boolean;
    openTrainerHours?: TrainerHoursOpening;
    reason?: null | string;
    waiveCharge?: boolean;
    expectedNetKopecks?: null | number;
};

export type ReschedulePreviewDto = {
    bookingId: string;
    priceTotalKopecks: number;
    newPriceTotalKopecks: number;
    penaltyAmountKopecks: number;
    isFreeReschedule: boolean;
    penaltyPercent: number;
    appliedTierMinHoursBefore?: null | number;
    hoursUntilBooking: number;
    wasPaid: boolean;
    canReschedule: boolean;
    priceDeltaKopecks: number;
    netKopecks: number;
    advanceBalanceKopecks: number;
    advanceCoversCharge: boolean;
    friendsRefundKopecks: number;
    waivableKopecks: number;
};

export type RescheduleTournamentBody = {
    startAt: string;
    endAt: string;
    fromResourceId?: null | string;
    toResourceId?: null | string;
    resourceIds?: null | Array<string>;
    expectedParticipants?: null | number;
    basics?: null | UpdateTournamentBody;
};

export type RescheduleTournamentResponse = {
    id: string;
    startAt: string;
    endAt: string;
    courtIds: Array<string>;
    expectedParticipants: number;
};

export type ResetBracketResponse = {
    tournamentId: string;
    status: TournamentStatus;
    discardedRounds: number;
    discardedMatches: number;
};

export type ResolveConversationBody = {
    clientId: string;
};

export type ResolveMatchPayload = {
    confirm: boolean;
    correctedTeam1Score?: null | number;
    correctedTeam2Score?: null | number;
};

export type ResolveObligationPayload = {
    note?: null | string;
};

export type ResolvePaymentIncidentRequest = {
    resolution: string;
    note?: null | string;
};

export type ResolvePlatformReceiptRequest = {
    resolution: string;
    note?: null | string;
};

export type ResolveRefundByStatementBody = {
    executed: boolean;
    statementReference: string;
    note?: null | string;
};

export type ResolveRefundByStatementResponse = {
    refundId: string;
    status: RefundStatus;
};

export type ResolveReportBody = {
    actioned: boolean;
    note?: null | string;
    hideMessage?: null | boolean;
    restrictDays?: null | number;
};

export type ResourceDto = {
    id: string;
    name: string;
    type: ResourceType;
    sportTypes: Array<unknown>;
    capacity?: null | number;
    isActive: boolean;
    sortOrder: number;
    isIndoor: boolean;
};

export enum ResourceType {
    COURT = 'court',
    GROUP_ROOM = 'groupRoom',
    GYM_FLOOR = 'gymFloor',
    POOL = 'pool',
    SAUNA = 'sauna',
    EQUIPMENT = 'equipment'
}

export type RespondToPartnerRequestPayload = {
    paymentMethod?: null | string;
    requestedBonusKopecks?: null | number;
};

export type ReturnTheObligationBody = {
    confirmedReturnedKopecks?: null | number;
};

export type ReturnTheObligationResponse = {
    obligationId: string;
    refundId: string;
    status: RefundStatus;
};

export type RevenueByDirection = {
    direction: string;
    kopecks: number;
    count: number;
};

export type RevenueByKind = {
    kind: string;
    kopecks: number;
    count: number;
};

export type RevenueByMethod = {
    method: string;
    kopecks: number;
    count: number;
};

export type RevenuePointDto = {
    date: string;
    kopecks: number;
};

export type RevenueSeriesPoint = {
    bucket: string;
    kopecks: number;
    saleCount: number;
};

export type RevenueTrendDto = {
    range: string;
    points: Array<RevenuePointDto>;
};

export type ReviewGroupSessionBody = {
    stars: number;
    comment?: null | string;
};

export type ReviewPromptDto = {
    kind: ReviewPromptKind;
    subjectId: string;
    title: string;
    isIndoor: boolean;
    startsAt: string;
    endsAt: string;
    reviewableUntil: string;
    trainerId?: null | string;
    trainerName?: null | string;
};

export enum ReviewPromptKind {
    BOOKING = 'booking',
    GROUP_SESSION = 'groupSession'
}

export type ReviewPromptsResponse = {
    items: Array<ReviewPromptDto>;
    windowDays: number;
};

export type RevokePayload = {
    permission: string;
    reason?: null | string;
    expiresAt?: null | string;
};

export type RoleConfigDto = {
    roleCode: string;
    label?: null | string;
    capabilities: Array<string>;
    description: string;
    builtInCapabilities: Array<string>;
    revokedCapabilities: Array<string>;
    editable: boolean;
    stillHeld: Array<HeldDespiteRevoke>;
    baseRole?: null | string;
    holders: number;
};

export type RolePayload = {
    label?: null | string;
    capabilities?: null | Array<string>;
    description?: null | string;
    revokedCapabilities?: null | Array<string>;
};

export type RoundDto = {
    id: string;
    roundNumber: number;
    status: RoundStatus;
    restingClientIds: Array<null | string>;
    completedAt?: null | string;
    restingIncludesMe: boolean;
};

export enum RoundStatus {
    PENDING = 'pending',
    IN_PROGRESS = 'inProgress',
    COMPLETED = 'completed'
}

export type SalaryBreakdownResponse = {
    periodId: string;
    startDate: string;
    endDate: string;
    status: SalaryPeriodStatus;
    trainerId: string;
    lessonsCount: number;
    lessonsRevenueKopecks: number;
    baseSalaryKopecks: number;
    bonusSalaryKopecks: number;
    deductionsKopecks: number;
    totalSalaryKopecks: number;
    compositionMissing: boolean;
    items: Array<SalaryItemDto>;
};

export type SalaryDetailDto = {
    id: string;
    trainerId: string;
    trainerName: string;
    lessonsCount: number;
    lessonsRevenueKopecks: number;
    baseSalaryKopecks: number;
    bonusSalaryKopecks: number;
    deductionsKopecks: number;
    totalSalaryKopecks: number;
    notes?: null | string;
    floorKopecks?: null | number;
    commissionKopecks?: null | number;
};

export type SalaryItemDto = {
    kind: SalaryItemKind;
    sourceId: string;
    date: string;
    title?: null | string;
    revenueKopecks: number;
    bonusKopecks: number;
    deductionKopecks: number;
    seats: number;
};

export enum SalaryItemKind {
    GROUP_SESSION = 'groupSession',
    BOOKING = 'booking',
    TRAINER_CANCELLATION = 'trainerCancellation'
}

export type SalaryModelDto = {
    type: SalaryType;
    baseAmountKopecks?: null | number;
    percentOfSession?: null | number;
};

export type SalaryPeriodDetailResponse = {
    id: string;
    startDate: string;
    endDate: string;
    status: SalaryPeriodStatus;
    calculatedAt?: null | string;
    approvedAt?: null | string;
    approvedBy?: null | string;
    details: Array<SalaryDetailDto>;
};

export type SalaryPeriodDto = {
    id: string;
    startDate: string;
    endDate: string;
    status: SalaryPeriodStatus;
    calculatedAt?: null | string;
    approvedAt?: null | string;
    approvedBy?: null | string;
};

export enum SalaryPeriodStatus {
    DRAFT = 'draft',
    CALCULATED = 'calculated',
    APPROVED = 'approved'
}

export enum SalaryType {
    FIXED = 'fixed',
    PERCENT = 'percent',
    MIXED = 'mixed',
    MIN_GUARANTEE = 'minGuarantee'
}

export type SaleDto = {
    id: string;
    shiftId: string;
    cashierUserId: string;
    clientId?: null | string;
    paymentMethod: PosPaymentMethod;
    status: SaleStatus;
    subtotal: number;
    discountTotal: number;
    total: number;
    cashGiven: number;
    changeGiven: number;
    originalSaleId?: null | string;
    paymentReference?: null | string;
    refundReason?: null | string;
    createdAt: string;
    confirmedAt?: null | string;
    lines: Array<SaleLineDto>;
    providerData?: null | SaleProviderData;
    bonusPaidKopecks: number;
    cashierName: string;
};

export type SaleLineDto = {
    id: string;
    productId?: null | string;
    name: string;
    kind: ProductKind;
    qty: number;
    unitPrice: number;
    discount: number;
    total: number;
    bookingId?: null | string;
    subscriptionId?: null | string;
    extensionForBookingId?: null | string;
    groupSessionParticipantId?: null | string;
    bonusKopecks: number;
};

export type SaleListResponse = {
    items: Array<SaleDto>;
    total: number;
    hasMore: boolean;
};

export type SaleProviderData = {
    qrUrl?: null | string;
    paymentRef?: null | string;
    ttlSeconds?: null | number;
    provider?: null | string;
};

export enum SaleRefundOutcome {
    COMPLETED = 'completed',
    PENDING_APPROVAL = 'pendingApproval'
}

export type SaleRefundRequest = {
    refundId: string;
    outcome: SaleRefundOutcome;
};

export enum SaleStatus {
    PENDING = 'pending',
    CONFIRMED = 'confirmed',
    CANCELLED = 'cancelled',
    REFUNDED = 'refunded'
}

export type SaveLayoutPayload = {
    widgets?: null | Array<DashboardWidgetSlotInput>;
};

export type ScheduleBlockPart = {
    title?: null | string;
    reason?: null | string;
};

export type ScheduleBookingDto = {
    id: string;
    courtId: string;
    trainerId?: null | string;
    startAt: string;
    endAt: string;
    status: BookingScheduleStatus;
    isTraining: boolean;
    isTournament: boolean;
    recurrenceId?: null | string;
    tournamentId?: null | string;
    pendingEndAt?: null | string;
    courtName: string;
    courtSport?: null | SportType;
    trainerName?: null | string;
    participantsCount: number;
    client?: null | ScheduleClientPart;
    money?: null | ScheduleMoneyPart;
    block?: null | ScheduleBlockPart;
    groupSessionId?: null | string;
    sessionCapacity?: null | number;
    cancelledAt?: null | string;
    cancelledInTime?: null | boolean;
    outsideTrainerHours?: null | TrainerOffScheduleReason;
    split?: null | BookingSplitSummary;
};

export type ScheduleClientPart = {
    clientId: string;
    clientName: string;
    clientCategory?: null | string;
    comment?: null | string;
    clientWish?: null | string;
};

export type ScheduleCourtDto = {
    id: string;
    name: string;
    sport?: null | SportType;
    type: string;
    sortOrder: number;
    assignedTrainers: Array<AssignedTrainerDto>;
    sportSortOrder: number;
    sportIcon?: null | string;
    sportColor?: null | string;
    placeType: ResourceType;
    sportTypes: Array<string>;
};

export type ScheduleGridResponse = {
    date: string;
    courts: Array<ScheduleCourtDto>;
    bookings: Array<ScheduleBookingDto>;
};

export type ScheduleInterval = {
    startMin: number;
    endMin: number;
};

export type ScheduleMoneyPart = {
    priceTotalKopecks: number;
    pricePaidKopecks: number;
    owedKopecks: number;
    pendingExtensionPriceKopecks?: null | number;
    pendingExtensionRequestedAt?: null | string;
    pendingExtensionExpiresAt?: null | string;
    holdExpiresAt?: null | string;
    changes?: null | BookingMoneyChangesPart;
};

export type ScheduleRangeResponse = {
    from: string;
    to: string;
    courts: Array<RangeCourtDto>;
    bookings: Array<RangeBookingDto>;
};

export enum ScoringMode {
    SIMPLE_POINTS = 'simplePoints',
    TENNIS_SETS = 'tennisSets',
    GAMES = 'games'
}

export enum SeatFee {
    DUE = 'due',
    RECEIVED = 'received',
    COVERED = 'covered'
}

export type SeatPaymentPlanDto = {
    priceKopecks: number;
    bonusKopecks: number;
    advanceKopecks: number;
    remainderKopecks: number;
    bonusMaxKopecks: number;
    bonusNotAllowed: boolean;
    advanceNotSpendable: boolean;
};

export type SeedRatingPayload = {
    sport: string;
    level: number;
};

export type SendAdminMessageCommand = {
    clientId: string;
    title: string;
    body: string;
    clientOperationId: string;
    channels?: null | Array<NotificationChannel>;
    category?: NotificationCategory;
    actionUrl?: null | string;
};

export type SendAdminMessageResponse = {
    notificationId: string;
    dispatchedChannels: Array<NotificationChannel>;
};

export type SendAudienceNotificationRequest = {
    audience: AudienceSpec;
    reason: AudienceReason;
    title: string;
    body: string;
    clientOperationId: string;
    purpose?: AudiencePurpose;
};

export type SendBroadcastNotificationCommand = {
    title: string;
    body: string;
    category: NotificationCategory;
    clientOperationId: string;
    actionUrl?: null | string;
    imageUrl?: null | string;
};

export type SendMyMessageBody = {
    clientMessageId: string;
    body: string;
};

export type SendMyPhoneCodeBody = {
    phone: string;
};

export type SendOtpCommand = {
    phone: string;
    audience?: null | SessionAudience;
};

export type SendOtpResponse = {
    success: boolean;
    expiresInSeconds: number;
    retryAfterSeconds: number;
};

export type SendPasswordCodeBody = {
    login?: null | string;
};

export type SendStaffMessageBody = {
    clientMessageId: string;
    body: string;
};

export type SeriesConflictDto = {
    date: string;
    reason: string;
};

export type SeriesOccurrenceNotCancelled = {
    bookingId: string;
    date: string;
    startTime: string;
    reason: string;
};

export enum SeriesOccurrenceStatus {
    PLANNED = 'planned',
    CHARGED = 'charged',
    AWAITING_PAYMENT = 'awaitingPayment',
    RELEASED = 'released',
    SKIPPED = 'skipped',
    CANCELLED = 'cancelled'
}

export type SeriesPlanDate = {
    id: string;
    date: string;
    status: SeriesOccurrenceStatus;
    bookingId?: null | string;
    paymentDeadline?: null | string;
    reason?: null | string;
};

export type SeriesPlanResponse = {
    id: string;
    clientId: string;
    clientName: string;
    resourceId: string;
    courtName: string;
    trainerId?: null | string;
    trainerName?: null | string;
    startTime: string;
    durationMinutes: number;
    daysOfWeek: Array<number>;
    seriesStartDate: string;
    seriesEndDate: string;
    estimatedOccurrencePriceKopecks?: null | number;
    chargeDaysAhead: number;
    cancelledAt?: null | string;
    dates: Array<SeriesPlanDate>;
};

export enum SessionAdmission {
    BY_REGISTRATION = 'byRegistration',
    OPEN = 'open'
}

export type SessionAndFollowingCount = {
    count: number;
    lastDate: string;
};

export enum SessionAudience {
    CLIENT = 'client',
    TRAINER = 'trainer',
    STAFF = 'staff'
}

export type SessionJournalEntryDto = {
    occurredAt: string;
    eventType: string;
    summary: string;
    actorName?: null | string;
    amountKopecks?: null | number;
};

export enum SessionLevel {
    BEGINNER = 'beginner',
    INTERMEDIATE = 'intermediate',
    ADVANCED = 'advanced',
    ANY = 'any'
}

export type SessionParticipantDto = {
    id: string;
    clientId: string;
    clientName: string;
    memberNumber: string;
    status: ParticipantStatus;
    registeredAt: string;
    checkedInAt?: null | string;
    fee: SeatFee;
    holdExpiresAt?: null | string;
    clientWish?: null | string;
};

export type SessionPlanningCategory = {
    code: string;
    maxRating?: null | number;
};

export type SessionPlanningHour = {
    hour: number;
    start: string;
    end: string;
    state: SessionPlanningHourState;
    reason?: null | string;
};

export enum SessionPlanningHourState {
    FREE = 'free',
    PAST = 'past',
    OUTSIDE_THE_DAY = 'outsideTheDay',
    CLUB_CLOSED = 'clubClosed',
    ON_VACATION = 'onVacation',
    OUTSIDE_HOURS = 'outsideHours',
    TRAINER_BUSY = 'trainerBusy',
    NO_FREE_PLACE = 'noFreePlace'
}

export type SessionPlanningLevel = {
    level: SessionLevel;
    fromCategory?: null | string;
    toCategory?: null | string;
    minRating?: null | number;
    maxRating?: null | number;
};

export type SessionPlanningPlace = {
    id: string;
    name: string;
    placeType: string;
    sport?: null | string;
    assigned: boolean;
    busyHours: Array<number>;
};

export type SessionPlanningRange = {
    from: string;
    to: string;
};

export type SessionPlanningResponse = {
    trainerId: string;
    date: string;
    durationHours: number;
    anyTime: boolean;
    workingHours: Array<SessionPlanningRange>;
    hours: Array<SessionPlanningHour>;
    places: Array<SessionPlanningPlace>;
    levels: Array<SessionPlanningLevel>;
    categories: Array<SessionPlanningCategory>;
};

export enum SessionRegistrationBy {
    SELF = 'self',
    STAFF = 'staff'
}

export enum SessionStatus {
    DRAFT = 'draft',
    PUBLISHED = 'published',
    FULL = 'full',
    IN_PROGRESS = 'inProgress',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled'
}

export enum SessionType {
    MINI_GROUP = 'miniGroup',
    GROUP = 'group',
    PERSONAL = 'personal'
}

export type SessionWaitlistRowDto = {
    id: string;
    clientId: string;
    clientName: string;
    memberNumber: string;
    status: WaitlistStatus;
    position: number;
    joinedAt: string;
    offerExpiresAt?: null | string;
};

export type SetActiveBody = {
    isActive: boolean;
};

export type SetClientParallelCourtsPayload = {
    parallelCourts?: null | number;
};

export type SetClientSigurLinkRequest = {
    sigurEmployeeId?: null | number;
    cardKey?: null | string;
};

export type SetFirstPasswordBody = {
    newPassword: string;
    smsCode?: null | string;
    login?: null | string;
};

export type SetOnlineReceiptsBody = {
    enabled: boolean;
    taxationSystem?: null | string;
    autoFormationOffConfirmed: boolean;
};

export type SetPasswordByInviteBody = {
    userId: string;
    token: string;
    newPassword: string;
};

export type SetTenantLimitsRequest = {
    overrides: {
        [key: string]: number;
    };
};

export type SetTrainerClassesBody = {
    classIds?: null | Array<string>;
};

export type SetTrialExtensionLimitRequest = {
    days: number;
};

export type SettingsAuditDto = {
    id: string;
    path: string;
    actorId?: null | string;
    actorName: string;
    summary: string;
    before?: null | string;
    after?: null | string;
    createdAt: string;
};

export type SettleInvoiceByTransferRequest = {
    paymentOrderNumber: string;
    paymentOrderDate: string;
    receivedAmountKopecks: number;
};

export type SettleOrderPayload = {
    useBonuses: boolean;
    useAdvance: boolean;
    method: PaymentMethod;
    returnUrl?: null | string;
    useSubscriptionId?: null | string;
};

export type SettleOrderResponse = {
    orderId: string;
    status: OrderStatus;
    totalKopecks: number;
    bonusDebitKopecks: number;
    advanceDebitKopecks: number;
    payableKopecks: number;
    paymentId?: null | string;
    redirectUrl?: null | string;
};

export type ShiftDetailResponse = {
    shift: ShiftDto;
    sales: Array<SaleDto>;
};

export type ShiftDto = {
    id: string;
    cashierUserId: string;
    cashierName: string;
    status: ShiftStatus;
    openingFloat: number;
    closingFloat?: null | number;
    openedAt: string;
    closedAt?: null | string;
    zReport?: null | ZReport;
    expectedCashKopecks?: null | number;
};

export enum ShiftStatus {
    OPEN = 'open',
    CLOSED = 'closed'
}

export type SkippedSessionDto = {
    date: string;
    startTime: string;
    title?: null | string;
    reason: string;
};

export type SlotPolicyDto = {
    slotDurationMin: number;
    minLeadMin: number;
    holdWindowSec: number;
    extensionHoldMin: number;
    noShowResalePartial: boolean;
    noShowResalePartialPct: number;
    cancellationDeadlineMin: number;
    bookingHorizonDays: number;
    noShowRefundTiers: Array<RefundTier>;
    tournamentRefundTiers: Array<TournamentRefundTier>;
    groupSessionRefundTiers: Array<GroupSessionRefundTier>;
    minReliabilityPctToJoinMatch: number;
    splitPayDeadlineBufferHours: number;
    splitPayReminderLeadHours: number;
    noShowStrikeLimit: number;
    noShowStrikeWindowDays: number;
    waitlistOfferMinutes: number;
    waitlistMode: WaitlistMode;
    splitMaxSeats: number;
    tournamentNoShowStrikeLimit: number;
    tournamentNoShowStrikeWindowDays: number;
    deskLateStartMin: number;
    groupSessionMaxSeats: number;
    fitnessSessionMaxSeats: number;
    seriesChargeDaysAhead: number;
};

export type SlotPolicyPayload = {
    slotDurationMin?: null | number;
    minLeadMin?: null | number;
    holdWindowSec?: null | number;
    extensionHoldMin?: null | number;
    noShowResalePartial?: null | boolean;
    noShowResalePartialPct?: null | number;
    cancellationDeadlineMin?: null | number;
    bookingHorizonDays?: null | number;
    noShowRefundTiers?: null | Array<RefundTier>;
    tournamentRefundTiers?: null | Array<TournamentRefundTier>;
    groupSessionRefundTiers?: null | Array<GroupSessionRefundTier>;
    minReliabilityPctToJoinMatch?: null | number;
    splitPayDeadlineBufferHours?: null | number;
    splitPayReminderLeadHours?: null | number;
    noShowStrikeLimit?: null | number;
    noShowStrikeWindowDays?: null | number;
    waitlistOfferMinutes?: null | number;
    waitlistMode?: null | WaitlistMode;
    splitMaxSeats?: null | number;
    tournamentNoShowStrikeLimit?: null | number;
    tournamentNoShowStrikeWindowDays?: null | number;
    deskLateStartMin?: null | number;
    groupSessionMaxSeats?: null | number;
    fitnessSessionMaxSeats?: null | number;
    seriesChargeDaysAhead?: null | number;
};

export enum SortOrder {
    ASC = 'asc',
    DESC = 'desc'
}

export type SplitBookingSummaryDto = {
    bookingId: string;
    date: string;
    startTime: string;
    endTime: string;
    resourceId: string;
    totalPriceKopecks: number;
    courtName: string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sport: string;
};

export type SplitDebtItem = {
    splitId: string;
    bookingId: string;
    shareKopecks: number;
    defaultedAt: string;
    organizerName: string;
};

export type SplitOfferDto = {
    bookingId: string;
    splitId: string;
    status: SplitStatus;
    date: string;
    startTime: string;
    endTime: string;
    courtName: string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sport: string;
    organizerName: string;
    totalSpots: number;
    freeSpots: number;
    seatPriceKopecks: number;
    policy: SplitPolicy;
    deadlineAt: string;
    deadlineDate: string;
    deadlineTime: string;
    inviteUrl?: null | string;
};

export enum SplitParticipantStatus {
    AWAITING = 'awaiting',
    PAID = 'paid',
    REFUSED = 'refused',
    DEFAULTED = 'defaulted',
    LAPSED = 'lapsed'
}

export enum SplitPayDefaultPolicy {
    CHARGE_ORGANIZER = 'chargeOrganizer',
    BURN_AND_BLOCK = 'burnAndBlock'
}

export enum SplitPolicy {
    CHARGE_ORGANIZER = 'chargeOrganizer',
    BURN_AND_BLOCK = 'burnAndBlock'
}

export enum SplitSeatState {
    UNPAID = 'unpaid',
    PAID = 'paid',
    OUT = 'out'
}

export type SplitShareLinePayload = {
    bookingId: string;
    participantClientId: string;
};

export type SplitSharePlanDto = {
    shareKopecks: number;
    bonusKopecks: number;
    advanceKopecks: number;
    remainderKopecks: number;
    bonusMaxKopecks: number;
    bonusCapBinding: boolean;
    bonusNotAllowed: boolean;
    advanceNotSpendable: boolean;
};

export enum SplitStatus {
    DRAFT = 'draft',
    AWAITING_PAYMENTS = 'awaitingPayments',
    ALL_PAID = 'allPaid',
    CHARGE_ORGANIZER = 'chargeOrganizer',
    BURNED = 'burned',
    CANCELLED = 'cancelled'
}

export enum SportActivityKind {
    BOOKINGS = 'bookings',
    OPEN_MATCHES = 'openMatches',
    PARTNER_REQUESTS = 'partnerRequests',
    GROUP_SESSIONS = 'groupSessions',
    TOURNAMENTS = 'tournaments'
}

export type SportDto = {
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    code: string;
    label: string;
    sortOrder: number;
    icon?: null | string;
    color?: null | string;
    builtin: boolean;
    state: SportState;
};

export type SportListResponse = {
    items: Array<SportDto>;
};

export enum SportState {
    OPEN = 'open',
    BOOKING_CLOSED = 'bookingClosed',
    DISABLED = 'disabled'
}

/**
 * Sport code from the tenant catalogue (e.g. "padel").
 */
export type SportType = string;

export type SportUnfinishedItem = {
    kind: SportActivityKind;
    count: number;
};

export type SportUnfinishedResponse = {
    items: Array<SportUnfinishedItem>;
    totalCount: number;
};

export type StaffContentDto = {
    id: string;
    kind: NewsKind;
    title: string;
    excerpt: string;
    body: string;
    topic?: null | string;
    publishedAt: string;
    pinnedUntil?: null | string;
    isPinned: boolean;
    requiresAck: boolean;
    cover?: null | NewsCoverDto;
    readAt?: null | string;
    ackedAt?: null | string;
};

export type StaffContentInput = {
    title: string;
    excerpt?: null | string;
    body?: null | string;
    coverMediaId?: null | string;
    coverFocusX?: null | number;
    coverFocusY?: null | number;
    kind?: null | NewsKind;
    topic?: null | string;
    pinnedUntil?: null | string;
    requiresAck?: null | boolean;
};

export type StaffContentListResponse = {
    items: Array<StaffContentDto>;
};

export type StaffFriendDto = {
    clientId: string;
    displayName: string;
    memberNumber: string;
    friendsSince: string;
};

export type StaffPendingCounts = {
    incoming: number;
    outgoing: number;
};

export type StaffProposalListResponse = {
    items: Array<NewsAdminDto>;
};

export type StaffTrainerReviewDto = {
    id: string;
    stars: number;
    comment?: null | string;
    authorName: string;
    subjectKind: TrainerReviewSubject;
    createdAt: string;
    hiddenAt?: null | string;
    hiddenByName?: null | string;
};

export type StaffTrainerReviewsResponse = {
    ratingAvg: number;
    ratingCount: number;
    hiddenCount: number;
    items: Array<StaffTrainerReviewDto>;
    nextCursor?: null | string;
    hasMore: boolean;
};

export type StartVkAuthBody = {
    redirectUri?: null | string;
    audience?: null | SessionAudience;
};

export type SubmitBookingReviewBody = {
    overall: number;
    trainer?: null | number;
    game?: null | number;
    comment?: null | string;
    trainerComment?: null | string;
};

export type SubmitMatchPayload = {
    sport: string;
    playedAt: string;
    team1: Array<string>;
    team2: Array<string>;
    team1Score: number;
    team2Score: number;
    openMatchId?: null | string;
    competitive?: boolean;
};

export type SubmitMatchScoreBody = {
    team1Points?: null | number;
    team2Points?: null | number;
    sets?: null | Array<TennisSetScoreBody>;
};

export type SubmitMatchScoreResponse = {
    match: SubmittedMatchDto;
    leaderboard: Array<MatchLeaderboardEntry>;
    roundCompleted: boolean;
    nextRoundId?: null | string;
};

export type SubmittedMatchDto = {
    id: string;
    roundId: string;
    roundNumber: number;
    resourceId: string;
    team1: Array<string>;
    team2: Array<string>;
    status: MatchStatus;
    team1Points?: null | number;
    team2Points?: null | number;
    sets: Array<TennisSetScore>;
    scheduledAt: string;
    startedAt?: null | string;
    completedAt?: null | string;
};

export type SubscriptionCheckoutDto = {
    invoiceId: string;
    amountKopecks: number;
    description: string;
    method: string;
    publicId?: null | string;
    paymentUrl?: null | string;
};

export type SubscriptionDto = {
    id: string;
    clientId: string;
    templateId: string;
    snapshotName: string;
    snapshotSport?: null | SportType;
    sessionsTotal: number;
    sessionsRemaining: number;
    gymVisitsTotal: number;
    gymVisitsRemaining: number;
    gymVisitsKind: SubscriptionKind;
    scope: SubscriptionScope;
    purchasedAt: string;
    expiresAt: string;
    status: SubscriptionStatus;
    pricePaidKopecks: number;
    kind: SubscriptionKind;
    trainerId?: null | string;
    freezeDaysAllowed: number;
    freezeDaysLeft: number;
    pausedUntil?: null | string;
};

export enum SubscriptionGrantReason {
    GIFT = 'gift',
    COMPENSATION = 'compensation',
    TRANSFER = 'transfer',
    CORRECTION = 'correction'
}

export type SubscriptionHistoryEntryDto = {
    id: string;
    opType: SubscriptionOpType;
    sessionsBefore: number;
    sessionsAfter: number;
    statusBefore: SubscriptionStatus;
    statusAfter: SubscriptionStatus;
    use?: null | SubscriptionUse;
    bookingId?: null | string;
    actorId?: null | string;
    reason?: null | string;
    occurredAt: string;
    refusal?: null | SubscriptionRefusal;
};

export type SubscriptionHistoryResponse = {
    subscriptionId: string;
    entries: Array<SubscriptionHistoryEntryDto>;
};

export type SubscriptionInvoiceDto = {
    id: string;
    plan: string;
    planName: string;
    periodStart: string;
    periodEnd: string;
    amountKopecks: number;
    status: string;
    paidAt?: null | string;
    createdAt: string;
    kind: string;
    method?: null | string;
    documentNumber?: null | string;
    payBy?: null | string;
    awaitsTransfer: boolean;
};

export type SubscriptionInvoicesDto = {
    items: Array<SubscriptionInvoiceDto>;
};

export enum SubscriptionKind {
    LIMITED = 'limited',
    UNLIMITED = 'unlimited'
}

export type SubscriptionListResponse = {
    items: Array<SubscriptionDto>;
};

export enum SubscriptionOpType {
    ISSUED = 'issued',
    RENEWED = 'renewed',
    REDEEMED = 'redeemed',
    RESTORED = 'restored',
    PAUSED = 'paused',
    RESUMED = 'resumed',
    CANCELLED = 'cancelled',
    EXPIRED = 'expired',
    SCOPE_CONVERTED = 'scopeConverted',
    RENEWAL_INVOICED = 'renewalInvoiced',
    CHARGE_REFUSED = 'chargeRefused',
    GUEST_VISIT_CHARGED = 'guestVisitCharged',
    ENTERED = 'entered'
}

export type SubscriptionPatchPayload = {
    action: string;
    freezeDays?: null | number;
};

export type SubscriptionPlanChangeDto = {
    outcome: string;
    checkout?: null | SubscriptionCheckoutDto;
};

export type SubscriptionPlanOptionDto = {
    plan: string;
    name: string;
    tagline?: null | string;
    sortOrder: number;
    monthlyKopecks: number;
    isPaid: boolean;
    limits: Array<PlanLimitDto>;
    route: string;
    dueNowKopecks: number;
    coversDays: number;
    block: string;
    overflow: Array<TenantLimitDto>;
    modules: Array<string>;
    modulesLost: Array<string>;
};

export type SubscriptionPlansDto = {
    currentPlan: string;
    plans: Array<SubscriptionPlanOptionDto>;
    usage: Array<TenantLimitDto>;
    timeline: SubscriptionTimelineDto;
};

export type SubscriptionPurchasePlanDto = {
    priceKopecks: number;
    bonusKopecks: number;
    remainderKopecks: number;
    bonusMaxKopecks: number;
    bonusCapBinding: boolean;
    bonusNotAllowed: boolean;
};

export enum SubscriptionRefusal {
    MISSING = 'missing',
    NOT_THEIRS = 'notTheirs',
    RETURNED = 'returned',
    CANCELLED = 'cancelled',
    ALREADY_ISSUED = 'alreadyIssued',
    SECOND_LIVE_RIGHT = 'secondLiveRight',
    TERMS_GONE = 'termsGone',
    BEING_RETURNED = 'beingReturned',
    UNDERPAID = 'underpaid'
}

export type SubscriptionRegistryItemDto = {
    id: string;
    clientId: string;
    clientFirstName: string;
    clientLastName: string;
    clientMemberPrefix: string;
    clientMemberNumber: string;
    clientAvatarUrl: string;
    templateId: string;
    templateName: string;
    sport?: null | SportType;
    direction: ActivityDirection;
    sessionsTotal: number;
    sessionsRemaining: number;
    purchasedAt: string;
    expiresAt: string;
    pausedAt?: null | string;
    status: SubscriptionStatus;
    expiringSoon: boolean;
    transferable: boolean;
    pricePaidKopecks: number;
};

export type SubscriptionRegistryKpiDto = {
    active: number;
    expiringSoon: number;
    paused: number;
    renewalRatePercent?: null | number;
};

export type SubscriptionRegistryResponse = {
    items: Array<SubscriptionRegistryItemDto>;
    totalCount: number;
    page: number;
    pageSize: number;
    kpi: SubscriptionRegistryKpiDto;
    fitnessEnabled: boolean;
};

export enum SubscriptionScope {
    GYM = 'gym',
    GROUP_SESSIONS = 'groupSessions',
    BOTH = 'both',
    PERSONAL_TRAINING = 'personalTraining',
    COURTS = 'courts'
}

export enum SubscriptionStatus {
    ACTIVE = 'active',
    PAUSED = 'paused',
    EXPIRED = 'expired',
    CANCELLED = 'cancelled',
    PENDING_PAYMENT = 'pendingPayment'
}

export type SubscriptionSummaryDto = {
    plan: string;
    planName: string;
    planTagline?: null | string;
    planIsOffered: boolean;
    monthlyKopecks: number;
    isPaidPlan: boolean;
    status: string;
    planExpiresAt?: null | string;
    pendingInvoiceId?: null | string;
    pendingAmountKopecks?: null | number;
    trialEndsAt?: null | string;
    pendingKind?: null | string;
    pendingPlan?: null | string;
    pendingPlanName?: null | string;
    unpaidInvoiceCount: number;
    unpaidTotalKopecks: number;
};

export type SubscriptionTemplateDto = {
    id: string;
    name: string;
    sport?: null | SportType;
    direction: ActivityDirection;
    sessionsTotal: number;
    gymVisitsTotal: number;
    validForDays: number;
    price: number;
    transferable: boolean;
    publishedInApp: boolean;
    enabled: boolean;
    kind: SubscriptionKind;
    gymVisitsKind: SubscriptionKind;
    scope: SubscriptionScope;
    trainerId?: null | string;
    freezeDaysAllowed: number;
    guestVisitsTotal: number;
    promocodeWithSubscription: PromocodeWithSubscription;
};

export type SubscriptionTemplateListResponse = {
    items: Array<SubscriptionTemplateDto>;
};

export type SubscriptionTimelineDto = {
    periodDays: number;
    reminderDaysBefore: number;
    graceDaysAfter: number;
};

export enum SubscriptionUse {
    GYM_VISIT = 'gymVisit',
    GROUP_SESSION = 'groupSession',
    PERSONAL_TRAINING = 'personalTraining',
    COURT_BOOKING = 'courtBooking'
}

export type SubstitutionInboxItemDto = {
    id: string;
    groupSessionId: string;
    originatorTrainerId: string;
    originatorName: string;
    reason: string;
    reasonComment?: null | string;
    sport?: null | string;
    sessionType: SessionType;
    resourceId: string;
    date: string;
    startTime: string;
    endTime: string;
    maxParticipants: number;
    currentParticipants: number;
    pricePerPersonKopecks: number;
    requestedAt: string;
    expiresAt: string;
    myStatus: string;
    placeName?: null | string;
    className?: null | string;
};

export enum SubstitutionReason {
    SICKNESS = 'sickness',
    PERSONAL = 'personal',
    EMERGENCY = 'emergency',
    OTHER = 'other'
}

export type SuspendBody = {
    suspended: boolean;
};

export type SuspendTenantRequest = {
    reason: string;
};

export type SwitchTenantRequest = {
    tenantId: string;
};

export type SwitchTrainingFormatPayload = {
    format: TrainingFormat;
    participantIds?: null | Array<string>;
};

export type SwitchTrainingFormatResponse = {
    switched: boolean;
    refundedKopecks: number;
    owedKopecks: number;
    payUrl?: null | string;
};

export type TPayDto = {
    available: boolean;
};

export type TPayLinkDto = {
    url: string;
};

export type TakeSplitSeatPayload = {
    method?: null | string;
    requestedBonusKopecks?: null | number;
};

export type TakeSplitSeatResponse = {
    shareKopecks: number;
    paid: boolean;
    heldUntil?: null | string;
    allPaid: boolean;
};

export type TaskAssigneeDto = {
    id: string;
    name: string;
    roles: Array<string>;
};

export type TaskAssigneesResponse = {
    items: Array<TaskAssigneeDto>;
};

export type TaxConfigDto = {
    vat: VatRate;
    vatPercent: number;
    acquiringFeePct: number;
    sbpFeePct: number;
};

export type TaxConfigPayload = {
    vat?: null | VatRate;
    acquiringFeePct?: null | number;
    sbpFeePct?: null | number;
};

export type TemplateSalesDto = {
    templateId: string;
    soldCount: number;
    activeCount: number;
};

export type TemplateSalesResponse = {
    items: Array<TemplateSalesDto>;
};

export type TenantBillingDto = {
    summary: SubscriptionSummaryDto;
    invoices: Array<SubscriptionInvoiceDto>;
};

export type TenantDetailDto = {
    id: string;
    slug: string;
    name: string;
    status: string;
    plan: string;
    planName: string;
    ownerUserId: string;
    ownerEmail?: null | string;
    timezone: string;
    locale: string;
    createdAt: string;
    updatedAt: string;
    statusChangedAt: string;
    trialEndsAt?: null | string;
    trialExtensionReason?: null | string;
    trialExtensionLimitDays: number;
    planExpiresAt?: null | string;
    suspendedReason?: null | string;
    suspendedAt?: null | string;
    archivedAt?: null | string;
    deletionScheduledAt?: null | string;
    joinCode?: null | string;
};

export type TenantLimitDto = {
    key: string;
    used: number;
    limit: number;
};

export type TenantLimitsDto = {
    plan: string;
    planName: string;
    limits: Array<TenantLimitDto>;
};

export type TenantListItemDto = {
    id: string;
    slug: string;
    name: string;
    status: string;
    plan: string;
    planName: string;
    createdAt: string;
    statusChangedAt: string;
    trialEndsAt?: null | string;
    planExpiresAt?: null | string;
    debtKopecks: number;
    unpaidInvoiceCount: number;
};

export type TenantMemberContactsChanged = {
    fields: Array<string>;
    signedOut: boolean;
};

export type TenantMemberDto = {
    userId: string;
    email?: null | string;
    firstName?: null | string;
    lastName?: null | string;
    phoneNumber?: null | string;
    phoneConfirmed: boolean;
    role: string;
    status: string;
    isOwner: boolean;
    createdAt: string;
};

export type TennisSetScore = {
    setNumber: number;
    gamesA: number;
    gamesB: number;
    tieBreakA?: null | number;
    tieBreakB?: null | number;
    winnerIndex?: null | number;
};

export type TennisSetScoreBody = {
    gamesA: number;
    gamesB: number;
    tieBreakA?: null | number;
    tieBreakB?: null | number;
};

export type TillBonusCapDto = {
    maxKopecks: number;
    capKopecks: number;
    balanceKopecks: number;
    allowedBaseKopecks: number;
    maxPaymentPct: number;
    notAllowed: Array<BonusSpendCategory>;
    refusal?: null | string;
};

export type TillBonusCapLinePayload = {
    kind?: null | string;
    totalKopecks: number;
    bookingId?: null | string;
};

export type TillBonusCapPayload = {
    clientId: string;
    lines?: null | Array<TillBonusCapLinePayload>;
};

export type TillTopupReceipt = {
    state: WalletTopupReceiptState;
    fiscalDocumentNumber?: null | string;
    registeredAt?: null | string;
    ofdUrl?: null | string;
};

export type TopClubDto = {
    id: string;
    name: string;
    slug: string;
    clients: number;
    bookings: number;
    revenueKopecks: number;
};

export type TopSpenderDto = {
    clientId: string;
    firstName: string;
    lastName: string;
    category: string;
    ltvKopecks: number;
    lastVisitAt?: null | string;
};

export type TopSubscriptionTemplateDto = {
    id: string;
    name: string;
    soldCount: number;
    revenueKopecks: number;
};

export type TopupBody = {
    amountKopecks: number;
    method: PaymentMethod;
    idempotencyKey: string;
};

export type TopupDepositBody = {
    amountKopecks: number;
    method: PaymentMethod;
    returnUrl?: null | string;
};

export type TopupDepositResponse = {
    paymentId: string;
    redirectUrl?: null | string;
};

export type TopupOrganizationResponse = {
    paymentId: string;
    payUrl?: null | string;
};

export enum TournamentAttendance {
    PENDING = 'pending',
    ATTENDED = 'attended',
    NO_SHOW = 'noShow'
}

export type TournamentBrief = {
    id: string;
    name: string;
    status: TournamentStatus;
};

export type TournamentCoachDto = {
    tournamentId: string;
    trainerId?: null | string;
    trainerName?: null | string;
};

export type TournamentDetailDto = {
    id: string;
    name: string;
    description?: null | string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sport: string;
    format: TournamentFormat;
    scoring: ScoringMode;
    status: TournamentStatus;
    effectiveStatus: TournamentStatus;
    isArchived: boolean;
    minPlayers: number;
    maxPlayers: number;
    expectedParticipants: number;
    registrationOpensAt?: null | string;
    registrationClosesAt?: null | string;
    startAt: string;
    endAt: string;
    courtIds: Array<string>;
    entryFeeKopecks: number;
    prizePoolKopecks: number;
    currency: string;
    prizeDistribution: Array<PrizeShareDto>;
    pointsPerMatch: number;
    note?: null | string;
    completedAt?: null | string;
    cancelledAt?: null | string;
    gradientFrom?: null | string;
    gradientTo?: null | string;
    levelMin?: null | number;
    levelMax?: null | number;
    hideParticipants: boolean;
    registeredCount: number;
    prizeDestination: PrizeDestination;
    isRegistered: boolean;
    refundTiers: Array<TournamentRefundTierDto>;
    coachTrainerId?: null | string;
    coachName?: null | string;
    plan?: null | TournamentPlanDto;
    bracketResettable: boolean;
    bracketResetRefusal?: null | string;
};

export type TournamentDetailResponse = {
    tournament: TournamentDetailDto;
    registrations: Array<RegistrationDto>;
    rounds: Array<RoundDto>;
    matches: Array<MatchDto>;
    leaderboard: Array<LeaderboardRowDto>;
    myResult?: null | MyTournamentResultDto;
    participantNames: Array<ParticipantNameDto>;
};

export enum TournamentFormat {
    AMERICANO = 'americano',
    MEXICANO = 'mexicano',
    MIXICANO = 'mixicano',
    TEAM_AMERICANO = 'teamAmericano',
    ROUND_ROBIN = 'roundRobin',
    SWISS = 'swiss',
    SINGLE_ELIMINATION = 'singleElimination',
    DOUBLE_ELIMINATION = 'doubleElimination',
    FREE = 'free'
}

export type TournamentNormValueDto = {
    minutes: number;
    setByClub: boolean;
};

export type TournamentNormsResponse = {
    points: Array<TournamentTargetNormDto>;
    games: Array<TournamentTargetNormDto>;
    sets: TournamentNormValueDto;
    changeover: TournamentNormValueDto;
};

export type TournamentPlanDto = {
    format: TournamentFormat;
    scoring: ScoringMode;
    pointsTarget: number;
    participants: number;
    units: number;
    unitKind: PlanUnitKind;
    rounds: number;
    matchesPerRound: number;
    courtsNeeded: number;
    minutesPerGame: number;
    normTarget: number;
    changeoverMinutes: number;
    playMinutes: number;
    slotMinutes: number;
    requiredWindowMinutes: number;
    slots: number;
    explanation: string;
};

export type TournamentRefundTier = {
    minHoursBefore: number;
    refundPct: number;
};

export type TournamentRefundTierDto = {
    minHoursBefore: number;
    refundPct: number;
};

export enum TournamentStatus {
    DRAFT = 'draft',
    REGISTRATION_OPEN = 'registrationOpen',
    REGISTRATION_CLOSED = 'registrationClosed',
    IN_PROGRESS = 'inProgress',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled'
}

export type TournamentSummary = {
    id: string;
    name: string;
    /**
     * Sport code from the tenant catalogue (e.g. "padel").
     */
    sport: string;
    format: TournamentFormat;
    status: TournamentStatus;
    effectiveStatus: TournamentStatus;
    isArchived: boolean;
    scoring: ScoringMode;
    startAt: string;
    endAt: string;
    minPlayers: number;
    maxPlayers: number;
    registeredCount: number;
    courtCount: number;
    isRegistered: boolean;
    entryFeeKopecks: number;
    prizePoolKopecks: number;
    pointsPerMatch: number;
    gradientFrom?: null | string;
    gradientTo?: null | string;
    levelMin?: null | number;
    levelMax?: null | number;
    registrationClosesAt?: null | string;
};

export type TournamentSummaryDto = {
    id: string;
    name: string;
    status: TournamentStatus;
    format: TournamentFormat;
    startAt: string;
    endAt: string;
    courtIds: Array<string>;
};

export type TournamentTargetNormDto = {
    target: number;
    minutes: number;
    setByClub: boolean;
};

export type TournamentTargetNormInput = {
    target: number;
    minutes: number;
};

export type TrainerAnalyticsMonth = {
    key: string;
    sessions: number;
    revenue: number;
    hours: number;
    avgRating: number;
};

export type TrainerAnalyticsResponse = {
    months: Array<TrainerAnalyticsMonth>;
    totals: TrainerAnalyticsTotals;
};

export type TrainerAnalyticsTotals = {
    sessions: number;
    revenue: number;
    hours: number;
};

export enum TrainerAudience {
    KIDS = 'kids',
    TEENS = 'teens',
    ADULTS = 'adults',
    BEGINNERS = 'beginners',
    INTERMEDIATE = 'intermediate',
    ADVANCED = 'advanced',
    PROFESSIONALS = 'professionals'
}

export type TrainerAvailabilityResponse = {
    trainerId: string;
    date: string;
    slots: Array<AvailableSlotDto>;
};

export type TrainerBusyIntervalDto = {
    id: string;
    date: string;
    startMin: number;
    endMin: number;
    reason: TrainerBusyReason;
    comment?: null | string;
};

export enum TrainerBusyReason {
    PERSONAL = 'personal',
    BREAK = 'break',
    SICK_LEAVE = 'sickLeave',
    VACATION = 'vacation',
    OTHER = 'other'
}

export type TrainerCalendarClubDto = {
    isOpen: boolean;
    openMin: number;
    closeMin: number;
    closedKind?: null | TrainerClubClosedKind;
    closedReason?: null | string;
};

export type TrainerCalendarDayDto = {
    date: string;
    source: TrainerDaySource;
    intervals: Array<ScheduleInterval>;
    version: string;
    onVacation: boolean;
    club: TrainerCalendarClubDto;
    events: Array<TrainerCalendarEventDto>;
    special?: null | TrainerSpecialDayDto;
};

export type TrainerCalendarDto = {
    trainerId: string;
    from: string;
    to: string;
    templateVersion: string;
    weeklyTemplate: Array<WeeklyScheduleEntry>;
    templateIsEmpty: boolean;
    days: Array<TrainerCalendarDayDto>;
    outsideCount: number;
};

export type TrainerCalendarEventDto = {
    id: string;
    kind: TrainerCalendarEventKind;
    startMin: number;
    endMin: number;
    status: BookingScheduleStatus;
    title?: null | string;
    courtName?: null | string;
    participants?: null | number;
    capacity?: null | number;
    outsideTrainerHours?: null | TrainerOffScheduleReason;
};

export enum TrainerCalendarEventKind {
    BOOKING = 'booking',
    GROUP_SESSION = 'groupSession'
}

export type TrainerCardDto = {
    id: string;
    firstName: string;
    lastName: string;
    avatarUrl?: null | string;
    ratingAvg: number;
    ratingCount: number;
    yearsExperience: number;
    sports: Array<string>;
    audiences: Array<TrainerAudience>;
    bio?: null | string;
    methodology?: null | string;
    individualRateKopecks: number;
};

export type TrainerCardWithoutLogin = {
    trainerId: string;
    firstName: string;
    lastName: string;
};

export type TrainerClientDetailDto = {
    clientId: string;
    name: string;
    memberCard?: null | string;
    sport?: null | string;
    rating?: null | number;
    ratingCategory?: null | string;
    sessionsTotal: number;
    upcoming: number;
    completed: number;
    noShows: number;
    favouriteTime?: null | string;
    sessions: Array<TrainerClientSessionDto>;
};

export type TrainerClientLookupItem = {
    clientId: string;
    firstName: string;
    lastName: string;
    memberCode: string;
    avatarUrl: string;
};

export type TrainerClientLookupResponse = {
    items: Array<TrainerClientLookupItem>;
};

export type TrainerClientSessionDto = {
    kind: string;
    refId: string;
    date: string;
    startTime: string;
    endTime: string;
    sport?: null | string;
    status: string;
    sessionType?: null | string;
};

export type TrainerClientSummaryDto = {
    clientId: string;
    name: string;
    memberCard?: null | string;
    sport?: null | string;
    rating?: null | number;
    ratingCategory?: null | string;
    sessionsCount: number;
    lastSessionAt?: null | string;
};

export enum TrainerClubClosedKind {
    WEEKDAY = 'weekday',
    CLOSED_DATE = 'closedDate'
}

export enum TrainerDaySource {
    UNRESTRICTED = 'unrestricted',
    TEMPLATE = 'template',
    SPECIAL = 'special',
    VACATION = 'vacation'
}

export type TrainerDayVersionInput = {
    date: string;
    version?: null | string;
};

export type TrainerDetailDto = {
    id: string;
    tenantId: string;
    firstName: string;
    lastName: string;
    sports: Array<string>;
    ratingAvg: number;
    ratingCount: number;
    yearsExperience: number;
    bio?: null | string;
    baseSalary?: null | number;
    individualRate?: null | number;
    groupRate?: null | number;
    groupSplit2Rate?: null | number;
    groupSplit3Rate?: null | number;
    groupSplit4Rate?: null | number;
    gameRate?: null | number;
    assignedPlaceIds: Array<string>;
    avatarUrl?: null | string;
    sessionsLast30: number;
    sessionsNext7: number;
    hoursLast30: number;
    revenueLast30Kopecks?: null | number;
    salaryModel?: null | SalaryModelDto;
    weeklySchedule: Array<WeeklyScheduleEntry>;
    vacationDays: Array<string>;
    isActive: boolean;
    upcomingNext: Array<UpcomingSessionDto>;
    assignedCourts: Array<AssignedCourtDto>;
    methodology?: null | string;
    audiences: Array<TrainerAudience>;
    canEditOwnSchedule: boolean;
    canOpenOwnHours: boolean;
};

export type TrainerFloorResponse = {
    items: Array<TrainerFloorRow>;
};

export type TrainerFloorRow = {
    trainer: TrainerFloorTrainerDto;
    sessions: Array<TrainerFloorSessionDto>;
};

export type TrainerFloorSessionDto = {
    id: string;
    startAt: string;
    endAt: string;
    status: BookingScheduleStatus;
    courtId: string;
    courtName?: null | string;
    sport?: null | string;
    clientName?: null | string;
    title?: null | string;
    outsideTrainerHours?: null | TrainerOffScheduleReason;
};

export type TrainerFloorTrainerDto = {
    id: string;
    firstName: string;
    lastName: string;
    sports: Array<string>;
    ratingAvg: number;
    avatarUrl?: null | string;
    isActive: boolean;
    weeklySchedule: Array<WeeklyScheduleEntry>;
    vacationDays: Array<string>;
    assignedPlaceIds: Array<string>;
    workingIntervals: Array<ScheduleInterval>;
    daySource: TrainerDaySource;
};

export enum TrainerHoursOpening {
    ENFORCE = 'enforce',
    OPEN = 'open',
    OPEN_AND_LIFT_VACATION = 'openAndLiftVacation'
}

export type TrainerListItemDto = {
    id: string;
    firstName: string;
    lastName: string;
    sports: Array<string>;
    ratingAvg: number;
    ratingCount: number;
    yearsExperience: number;
    bio?: null | string;
    baseSalary?: null | number;
    individualRate?: null | number;
    groupRate?: null | number;
    assignedPlaceIds: Array<string>;
    avatarUrl?: null | string;
    sessionsLast30: number;
    sessionsNext7: number;
};

export enum TrainerOffScheduleReason {
    VACATION = 'vacation',
    DAY_OFF = 'dayOff',
    OUTSIDE_HOURS = 'outsideHours',
    TIME_CLOSED = 'timeClosed'
}

export type TrainerOpenWindowInput = {
    date: string;
    startMin: number;
    endMin: number;
};

export type TrainerProfilePhotoResponse = {
    avatarUrl: string;
};

export type TrainerReviewDto = {
    id: string;
    stars: number;
    comment?: null | string;
    authorName: string;
    subjectKind: TrainerReviewSubject;
    createdAt: string;
};

export enum TrainerReviewSubject {
    BOOKING = 'booking',
    GROUP_SESSION = 'groupSession'
}

export type TrainerReviewsResponse = {
    ratingAvg: number;
    ratingCount: number;
    countsByStars: Array<number>;
    items: Array<TrainerReviewDto>;
    nextCursor?: null | string;
    hasMore: boolean;
};

export type TrainerRow = {
    trainerId: string;
    firstName: string;
    lastName: string;
    sports: Array<string>;
    ratingAvg: number;
    sessions: number;
    hours: number;
    uniqueClients: number;
    isActive: boolean;
};

export type TrainerSalaryModel = {
    type?: SalaryType;
    baseAmountKopecks?: null | number;
    percentOfSession?: null | number;
};

export type TrainerSalaryPreviewDto = {
    trainerId: string;
    from: string;
    to: string;
    days: number;
    model: SalaryType;
    baseKopecks: number;
    percentOfSession: number;
    individualSessions: number;
    individualPayoutKopecks: number;
    groupSessions: number;
    groupPayoutKopecks: number;
    sessions: Array<TrainerSalarySessionDto>;
    excludedRefunded: number;
    totalKopecks: number;
    floorKopecks: number;
    commissionKopecks: number;
    bonusKopecks: number;
    deductionsKopecks: number;
    individualRevenueKopecks: number;
    groupRevenueKopecks: number;
    awaitingPayment: number;
};

export type TrainerSalarySessionDto = {
    id: string;
    startAt: string;
    endAt: string;
    clientName: string;
    courtName: string;
    pricePaidKopecks: number;
    payoutKopecks: number;
};

export type TrainerScheduleChangeBody = {
    template?: null | Array<WeeklyScheduleEntry>;
    set?: null | Array<TrainerSpecialDayInput>;
    clear?: null | Array<string>;
    open?: null | Array<TrainerOpenWindowInput>;
    liftVacation?: boolean;
    vacationAdd?: null | Array<string>;
    vacationRemove?: null | Array<string>;
    expectedDays?: null | Array<TrainerDayVersionInput>;
    expectedTemplateVersion?: null | string;
    dryRun?: boolean;
};

export type TrainerScheduleChangeResult = {
    templateVersion: string;
    days: Array<TrainerCalendarDayDto>;
    offSchedule: OffScheduleReport;
    undo?: null | TrainerScheduleChangeBody;
};

export type TrainerScheduleItemDto = {
    id: string;
    startAt: string;
    endAt: string;
    status: BookingScheduleStatus;
    courtName?: null | string;
    sport?: null | string;
    clientName?: null | string;
    split?: null | BookingSplitSummary;
};

export type TrainerScheduleResponse = {
    items: Array<TrainerScheduleItemDto>;
};

export type TrainerSnippet = {
    id: string;
    firstName: string;
    lastName: string;
    ratingAvg: number;
};

export type TrainerSpecialDayDto = {
    intervals: Array<ScheduleInterval>;
    reason?: null | string;
};

export type TrainerSpecialDayInput = {
    date: string;
    intervals: Array<ScheduleInterval>;
    reason?: null | string;
};

export enum TrainingFormat {
    INDIVIDUAL = 'individual',
    GROUP = 'group'
}

export type TransferAdvanceToBonusResult = {
    depositBalanceKopecks: number;
    bonusBalanceKopecks: number;
    at: string;
};

export type TransferToBonusPayload = {
    amountKopecks?: null | number;
    idempotencyKey: string;
};

export type TrendPointDto = {
    date: string;
    count: number;
};

export enum UnfiscalisedClass {
    NEVER_SENT = 'neverSent',
    AWAITING_ANSWER = 'awaitingAnswer',
    REFUSED = 'refused',
    UNKNOWN = 'unknown',
    RESOLVE_BY_HAND = 'resolveByHand',
    CANNOT_BE_FISCALISED = 'cannotBeFiscalised'
}

export type UnfiscalisedSale = {
    saleId: string;
    createdAt: string;
    totalKopecks: number;
    isReturn: boolean;
    class: UnfiscalisedClass;
    handReason?: null | FiscalHandReason;
    refusalText?: null | string;
    obstacleCode?: null | string;
    obstacleText?: null | string;
};

export type UnfiscalisedSalesResponse = {
    kkmEnabled: boolean;
    shiftId?: null | string;
    sales: Array<UnfiscalisedSale>;
};

export type UnreadCountDto = {
    count: number;
};

export type UnregisterFromTournamentResponse = {
    refundAmountKopecks: number;
    atTheTillKopecks: number;
};

export type UpcomingBookingDto = {
    id: string;
    sport: string;
    courtName: string;
    isIndoor: boolean;
    date: string;
    startTime: string;
    endTime: string;
    status: string;
    priceKopecks: number;
};

export type UpcomingSessionDto = {
    id: string;
    startAt: string;
    endAt: string;
    courtName?: null | string;
    sport?: null | string;
    status: BookingScheduleStatus;
};

export type UpcomingTournamentDto = {
    id: string;
    name: string;
    date: string;
    sport: string;
    format: string;
    registeredCount: number;
    maxPlayers: number;
    entryFeeKopecks: number;
    levelRange?: null | LevelRangeDto;
    gradientFrom?: null | string;
    gradientTo?: null | string;
};

export type UpdateAccessDeviceCommand = {
    deviceId: string;
    name?: null | string;
    deviceType?: null | DeviceType;
    zoneId?: null | string;
    vendor?: null | string;
    externalAccessPointId?: null | number;
};

export type UpdateAccessZonePayload = {
    name: string;
    zoneType: ZoneType;
    requiresBooking: boolean;
    requiresMembership: boolean;
    requiresSubscription: boolean;
    maxCapacity?: null | number;
    accessWindowBeforeMinutes: number;
    accessWindowAfterMinutes: number;
    isActive: boolean;
    externalZoneId?: null | number;
};

export type UpdateBonusRulePayload = {
    label?: null | string;
    amount?: null | number;
    amountMode?: null | string;
    triggerVisits?: null | number;
    minOrderAmount?: null | number;
    expiresAfterDays?: null | number;
    description?: null | string;
    enabled?: null | boolean;
    sortOrder?: null | number;
};

export type UpdateCardCategoryPayload = {
    label?: null | string;
    courtDiscountPct?: null | number;
    trainerDiscountPct?: null | number;
    retentionThreshold?: null | number;
    gradientFrom?: null | string;
    gradientTo?: null | string;
    enabled?: null | boolean;
    bookingHorizonDays?: null | number;
    parallelCourts?: null | number;
};

export type UpdateClientHighlightPayload = {
    highlight?: null | string;
};

export type UpdateClientNotePayload = {
    text?: null | string;
    expectedNote?: null | string;
    mode?: ClientNoteMode;
};

export type UpdateCourtOptionPayload = {
    label?: null | string;
    description?: null | string;
    category?: null | string;
    icon?: null | string;
    color?: null | string;
    priceDelta?: null | number;
    priceMode?: null | string;
    enabled?: null | boolean;
    sortOrder?: null | number;
};

export type UpdateCourtPayload = {
    name?: null | string;
    sport?: null | string;
    type?: null | string;
    basePricePerHourRubles?: null | number;
    active?: null | boolean;
    optionIds?: null | Array<string>;
};

export type UpdateDeliveryPreferencesPayload = {
    emailEnabled: boolean;
    pushEnabled: boolean;
    quietHoursEnabled: boolean;
    quietHoursStart?: null | string;
    quietHoursEnd?: null | string;
    timeZoneId?: null | string;
    smsEnabled?: boolean;
    telegramEnabled?: boolean;
    mutedCategories?: null | Array<NotificationCategory>;
};

export type UpdateGroupSessionBody = {
    trainerId: string;
    resourceId: string;
    sessionType: SessionType;
    date: string;
    startTime: string;
    endTime: string;
    maxParticipants: number;
    pricePerPersonKopecks: number;
    title?: null | string;
    description?: null | string;
    level: SessionLevel;
    direction?: null | ActivityDirection;
    waitlistDepth?: null | number;
    subscriptionTemplateIds?: null | Array<string>;
    openTrainerHours?: TrainerHoursOpening;
};

export type UpdateGuestRequest = {
    firstName: string;
    lastName: string;
    phone?: null | string;
    documentId?: null | string;
    birthDate?: null | string;
    note?: null | string;
};

export type UpdateMyNameBody = {
    firstName?: null | string;
    lastName?: null | string;
};

export type UpdateMyProfileRequest = {
    firstName: string;
    lastName: string;
    birthDate?: null | string;
    gender?: null | ClientGender;
};

export type UpdateNotificationPolicyCommand = {
    clientDisableableCategories?: null | Array<NotificationCategory>;
    quietHoursEnabled?: null | boolean;
    quietHoursFrom?: null | string;
    quietHoursTo?: null | string;
};

export type UpdateNotificationTemplatePayload = {
    titleTemplate: string;
    bodyTemplate: string;
    htmlBodyTemplate?: null | string;
};

export type UpdateOrganizationBody = {
    name: string;
    legalName?: null | string;
    inn?: null | string;
    kpp?: null | string;
    contactEmail?: null | string;
    contactPhone?: null | string;
    ogrn?: null | string;
    legalAddress?: null | string;
    postalAddress?: null | string;
    bankName?: null | string;
    bik?: null | string;
    settlementAccount?: null | string;
    correspondentAccount?: null | string;
    contactPersonName?: null | string;
    contactPersonPosition?: null | string;
    invoiceEmail?: null | string;
    contractNumber?: null | string;
    contractDate?: null | string;
    vatMode?: null | OrganizationVatMode;
    paymentTermDays?: null | number;
};

export type UpdatePlaceBody = {
    name: string;
    capacity?: null | number;
    isIndoor: boolean;
    isActive: boolean;
    sortOrder: number;
};

export type UpdatePlatformAcquiringRequest = {
    enabled: boolean;
    cardProvider?: null | string;
    tBankTerminalKey?: null | string;
    tBankPassword?: null | string;
    cloudPaymentsPublicId?: null | string;
    cloudPaymentsApiSecret?: null | string;
};

export type UpdatePlatformPlanRequest = {
    name: string;
    tagline?: null | string;
    monthlyPriceKopecks: number;
    courtsLimit: number;
    staffLimit: number;
    clientsLimit: number;
    bookingsPerMonthLimit: number;
    fitnessMembersLimit: number;
    sortOrder: number;
    isPublic: boolean;
    reason?: null | string;
    version: number;
    courtsModule: boolean;
    fitnessModule: boolean;
};

export type UpdatePlatformRequisitesRequest = {
    sellerLegalName?: null | string;
    sellerInn?: null | string;
    sellerKpp?: null | string;
    sellerLegalAddress?: null | string;
    bankName?: null | string;
    bankBik?: null | string;
    bankAccount?: null | string;
    bankCorrAccount?: null | string;
    vatRatePercent?: null | number;
    vatBasisText?: null | string;
    contractReference?: null | string;
    taxSystem?: null | string;
    paymentTermDays: number;
    transitAllowanceDays: number;
};

export type UpdateProductPayload = {
    name?: null | string;
    price?: null | number;
    sport?: null | string;
    enabled?: null | boolean;
    sortOrder?: null | number;
    unit?: null | string;
    includedInTraining?: null | boolean;
    tillOnly?: null | boolean;
};

export type UpdatePromocodePayload = {
    kind?: null | string;
    amount?: null | number;
    area?: null | PromocodeAreaDto;
    validFrom?: null | string;
    validUntil?: null | string;
    maxRedemptions?: null | number;
    minOrderAmount?: null | number;
    enabled?: null | boolean;
    maxRedemptionsPerClient?: null | number;
};

export type UpdateReminderPayload = {
    minutesBefore?: null | number;
    channel?: null | string;
    appliesTo?: null | string;
    enabled?: null | boolean;
};

export type UpdateSettingsBody = {
    acceptSocialConsent?: null | boolean;
    allowFriendRequests?: null | boolean;
    shareActivityWithFriends?: null | boolean;
    directMessages?: null | DirectMessageAudience;
};

export type UpdateSportPayload = {
    label?: null | string;
    sortOrder?: null | number;
    icon?: null | string;
    color?: null | string;
    state?: null | SportState;
};

export type UpdateSubscriptionTemplatePayload = {
    name?: null | string;
    sport?: null | string;
    sessionsTotal?: null | number;
    gymVisitsTotal?: null | number;
    validForDays?: null | number;
    price?: null | number;
    transferable?: null | boolean;
    publishedInApp?: null | boolean;
    enabled?: null | boolean;
    direction?: null | ActivityDirection;
    clearSport?: null | boolean;
    kind?: null | SubscriptionKind;
    gymVisitsKind?: null | SubscriptionKind;
    scope?: null | SubscriptionScope;
    trainerId?: null | string;
    freezeDaysAllowed?: null | number;
    guestVisitsTotal?: null | number;
    promocodeWithSubscription?: null | PromocodeWithSubscription;
};

export type UpdateTenantMemberContactsRequest = {
    firstName?: null | string;
    lastName?: null | string;
    phone?: null | string;
    email?: null | string;
};

export type UpdateTenantMemberRoleRequest = {
    role: string;
};

export type UpdateTournamentBody = {
    name?: null | string;
    description?: null | string;
    note?: null | string;
    entryFeeKopecks?: null | number;
    prizePoolKopecks?: null | number;
    pointsPerMatch?: null | number;
    maxPlayers?: null | number;
    prizeDistribution?: null | Array<PrizeShareBody>;
    status?: null | TournamentStatus;
    registrationOpensAt?: null | string;
    registrationClosesAt?: null | string;
    gradientFrom?: null | string;
    gradientTo?: null | string;
    scoring?: null | ScoringMode;
    minPlayers?: null | number;
    level?: null | LevelBandBody;
    hideParticipants?: null | boolean;
    prizeDestination?: null | PrizeDestination;
};

export type UpdateTournamentResponse = {
    id: string;
    status: TournamentStatus;
};

export type UpdateTrainerBody = {
    firstName?: null | string;
    lastName?: null | string;
    sports?: null | Array<string>;
    bio?: null | string;
    yearsExperience?: null | number;
    individualRate?: null | number;
    groupRate?: null | number;
    baseSalary?: null | number;
    groupSplit2Rate?: null | number;
    groupSplit3Rate?: null | number;
    groupSplit4Rate?: null | number;
    gameRate?: null | number;
    assignedPlaceIds?: null | Array<string>;
    salaryModel?: null | TrainerSalaryModel;
    isActive?: null | boolean;
    methodology?: null | string;
    audiences?: null | Array<TrainerAudience>;
    canEditOwnSchedule?: null | boolean;
    canOpenOwnHours?: null | boolean;
};

export type UserDto = {
    id: string;
    email?: null | string;
    phoneNumber?: null | string;
    firstName?: null | string;
    lastName?: null | string;
    roles: Array<string>;
    permissions: Array<string>;
    tenantId?: null | string;
    tenantName?: null | string;
    clubTimezone?: null | string;
    hasPassword: boolean;
};

export type UserListItemDto = {
    id: string;
    email?: null | string;
    firstName?: null | string;
    lastName?: null | string;
    roles: Array<string>;
};

export type UserPermissionOverrideDto = {
    id: string;
    permission: string;
    effect: string;
    reason?: null | string;
    expiresAt?: null | string;
    createdAt: string;
    grantedBy: string;
};

export enum VatRate {
    NO_VAT = 'noVat',
    VAT0 = 'vat0',
    VAT5 = 'vat5',
    VAT7 = 'vat7',
    VAT10 = 'vat10',
    VAT20 = 'vat20',
    VAT22 = 'vat22'
}

export type VerifyOtpCommand = {
    phone: string;
    code: string;
    audience?: null | SessionAudience;
};

export type VkAuthCallbackBody = {
    code?: null | string;
    deviceId?: null | string;
    state?: null | string;
};

export type VkAuthStartResponse = {
    authorizeUrl: string;
    state: string;
    redirectUri: string;
};

export enum WaitlistMode {
    MANUAL = 'manual',
    OFF = 'off',
    AUTO_BOOK = 'autoBook'
}

export enum WaitlistStatus {
    WAITING = 'waiting',
    OFFERED = 'offered',
    ACCEPTED = 'accepted',
    DECLINED = 'declined',
    EXPIRED = 'expired',
    CANCELLED = 'cancelled'
}

export type WalletDto = {
    depositKopecks: number;
    bonusesKopecks: number;
    bonusExpiresAt?: null | string;
    currency: string;
    bonusExpiringKopecks?: null | number;
};

export type WalletSpendingCategoryDto = {
    category: DepositTxCategory;
    kopecks: number;
};

export type WalletSpendingDto = {
    month: string;
    moneyKopecks: number;
    cardKopecks: number;
    refundedKopecks: number;
    totalKopecks: number;
    bonusKopecks: number;
    byCategory: Array<WalletSpendingCategoryDto>;
    previousMonthTotalKopecks: number;
};

export enum WalletTopupChannel {
    APP = 'app',
    PAYMENT_LINK = 'paymentLink',
    TILL = 'till',
    CORRECTION = 'correction'
}

export type WalletTopupDto = {
    id: string;
    createdAt: string;
    amountKopecks: number;
    channel: WalletTopupChannel;
    method?: null | WalletTopupMethod;
    performedById?: null | string;
    performedByName?: null | string;
    comment?: null | string;
    receipt?: null | TillTopupReceipt;
};

export enum WalletTopupMethod {
    CARD = 'card',
    SBP = 'sbp',
    CASH = 'cash',
    MIXED = 'mixed'
}

export enum WalletTopupReceiptState {
    REGISTERED = 'registered',
    PENDING = 'pending',
    REFUSED = 'refused',
    NOT_ISSUED = 'notIssued'
}

export type WeeklyScheduleEntry = {
    dayOfWeek: number;
    startMin: number;
    endMin: number;
};

export type WithdrawPlanChangeRequest = {
    confirmedAnnulledDocument?: null | string;
};

export type ZReport = {
    generatedAt: string;
    totalSales: number;
    totalRefunds: number;
    saleCount: number;
    refundCount: number;
    byMethod: Array<ZReportByMethod>;
    byKind: Array<ZReportByKind>;
    expectedCash?: null | number;
    countedCash?: null | number;
    cashDifference?: null | number;
    unfiscalisedSales?: null | Array<UnfiscalisedSale>;
};

export type ZReportByKind = {
    kind: ProductKind;
    gross: number;
    count: number;
};

export type ZReportByMethod = {
    method: PosPaymentMethod;
    gross: number;
    count: number;
};

export type ZoneClientDto = {
    clientId: string;
    enteredAt: string;
};

export type ZoneClientsResponse = {
    zoneId: string;
    clients: Array<ZoneClientDto>;
    totalCount: number;
};

export type ZoneOccupancyDto = {
    zoneId: string;
    zoneName: string;
    zoneType: string;
    currentCount: number;
    maxCapacity?: null | number;
};

export enum ZoneType {
    ENTRANCE = 'entrance',
    SPORT_ZONE = 'sportZone',
    FITNESS_ZONE = 'fitnessZone',
    VIP = 'vip',
    LOCKER_ROOM = 'lockerRoom'
}

export type PostApiV1AccessCheckData = {
    body: CheckAccessPayload;
    path?: never;
    query?: never;
    url: '/api/v1/access/check';
};

export type PostApiV1AccessCheckErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AccessCheckError = PostApiV1AccessCheckErrors[keyof PostApiV1AccessCheckErrors];

export type PostApiV1AccessCheckResponses = {
    /**
     * OK
     */
    200: CheckAccessResponse;
};

export type PostApiV1AccessCheckResponse = PostApiV1AccessCheckResponses[keyof PostApiV1AccessCheckResponses];

export type GetApiV1AccessClientsByClientIdSigurLinkData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/access/clients/{clientId}/sigur-link';
};

export type GetApiV1AccessClientsByClientIdSigurLinkErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AccessClientsByClientIdSigurLinkError = GetApiV1AccessClientsByClientIdSigurLinkErrors[keyof GetApiV1AccessClientsByClientIdSigurLinkErrors];

export type GetApiV1AccessClientsByClientIdSigurLinkResponses = {
    /**
     * OK
     */
    200: ClientSigurLinkDto;
};

export type GetApiV1AccessClientsByClientIdSigurLinkResponse = GetApiV1AccessClientsByClientIdSigurLinkResponses[keyof GetApiV1AccessClientsByClientIdSigurLinkResponses];

export type PutApiV1AccessClientsByClientIdSigurLinkData = {
    body: SetClientSigurLinkRequest;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/access/clients/{clientId}/sigur-link';
};

export type PutApiV1AccessClientsByClientIdSigurLinkResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetApiV1AccessDevicesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/access/devices';
};

export type GetApiV1AccessDevicesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AccessDevicesError = GetApiV1AccessDevicesErrors[keyof GetApiV1AccessDevicesErrors];

export type GetApiV1AccessDevicesResponses = {
    /**
     * OK
     */
    200: Array<AccessDeviceDto>;
};

export type GetApiV1AccessDevicesResponse = GetApiV1AccessDevicesResponses[keyof GetApiV1AccessDevicesResponses];

export type PostApiV1AccessDevicesData = {
    body: CreateAccessDeviceCommand;
    path?: never;
    query?: never;
    url: '/api/v1/access/devices';
};

export type PostApiV1AccessDevicesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AccessDevicesError = PostApiV1AccessDevicesErrors[keyof PostApiV1AccessDevicesErrors];

export type PostApiV1AccessDevicesResponses = {
    /**
     * Created
     */
    201: EntityIdResponse;
};

export type PostApiV1AccessDevicesResponse = PostApiV1AccessDevicesResponses[keyof PostApiV1AccessDevicesResponses];

export type DeleteApiV1AccessDevicesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/access/devices/{id}';
};

export type DeleteApiV1AccessDevicesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1AccessDevicesByIdError = DeleteApiV1AccessDevicesByIdErrors[keyof DeleteApiV1AccessDevicesByIdErrors];

export type DeleteApiV1AccessDevicesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1AccessDevicesByIdResponse = DeleteApiV1AccessDevicesByIdResponses[keyof DeleteApiV1AccessDevicesByIdResponses];

export type PatchApiV1AccessDevicesByIdData = {
    body: UpdateAccessDeviceCommand;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/access/devices/{id}';
};

export type PatchApiV1AccessDevicesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1AccessDevicesByIdError = PatchApiV1AccessDevicesByIdErrors[keyof PatchApiV1AccessDevicesByIdErrors];

export type PatchApiV1AccessDevicesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1AccessDevicesByIdResponse = PatchApiV1AccessDevicesByIdResponses[keyof PatchApiV1AccessDevicesByIdResponses];

export type PostApiV1AccessDevicesByIdHeartbeatData = {
    body: HeartbeatAccessDevicePayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/access/devices/{id}/heartbeat';
};

export type PostApiV1AccessDevicesByIdHeartbeatErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AccessDevicesByIdHeartbeatError = PostApiV1AccessDevicesByIdHeartbeatErrors[keyof PostApiV1AccessDevicesByIdHeartbeatErrors];

export type PostApiV1AccessDevicesByIdHeartbeatResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1AccessDevicesByIdHeartbeatResponse = PostApiV1AccessDevicesByIdHeartbeatResponses[keyof PostApiV1AccessDevicesByIdHeartbeatResponses];

export type GetApiV1AccessEventsData = {
    body?: never;
    path?: never;
    query?: {
        ZoneId?: string;
        ClientId?: string;
        Decision?: AccessDecisionType;
        Limit?: number;
        Cursor?: string;
        From?: string;
        To?: string;
    };
    url: '/api/v1/access/events';
};

export type GetApiV1AccessEventsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AccessEventsError = GetApiV1AccessEventsErrors[keyof GetApiV1AccessEventsErrors];

export type GetApiV1AccessEventsResponses = {
    /**
     * OK
     */
    200: PagedListOfAccessEventDto;
};

export type GetApiV1AccessEventsResponse = GetApiV1AccessEventsResponses[keyof GetApiV1AccessEventsResponses];

export type PostApiV1AccessManualPassData = {
    body: ManualPassPayload;
    path?: never;
    query?: never;
    url: '/api/v1/access/manual-pass';
};

export type PostApiV1AccessManualPassErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AccessManualPassError = PostApiV1AccessManualPassErrors[keyof PostApiV1AccessManualPassErrors];

export type PostApiV1AccessManualPassResponses = {
    /**
     * Created
     */
    201: EntityIdResponse;
};

export type PostApiV1AccessManualPassResponse = PostApiV1AccessManualPassResponses[keyof PostApiV1AccessManualPassResponses];

export type GetApiV1AccessMeEventsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
        cursor?: string;
    };
    url: '/api/v1/access/me/events';
};

export type GetApiV1AccessMeEventsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AccessMeEventsError = GetApiV1AccessMeEventsErrors[keyof GetApiV1AccessMeEventsErrors];

export type GetApiV1AccessMeEventsResponses = {
    /**
     * OK
     */
    200: PagedListOfMyAccessEventDto;
};

export type GetApiV1AccessMeEventsResponse = GetApiV1AccessMeEventsResponses[keyof GetApiV1AccessMeEventsResponses];

export type GetApiV1AccessOccupancyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/access/occupancy';
};

export type GetApiV1AccessOccupancyErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AccessOccupancyError = GetApiV1AccessOccupancyErrors[keyof GetApiV1AccessOccupancyErrors];

export type GetApiV1AccessOccupancyResponses = {
    /**
     * OK
     */
    200: OccupancyResponse;
};

export type GetApiV1AccessOccupancyResponse = GetApiV1AccessOccupancyResponses[keyof GetApiV1AccessOccupancyResponses];

export type GetApiV1AccessOccupancySummaryData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/access/occupancy/summary';
};

export type GetApiV1AccessOccupancySummaryErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AccessOccupancySummaryError = GetApiV1AccessOccupancySummaryErrors[keyof GetApiV1AccessOccupancySummaryErrors];

export type GetApiV1AccessOccupancySummaryResponses = {
    /**
     * OK
     */
    200: OccupancySummaryResponse;
};

export type GetApiV1AccessOccupancySummaryResponse = GetApiV1AccessOccupancySummaryResponses[keyof GetApiV1AccessOccupancySummaryResponses];

export type GetApiV1AccessQrData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/access/qr';
};

export type GetApiV1AccessQrErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AccessQrError = GetApiV1AccessQrErrors[keyof GetApiV1AccessQrErrors];

export type GetApiV1AccessQrResponses = {
    /**
     * OK
     */
    200: QrCodeResponse;
};

export type GetApiV1AccessQrResponse = GetApiV1AccessQrResponses[keyof GetApiV1AccessQrResponses];

export type GetApiV1AccessStatusData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/access/status';
};

export type GetApiV1AccessStatusErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AccessStatusError = GetApiV1AccessStatusErrors[keyof GetApiV1AccessStatusErrors];

export type GetApiV1AccessStatusResponses = {
    /**
     * OK
     */
    200: AccessControlStatusDto;
};

export type GetApiV1AccessStatusResponse = GetApiV1AccessStatusResponses[keyof GetApiV1AccessStatusResponses];

export type GetApiV1AccessZonesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/access/zones';
};

export type GetApiV1AccessZonesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AccessZonesError = GetApiV1AccessZonesErrors[keyof GetApiV1AccessZonesErrors];

export type GetApiV1AccessZonesResponses = {
    /**
     * OK
     */
    200: Array<AccessZoneDto>;
};

export type GetApiV1AccessZonesResponse = GetApiV1AccessZonesResponses[keyof GetApiV1AccessZonesResponses];

export type PostApiV1AccessZonesData = {
    body: CreateAccessZoneCommand;
    path?: never;
    query?: never;
    url: '/api/v1/access/zones';
};

export type PostApiV1AccessZonesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AccessZonesError = PostApiV1AccessZonesErrors[keyof PostApiV1AccessZonesErrors];

export type PostApiV1AccessZonesResponses = {
    /**
     * Created
     */
    201: EntityIdResponse;
};

export type PostApiV1AccessZonesResponse = PostApiV1AccessZonesResponses[keyof PostApiV1AccessZonesResponses];

export type DeleteApiV1AccessZonesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/access/zones/{id}';
};

export type DeleteApiV1AccessZonesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1AccessZonesByIdError = DeleteApiV1AccessZonesByIdErrors[keyof DeleteApiV1AccessZonesByIdErrors];

export type DeleteApiV1AccessZonesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1AccessZonesByIdResponse = DeleteApiV1AccessZonesByIdResponses[keyof DeleteApiV1AccessZonesByIdResponses];

export type PutApiV1AccessZonesByIdData = {
    body: UpdateAccessZonePayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/access/zones/{id}';
};

export type PutApiV1AccessZonesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1AccessZonesByIdError = PutApiV1AccessZonesByIdErrors[keyof PutApiV1AccessZonesByIdErrors];

export type PutApiV1AccessZonesByIdResponses = {
    /**
     * OK
     */
    200: AccessZoneDto;
};

export type PutApiV1AccessZonesByIdResponse = PutApiV1AccessZonesByIdResponses[keyof PutApiV1AccessZonesByIdResponses];

export type GetApiV1AccessZonesByIdClientsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/access/zones/{id}/clients';
};

export type GetApiV1AccessZonesByIdClientsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AccessZonesByIdClientsError = GetApiV1AccessZonesByIdClientsErrors[keyof GetApiV1AccessZonesByIdClientsErrors];

export type GetApiV1AccessZonesByIdClientsResponses = {
    /**
     * OK
     */
    200: ZoneClientsResponse;
};

export type GetApiV1AccessZonesByIdClientsResponse = GetApiV1AccessZonesByIdClientsResponses[keyof GetApiV1AccessZonesByIdClientsResponses];

export type GetApiV1AdminActivityData = {
    body?: never;
    path?: never;
    query?: {
        Category?: string;
        From?: string;
        To?: string;
        Page?: number;
        PageSize?: number;
    };
    url: '/api/v1/admin/activity';
};

export type GetApiV1AdminActivityErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AdminActivityError = GetApiV1AdminActivityErrors[keyof GetApiV1AdminActivityErrors];

export type GetApiV1AdminActivityResponses = {
    /**
     * OK
     */
    200: ListActivityResponse;
};

export type GetApiV1AdminActivityResponse = GetApiV1AdminActivityResponses[keyof GetApiV1AdminActivityResponses];

export type GetApiV1AdminActivityGroupSessionsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/activity/group-sessions/{id}';
};

export type GetApiV1AdminActivityGroupSessionsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AdminActivityGroupSessionsByIdError = GetApiV1AdminActivityGroupSessionsByIdErrors[keyof GetApiV1AdminActivityGroupSessionsByIdErrors];

export type GetApiV1AdminActivityGroupSessionsByIdResponses = {
    /**
     * OK
     */
    200: Array<SessionJournalEntryDto>;
};

export type GetApiV1AdminActivityGroupSessionsByIdResponse = GetApiV1AdminActivityGroupSessionsByIdResponses[keyof GetApiV1AdminActivityGroupSessionsByIdResponses];

export type PatchApiV1AdminClientsByIdProfileData = {
    body: AdminCorrectFioPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/clients/{id}/profile';
};

export type PatchApiV1AdminClientsByIdProfileErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1AdminClientsByIdProfileError = PatchApiV1AdminClientsByIdProfileErrors[keyof PatchApiV1AdminClientsByIdProfileErrors];

export type PatchApiV1AdminClientsByIdProfileResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1AdminClientsByIdProfileResponse = PatchApiV1AdminClientsByIdProfileResponses[keyof PatchApiV1AdminClientsByIdProfileResponses];

export type PostApiV1AdminGroupSessionsData = {
    body: CreateGroupSessionBody;
    path?: never;
    query?: never;
    url: '/api/v1/admin/group-sessions';
};

export type PostApiV1AdminGroupSessionsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminGroupSessionsError = PostApiV1AdminGroupSessionsErrors[keyof PostApiV1AdminGroupSessionsErrors];

export type PostApiV1AdminGroupSessionsResponses = {
    /**
     * Created
     */
    201: CreateGroupSessionResponse;
};

export type PostApiV1AdminGroupSessionsResponse = PostApiV1AdminGroupSessionsResponses[keyof PostApiV1AdminGroupSessionsResponses];

export type GetApiV1AdminGroupSessionsAttendanceByClientIdData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: {
        limit?: number;
    };
    url: '/api/v1/admin/group-sessions/attendance/{clientId}';
};

export type GetApiV1AdminGroupSessionsAttendanceByClientIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AdminGroupSessionsAttendanceByClientIdError = GetApiV1AdminGroupSessionsAttendanceByClientIdErrors[keyof GetApiV1AdminGroupSessionsAttendanceByClientIdErrors];

export type GetApiV1AdminGroupSessionsAttendanceByClientIdResponses = {
    /**
     * OK
     */
    200: ClientAttendanceResponse;
};

export type GetApiV1AdminGroupSessionsAttendanceByClientIdResponse = GetApiV1AdminGroupSessionsAttendanceByClientIdResponses[keyof GetApiV1AdminGroupSessionsAttendanceByClientIdResponses];

export type PostApiV1AdminGroupSessionsBulkData = {
    body: BulkGroupSessionActionBody;
    path?: never;
    query?: never;
    url: '/api/v1/admin/group-sessions/bulk';
};

export type PostApiV1AdminGroupSessionsBulkErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminGroupSessionsBulkError = PostApiV1AdminGroupSessionsBulkErrors[keyof PostApiV1AdminGroupSessionsBulkErrors];

export type PostApiV1AdminGroupSessionsBulkResponses = {
    /**
     * OK
     */
    200: BulkGroupSessionActionResponse;
};

export type PostApiV1AdminGroupSessionsBulkResponse = PostApiV1AdminGroupSessionsBulkResponses[keyof PostApiV1AdminGroupSessionsBulkResponses];

export type PostApiV1AdminGroupSessionsCopyWeekData = {
    body: CopyGroupSessionWeekBody;
    path?: never;
    query?: never;
    url: '/api/v1/admin/group-sessions/copy-week';
};

export type PostApiV1AdminGroupSessionsCopyWeekErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminGroupSessionsCopyWeekError = PostApiV1AdminGroupSessionsCopyWeekErrors[keyof PostApiV1AdminGroupSessionsCopyWeekErrors];

export type PostApiV1AdminGroupSessionsCopyWeekResponses = {
    /**
     * OK
     */
    200: CopyGroupSessionWeekResponse;
};

export type PostApiV1AdminGroupSessionsCopyWeekResponse = PostApiV1AdminGroupSessionsCopyWeekResponses[keyof PostApiV1AdminGroupSessionsCopyWeekResponses];

export type PatchApiV1AdminGroupSessionsByIdData = {
    body: UpdateGroupSessionBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/group-sessions/{id}';
};

export type PatchApiV1AdminGroupSessionsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1AdminGroupSessionsByIdError = PatchApiV1AdminGroupSessionsByIdErrors[keyof PatchApiV1AdminGroupSessionsByIdErrors];

export type PatchApiV1AdminGroupSessionsByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1AdminGroupSessionsByIdResponse = PatchApiV1AdminGroupSessionsByIdResponses[keyof PatchApiV1AdminGroupSessionsByIdResponses];

export type PostApiV1AdminGroupSessionsByIdDiscardData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/group-sessions/{id}/discard';
};

export type PostApiV1AdminGroupSessionsByIdDiscardErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminGroupSessionsByIdDiscardError = PostApiV1AdminGroupSessionsByIdDiscardErrors[keyof PostApiV1AdminGroupSessionsByIdDiscardErrors];

export type PostApiV1AdminGroupSessionsByIdDiscardResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1AdminGroupSessionsByIdDiscardResponse = PostApiV1AdminGroupSessionsByIdDiscardResponses[keyof PostApiV1AdminGroupSessionsByIdDiscardResponses];

export type GetApiV1AdminGroupSessionsByIdFollowingData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/group-sessions/{id}/following';
};

export type GetApiV1AdminGroupSessionsByIdFollowingErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AdminGroupSessionsByIdFollowingError = GetApiV1AdminGroupSessionsByIdFollowingErrors[keyof GetApiV1AdminGroupSessionsByIdFollowingErrors];

export type GetApiV1AdminGroupSessionsByIdFollowingResponses = {
    /**
     * OK
     */
    200: SessionAndFollowingCount;
};

export type GetApiV1AdminGroupSessionsByIdFollowingResponse = GetApiV1AdminGroupSessionsByIdFollowingResponses[keyof GetApiV1AdminGroupSessionsByIdFollowingResponses];

export type PatchApiV1AdminGroupSessionsByIdFollowingData = {
    body: UpdateGroupSessionBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/group-sessions/{id}/following';
};

export type PatchApiV1AdminGroupSessionsByIdFollowingErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1AdminGroupSessionsByIdFollowingError = PatchApiV1AdminGroupSessionsByIdFollowingErrors[keyof PatchApiV1AdminGroupSessionsByIdFollowingErrors];

export type PatchApiV1AdminGroupSessionsByIdFollowingResponses = {
    /**
     * OK
     */
    200: BulkGroupSessionActionResponse;
};

export type PatchApiV1AdminGroupSessionsByIdFollowingResponse = PatchApiV1AdminGroupSessionsByIdFollowingResponses[keyof PatchApiV1AdminGroupSessionsByIdFollowingResponses];

export type GetApiV1AdminGroupSessionsByIdMoveCheckData = {
    body?: never;
    path: {
        id: string;
    };
    query: {
        date: string;
        startTime: string;
        endTime: string;
        resourceId: string;
        trainerId?: string;
    };
    url: '/api/v1/admin/group-sessions/{id}/move-check';
};

export type GetApiV1AdminGroupSessionsByIdMoveCheckErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AdminGroupSessionsByIdMoveCheckError = GetApiV1AdminGroupSessionsByIdMoveCheckErrors[keyof GetApiV1AdminGroupSessionsByIdMoveCheckErrors];

export type GetApiV1AdminGroupSessionsByIdMoveCheckResponses = {
    /**
     * OK
     */
    200: GroupSessionMoveCheck;
};

export type GetApiV1AdminGroupSessionsByIdMoveCheckResponse = GetApiV1AdminGroupSessionsByIdMoveCheckResponses[keyof GetApiV1AdminGroupSessionsByIdMoveCheckResponses];

export type PostApiV1AdminGroupSessionsByIdPublishData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/group-sessions/{id}/publish';
};

export type PostApiV1AdminGroupSessionsByIdPublishErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminGroupSessionsByIdPublishError = PostApiV1AdminGroupSessionsByIdPublishErrors[keyof PostApiV1AdminGroupSessionsByIdPublishErrors];

export type PostApiV1AdminGroupSessionsByIdPublishResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1AdminGroupSessionsByIdPublishResponse = PostApiV1AdminGroupSessionsByIdPublishResponses[keyof PostApiV1AdminGroupSessionsByIdPublishResponses];

export type GetApiV1AdminNewsData = {
    body?: never;
    path?: never;
    query?: {
        status?: NewsStatus;
        kind?: NewsKind;
        audience?: NewsAudience;
    };
    url: '/api/v1/admin/news';
};

export type GetApiV1AdminNewsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AdminNewsError = GetApiV1AdminNewsErrors[keyof GetApiV1AdminNewsErrors];

export type GetApiV1AdminNewsResponses = {
    /**
     * OK
     */
    200: NewsListResponse;
};

export type GetApiV1AdminNewsResponse = GetApiV1AdminNewsResponses[keyof GetApiV1AdminNewsResponses];

export type PostApiV1AdminNewsData = {
    body: NewsContentInput;
    path?: never;
    query?: never;
    url: '/api/v1/admin/news';
};

export type PostApiV1AdminNewsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminNewsError = PostApiV1AdminNewsErrors[keyof PostApiV1AdminNewsErrors];

export type PostApiV1AdminNewsResponses = {
    /**
     * Created
     */
    201: NewsAdminDto;
};

export type PostApiV1AdminNewsResponse = PostApiV1AdminNewsResponses[keyof PostApiV1AdminNewsResponses];

export type DeleteApiV1AdminNewsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/news/{id}';
};

export type DeleteApiV1AdminNewsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1AdminNewsByIdError = DeleteApiV1AdminNewsByIdErrors[keyof DeleteApiV1AdminNewsByIdErrors];

export type DeleteApiV1AdminNewsByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1AdminNewsByIdResponse = DeleteApiV1AdminNewsByIdResponses[keyof DeleteApiV1AdminNewsByIdResponses];

export type GetApiV1AdminNewsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/news/{id}';
};

export type GetApiV1AdminNewsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AdminNewsByIdError = GetApiV1AdminNewsByIdErrors[keyof GetApiV1AdminNewsByIdErrors];

export type GetApiV1AdminNewsByIdResponses = {
    /**
     * OK
     */
    200: NewsAdminDto;
};

export type GetApiV1AdminNewsByIdResponse = GetApiV1AdminNewsByIdResponses[keyof GetApiV1AdminNewsByIdResponses];

export type PutApiV1AdminNewsByIdData = {
    body: NewsContentInput;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/news/{id}';
};

export type PutApiV1AdminNewsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1AdminNewsByIdError = PutApiV1AdminNewsByIdErrors[keyof PutApiV1AdminNewsByIdErrors];

export type PutApiV1AdminNewsByIdResponses = {
    /**
     * OK
     */
    200: NewsAdminDto;
};

export type PutApiV1AdminNewsByIdResponse = PutApiV1AdminNewsByIdResponses[keyof PutApiV1AdminNewsByIdResponses];

export type PostApiV1AdminNewsByIdArchiveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/news/{id}/archive';
};

export type PostApiV1AdminNewsByIdArchiveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminNewsByIdArchiveError = PostApiV1AdminNewsByIdArchiveErrors[keyof PostApiV1AdminNewsByIdArchiveErrors];

export type PostApiV1AdminNewsByIdArchiveResponses = {
    /**
     * OK
     */
    200: NewsAdminDto;
};

export type PostApiV1AdminNewsByIdArchiveResponse = PostApiV1AdminNewsByIdArchiveResponses[keyof PostApiV1AdminNewsByIdArchiveResponses];

export type PostApiV1AdminNewsByIdFeatureData = {
    body: FeatureNewsBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/news/{id}/feature';
};

export type PostApiV1AdminNewsByIdFeatureErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminNewsByIdFeatureError = PostApiV1AdminNewsByIdFeatureErrors[keyof PostApiV1AdminNewsByIdFeatureErrors];

export type PostApiV1AdminNewsByIdFeatureResponses = {
    /**
     * OK
     */
    200: NewsAdminDto;
};

export type PostApiV1AdminNewsByIdFeatureResponse = PostApiV1AdminNewsByIdFeatureResponses[keyof PostApiV1AdminNewsByIdFeatureResponses];

export type PostApiV1AdminNewsByIdPublishData = {
    body?: null | PublishNewsBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/news/{id}/publish';
};

export type PostApiV1AdminNewsByIdPublishErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminNewsByIdPublishError = PostApiV1AdminNewsByIdPublishErrors[keyof PostApiV1AdminNewsByIdPublishErrors];

export type PostApiV1AdminNewsByIdPublishResponses = {
    /**
     * OK
     */
    200: NewsAdminDto;
};

export type PostApiV1AdminNewsByIdPublishResponse = PostApiV1AdminNewsByIdPublishResponses[keyof PostApiV1AdminNewsByIdPublishResponses];

export type PostApiV1AdminNewsByIdUnpublishData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/news/{id}/unpublish';
};

export type PostApiV1AdminNewsByIdUnpublishErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminNewsByIdUnpublishError = PostApiV1AdminNewsByIdUnpublishErrors[keyof PostApiV1AdminNewsByIdUnpublishErrors];

export type PostApiV1AdminNewsByIdUnpublishResponses = {
    /**
     * OK
     */
    200: NewsAdminDto;
};

export type PostApiV1AdminNewsByIdUnpublishResponse = PostApiV1AdminNewsByIdUnpublishResponses[keyof PostApiV1AdminNewsByIdUnpublishResponses];

export type PostApiV1AdminNotificationsBroadcastData = {
    body: SendBroadcastNotificationCommand;
    path?: never;
    query?: never;
    url: '/api/v1/admin/notifications/broadcast';
};

export type PostApiV1AdminNotificationsBroadcastErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminNotificationsBroadcastError = PostApiV1AdminNotificationsBroadcastErrors[keyof PostApiV1AdminNotificationsBroadcastErrors];

export type PostApiV1AdminNotificationsBroadcastResponses = {
    /**
     * OK
     */
    200: BroadcastNotificationResponse;
};

export type PostApiV1AdminNotificationsBroadcastResponse = PostApiV1AdminNotificationsBroadcastResponses[keyof PostApiV1AdminNotificationsBroadcastResponses];

export type GetApiV1AdminNotificationsOwnerReportsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/admin/notifications/owner-reports';
};

export type GetApiV1AdminNotificationsOwnerReportsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AdminNotificationsOwnerReportsError = GetApiV1AdminNotificationsOwnerReportsErrors[keyof GetApiV1AdminNotificationsOwnerReportsErrors];

export type GetApiV1AdminNotificationsOwnerReportsResponses = {
    /**
     * OK
     */
    200: OwnerReportSettingsDto;
};

export type GetApiV1AdminNotificationsOwnerReportsResponse = GetApiV1AdminNotificationsOwnerReportsResponses[keyof GetApiV1AdminNotificationsOwnerReportsResponses];

export type PutApiV1AdminNotificationsOwnerReportsData = {
    body: OwnerReportSettingsBody;
    path?: never;
    query?: never;
    url: '/api/v1/admin/notifications/owner-reports';
};

export type PutApiV1AdminNotificationsOwnerReportsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1AdminNotificationsOwnerReportsError = PutApiV1AdminNotificationsOwnerReportsErrors[keyof PutApiV1AdminNotificationsOwnerReportsErrors];

export type PutApiV1AdminNotificationsOwnerReportsResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1AdminNotificationsOwnerReportsResponse = PutApiV1AdminNotificationsOwnerReportsResponses[keyof PutApiV1AdminNotificationsOwnerReportsResponses];

export type GetApiV1AdminNotificationsPolicyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/admin/notifications/policy';
};

export type GetApiV1AdminNotificationsPolicyErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AdminNotificationsPolicyError = GetApiV1AdminNotificationsPolicyErrors[keyof GetApiV1AdminNotificationsPolicyErrors];

export type GetApiV1AdminNotificationsPolicyResponses = {
    /**
     * OK
     */
    200: NotificationPolicyDto;
};

export type GetApiV1AdminNotificationsPolicyResponse = GetApiV1AdminNotificationsPolicyResponses[keyof GetApiV1AdminNotificationsPolicyResponses];

export type PutApiV1AdminNotificationsPolicyData = {
    body: UpdateNotificationPolicyCommand;
    path?: never;
    query?: never;
    url: '/api/v1/admin/notifications/policy';
};

export type PutApiV1AdminNotificationsPolicyErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1AdminNotificationsPolicyError = PutApiV1AdminNotificationsPolicyErrors[keyof PutApiV1AdminNotificationsPolicyErrors];

export type PutApiV1AdminNotificationsPolicyResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1AdminNotificationsPolicyResponse = PutApiV1AdminNotificationsPolicyResponses[keyof PutApiV1AdminNotificationsPolicyResponses];

export type GetApiV1AdminNotificationsTemplatesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/admin/notifications/templates';
};

export type GetApiV1AdminNotificationsTemplatesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AdminNotificationsTemplatesError = GetApiV1AdminNotificationsTemplatesErrors[keyof GetApiV1AdminNotificationsTemplatesErrors];

export type GetApiV1AdminNotificationsTemplatesResponses = {
    /**
     * OK
     */
    200: Array<NotificationTemplateDto>;
};

export type GetApiV1AdminNotificationsTemplatesResponse = GetApiV1AdminNotificationsTemplatesResponses[keyof GetApiV1AdminNotificationsTemplatesResponses];

export type PutApiV1AdminNotificationsTemplatesByIdData = {
    body: UpdateNotificationTemplatePayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/notifications/templates/{id}';
};

export type PutApiV1AdminNotificationsTemplatesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1AdminNotificationsTemplatesByIdError = PutApiV1AdminNotificationsTemplatesByIdErrors[keyof PutApiV1AdminNotificationsTemplatesByIdErrors];

export type PutApiV1AdminNotificationsTemplatesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1AdminNotificationsTemplatesByIdResponse = PutApiV1AdminNotificationsTemplatesByIdResponses[keyof PutApiV1AdminNotificationsTemplatesByIdResponses];

export type PostApiV1AdminSalaryCalculateData = {
    body: CalculateSalaryRequest;
    path?: never;
    query?: never;
    url: '/api/v1/admin/salary/calculate';
};

export type PostApiV1AdminSalaryCalculateErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminSalaryCalculateError = PostApiV1AdminSalaryCalculateErrors[keyof PostApiV1AdminSalaryCalculateErrors];

export type PostApiV1AdminSalaryCalculateResponses = {
    /**
     * Created
     */
    201: EntityIdResponse;
};

export type PostApiV1AdminSalaryCalculateResponse = PostApiV1AdminSalaryCalculateResponses[keyof PostApiV1AdminSalaryCalculateResponses];

export type GetApiV1AdminSalaryPeriodsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
    };
    url: '/api/v1/admin/salary/periods';
};

export type GetApiV1AdminSalaryPeriodsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AdminSalaryPeriodsError = GetApiV1AdminSalaryPeriodsErrors[keyof GetApiV1AdminSalaryPeriodsErrors];

export type GetApiV1AdminSalaryPeriodsResponses = {
    /**
     * OK
     */
    200: Array<SalaryPeriodDto>;
};

export type GetApiV1AdminSalaryPeriodsResponse = GetApiV1AdminSalaryPeriodsResponses[keyof GetApiV1AdminSalaryPeriodsResponses];

export type GetApiV1AdminSalaryPeriodsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/salary/periods/{id}';
};

export type GetApiV1AdminSalaryPeriodsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AdminSalaryPeriodsByIdError = GetApiV1AdminSalaryPeriodsByIdErrors[keyof GetApiV1AdminSalaryPeriodsByIdErrors];

export type GetApiV1AdminSalaryPeriodsByIdResponses = {
    /**
     * OK
     */
    200: SalaryPeriodDetailResponse;
};

export type GetApiV1AdminSalaryPeriodsByIdResponse = GetApiV1AdminSalaryPeriodsByIdResponses[keyof GetApiV1AdminSalaryPeriodsByIdResponses];

export type PostApiV1AdminSalaryPeriodsByIdApproveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/salary/periods/{id}/approve';
};

export type PostApiV1AdminSalaryPeriodsByIdApproveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminSalaryPeriodsByIdApproveError = PostApiV1AdminSalaryPeriodsByIdApproveErrors[keyof PostApiV1AdminSalaryPeriodsByIdApproveErrors];

export type PostApiV1AdminSalaryPeriodsByIdApproveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1AdminSalaryPeriodsByIdApproveResponse = PostApiV1AdminSalaryPeriodsByIdApproveResponses[keyof PostApiV1AdminSalaryPeriodsByIdApproveResponses];

export type GetApiV1AdminSalaryPeriodsByIdTrainersByTrainerIdItemsData = {
    body?: never;
    path: {
        id: string;
        trainerId: string;
    };
    query?: never;
    url: '/api/v1/admin/salary/periods/{id}/trainers/{trainerId}/items';
};

export type GetApiV1AdminSalaryPeriodsByIdTrainersByTrainerIdItemsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AdminSalaryPeriodsByIdTrainersByTrainerIdItemsError = GetApiV1AdminSalaryPeriodsByIdTrainersByTrainerIdItemsErrors[keyof GetApiV1AdminSalaryPeriodsByIdTrainersByTrainerIdItemsErrors];

export type GetApiV1AdminSalaryPeriodsByIdTrainersByTrainerIdItemsResponses = {
    /**
     * OK
     */
    200: SalaryBreakdownResponse;
};

export type GetApiV1AdminSalaryPeriodsByIdTrainersByTrainerIdItemsResponse = GetApiV1AdminSalaryPeriodsByIdTrainersByTrainerIdItemsResponses[keyof GetApiV1AdminSalaryPeriodsByIdTrainersByTrainerIdItemsResponses];

export type GetApiV1AdminTrainersByIdClassesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/trainers/{id}/classes';
};

export type GetApiV1AdminTrainersByIdClassesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AdminTrainersByIdClassesError = GetApiV1AdminTrainersByIdClassesErrors[keyof GetApiV1AdminTrainersByIdClassesErrors];

export type GetApiV1AdminTrainersByIdClassesResponses = {
    /**
     * OK
     */
    200: Array<string>;
};

export type GetApiV1AdminTrainersByIdClassesResponse = GetApiV1AdminTrainersByIdClassesResponses[keyof GetApiV1AdminTrainersByIdClassesResponses];

export type PutApiV1AdminTrainersByIdClassesData = {
    body: SetTrainerClassesBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/trainers/{id}/classes';
};

export type PutApiV1AdminTrainersByIdClassesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1AdminTrainersByIdClassesError = PutApiV1AdminTrainersByIdClassesErrors[keyof PutApiV1AdminTrainersByIdClassesErrors];

export type PutApiV1AdminTrainersByIdClassesResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1AdminTrainersByIdClassesResponse = PutApiV1AdminTrainersByIdClassesResponses[keyof PutApiV1AdminTrainersByIdClassesResponses];

export type PostApiV1AdminTrainersByIdScheduleChangesData = {
    body: TrainerScheduleChangeBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/trainers/{id}/schedule/changes';
};

export type PostApiV1AdminTrainersByIdScheduleChangesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminTrainersByIdScheduleChangesError = PostApiV1AdminTrainersByIdScheduleChangesErrors[keyof PostApiV1AdminTrainersByIdScheduleChangesErrors];

export type PostApiV1AdminTrainersByIdScheduleChangesResponses = {
    /**
     * OK
     */
    200: TrainerScheduleChangeResult;
};

export type PostApiV1AdminTrainersByIdScheduleChangesResponse = PostApiV1AdminTrainersByIdScheduleChangesResponses[keyof PostApiV1AdminTrainersByIdScheduleChangesResponses];

export type GetApiV1AdminUsersByIdPermissionsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/users/{id}/permissions';
};

export type GetApiV1AdminUsersByIdPermissionsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AdminUsersByIdPermissionsError = GetApiV1AdminUsersByIdPermissionsErrors[keyof GetApiV1AdminUsersByIdPermissionsErrors];

export type GetApiV1AdminUsersByIdPermissionsResponses = {
    /**
     * OK
     */
    200: GetUserPermissionsResponse;
};

export type GetApiV1AdminUsersByIdPermissionsResponse = GetApiV1AdminUsersByIdPermissionsResponses[keyof GetApiV1AdminUsersByIdPermissionsResponses];

export type PostApiV1AdminUsersByIdPermissionsGrantData = {
    body: GrantPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/users/{id}/permissions/grant';
};

export type PostApiV1AdminUsersByIdPermissionsGrantErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminUsersByIdPermissionsGrantError = PostApiV1AdminUsersByIdPermissionsGrantErrors[keyof PostApiV1AdminUsersByIdPermissionsGrantErrors];

export type PostApiV1AdminUsersByIdPermissionsGrantResponses = {
    /**
     * OK
     */
    200: GrantUserPermissionResponse;
};

export type PostApiV1AdminUsersByIdPermissionsGrantResponse = PostApiV1AdminUsersByIdPermissionsGrantResponses[keyof PostApiV1AdminUsersByIdPermissionsGrantResponses];

export type PostApiV1AdminUsersByIdPermissionsRevokeData = {
    body: RevokePayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/users/{id}/permissions/revoke';
};

export type PostApiV1AdminUsersByIdPermissionsRevokeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AdminUsersByIdPermissionsRevokeError = PostApiV1AdminUsersByIdPermissionsRevokeErrors[keyof PostApiV1AdminUsersByIdPermissionsRevokeErrors];

export type PostApiV1AdminUsersByIdPermissionsRevokeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1AdminUsersByIdPermissionsRevokeResponse = PostApiV1AdminUsersByIdPermissionsRevokeResponses[keyof PostApiV1AdminUsersByIdPermissionsRevokeResponses];

export type DeleteApiV1AdminUsersByIdPermissionsByPermissionData = {
    body?: never;
    path: {
        id: string;
        permission: string;
    };
    query?: never;
    url: '/api/v1/admin/users/{id}/permissions/{permission}';
};

export type DeleteApiV1AdminUsersByIdPermissionsByPermissionErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1AdminUsersByIdPermissionsByPermissionError = DeleteApiV1AdminUsersByIdPermissionsByPermissionErrors[keyof DeleteApiV1AdminUsersByIdPermissionsByPermissionErrors];

export type DeleteApiV1AdminUsersByIdPermissionsByPermissionResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1AdminUsersByIdPermissionsByPermissionResponse = DeleteApiV1AdminUsersByIdPermissionsByPermissionResponses[keyof DeleteApiV1AdminUsersByIdPermissionsByPermissionResponses];

export type GetApiV1AnalyticsAttendanceData = {
    body?: never;
    path?: never;
    query: {
        from: string;
        to: string;
    };
    url: '/api/v1/analytics/attendance';
};

export type GetApiV1AnalyticsAttendanceErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AnalyticsAttendanceError = GetApiV1AnalyticsAttendanceErrors[keyof GetApiV1AnalyticsAttendanceErrors];

export type GetApiV1AnalyticsAttendanceResponses = {
    /**
     * OK
     */
    200: AnalyticsAttendanceResponse;
};

export type GetApiV1AnalyticsAttendanceResponse = GetApiV1AnalyticsAttendanceResponses[keyof GetApiV1AnalyticsAttendanceResponses];

export type GetApiV1AnalyticsClientsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/analytics/clients';
};

export type GetApiV1AnalyticsClientsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AnalyticsClientsError = GetApiV1AnalyticsClientsErrors[keyof GetApiV1AnalyticsClientsErrors];

export type GetApiV1AnalyticsClientsResponses = {
    /**
     * OK
     */
    200: AnalyticsClientsResponse;
};

export type GetApiV1AnalyticsClientsResponse = GetApiV1AnalyticsClientsResponses[keyof GetApiV1AnalyticsClientsResponses];

export type GetApiV1AnalyticsRevenueData = {
    body?: never;
    path?: never;
    query: {
        from: string;
        to: string;
        groupBy?: string;
    };
    url: '/api/v1/analytics/revenue';
};

export type GetApiV1AnalyticsRevenueErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AnalyticsRevenueError = GetApiV1AnalyticsRevenueErrors[keyof GetApiV1AnalyticsRevenueErrors];

export type GetApiV1AnalyticsRevenueResponses = {
    /**
     * OK
     */
    200: AnalyticsRevenueResponse;
};

export type GetApiV1AnalyticsRevenueResponse = GetApiV1AnalyticsRevenueResponses[keyof GetApiV1AnalyticsRevenueResponses];

export type GetApiV1AnalyticsTrainersData = {
    body?: never;
    path?: never;
    query: {
        from: string;
        to: string;
    };
    url: '/api/v1/analytics/trainers';
};

export type GetApiV1AnalyticsTrainersErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AnalyticsTrainersError = GetApiV1AnalyticsTrainersErrors[keyof GetApiV1AnalyticsTrainersErrors];

export type GetApiV1AnalyticsTrainersResponses = {
    /**
     * OK
     */
    200: AnalyticsTrainersResponse;
};

export type GetApiV1AnalyticsTrainersResponse = GetApiV1AnalyticsTrainersResponses[keyof GetApiV1AnalyticsTrainersResponses];

export type GetApiV1AssistanceData = {
    body?: never;
    path?: never;
    query?: {
        includeResolved?: boolean;
    };
    url: '/api/v1/assistance';
};

export type GetApiV1AssistanceErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AssistanceError = GetApiV1AssistanceErrors[keyof GetApiV1AssistanceErrors];

export type GetApiV1AssistanceResponses = {
    /**
     * OK
     */
    200: AssistanceListResponse;
};

export type GetApiV1AssistanceResponse = GetApiV1AssistanceResponses[keyof GetApiV1AssistanceResponses];

export type PutApiV1AssistanceByIdAckData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/assistance/{id}/ack';
};

export type PutApiV1AssistanceByIdAckErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1AssistanceByIdAckError = PutApiV1AssistanceByIdAckErrors[keyof PutApiV1AssistanceByIdAckErrors];

export type PutApiV1AssistanceByIdAckResponses = {
    /**
     * OK
     */
    200: boolean;
};

export type PutApiV1AssistanceByIdAckResponse = PutApiV1AssistanceByIdAckResponses[keyof PutApiV1AssistanceByIdAckResponses];

export type PutApiV1AssistanceByIdResolveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/assistance/{id}/resolve';
};

export type PutApiV1AssistanceByIdResolveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1AssistanceByIdResolveError = PutApiV1AssistanceByIdResolveErrors[keyof PutApiV1AssistanceByIdResolveErrors];

export type PutApiV1AssistanceByIdResolveResponses = {
    /**
     * OK
     */
    200: boolean;
};

export type PutApiV1AssistanceByIdResolveResponse = PutApiV1AssistanceByIdResolveResponses[keyof PutApiV1AssistanceByIdResolveResponses];

export type PostApiV1AuthChangePasswordData = {
    body: ChangePasswordBody;
    path?: never;
    query?: never;
    url: '/api/v1/auth/change-password';
};

export type PostApiV1AuthChangePasswordErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthChangePasswordError = PostApiV1AuthChangePasswordErrors[keyof PostApiV1AuthChangePasswordErrors];

export type PostApiV1AuthInviteSetPasswordData = {
    body: SetPasswordByInviteBody;
    path?: never;
    query?: never;
    url: '/api/v1/auth/invite/set-password';
};

export type PostApiV1AuthInviteSetPasswordErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthInviteSetPasswordError = PostApiV1AuthInviteSetPasswordErrors[keyof PostApiV1AuthInviteSetPasswordErrors];

export type PostApiV1AuthLoginData = {
    body: LoginByEmailCommand;
    path?: never;
    query?: never;
    url: '/api/v1/auth/login';
};

export type PostApiV1AuthLoginErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthLoginError = PostApiV1AuthLoginErrors[keyof PostApiV1AuthLoginErrors];

export type PostApiV1AuthLoginResponses = {
    /**
     * OK
     */
    200: AuthResponse;
    /**
     * Accepted
     */
    202: LoginChallengeResponse;
};

export type PostApiV1AuthLoginResponse = PostApiV1AuthLoginResponses[keyof PostApiV1AuthLoginResponses];

export type PostApiV1AuthLoginConfirmData = {
    body: ConfirmLoginCommand;
    path?: never;
    query?: never;
    url: '/api/v1/auth/login/confirm';
};

export type PostApiV1AuthLoginConfirmErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthLoginConfirmError = PostApiV1AuthLoginConfirmErrors[keyof PostApiV1AuthLoginConfirmErrors];

export type PostApiV1AuthLoginConfirmResponses = {
    /**
     * OK
     */
    200: AuthResponse;
};

export type PostApiV1AuthLoginConfirmResponse = PostApiV1AuthLoginConfirmResponses[keyof PostApiV1AuthLoginConfirmResponses];

export type PostApiV1AuthLogoutData = {
    body?: null | LogoutRequest;
    path?: never;
    query?: never;
    url: '/api/v1/auth/logout';
};

export type PostApiV1AuthLogoutErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthLogoutError = PostApiV1AuthLogoutErrors[keyof PostApiV1AuthLogoutErrors];

export type PostApiV1AuthLogoutAllData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/auth/logout-all';
};

export type PostApiV1AuthLogoutAllErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthLogoutAllError = PostApiV1AuthLogoutAllErrors[keyof PostApiV1AuthLogoutAllErrors];

export type GetApiV1AuthMeData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/auth/me';
};

export type GetApiV1AuthMeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AuthMeError = GetApiV1AuthMeErrors[keyof GetApiV1AuthMeErrors];

export type GetApiV1AuthMeResponses = {
    /**
     * OK
     */
    200: UserDto;
};

export type GetApiV1AuthMeResponse = GetApiV1AuthMeResponses[keyof GetApiV1AuthMeResponses];

export type PatchApiV1AuthMeData = {
    body: UpdateMyNameBody;
    path?: never;
    query?: never;
    url: '/api/v1/auth/me';
};

export type PatchApiV1AuthMeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1AuthMeError = PatchApiV1AuthMeErrors[keyof PatchApiV1AuthMeErrors];

export type PatchApiV1AuthMeResponses = {
    /**
     * OK
     */
    200: MyContactsResponse;
};

export type PatchApiV1AuthMeResponse = PatchApiV1AuthMeResponses[keyof PatchApiV1AuthMeResponses];

export type PostApiV1AuthMeAnonymizeData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/auth/me/anonymize';
};

export type PostApiV1AuthMeAnonymizeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthMeAnonymizeError = PostApiV1AuthMeAnonymizeErrors[keyof PostApiV1AuthMeAnonymizeErrors];

export type PostApiV1AuthMeAnonymizeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1AuthMeAnonymizeResponse = PostApiV1AuthMeAnonymizeResponses[keyof PostApiV1AuthMeAnonymizeResponses];

export type PostApiV1AuthMePhoneData = {
    body: ConfirmMyPhoneBody;
    path?: never;
    query?: never;
    url: '/api/v1/auth/me/phone';
};

export type PostApiV1AuthMePhoneErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthMePhoneError = PostApiV1AuthMePhoneErrors[keyof PostApiV1AuthMePhoneErrors];

export type PostApiV1AuthMePhoneResponses = {
    /**
     * OK
     */
    200: MyContactsResponse;
};

export type PostApiV1AuthMePhoneResponse = PostApiV1AuthMePhoneResponses[keyof PostApiV1AuthMePhoneResponses];

export type PostApiV1AuthMePhoneSendCodeData = {
    body: SendMyPhoneCodeBody;
    path?: never;
    query?: never;
    url: '/api/v1/auth/me/phone/send-code';
};

export type PostApiV1AuthMePhoneSendCodeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthMePhoneSendCodeError = PostApiV1AuthMePhoneSendCodeErrors[keyof PostApiV1AuthMePhoneSendCodeErrors];

export type PostApiV1AuthMePhoneSendCodeResponses = {
    /**
     * OK
     */
    200: SendOtpResponse;
};

export type PostApiV1AuthMePhoneSendCodeResponse = PostApiV1AuthMePhoneSendCodeResponses[keyof PostApiV1AuthMePhoneSendCodeResponses];

export type PostApiV1AuthPasswordSetData = {
    body: SetFirstPasswordBody;
    path?: never;
    query?: never;
    url: '/api/v1/auth/password/set';
};

export type PostApiV1AuthPasswordSetErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthPasswordSetError = PostApiV1AuthPasswordSetErrors[keyof PostApiV1AuthPasswordSetErrors];

export type PostApiV1AuthPasswordSetSendCodeData = {
    body?: null | SendPasswordCodeBody;
    path?: never;
    query?: never;
    url: '/api/v1/auth/password/set/send-code';
};

export type PostApiV1AuthPasswordSetSendCodeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthPasswordSetSendCodeError = PostApiV1AuthPasswordSetSendCodeErrors[keyof PostApiV1AuthPasswordSetSendCodeErrors];

export type PostApiV1AuthPasswordSetSendCodeResponses = {
    /**
     * OK
     */
    200: SendOtpResponse;
};

export type PostApiV1AuthPasswordSetSendCodeResponse = PostApiV1AuthPasswordSetSendCodeResponses[keyof PostApiV1AuthPasswordSetSendCodeResponses];

export type PostApiV1AuthPhoneSendOtpData = {
    body: SendOtpCommand;
    path?: never;
    query?: never;
    url: '/api/v1/auth/phone/send-otp';
};

export type PostApiV1AuthPhoneSendOtpErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthPhoneSendOtpError = PostApiV1AuthPhoneSendOtpErrors[keyof PostApiV1AuthPhoneSendOtpErrors];

export type PostApiV1AuthPhoneSendOtpResponses = {
    /**
     * OK
     */
    200: SendOtpResponse;
};

export type PostApiV1AuthPhoneSendOtpResponse = PostApiV1AuthPhoneSendOtpResponses[keyof PostApiV1AuthPhoneSendOtpResponses];

export type PostApiV1AuthPhoneVerifyData = {
    body: VerifyOtpCommand;
    path?: never;
    query?: never;
    url: '/api/v1/auth/phone/verify';
};

export type PostApiV1AuthPhoneVerifyErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthPhoneVerifyError = PostApiV1AuthPhoneVerifyErrors[keyof PostApiV1AuthPhoneVerifyErrors];

export type PostApiV1AuthPhoneVerifyResponses = {
    /**
     * OK
     */
    200: AuthResponse;
};

export type PostApiV1AuthPhoneVerifyResponse = PostApiV1AuthPhoneVerifyResponses[keyof PostApiV1AuthPhoneVerifyResponses];

export type PostApiV1AuthRefreshData = {
    body?: null | RefreshTokenRequest;
    path?: never;
    query?: never;
    url: '/api/v1/auth/refresh';
};

export type PostApiV1AuthRefreshErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthRefreshError = PostApiV1AuthRefreshErrors[keyof PostApiV1AuthRefreshErrors];

export type PostApiV1AuthRefreshResponses = {
    /**
     * OK
     */
    200: AuthResponse;
};

export type PostApiV1AuthRefreshResponse = PostApiV1AuthRefreshResponses[keyof PostApiV1AuthRefreshResponses];

export type GetApiV1AuthTenantsMineData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/auth/tenants/mine';
};

export type GetApiV1AuthTenantsMineErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AuthTenantsMineError = GetApiV1AuthTenantsMineErrors[keyof GetApiV1AuthTenantsMineErrors];

export type GetApiV1AuthTenantsMineResponses = {
    /**
     * OK
     */
    200: Array<MyTenantDto>;
};

export type GetApiV1AuthTenantsMineResponse = GetApiV1AuthTenantsMineResponses[keyof GetApiV1AuthTenantsMineResponses];

export type PostApiV1AuthTenantsSwitchData = {
    body: SwitchTenantRequest;
    path?: never;
    query?: never;
    url: '/api/v1/auth/tenants/switch';
};

export type PostApiV1AuthTenantsSwitchErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthTenantsSwitchError = PostApiV1AuthTenantsSwitchErrors[keyof PostApiV1AuthTenantsSwitchErrors];

export type PostApiV1AuthTenantsSwitchResponses = {
    /**
     * OK
     */
    200: AuthResponse;
};

export type PostApiV1AuthTenantsSwitchResponse = PostApiV1AuthTenantsSwitchResponses[keyof PostApiV1AuthTenantsSwitchResponses];

export type PostApiV1AuthVkCallbackData = {
    body: VkAuthCallbackBody;
    path?: never;
    query?: never;
    url: '/api/v1/auth/vk/callback';
};

export type PostApiV1AuthVkCallbackErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthVkCallbackError = PostApiV1AuthVkCallbackErrors[keyof PostApiV1AuthVkCallbackErrors];

export type PostApiV1AuthVkCallbackResponses = {
    /**
     * OK
     */
    200: AuthResponse;
};

export type PostApiV1AuthVkCallbackResponse = PostApiV1AuthVkCallbackResponses[keyof PostApiV1AuthVkCallbackResponses];

export type PostApiV1AuthVkStartData = {
    body?: null | StartVkAuthBody;
    path?: never;
    query?: never;
    url: '/api/v1/auth/vk/start';
};

export type PostApiV1AuthVkStartErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthVkStartError = PostApiV1AuthVkStartErrors[keyof PostApiV1AuthVkStartErrors];

export type PostApiV1AuthVkStartResponses = {
    /**
     * OK
     */
    200: VkAuthStartResponse;
};

export type PostApiV1AuthVkStartResponse = PostApiV1AuthVkStartResponses[keyof PostApiV1AuthVkStartResponses];

export type GetApiV1BillingInvoicesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/billing/invoices';
};

export type GetApiV1BillingInvoicesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BillingInvoicesError = GetApiV1BillingInvoicesErrors[keyof GetApiV1BillingInvoicesErrors];

export type GetApiV1BillingInvoicesResponses = {
    /**
     * OK
     */
    200: SubscriptionInvoicesDto;
};

export type GetApiV1BillingInvoicesResponse = GetApiV1BillingInvoicesResponses[keyof GetApiV1BillingInvoicesResponses];

export type GetApiV1BillingInvoicesByInvoiceIdDocumentData = {
    body?: never;
    path: {
        invoiceId: string;
    };
    query?: never;
    url: '/api/v1/billing/invoices/{invoiceId}/document';
};

export type GetApiV1BillingInvoicesByInvoiceIdDocumentResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetApiV1BillingPlansData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/billing/plans';
};

export type GetApiV1BillingPlansErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BillingPlansError = GetApiV1BillingPlansErrors[keyof GetApiV1BillingPlansErrors];

export type GetApiV1BillingPlansResponses = {
    /**
     * OK
     */
    200: SubscriptionPlansDto;
};

export type GetApiV1BillingPlansResponse = GetApiV1BillingPlansResponses[keyof GetApiV1BillingPlansResponses];

export type GetApiV1BillingSubscriptionData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/billing/subscription';
};

export type GetApiV1BillingSubscriptionErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BillingSubscriptionError = GetApiV1BillingSubscriptionErrors[keyof GetApiV1BillingSubscriptionErrors];

export type GetApiV1BillingSubscriptionResponses = {
    /**
     * OK
     */
    200: SubscriptionSummaryDto;
};

export type GetApiV1BillingSubscriptionResponse = GetApiV1BillingSubscriptionResponses[keyof GetApiV1BillingSubscriptionResponses];

export type PostApiV1BillingSubscriptionCallbackData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/billing/subscription/callback';
};

export type PostApiV1BillingSubscriptionCallbackResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1BillingSubscriptionCallbackCheckData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/billing/subscription/callback/check';
};

export type PostApiV1BillingSubscriptionCallbackCheckResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1BillingSubscriptionCallbackReceiptData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/billing/subscription/callback/receipt';
};

export type PostApiV1BillingSubscriptionCallbackReceiptResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1BillingSubscriptionCallbackTbankData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/billing/subscription/callback/tbank';
};

export type PostApiV1BillingSubscriptionCallbackTbankResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1BillingSubscriptionChangePlanData = {
    body: ChangeSubscriptionPlanRequest;
    path?: never;
    query?: never;
    url: '/api/v1/billing/subscription/change-plan';
};

export type PostApiV1BillingSubscriptionChangePlanErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BillingSubscriptionChangePlanError = PostApiV1BillingSubscriptionChangePlanErrors[keyof PostApiV1BillingSubscriptionChangePlanErrors];

export type PostApiV1BillingSubscriptionChangePlanResponses = {
    /**
     * OK
     */
    200: SubscriptionPlanChangeDto;
};

export type PostApiV1BillingSubscriptionChangePlanResponse = PostApiV1BillingSubscriptionChangePlanResponses[keyof PostApiV1BillingSubscriptionChangePlanResponses];

export type PostApiV1BillingSubscriptionCheckoutData = {
    body?: null | CheckoutSubscriptionRequest;
    path?: never;
    query?: never;
    url: '/api/v1/billing/subscription/checkout';
};

export type PostApiV1BillingSubscriptionCheckoutErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BillingSubscriptionCheckoutError = PostApiV1BillingSubscriptionCheckoutErrors[keyof PostApiV1BillingSubscriptionCheckoutErrors];

export type PostApiV1BillingSubscriptionCheckoutResponses = {
    /**
     * OK
     */
    200: SubscriptionCheckoutDto;
};

export type PostApiV1BillingSubscriptionCheckoutResponse = PostApiV1BillingSubscriptionCheckoutResponses[keyof PostApiV1BillingSubscriptionCheckoutResponses];

export type PostApiV1BillingSubscriptionPlanChangeCancelData = {
    body?: null | WithdrawPlanChangeRequest;
    path?: never;
    query?: never;
    url: '/api/v1/billing/subscription/plan-change/cancel';
};

export type PostApiV1BillingSubscriptionPlanChangeCancelErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BillingSubscriptionPlanChangeCancelError = PostApiV1BillingSubscriptionPlanChangeCancelErrors[keyof PostApiV1BillingSubscriptionPlanChangeCancelErrors];

export type PostApiV1BillingSubscriptionPlanChangeCancelResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1BillingSubscriptionPlanChangeCancelResponse = PostApiV1BillingSubscriptionPlanChangeCancelResponses[keyof PostApiV1BillingSubscriptionPlanChangeCancelResponses];

export type GetApiV1BonusRulesData = {
    body?: never;
    path?: never;
    query?: {
        includeDisabled?: boolean;
    };
    url: '/api/v1/bonus-rules';
};

export type GetApiV1BonusRulesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BonusRulesError = GetApiV1BonusRulesErrors[keyof GetApiV1BonusRulesErrors];

export type GetApiV1BonusRulesResponses = {
    /**
     * OK
     */
    200: BonusRuleListResponse;
};

export type GetApiV1BonusRulesResponse = GetApiV1BonusRulesResponses[keyof GetApiV1BonusRulesResponses];

export type PostApiV1BonusRulesData = {
    body: CreateBonusRulePayload;
    path?: never;
    query?: never;
    url: '/api/v1/bonus-rules';
};

export type PostApiV1BonusRulesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BonusRulesError = PostApiV1BonusRulesErrors[keyof PostApiV1BonusRulesErrors];

export type PostApiV1BonusRulesResponses = {
    /**
     * Created
     */
    201: BonusRuleDto;
};

export type PostApiV1BonusRulesResponse = PostApiV1BonusRulesResponses[keyof PostApiV1BonusRulesResponses];

export type DeleteApiV1BonusRulesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bonus-rules/{id}';
};

export type DeleteApiV1BonusRulesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1BonusRulesByIdError = DeleteApiV1BonusRulesByIdErrors[keyof DeleteApiV1BonusRulesByIdErrors];

export type DeleteApiV1BonusRulesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1BonusRulesByIdResponse = DeleteApiV1BonusRulesByIdResponses[keyof DeleteApiV1BonusRulesByIdResponses];

export type PatchApiV1BonusRulesByIdData = {
    body: UpdateBonusRulePayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bonus-rules/{id}';
};

export type PatchApiV1BonusRulesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1BonusRulesByIdError = PatchApiV1BonusRulesByIdErrors[keyof PatchApiV1BonusRulesByIdErrors];

export type PatchApiV1BonusRulesByIdResponses = {
    /**
     * OK
     */
    200: BonusRuleDto;
};

export type PatchApiV1BonusRulesByIdResponse = PatchApiV1BonusRulesByIdResponses[keyof PatchApiV1BonusRulesByIdResponses];

export type GetApiV1BonusTransactionsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
        cursor?: string;
        kinds?: string;
        direction?: string;
        clientId?: string;
        from?: string;
        to?: string;
        actorId?: string;
    };
    url: '/api/v1/bonus-transactions';
};

export type GetApiV1BonusTransactionsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BonusTransactionsError = GetApiV1BonusTransactionsErrors[keyof GetApiV1BonusTransactionsErrors];

export type GetApiV1BonusTransactionsResponses = {
    /**
     * OK
     */
    200: BonusTransactionListResponse;
};

export type GetApiV1BonusTransactionsResponse = GetApiV1BonusTransactionsResponses[keyof GetApiV1BonusTransactionsResponses];

export type GetApiV1BookingsData = {
    body?: never;
    path?: never;
    query?: {
        q?: string;
        status?: string;
        sport?: string;
        from?: string;
        to?: string;
        courtId?: string;
        clientId?: string;
        trainerId?: string;
        isRecurring?: boolean;
        includeCancelled?: boolean;
        hidePast?: boolean;
        sort?: BookingSortKey;
        order?: string;
        page?: number;
        pageSize?: number;
    };
    url: '/api/v1/bookings';
};

export type GetApiV1BookingsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsError = GetApiV1BookingsErrors[keyof GetApiV1BookingsErrors];

export type GetApiV1BookingsResponses = {
    /**
     * OK
     */
    200: ListBookingsResponse;
};

export type GetApiV1BookingsResponse = GetApiV1BookingsResponses[keyof GetApiV1BookingsResponses];

export type GetApiV1BookingsAvailabilityData = {
    body?: never;
    path?: never;
    query: {
        Date: string;
        SportType: string;
        DurationMinutes: number;
        StartTimeFrom?: string;
        StartTimeTo?: string;
        ResourceId?: string;
        TrainerId?: string;
    };
    url: '/api/v1/bookings/availability';
};

export type GetApiV1BookingsAvailabilityErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsAvailabilityError = GetApiV1BookingsAvailabilityErrors[keyof GetApiV1BookingsAvailabilityErrors];

export type GetApiV1BookingsAvailabilityResponses = {
    /**
     * OK
     */
    200: AvailabilityResponse;
};

export type GetApiV1BookingsAvailabilityResponse = GetApiV1BookingsAvailabilityResponses[keyof GetApiV1BookingsAvailabilityResponses];

export type PostApiV1BookingsBulkData = {
    body: BulkBookingActionPayload;
    path?: never;
    query?: never;
    url: '/api/v1/bookings/bulk';
};

export type PostApiV1BookingsBulkErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BookingsBulkError = PostApiV1BookingsBulkErrors[keyof PostApiV1BookingsBulkErrors];

export type PostApiV1BookingsBulkResponses = {
    /**
     * OK
     */
    200: BulkBookingActionResponse;
};

export type PostApiV1BookingsBulkResponse = PostApiV1BookingsBulkResponses[keyof PostApiV1BookingsBulkResponses];

export type GetApiV1BookingsMyData = {
    body?: never;
    path?: never;
    query?: {
        Status?: BookingStatus;
        Bucket?: MyBookingsBucket;
        SportType?: string;
        Limit?: number;
        Cursor?: string;
    };
    url: '/api/v1/bookings/my';
};

export type GetApiV1BookingsMyErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsMyError = GetApiV1BookingsMyErrors[keyof GetApiV1BookingsMyErrors];

export type GetApiV1BookingsMyResponses = {
    /**
     * OK
     */
    200: PagedListOfBookingSummaryDto;
};

export type GetApiV1BookingsMyResponse = GetApiV1BookingsMyResponses[keyof GetApiV1BookingsMyResponses];

export type GetApiV1BookingsMyWindowData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/bookings/my-window';
};

export type GetApiV1BookingsMyWindowErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsMyWindowError = GetApiV1BookingsMyWindowErrors[keyof GetApiV1BookingsMyWindowErrors];

export type GetApiV1BookingsMyWindowResponses = {
    /**
     * OK
     */
    200: MyBookingWindowResponse;
};

export type GetApiV1BookingsMyWindowResponse = GetApiV1BookingsMyWindowResponses[keyof GetApiV1BookingsMyWindowResponses];

export type GetApiV1BookingsRecurringData = {
    body?: never;
    path?: never;
    query: {
        clientId: string;
    };
    url: '/api/v1/bookings/recurring';
};

export type GetApiV1BookingsRecurringErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsRecurringError = GetApiV1BookingsRecurringErrors[keyof GetApiV1BookingsRecurringErrors];

export type GetApiV1BookingsRecurringResponses = {
    /**
     * OK
     */
    200: ClientSeriesListResponse;
};

export type GetApiV1BookingsRecurringResponse = GetApiV1BookingsRecurringResponses[keyof GetApiV1BookingsRecurringResponses];

export type PostApiV1BookingsRecurringData = {
    body: CreateRecurringPayload;
    path?: never;
    query?: never;
    url: '/api/v1/bookings/recurring';
};

export type PostApiV1BookingsRecurringErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BookingsRecurringError = PostApiV1BookingsRecurringErrors[keyof PostApiV1BookingsRecurringErrors];

export type PostApiV1BookingsRecurringResponses = {
    /**
     * Created
     */
    201: CreateRecurringBookingsResponse;
};

export type PostApiV1BookingsRecurringResponse = PostApiV1BookingsRecurringResponses[keyof PostApiV1BookingsRecurringResponses];

export type DeleteApiV1BookingsRecurringByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/recurring/{id}';
};

export type DeleteApiV1BookingsRecurringByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1BookingsRecurringByIdError = DeleteApiV1BookingsRecurringByIdErrors[keyof DeleteApiV1BookingsRecurringByIdErrors];

export type DeleteApiV1BookingsRecurringByIdResponses = {
    /**
     * OK
     */
    200: CancelRecurringSeriesResponse;
};

export type DeleteApiV1BookingsRecurringByIdResponse = DeleteApiV1BookingsRecurringByIdResponses[keyof DeleteApiV1BookingsRecurringByIdResponses];

export type GetApiV1BookingsRecurringByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/recurring/{id}';
};

export type GetApiV1BookingsRecurringByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsRecurringByIdError = GetApiV1BookingsRecurringByIdErrors[keyof GetApiV1BookingsRecurringByIdErrors];

export type GetApiV1BookingsRecurringByIdResponses = {
    /**
     * OK
     */
    200: SeriesPlanResponse;
};

export type GetApiV1BookingsRecurringByIdResponse = GetApiV1BookingsRecurringByIdResponses[keyof GetApiV1BookingsRecurringByIdResponses];

export type PostApiV1BookingsSplitCheckoutData = {
    body: CreateBookingWithSplitPayload;
    path?: never;
    query?: never;
    url: '/api/v1/bookings/split-checkout';
};

export type PostApiV1BookingsSplitCheckoutErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BookingsSplitCheckoutError = PostApiV1BookingsSplitCheckoutErrors[keyof PostApiV1BookingsSplitCheckoutErrors];

export type PostApiV1BookingsSplitCheckoutResponses = {
    /**
     * Created
     */
    201: CreateBookingWithSplitResponse;
};

export type PostApiV1BookingsSplitCheckoutResponse = PostApiV1BookingsSplitCheckoutResponses[keyof PostApiV1BookingsSplitCheckoutResponses];

export type GetApiV1BookingsSplitCheckoutPlanData = {
    body?: never;
    path?: never;
    query: {
        courtId: string;
        scheduledAt: string;
        durationMinutes: number;
        trainerId?: string;
        totalSpots: number;
        paymentMethod: string;
        bonusKopecks?: number;
    };
    url: '/api/v1/bookings/split-checkout/plan';
};

export type GetApiV1BookingsSplitCheckoutPlanErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsSplitCheckoutPlanError = GetApiV1BookingsSplitCheckoutPlanErrors[keyof GetApiV1BookingsSplitCheckoutPlanErrors];

export type GetApiV1BookingsSplitCheckoutPlanResponses = {
    /**
     * OK
     */
    200: OrganizerSharePlanDto;
};

export type GetApiV1BookingsSplitCheckoutPlanResponse = GetApiV1BookingsSplitCheckoutPlanResponses[keyof GetApiV1BookingsSplitCheckoutPlanResponses];

export type DeleteApiV1BookingsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        expectedRefundKopecks?: number;
    };
    url: '/api/v1/bookings/{id}';
};

export type DeleteApiV1BookingsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1BookingsByIdError = DeleteApiV1BookingsByIdErrors[keyof DeleteApiV1BookingsByIdErrors];

export type DeleteApiV1BookingsByIdResponses = {
    /**
     * OK
     */
    200: CancelBookingResponse;
};

export type DeleteApiV1BookingsByIdResponse = DeleteApiV1BookingsByIdResponses[keyof DeleteApiV1BookingsByIdResponses];

export type GetApiV1BookingsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}';
};

export type GetApiV1BookingsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsByIdError = GetApiV1BookingsByIdErrors[keyof GetApiV1BookingsByIdErrors];

export type GetApiV1BookingsByIdResponses = {
    /**
     * OK
     */
    200: BookingDetailDto;
};

export type GetApiV1BookingsByIdResponse = GetApiV1BookingsByIdResponses[keyof GetApiV1BookingsByIdResponses];

export type GetApiV1BookingsByIdActivityData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/activity';
};

export type GetApiV1BookingsByIdActivityErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsByIdActivityError = GetApiV1BookingsByIdActivityErrors[keyof GetApiV1BookingsByIdActivityErrors];

export type GetApiV1BookingsByIdActivityResponses = {
    /**
     * OK
     */
    200: GetBookingActivityResponse;
};

export type GetApiV1BookingsByIdActivityResponse = GetApiV1BookingsByIdActivityResponses[keyof GetApiV1BookingsByIdActivityResponses];

export type GetApiV1BookingsByIdCancelPreviewData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/cancel-preview';
};

export type GetApiV1BookingsByIdCancelPreviewErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsByIdCancelPreviewError = GetApiV1BookingsByIdCancelPreviewErrors[keyof GetApiV1BookingsByIdCancelPreviewErrors];

export type GetApiV1BookingsByIdCancelPreviewResponses = {
    /**
     * OK
     */
    200: CancelPreviewDto;
};

export type GetApiV1BookingsByIdCancelPreviewResponse = GetApiV1BookingsByIdCancelPreviewResponses[keyof GetApiV1BookingsByIdCancelPreviewResponses];

export type PatchApiV1BookingsByIdCommentData = {
    body: ChangeBookingCommentPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/comment';
};

export type PatchApiV1BookingsByIdCommentErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1BookingsByIdCommentError = PatchApiV1BookingsByIdCommentErrors[keyof PatchApiV1BookingsByIdCommentErrors];

export type PatchApiV1BookingsByIdCommentResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1BookingsByIdCommentResponse = PatchApiV1BookingsByIdCommentResponses[keyof PatchApiV1BookingsByIdCommentResponses];

export type DeleteApiV1BookingsByIdExtendData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/extend';
};

export type DeleteApiV1BookingsByIdExtendErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1BookingsByIdExtendError = DeleteApiV1BookingsByIdExtendErrors[keyof DeleteApiV1BookingsByIdExtendErrors];

export type DeleteApiV1BookingsByIdExtendResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1BookingsByIdExtendResponse = DeleteApiV1BookingsByIdExtendResponses[keyof DeleteApiV1BookingsByIdExtendResponses];

export type PatchApiV1BookingsByIdExtendData = {
    body: ExtendPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/extend';
};

export type PatchApiV1BookingsByIdExtendErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1BookingsByIdExtendError = PatchApiV1BookingsByIdExtendErrors[keyof PatchApiV1BookingsByIdExtendErrors];

export type PatchApiV1BookingsByIdExtendResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1BookingsByIdExtendResponse = PatchApiV1BookingsByIdExtendResponses[keyof PatchApiV1BookingsByIdExtendResponses];

export type PostApiV1BookingsByIdExtendData = {
    body: ExtendToEndBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/extend';
};

export type PostApiV1BookingsByIdExtendErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BookingsByIdExtendError = PostApiV1BookingsByIdExtendErrors[keyof PostApiV1BookingsByIdExtendErrors];

export type PostApiV1BookingsByIdExtendResponses = {
    /**
     * OK
     */
    200: ClientExtendBookingResponse;
};

export type PostApiV1BookingsByIdExtendResponse = PostApiV1BookingsByIdExtendResponses[keyof PostApiV1BookingsByIdExtendResponses];

export type GetApiV1BookingsByIdExtensionOptionsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/extension-options';
};

export type GetApiV1BookingsByIdExtensionOptionsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsByIdExtensionOptionsError = GetApiV1BookingsByIdExtensionOptionsErrors[keyof GetApiV1BookingsByIdExtensionOptionsErrors];

export type GetApiV1BookingsByIdExtensionOptionsResponses = {
    /**
     * OK
     */
    200: ExtensionOptionsResponse;
};

export type GetApiV1BookingsByIdExtensionOptionsResponse = GetApiV1BookingsByIdExtensionOptionsResponses[keyof GetApiV1BookingsByIdExtensionOptionsResponses];

export type DeleteApiV1BookingsByIdNoShowData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/no-show';
};

export type DeleteApiV1BookingsByIdNoShowErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1BookingsByIdNoShowError = DeleteApiV1BookingsByIdNoShowErrors[keyof DeleteApiV1BookingsByIdNoShowErrors];

export type DeleteApiV1BookingsByIdNoShowResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1BookingsByIdNoShowResponse = DeleteApiV1BookingsByIdNoShowResponses[keyof DeleteApiV1BookingsByIdNoShowResponses];

export type PatchApiV1BookingsByIdNoShowData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/no-show';
};

export type PatchApiV1BookingsByIdNoShowErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1BookingsByIdNoShowError = PatchApiV1BookingsByIdNoShowErrors[keyof PatchApiV1BookingsByIdNoShowErrors];

export type PatchApiV1BookingsByIdNoShowResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1BookingsByIdNoShowResponse = PatchApiV1BookingsByIdNoShowResponses[keyof PatchApiV1BookingsByIdNoShowResponses];

export type PatchApiV1BookingsByIdRescheduleData = {
    body: ReschedulePayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/reschedule';
};

export type PatchApiV1BookingsByIdRescheduleErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1BookingsByIdRescheduleError = PatchApiV1BookingsByIdRescheduleErrors[keyof PatchApiV1BookingsByIdRescheduleErrors];

export type PatchApiV1BookingsByIdRescheduleResponses = {
    /**
     * OK
     */
    200: RescheduleBookingResponse;
};

export type PatchApiV1BookingsByIdRescheduleResponse = PatchApiV1BookingsByIdRescheduleResponses[keyof PatchApiV1BookingsByIdRescheduleResponses];

export type PatchApiV1BookingsByIdRescheduleOwnData = {
    body: ReschedulePayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/reschedule-own';
};

export type PatchApiV1BookingsByIdRescheduleOwnErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1BookingsByIdRescheduleOwnError = PatchApiV1BookingsByIdRescheduleOwnErrors[keyof PatchApiV1BookingsByIdRescheduleOwnErrors];

export type PatchApiV1BookingsByIdRescheduleOwnResponses = {
    /**
     * OK
     */
    200: RescheduleBookingResponse;
};

export type PatchApiV1BookingsByIdRescheduleOwnResponse = PatchApiV1BookingsByIdRescheduleOwnResponses[keyof PatchApiV1BookingsByIdRescheduleOwnResponses];

export type GetApiV1BookingsByIdReschedulePreviewData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        courtId?: string;
        force?: boolean;
        waiveCharge?: boolean;
    };
    url: '/api/v1/bookings/{id}/reschedule-preview';
};

export type GetApiV1BookingsByIdReschedulePreviewErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsByIdReschedulePreviewError = GetApiV1BookingsByIdReschedulePreviewErrors[keyof GetApiV1BookingsByIdReschedulePreviewErrors];

export type GetApiV1BookingsByIdReschedulePreviewResponses = {
    /**
     * OK
     */
    200: ReschedulePreviewDto;
};

export type GetApiV1BookingsByIdReschedulePreviewResponse = GetApiV1BookingsByIdReschedulePreviewResponses[keyof GetApiV1BookingsByIdReschedulePreviewResponses];

export type PostApiV1BookingsByIdReviewData = {
    body: SubmitBookingReviewBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/review';
};

export type PostApiV1BookingsByIdReviewErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BookingsByIdReviewError = PostApiV1BookingsByIdReviewErrors[keyof PostApiV1BookingsByIdReviewErrors];

export type PostApiV1BookingsByIdReviewResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1BookingsByIdReviewResponse = PostApiV1BookingsByIdReviewResponses[keyof PostApiV1BookingsByIdReviewResponses];

export type GetApiV1BookingsByIdSplitData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/split';
};

export type GetApiV1BookingsByIdSplitErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsByIdSplitError = GetApiV1BookingsByIdSplitErrors[keyof GetApiV1BookingsByIdSplitErrors];

export type GetApiV1BookingsByIdSplitResponses = {
    /**
     * OK
     */
    200: BookingSplitDetailsDto;
    /**
     * No Content
     */
    204: void;
};

export type GetApiV1BookingsByIdSplitResponse = GetApiV1BookingsByIdSplitResponses[keyof GetApiV1BookingsByIdSplitResponses];

export type PostApiV1BookingsByIdSplitCancelData = {
    body?: null | CancelBookingSplitPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/split/cancel';
};

export type PostApiV1BookingsByIdSplitCancelErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BookingsByIdSplitCancelError = PostApiV1BookingsByIdSplitCancelErrors[keyof PostApiV1BookingsByIdSplitCancelErrors];

export type PostApiV1BookingsByIdSplitCancelResponses = {
    /**
     * OK
     */
    200: CancelBookingSplitResponse;
};

export type PostApiV1BookingsByIdSplitCancelResponse = PostApiV1BookingsByIdSplitCancelResponses[keyof PostApiV1BookingsByIdSplitCancelResponses];

export type PostApiV1BookingsByIdSplitCancelByClubData = {
    body?: null | CancelBookingSplitPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/split/cancel-by-club';
};

export type PostApiV1BookingsByIdSplitCancelByClubErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BookingsByIdSplitCancelByClubError = PostApiV1BookingsByIdSplitCancelByClubErrors[keyof PostApiV1BookingsByIdSplitCancelByClubErrors];

export type PostApiV1BookingsByIdSplitCancelByClubResponses = {
    /**
     * OK
     */
    200: CancelSplitByClubResponse;
};

export type PostApiV1BookingsByIdSplitCancelByClubResponse = PostApiV1BookingsByIdSplitCancelByClubResponses[keyof PostApiV1BookingsByIdSplitCancelByClubResponses];

export type PostApiV1BookingsByIdSplitLeaveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/split/leave';
};

export type PostApiV1BookingsByIdSplitLeaveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BookingsByIdSplitLeaveError = PostApiV1BookingsByIdSplitLeaveErrors[keyof PostApiV1BookingsByIdSplitLeaveErrors];

export type PostApiV1BookingsByIdSplitLeaveResponses = {
    /**
     * OK
     */
    200: LeaveSplitSeatResponse;
};

export type PostApiV1BookingsByIdSplitLeaveResponse = PostApiV1BookingsByIdSplitLeaveResponses[keyof PostApiV1BookingsByIdSplitLeaveResponses];

export type GetApiV1BookingsByIdSplitOfferData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/split/offer';
};

export type GetApiV1BookingsByIdSplitOfferErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsByIdSplitOfferError = GetApiV1BookingsByIdSplitOfferErrors[keyof GetApiV1BookingsByIdSplitOfferErrors];

export type GetApiV1BookingsByIdSplitOfferResponses = {
    /**
     * OK
     */
    200: SplitOfferDto;
};

export type GetApiV1BookingsByIdSplitOfferResponse = GetApiV1BookingsByIdSplitOfferResponses[keyof GetApiV1BookingsByIdSplitOfferResponses];

export type PostApiV1BookingsByIdSplitPayData = {
    body: PaySplitSharePayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/split/pay';
};

export type PostApiV1BookingsByIdSplitPayErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BookingsByIdSplitPayError = PostApiV1BookingsByIdSplitPayErrors[keyof PostApiV1BookingsByIdSplitPayErrors];

export type PostApiV1BookingsByIdSplitPayResponses = {
    /**
     * OK
     */
    200: PaySplitShareResponse;
};

export type PostApiV1BookingsByIdSplitPayResponse = PostApiV1BookingsByIdSplitPayResponses[keyof PostApiV1BookingsByIdSplitPayResponses];

export type PostApiV1BookingsByIdSplitPayRemainderData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/split/pay-remainder';
};

export type PostApiV1BookingsByIdSplitPayRemainderErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BookingsByIdSplitPayRemainderError = PostApiV1BookingsByIdSplitPayRemainderErrors[keyof PostApiV1BookingsByIdSplitPayRemainderErrors];

export type PostApiV1BookingsByIdSplitPayRemainderResponses = {
    /**
     * OK
     */
    200: PaySplitRemainderResponse;
};

export type PostApiV1BookingsByIdSplitPayRemainderResponse = PostApiV1BookingsByIdSplitPayRemainderResponses[keyof PostApiV1BookingsByIdSplitPayRemainderResponses];

export type GetApiV1BookingsByIdSplitPaymentPlanData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        bonusKopecks?: number;
    };
    url: '/api/v1/bookings/{id}/split/payment-plan';
};

export type GetApiV1BookingsByIdSplitPaymentPlanErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsByIdSplitPaymentPlanError = GetApiV1BookingsByIdSplitPaymentPlanErrors[keyof GetApiV1BookingsByIdSplitPaymentPlanErrors];

export type GetApiV1BookingsByIdSplitPaymentPlanResponses = {
    /**
     * OK
     */
    200: SplitSharePlanDto;
};

export type GetApiV1BookingsByIdSplitPaymentPlanResponse = GetApiV1BookingsByIdSplitPaymentPlanResponses[keyof GetApiV1BookingsByIdSplitPaymentPlanResponses];

export type PostApiV1BookingsByIdSplitSeatData = {
    body: TakeSplitSeatPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/split/seat';
};

export type PostApiV1BookingsByIdSplitSeatErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BookingsByIdSplitSeatError = PostApiV1BookingsByIdSplitSeatErrors[keyof PostApiV1BookingsByIdSplitSeatErrors];

export type PostApiV1BookingsByIdSplitSeatResponses = {
    /**
     * OK
     */
    200: TakeSplitSeatResponse;
};

export type PostApiV1BookingsByIdSplitSeatResponse = PostApiV1BookingsByIdSplitSeatResponses[keyof PostApiV1BookingsByIdSplitSeatResponses];

export type GetApiV1BookingsByIdSplitSeatPlanData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        bonusKopecks?: number;
    };
    url: '/api/v1/bookings/{id}/split/seat-plan';
};

export type GetApiV1BookingsByIdSplitSeatPlanErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1BookingsByIdSplitSeatPlanError = GetApiV1BookingsByIdSplitSeatPlanErrors[keyof GetApiV1BookingsByIdSplitSeatPlanErrors];

export type GetApiV1BookingsByIdSplitSeatPlanResponses = {
    /**
     * OK
     */
    200: SplitSharePlanDto;
};

export type GetApiV1BookingsByIdSplitSeatPlanResponse = GetApiV1BookingsByIdSplitSeatPlanResponses[keyof GetApiV1BookingsByIdSplitSeatPlanResponses];

export type PostApiV1BookingsByIdTrainingFormatData = {
    body: SwitchTrainingFormatPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{id}/training-format';
};

export type PostApiV1BookingsByIdTrainingFormatErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1BookingsByIdTrainingFormatError = PostApiV1BookingsByIdTrainingFormatErrors[keyof PostApiV1BookingsByIdTrainingFormatErrors];

export type PostApiV1BookingsByIdTrainingFormatResponses = {
    /**
     * OK
     */
    200: SwitchTrainingFormatResponse;
};

export type PostApiV1BookingsByIdTrainingFormatResponse = PostApiV1BookingsByIdTrainingFormatResponses[keyof PostApiV1BookingsByIdTrainingFormatResponses];

export type GetApiV1CardCategoriesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/card-categories';
};

export type GetApiV1CardCategoriesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1CardCategoriesError = GetApiV1CardCategoriesErrors[keyof GetApiV1CardCategoriesErrors];

export type GetApiV1CardCategoriesResponses = {
    /**
     * OK
     */
    200: CardCategoryListResponse;
};

export type GetApiV1CardCategoriesResponse = GetApiV1CardCategoriesResponses[keyof GetApiV1CardCategoriesResponses];

export type PostApiV1CardCategoriesData = {
    body: CreateCardCategoryPayload;
    path?: never;
    query?: never;
    url: '/api/v1/card-categories';
};

export type PostApiV1CardCategoriesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1CardCategoriesError = PostApiV1CardCategoriesErrors[keyof PostApiV1CardCategoriesErrors];

export type PostApiV1CardCategoriesResponses = {
    /**
     * Created
     */
    201: CardCategoryDto;
};

export type PostApiV1CardCategoriesResponse = PostApiV1CardCategoriesResponses[keyof PostApiV1CardCategoriesResponses];

export type DeleteApiV1CardCategoriesByCodeData = {
    body?: never;
    path: {
        code: string;
    };
    query?: never;
    url: '/api/v1/card-categories/{code}';
};

export type DeleteApiV1CardCategoriesByCodeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1CardCategoriesByCodeError = DeleteApiV1CardCategoriesByCodeErrors[keyof DeleteApiV1CardCategoriesByCodeErrors];

export type DeleteApiV1CardCategoriesByCodeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1CardCategoriesByCodeResponse = DeleteApiV1CardCategoriesByCodeResponses[keyof DeleteApiV1CardCategoriesByCodeResponses];

export type PatchApiV1CardCategoriesByCodeData = {
    body: UpdateCardCategoryPayload;
    path: {
        code: string;
    };
    query?: never;
    url: '/api/v1/card-categories/{code}';
};

export type PatchApiV1CardCategoriesByCodeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1CardCategoriesByCodeError = PatchApiV1CardCategoriesByCodeErrors[keyof PatchApiV1CardCategoriesByCodeErrors];

export type PatchApiV1CardCategoriesByCodeResponses = {
    /**
     * OK
     */
    200: CardCategoryDto;
};

export type PatchApiV1CardCategoriesByCodeResponse = PatchApiV1CardCategoriesByCodeResponses[keyof PatchApiV1CardCategoriesByCodeResponses];

export type GetApiV1CardCategoriesByCodeAccrualData = {
    body?: never;
    path: {
        code: string;
    };
    query?: never;
    url: '/api/v1/card-categories/{code}/accrual';
};

export type GetApiV1CardCategoriesByCodeAccrualErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1CardCategoriesByCodeAccrualError = GetApiV1CardCategoriesByCodeAccrualErrors[keyof GetApiV1CardCategoriesByCodeAccrualErrors];

export type GetApiV1CardCategoriesByCodeAccrualResponses = {
    /**
     * OK
     */
    200: CardCategoryAccrualDto;
};

export type GetApiV1CardCategoriesByCodeAccrualResponse = GetApiV1CardCategoriesByCodeAccrualResponses[keyof GetApiV1CardCategoriesByCodeAccrualResponses];

export type PutApiV1CardCategoriesByCodeAccrualData = {
    body: ReplaceCardCategoryAccrualPayload;
    path: {
        code: string;
    };
    query?: never;
    url: '/api/v1/card-categories/{code}/accrual';
};

export type PutApiV1CardCategoriesByCodeAccrualErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1CardCategoriesByCodeAccrualError = PutApiV1CardCategoriesByCodeAccrualErrors[keyof PutApiV1CardCategoriesByCodeAccrualErrors];

export type PutApiV1CardCategoriesByCodeAccrualResponses = {
    /**
     * OK
     */
    200: CardCategoryAccrualDto;
};

export type PutApiV1CardCategoriesByCodeAccrualResponse = PutApiV1CardCategoriesByCodeAccrualResponses[keyof PutApiV1CardCategoriesByCodeAccrualResponses];

export type GetApiV1ChatConversationsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/chat/conversations';
};

export type GetApiV1ChatConversationsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatConversationsError = GetApiV1ChatConversationsErrors[keyof GetApiV1ChatConversationsErrors];

export type GetApiV1ChatConversationsResponses = {
    /**
     * OK
     */
    200: Array<ConversationDto>;
};

export type GetApiV1ChatConversationsResponse = GetApiV1ChatConversationsResponses[keyof GetApiV1ChatConversationsResponses];

export type PostApiV1ChatConversationsResolveData = {
    body: ResolveConversationBody;
    path?: never;
    query?: never;
    url: '/api/v1/chat/conversations/resolve';
};

export type PostApiV1ChatConversationsResolveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatConversationsResolveError = PostApiV1ChatConversationsResolveErrors[keyof PostApiV1ChatConversationsResolveErrors];

export type PostApiV1ChatConversationsResolveResponses = {
    /**
     * OK
     */
    200: ConversationDto;
};

export type PostApiV1ChatConversationsResolveResponse = PostApiV1ChatConversationsResolveResponses[keyof PostApiV1ChatConversationsResolveResponses];

export type GetApiV1ChatConversationsRoomsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/chat/conversations/rooms';
};

export type GetApiV1ChatConversationsRoomsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatConversationsRoomsError = GetApiV1ChatConversationsRoomsErrors[keyof GetApiV1ChatConversationsRoomsErrors];

export type GetApiV1ChatConversationsRoomsResponses = {
    /**
     * OK
     */
    200: Array<ClubChatRoomDto>;
};

export type GetApiV1ChatConversationsRoomsResponse = GetApiV1ChatConversationsRoomsResponses[keyof GetApiV1ChatConversationsRoomsResponses];

export type GetApiV1ChatConversationsRoomsByKindBySubjectIdMessagesData = {
    body?: never;
    path: {
        kind: string;
        subjectId: string;
    };
    query?: {
        afterSeq?: number;
        beforeSeq?: number;
        limit?: number;
    };
    url: '/api/v1/chat/conversations/rooms/{kind}/{subjectId}/messages';
};

export type GetApiV1ChatConversationsRoomsByKindBySubjectIdMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatConversationsRoomsByKindBySubjectIdMessagesError = GetApiV1ChatConversationsRoomsByKindBySubjectIdMessagesErrors[keyof GetApiV1ChatConversationsRoomsByKindBySubjectIdMessagesErrors];

export type GetApiV1ChatConversationsRoomsByKindBySubjectIdMessagesResponses = {
    /**
     * OK
     */
    200: Array<ChatRoomMessageDto>;
};

export type GetApiV1ChatConversationsRoomsByKindBySubjectIdMessagesResponse = GetApiV1ChatConversationsRoomsByKindBySubjectIdMessagesResponses[keyof GetApiV1ChatConversationsRoomsByKindBySubjectIdMessagesResponses];

export type GetApiV1ChatConversationsByIdMessagesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        afterSeq?: number;
        beforeSeq?: number;
        limit?: number;
    };
    url: '/api/v1/chat/conversations/{id}/messages';
};

export type GetApiV1ChatConversationsByIdMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatConversationsByIdMessagesError = GetApiV1ChatConversationsByIdMessagesErrors[keyof GetApiV1ChatConversationsByIdMessagesErrors];

export type GetApiV1ChatConversationsByIdMessagesResponses = {
    /**
     * OK
     */
    200: Array<ChatMessageDto>;
};

export type GetApiV1ChatConversationsByIdMessagesResponse = GetApiV1ChatConversationsByIdMessagesResponses[keyof GetApiV1ChatConversationsByIdMessagesResponses];

export type PostApiV1ChatConversationsByIdMessagesData = {
    body: SendStaffMessageBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/chat/conversations/{id}/messages';
};

export type PostApiV1ChatConversationsByIdMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatConversationsByIdMessagesError = PostApiV1ChatConversationsByIdMessagesErrors[keyof PostApiV1ChatConversationsByIdMessagesErrors];

export type PostApiV1ChatConversationsByIdMessagesResponses = {
    /**
     * Created
     */
    201: ChatMessageDto;
};

export type PostApiV1ChatConversationsByIdMessagesResponse = PostApiV1ChatConversationsByIdMessagesResponses[keyof PostApiV1ChatConversationsByIdMessagesResponses];

export type PostApiV1ChatConversationsByIdReadData = {
    body: MarkReadBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/chat/conversations/{id}/read';
};

export type PostApiV1ChatConversationsByIdReadErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatConversationsByIdReadError = PostApiV1ChatConversationsByIdReadErrors[keyof PostApiV1ChatConversationsByIdReadErrors];

export type PostApiV1ChatConversationsByIdReadResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ChatConversationsByIdReadResponse = PostApiV1ChatConversationsByIdReadResponses[keyof PostApiV1ChatConversationsByIdReadResponses];

export type GetApiV1ChatMeAuditData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/chat/me/audit';
};

export type GetApiV1ChatMeAuditErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatMeAuditError = GetApiV1ChatMeAuditErrors[keyof GetApiV1ChatMeAuditErrors];

export type GetApiV1ChatMeAuditResponses = {
    /**
     * OK
     */
    200: Array<ChatReadDto>;
};

export type GetApiV1ChatMeAuditResponse = GetApiV1ChatMeAuditResponses[keyof GetApiV1ChatMeAuditResponses];

export type GetApiV1ChatMeConversationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/chat/me/conversation';
};

export type GetApiV1ChatMeConversationErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatMeConversationError = GetApiV1ChatMeConversationErrors[keyof GetApiV1ChatMeConversationErrors];

export type GetApiV1ChatMeConversationResponses = {
    /**
     * OK
     */
    200: MyConversationResponse;
};

export type GetApiV1ChatMeConversationResponse = GetApiV1ChatMeConversationResponses[keyof GetApiV1ChatMeConversationResponses];

export type GetApiV1ChatMeConversationMessagesData = {
    body?: never;
    path?: never;
    query?: {
        afterSeq?: number;
        beforeSeq?: number;
        limit?: number;
    };
    url: '/api/v1/chat/me/conversation/messages';
};

export type GetApiV1ChatMeConversationMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatMeConversationMessagesError = GetApiV1ChatMeConversationMessagesErrors[keyof GetApiV1ChatMeConversationMessagesErrors];

export type GetApiV1ChatMeConversationMessagesResponses = {
    /**
     * OK
     */
    200: Array<ChatMessageDto>;
};

export type GetApiV1ChatMeConversationMessagesResponse = GetApiV1ChatMeConversationMessagesResponses[keyof GetApiV1ChatMeConversationMessagesResponses];

export type PostApiV1ChatMeConversationMessagesData = {
    body: SendMyMessageBody;
    path?: never;
    query?: never;
    url: '/api/v1/chat/me/conversation/messages';
};

export type PostApiV1ChatMeConversationMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatMeConversationMessagesError = PostApiV1ChatMeConversationMessagesErrors[keyof PostApiV1ChatMeConversationMessagesErrors];

export type PostApiV1ChatMeConversationMessagesResponses = {
    /**
     * Created
     */
    201: ChatMessageDto;
};

export type PostApiV1ChatMeConversationMessagesResponse = PostApiV1ChatMeConversationMessagesResponses[keyof PostApiV1ChatMeConversationMessagesResponses];

export type PostApiV1ChatMeConversationReadData = {
    body: MarkReadBody;
    path?: never;
    query?: never;
    url: '/api/v1/chat/me/conversation/read';
};

export type PostApiV1ChatMeConversationReadErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatMeConversationReadError = PostApiV1ChatMeConversationReadErrors[keyof PostApiV1ChatMeConversationReadErrors];

export type PostApiV1ChatMeConversationReadResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ChatMeConversationReadResponse = PostApiV1ChatMeConversationReadResponses[keyof PostApiV1ChatMeConversationReadResponses];

export type PostApiV1ChatMeDirectData = {
    body: OpenDirectRoomBody;
    path?: never;
    query?: never;
    url: '/api/v1/chat/me/direct';
};

export type PostApiV1ChatMeDirectErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatMeDirectError = PostApiV1ChatMeDirectErrors[keyof PostApiV1ChatMeDirectErrors];

export type PostApiV1ChatMeDirectResponses = {
    /**
     * OK
     */
    200: DirectRoomDto;
};

export type PostApiV1ChatMeDirectResponse = PostApiV1ChatMeDirectResponses[keyof PostApiV1ChatMeDirectResponses];

export type GetApiV1ChatMeDirectRoomsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/chat/me/direct-rooms';
};

export type GetApiV1ChatMeDirectRoomsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatMeDirectRoomsError = GetApiV1ChatMeDirectRoomsErrors[keyof GetApiV1ChatMeDirectRoomsErrors];

export type GetApiV1ChatMeDirectRoomsResponses = {
    /**
     * OK
     */
    200: Array<DirectRoomDto>;
};

export type GetApiV1ChatMeDirectRoomsResponse = GetApiV1ChatMeDirectRoomsResponses[keyof GetApiV1ChatMeDirectRoomsResponses];

export type GetApiV1ChatMeDirectByRoomIdMessagesData = {
    body?: never;
    path: {
        roomId: string;
    };
    query?: {
        afterSeq?: number;
        beforeSeq?: number;
        limit?: number;
    };
    url: '/api/v1/chat/me/direct/{roomId}/messages';
};

export type GetApiV1ChatMeDirectByRoomIdMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatMeDirectByRoomIdMessagesError = GetApiV1ChatMeDirectByRoomIdMessagesErrors[keyof GetApiV1ChatMeDirectByRoomIdMessagesErrors];

export type GetApiV1ChatMeDirectByRoomIdMessagesResponses = {
    /**
     * OK
     */
    200: Array<DirectRoomMessageDto>;
};

export type GetApiV1ChatMeDirectByRoomIdMessagesResponse = GetApiV1ChatMeDirectByRoomIdMessagesResponses[keyof GetApiV1ChatMeDirectByRoomIdMessagesResponses];

export type PostApiV1ChatMeDirectByRoomIdMessagesData = {
    body: SendMyMessageBody;
    path: {
        roomId: string;
    };
    query?: never;
    url: '/api/v1/chat/me/direct/{roomId}/messages';
};

export type PostApiV1ChatMeDirectByRoomIdMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatMeDirectByRoomIdMessagesError = PostApiV1ChatMeDirectByRoomIdMessagesErrors[keyof PostApiV1ChatMeDirectByRoomIdMessagesErrors];

export type PostApiV1ChatMeDirectByRoomIdMessagesResponses = {
    /**
     * Created
     */
    201: DirectRoomMessageDto;
};

export type PostApiV1ChatMeDirectByRoomIdMessagesResponse = PostApiV1ChatMeDirectByRoomIdMessagesResponses[keyof PostApiV1ChatMeDirectByRoomIdMessagesResponses];

export type PostApiV1ChatMeDirectByRoomIdReadData = {
    body: MarkReadBody;
    path: {
        roomId: string;
    };
    query?: never;
    url: '/api/v1/chat/me/direct/{roomId}/read';
};

export type PostApiV1ChatMeDirectByRoomIdReadErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatMeDirectByRoomIdReadError = PostApiV1ChatMeDirectByRoomIdReadErrors[keyof PostApiV1ChatMeDirectByRoomIdReadErrors];

export type PostApiV1ChatMeDirectByRoomIdReadResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ChatMeDirectByRoomIdReadResponse = PostApiV1ChatMeDirectByRoomIdReadResponses[keyof PostApiV1ChatMeDirectByRoomIdReadResponses];

export type PostApiV1ChatMeMessagesByMessageIdReportData = {
    body: ReportMessageBody;
    path: {
        messageId: string;
    };
    query?: never;
    url: '/api/v1/chat/me/messages/{messageId}/report';
};

export type PostApiV1ChatMeMessagesByMessageIdReportResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetApiV1ChatMeRoomsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/chat/me/rooms';
};

export type GetApiV1ChatMeRoomsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatMeRoomsError = GetApiV1ChatMeRoomsErrors[keyof GetApiV1ChatMeRoomsErrors];

export type GetApiV1ChatMeRoomsResponses = {
    /**
     * OK
     */
    200: Array<ChatRoomDto>;
};

export type GetApiV1ChatMeRoomsResponse = GetApiV1ChatMeRoomsResponses[keyof GetApiV1ChatMeRoomsResponses];

export type GetApiV1ChatMeRoomsByKindBySubjectIdMessagesData = {
    body?: never;
    path: {
        kind: string;
        subjectId: string;
    };
    query?: {
        afterSeq?: number;
        beforeSeq?: number;
        limit?: number;
    };
    url: '/api/v1/chat/me/rooms/{kind}/{subjectId}/messages';
};

export type GetApiV1ChatMeRoomsByKindBySubjectIdMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatMeRoomsByKindBySubjectIdMessagesError = GetApiV1ChatMeRoomsByKindBySubjectIdMessagesErrors[keyof GetApiV1ChatMeRoomsByKindBySubjectIdMessagesErrors];

export type GetApiV1ChatMeRoomsByKindBySubjectIdMessagesResponses = {
    /**
     * OK
     */
    200: Array<ChatRoomMessageDto>;
};

export type GetApiV1ChatMeRoomsByKindBySubjectIdMessagesResponse = GetApiV1ChatMeRoomsByKindBySubjectIdMessagesResponses[keyof GetApiV1ChatMeRoomsByKindBySubjectIdMessagesResponses];

export type PostApiV1ChatMeRoomsByKindBySubjectIdMessagesData = {
    body: SendMyMessageBody;
    path: {
        kind: string;
        subjectId: string;
    };
    query?: never;
    url: '/api/v1/chat/me/rooms/{kind}/{subjectId}/messages';
};

export type PostApiV1ChatMeRoomsByKindBySubjectIdMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatMeRoomsByKindBySubjectIdMessagesError = PostApiV1ChatMeRoomsByKindBySubjectIdMessagesErrors[keyof PostApiV1ChatMeRoomsByKindBySubjectIdMessagesErrors];

export type PostApiV1ChatMeRoomsByKindBySubjectIdMessagesResponses = {
    /**
     * Created
     */
    201: ChatRoomMessageDto;
};

export type PostApiV1ChatMeRoomsByKindBySubjectIdMessagesResponse = PostApiV1ChatMeRoomsByKindBySubjectIdMessagesResponses[keyof PostApiV1ChatMeRoomsByKindBySubjectIdMessagesResponses];

export type PostApiV1ChatMeRoomsByKindBySubjectIdReadData = {
    body: MarkReadBody;
    path: {
        kind: string;
        subjectId: string;
    };
    query?: never;
    url: '/api/v1/chat/me/rooms/{kind}/{subjectId}/read';
};

export type PostApiV1ChatMeRoomsByKindBySubjectIdReadErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatMeRoomsByKindBySubjectIdReadError = PostApiV1ChatMeRoomsByKindBySubjectIdReadErrors[keyof PostApiV1ChatMeRoomsByKindBySubjectIdReadErrors];

export type PostApiV1ChatMeRoomsByKindBySubjectIdReadResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ChatMeRoomsByKindBySubjectIdReadResponse = PostApiV1ChatMeRoomsByKindBySubjectIdReadResponses[keyof PostApiV1ChatMeRoomsByKindBySubjectIdReadResponses];

export type GetApiV1ChatMeTrainerConversationsByIdMessagesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        afterSeq?: number;
        beforeSeq?: number;
        limit?: number;
    };
    url: '/api/v1/chat/me/trainer-conversations/{id}/messages';
};

export type GetApiV1ChatMeTrainerConversationsByIdMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatMeTrainerConversationsByIdMessagesError = GetApiV1ChatMeTrainerConversationsByIdMessagesErrors[keyof GetApiV1ChatMeTrainerConversationsByIdMessagesErrors];

export type GetApiV1ChatMeTrainerConversationsByIdMessagesResponses = {
    /**
     * OK
     */
    200: Array<ChatMessageDto>;
};

export type GetApiV1ChatMeTrainerConversationsByIdMessagesResponse = GetApiV1ChatMeTrainerConversationsByIdMessagesResponses[keyof GetApiV1ChatMeTrainerConversationsByIdMessagesResponses];

export type PostApiV1ChatMeTrainerConversationsByIdMessagesData = {
    body: SendMyMessageBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/chat/me/trainer-conversations/{id}/messages';
};

export type PostApiV1ChatMeTrainerConversationsByIdMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatMeTrainerConversationsByIdMessagesError = PostApiV1ChatMeTrainerConversationsByIdMessagesErrors[keyof PostApiV1ChatMeTrainerConversationsByIdMessagesErrors];

export type PostApiV1ChatMeTrainerConversationsByIdMessagesResponses = {
    /**
     * Created
     */
    201: ChatMessageDto;
};

export type PostApiV1ChatMeTrainerConversationsByIdMessagesResponse = PostApiV1ChatMeTrainerConversationsByIdMessagesResponses[keyof PostApiV1ChatMeTrainerConversationsByIdMessagesResponses];

export type PostApiV1ChatMeTrainerConversationsByIdReadData = {
    body: MarkReadBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/chat/me/trainer-conversations/{id}/read';
};

export type PostApiV1ChatMeTrainerConversationsByIdReadErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatMeTrainerConversationsByIdReadError = PostApiV1ChatMeTrainerConversationsByIdReadErrors[keyof PostApiV1ChatMeTrainerConversationsByIdReadErrors];

export type PostApiV1ChatMeTrainerConversationsByIdReadResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ChatMeTrainerConversationsByIdReadResponse = PostApiV1ChatMeTrainerConversationsByIdReadResponses[keyof PostApiV1ChatMeTrainerConversationsByIdReadResponses];

export type GetApiV1ChatMeTrainersData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/chat/me/trainers';
};

export type GetApiV1ChatMeTrainersErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatMeTrainersError = GetApiV1ChatMeTrainersErrors[keyof GetApiV1ChatMeTrainersErrors];

export type GetApiV1ChatMeTrainersResponses = {
    /**
     * OK
     */
    200: Array<ChatTrainerDto>;
};

export type GetApiV1ChatMeTrainersResponse = GetApiV1ChatMeTrainersResponses[keyof GetApiV1ChatMeTrainersResponses];

export type PostApiV1ChatMeTrainersByTrainerIdConversationData = {
    body?: never;
    path: {
        trainerId: string;
    };
    query?: never;
    url: '/api/v1/chat/me/trainers/{trainerId}/conversation';
};

export type PostApiV1ChatMeTrainersByTrainerIdConversationErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatMeTrainersByTrainerIdConversationError = PostApiV1ChatMeTrainersByTrainerIdConversationErrors[keyof PostApiV1ChatMeTrainersByTrainerIdConversationErrors];

export type PostApiV1ChatMeTrainersByTrainerIdConversationResponses = {
    /**
     * OK
     */
    200: ConversationDto;
};

export type PostApiV1ChatMeTrainersByTrainerIdConversationResponse = PostApiV1ChatMeTrainersByTrainerIdConversationResponses[keyof PostApiV1ChatMeTrainersByTrainerIdConversationResponses];

export type GetApiV1ChatOversightConversationsData = {
    body?: never;
    path?: never;
    query?: {
        trainerId?: string;
        clientId?: string;
        before?: string;
        limit?: number;
    };
    url: '/api/v1/chat/oversight/conversations';
};

export type GetApiV1ChatOversightConversationsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatOversightConversationsError = GetApiV1ChatOversightConversationsErrors[keyof GetApiV1ChatOversightConversationsErrors];

export type GetApiV1ChatOversightConversationsResponses = {
    /**
     * OK
     */
    200: Array<ConversationDto>;
};

export type GetApiV1ChatOversightConversationsResponse = GetApiV1ChatOversightConversationsResponses[keyof GetApiV1ChatOversightConversationsResponses];

export type GetApiV1ChatOversightConversationsByIdMessagesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        afterSeq?: number;
        beforeSeq?: number;
        limit?: number;
    };
    url: '/api/v1/chat/oversight/conversations/{id}/messages';
};

export type GetApiV1ChatOversightConversationsByIdMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatOversightConversationsByIdMessagesError = GetApiV1ChatOversightConversationsByIdMessagesErrors[keyof GetApiV1ChatOversightConversationsByIdMessagesErrors];

export type GetApiV1ChatOversightConversationsByIdMessagesResponses = {
    /**
     * OK
     */
    200: Array<ChatMessageDto>;
};

export type GetApiV1ChatOversightConversationsByIdMessagesResponse = GetApiV1ChatOversightConversationsByIdMessagesResponses[keyof GetApiV1ChatOversightConversationsByIdMessagesResponses];

export type GetApiV1ChatOversightConversationsByIdReadsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/chat/oversight/conversations/{id}/reads';
};

export type GetApiV1ChatOversightConversationsByIdReadsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatOversightConversationsByIdReadsError = GetApiV1ChatOversightConversationsByIdReadsErrors[keyof GetApiV1ChatOversightConversationsByIdReadsErrors];

export type GetApiV1ChatOversightConversationsByIdReadsResponses = {
    /**
     * OK
     */
    200: Array<ChatReadDto>;
};

export type GetApiV1ChatOversightConversationsByIdReadsResponse = GetApiV1ChatOversightConversationsByIdReadsResponses[keyof GetApiV1ChatOversightConversationsByIdReadsResponses];

export type PostApiV1ChatTrainerClientsByClientIdConversationData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/chat/trainer/clients/{clientId}/conversation';
};

export type PostApiV1ChatTrainerClientsByClientIdConversationErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatTrainerClientsByClientIdConversationError = PostApiV1ChatTrainerClientsByClientIdConversationErrors[keyof PostApiV1ChatTrainerClientsByClientIdConversationErrors];

export type PostApiV1ChatTrainerClientsByClientIdConversationResponses = {
    /**
     * OK
     */
    200: ConversationDto;
};

export type PostApiV1ChatTrainerClientsByClientIdConversationResponse = PostApiV1ChatTrainerClientsByClientIdConversationResponses[keyof PostApiV1ChatTrainerClientsByClientIdConversationResponses];

export type GetApiV1ChatTrainerConversationsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/chat/trainer/conversations';
};

export type GetApiV1ChatTrainerConversationsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatTrainerConversationsError = GetApiV1ChatTrainerConversationsErrors[keyof GetApiV1ChatTrainerConversationsErrors];

export type GetApiV1ChatTrainerConversationsResponses = {
    /**
     * OK
     */
    200: Array<ConversationDto>;
};

export type GetApiV1ChatTrainerConversationsResponse = GetApiV1ChatTrainerConversationsResponses[keyof GetApiV1ChatTrainerConversationsResponses];

export type GetApiV1ChatTrainerConversationsByIdMessagesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        afterSeq?: number;
        beforeSeq?: number;
        limit?: number;
    };
    url: '/api/v1/chat/trainer/conversations/{id}/messages';
};

export type GetApiV1ChatTrainerConversationsByIdMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatTrainerConversationsByIdMessagesError = GetApiV1ChatTrainerConversationsByIdMessagesErrors[keyof GetApiV1ChatTrainerConversationsByIdMessagesErrors];

export type GetApiV1ChatTrainerConversationsByIdMessagesResponses = {
    /**
     * OK
     */
    200: Array<ChatMessageDto>;
};

export type GetApiV1ChatTrainerConversationsByIdMessagesResponse = GetApiV1ChatTrainerConversationsByIdMessagesResponses[keyof GetApiV1ChatTrainerConversationsByIdMessagesResponses];

export type PostApiV1ChatTrainerConversationsByIdMessagesData = {
    body: SendMyMessageBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/chat/trainer/conversations/{id}/messages';
};

export type PostApiV1ChatTrainerConversationsByIdMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatTrainerConversationsByIdMessagesError = PostApiV1ChatTrainerConversationsByIdMessagesErrors[keyof PostApiV1ChatTrainerConversationsByIdMessagesErrors];

export type PostApiV1ChatTrainerConversationsByIdMessagesResponses = {
    /**
     * Created
     */
    201: ChatMessageDto;
};

export type PostApiV1ChatTrainerConversationsByIdMessagesResponse = PostApiV1ChatTrainerConversationsByIdMessagesResponses[keyof PostApiV1ChatTrainerConversationsByIdMessagesResponses];

export type PostApiV1ChatTrainerConversationsByIdReadData = {
    body: MarkReadBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/chat/trainer/conversations/{id}/read';
};

export type PostApiV1ChatTrainerConversationsByIdReadErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatTrainerConversationsByIdReadError = PostApiV1ChatTrainerConversationsByIdReadErrors[keyof PostApiV1ChatTrainerConversationsByIdReadErrors];

export type PostApiV1ChatTrainerConversationsByIdReadResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ChatTrainerConversationsByIdReadResponse = PostApiV1ChatTrainerConversationsByIdReadResponses[keyof PostApiV1ChatTrainerConversationsByIdReadResponses];

export type GetApiV1ChatTrainerRoomsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/chat/trainer/rooms';
};

export type GetApiV1ChatTrainerRoomsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatTrainerRoomsError = GetApiV1ChatTrainerRoomsErrors[keyof GetApiV1ChatTrainerRoomsErrors];

export type GetApiV1ChatTrainerRoomsResponses = {
    /**
     * OK
     */
    200: Array<ChatRoomDto>;
};

export type GetApiV1ChatTrainerRoomsResponse = GetApiV1ChatTrainerRoomsResponses[keyof GetApiV1ChatTrainerRoomsResponses];

export type GetApiV1ChatTrainerRoomsByKindBySubjectIdMessagesData = {
    body?: never;
    path: {
        kind: string;
        subjectId: string;
    };
    query?: {
        afterSeq?: number;
        beforeSeq?: number;
        limit?: number;
    };
    url: '/api/v1/chat/trainer/rooms/{kind}/{subjectId}/messages';
};

export type GetApiV1ChatTrainerRoomsByKindBySubjectIdMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ChatTrainerRoomsByKindBySubjectIdMessagesError = GetApiV1ChatTrainerRoomsByKindBySubjectIdMessagesErrors[keyof GetApiV1ChatTrainerRoomsByKindBySubjectIdMessagesErrors];

export type GetApiV1ChatTrainerRoomsByKindBySubjectIdMessagesResponses = {
    /**
     * OK
     */
    200: Array<ChatRoomMessageDto>;
};

export type GetApiV1ChatTrainerRoomsByKindBySubjectIdMessagesResponse = GetApiV1ChatTrainerRoomsByKindBySubjectIdMessagesResponses[keyof GetApiV1ChatTrainerRoomsByKindBySubjectIdMessagesResponses];

export type PostApiV1ChatTrainerRoomsByKindBySubjectIdMessagesData = {
    body: SendMyMessageBody;
    path: {
        kind: string;
        subjectId: string;
    };
    query?: never;
    url: '/api/v1/chat/trainer/rooms/{kind}/{subjectId}/messages';
};

export type PostApiV1ChatTrainerRoomsByKindBySubjectIdMessagesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatTrainerRoomsByKindBySubjectIdMessagesError = PostApiV1ChatTrainerRoomsByKindBySubjectIdMessagesErrors[keyof PostApiV1ChatTrainerRoomsByKindBySubjectIdMessagesErrors];

export type PostApiV1ChatTrainerRoomsByKindBySubjectIdMessagesResponses = {
    /**
     * Created
     */
    201: ChatRoomMessageDto;
};

export type PostApiV1ChatTrainerRoomsByKindBySubjectIdMessagesResponse = PostApiV1ChatTrainerRoomsByKindBySubjectIdMessagesResponses[keyof PostApiV1ChatTrainerRoomsByKindBySubjectIdMessagesResponses];

export type PostApiV1ChatTrainerRoomsByKindBySubjectIdReadData = {
    body: MarkReadBody;
    path: {
        kind: string;
        subjectId: string;
    };
    query?: never;
    url: '/api/v1/chat/trainer/rooms/{kind}/{subjectId}/read';
};

export type PostApiV1ChatTrainerRoomsByKindBySubjectIdReadErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ChatTrainerRoomsByKindBySubjectIdReadError = PostApiV1ChatTrainerRoomsByKindBySubjectIdReadErrors[keyof PostApiV1ChatTrainerRoomsByKindBySubjectIdReadErrors];

export type PostApiV1ChatTrainerRoomsByKindBySubjectIdReadResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ChatTrainerRoomsByKindBySubjectIdReadResponse = PostApiV1ChatTrainerRoomsByKindBySubjectIdReadResponses[keyof PostApiV1ChatTrainerRoomsByKindBySubjectIdReadResponses];

export type PostApiV1ClientAssistanceData = {
    body: CreateAssistancePayload;
    path?: never;
    query?: never;
    url: '/api/v1/client/assistance';
};

export type PostApiV1ClientAssistanceErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientAssistanceError = PostApiV1ClientAssistanceErrors[keyof PostApiV1ClientAssistanceErrors];

export type PostApiV1ClientAssistanceResponses = {
    /**
     * OK
     */
    200: AssistanceRequestDto;
};

export type PostApiV1ClientAssistanceResponse = PostApiV1ClientAssistanceResponses[keyof PostApiV1ClientAssistanceResponses];

export type GetApiV1ClientsData = {
    body?: never;
    path?: never;
    query?: {
        q?: string;
        category?: string;
        activity?: string;
        sport?: string;
        sort?: ClientSortKey;
        order?: SortOrder;
        page?: number;
        pageSize?: number;
        includeBlacklisted?: boolean;
        onlyBlacklisted?: boolean;
        hasBonuses?: boolean;
    };
    url: '/api/v1/clients';
};

export type GetApiV1ClientsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsError = GetApiV1ClientsErrors[keyof GetApiV1ClientsErrors];

export type GetApiV1ClientsResponses = {
    /**
     * OK
     */
    200: ListClientsResponse;
};

export type GetApiV1ClientsResponse = GetApiV1ClientsResponses[keyof GetApiV1ClientsResponses];

export type GetApiV1ClientsBlacklistData = {
    body?: never;
    path?: never;
    query?: {
        search?: string;
        page?: number;
        pageSize?: number;
    };
    url: '/api/v1/clients/blacklist';
};

export type GetApiV1ClientsBlacklistErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsBlacklistError = GetApiV1ClientsBlacklistErrors[keyof GetApiV1ClientsBlacklistErrors];

export type GetApiV1ClientsBlacklistResponses = {
    /**
     * OK
     */
    200: BlacklistedPhonesPage;
};

export type GetApiV1ClientsBlacklistResponse = GetApiV1ClientsBlacklistResponses[keyof GetApiV1ClientsBlacklistResponses];

export type PostApiV1ClientsBlacklistImportData = {
    body: ImportBlacklistCommand;
    path?: never;
    query?: never;
    url: '/api/v1/clients/blacklist/import';
};

export type PostApiV1ClientsBlacklistImportErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsBlacklistImportError = PostApiV1ClientsBlacklistImportErrors[keyof PostApiV1ClientsBlacklistImportErrors];

export type PostApiV1ClientsBlacklistImportResponses = {
    /**
     * OK
     */
    200: BlacklistImportResult;
};

export type PostApiV1ClientsBlacklistImportResponse = PostApiV1ClientsBlacklistImportResponses[keyof PostApiV1ClientsBlacklistImportResponses];

export type PostApiV1ClientsBlacklistImportPreviewData = {
    body: PreviewBlacklistImportQuery;
    path?: never;
    query?: never;
    url: '/api/v1/clients/blacklist/import/preview';
};

export type PostApiV1ClientsBlacklistImportPreviewErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsBlacklistImportPreviewError = PostApiV1ClientsBlacklistImportPreviewErrors[keyof PostApiV1ClientsBlacklistImportPreviewErrors];

export type PostApiV1ClientsBlacklistImportPreviewResponses = {
    /**
     * OK
     */
    200: BlacklistImportPreview;
};

export type PostApiV1ClientsBlacklistImportPreviewResponse = PostApiV1ClientsBlacklistImportPreviewResponses[keyof PostApiV1ClientsBlacklistImportPreviewResponses];

export type DeleteApiV1ClientsBlacklistByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/clients/blacklist/{id}';
};

export type DeleteApiV1ClientsBlacklistByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1ClientsBlacklistByIdError = DeleteApiV1ClientsBlacklistByIdErrors[keyof DeleteApiV1ClientsBlacklistByIdErrors];

export type DeleteApiV1ClientsBlacklistByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1ClientsBlacklistByIdResponse = DeleteApiV1ClientsBlacklistByIdResponses[keyof DeleteApiV1ClientsBlacklistByIdResponses];

export type PostApiV1ClientsBulkUpdateData = {
    body: BulkUpdatePayload;
    path?: never;
    query?: never;
    url: '/api/v1/clients/bulk-update';
};

export type PostApiV1ClientsBulkUpdateErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsBulkUpdateError = PostApiV1ClientsBulkUpdateErrors[keyof PostApiV1ClientsBulkUpdateErrors];

export type PostApiV1ClientsBulkUpdateResponses = {
    /**
     * OK
     */
    200: BulkUpdateResponse;
};

export type PostApiV1ClientsBulkUpdateResponse = PostApiV1ClientsBulkUpdateResponses[keyof PostApiV1ClientsBulkUpdateResponses];

export type GetApiV1ClientsCheckinCardsData = {
    body?: never;
    path?: never;
    query?: {
        ids?: string;
    };
    url: '/api/v1/clients/checkin-cards';
};

export type GetApiV1ClientsCheckinCardsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsCheckinCardsError = GetApiV1ClientsCheckinCardsErrors[keyof GetApiV1ClientsCheckinCardsErrors];

export type GetApiV1ClientsCheckinCardsResponses = {
    /**
     * OK
     */
    200: CheckinCardsResponse;
};

export type GetApiV1ClientsCheckinCardsResponse = GetApiV1ClientsCheckinCardsResponses[keyof GetApiV1ClientsCheckinCardsResponses];

export type GetApiV1ClientsMeAchievementsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/clients/me/achievements';
};

export type GetApiV1ClientsMeAchievementsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsMeAchievementsError = GetApiV1ClientsMeAchievementsErrors[keyof GetApiV1ClientsMeAchievementsErrors];

export type GetApiV1ClientsMeAchievementsResponses = {
    /**
     * OK
     */
    200: MyAchievementsResponse;
};

export type GetApiV1ClientsMeAchievementsResponse = GetApiV1ClientsMeAchievementsResponses[keyof GetApiV1ClientsMeAchievementsResponses];

export type GetApiV1ClientsMeActivityData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
    };
    url: '/api/v1/clients/me/activity';
};

export type GetApiV1ClientsMeActivityErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsMeActivityError = GetApiV1ClientsMeActivityErrors[keyof GetApiV1ClientsMeActivityErrors];

export type GetApiV1ClientsMeActivityResponses = {
    /**
     * OK
     */
    200: MyActivityResponse;
};

export type GetApiV1ClientsMeActivityResponse = GetApiV1ClientsMeActivityResponses[keyof GetApiV1ClientsMeActivityResponses];

export type DeleteApiV1ClientsMeAvatarData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/clients/me/avatar';
};

export type DeleteApiV1ClientsMeAvatarErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1ClientsMeAvatarError = DeleteApiV1ClientsMeAvatarErrors[keyof DeleteApiV1ClientsMeAvatarErrors];

export type DeleteApiV1ClientsMeAvatarResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1ClientsMeAvatarResponse = DeleteApiV1ClientsMeAvatarResponses[keyof DeleteApiV1ClientsMeAvatarResponses];

export type PutApiV1ClientsMeAvatarData = {
    body: {
        file?: IFormFile;
    };
    path?: never;
    query?: never;
    url: '/api/v1/clients/me/avatar';
};

export type PutApiV1ClientsMeAvatarErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1ClientsMeAvatarError = PutApiV1ClientsMeAvatarErrors[keyof PutApiV1ClientsMeAvatarErrors];

export type PutApiV1ClientsMeAvatarResponses = {
    /**
     * OK
     */
    200: ProfilePhotoResponse;
};

export type PutApiV1ClientsMeAvatarResponse = PutApiV1ClientsMeAvatarResponses[keyof PutApiV1ClientsMeAvatarResponses];

export type GetApiV1ClientsMeChildrenData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/clients/me/children';
};

export type GetApiV1ClientsMeChildrenErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsMeChildrenError = GetApiV1ClientsMeChildrenErrors[keyof GetApiV1ClientsMeChildrenErrors];

export type GetApiV1ClientsMeChildrenResponses = {
    /**
     * OK
     */
    200: Array<ChildDto>;
};

export type GetApiV1ClientsMeChildrenResponse = GetApiV1ClientsMeChildrenResponses[keyof GetApiV1ClientsMeChildrenResponses];

export type PostApiV1ClientsMeChildrenData = {
    body: AddChildRequest;
    path?: never;
    query?: never;
    url: '/api/v1/clients/me/children';
};

export type PostApiV1ClientsMeChildrenErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsMeChildrenError = PostApiV1ClientsMeChildrenErrors[keyof PostApiV1ClientsMeChildrenErrors];

export type PostApiV1ClientsMeChildrenResponses = {
    /**
     * OK
     */
    200: ChildDto;
};

export type PostApiV1ClientsMeChildrenResponse = PostApiV1ClientsMeChildrenResponses[keyof PostApiV1ClientsMeChildrenResponses];

export type PostApiV1ClientsMeChildrenPhoneLinkData = {
    body: AddChildRequest;
    path?: never;
    query?: never;
    url: '/api/v1/clients/me/children/phone-link';
};

export type PostApiV1ClientsMeChildrenPhoneLinkErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsMeChildrenPhoneLinkError = PostApiV1ClientsMeChildrenPhoneLinkErrors[keyof PostApiV1ClientsMeChildrenPhoneLinkErrors];

export type PostApiV1ClientsMeChildrenPhoneLinkResponses = {
    /**
     * OK
     */
    200: ChildPhoneLinkPending;
};

export type PostApiV1ClientsMeChildrenPhoneLinkResponse = PostApiV1ClientsMeChildrenPhoneLinkResponses[keyof PostApiV1ClientsMeChildrenPhoneLinkResponses];

export type PostApiV1ClientsMeChildrenPhoneLinkByConfirmationIdConfirmData = {
    body: ConfirmChildPhoneLinkRequest;
    path: {
        confirmationId: string;
    };
    query?: never;
    url: '/api/v1/clients/me/children/phone-link/{confirmationId}/confirm';
};

export type PostApiV1ClientsMeChildrenPhoneLinkByConfirmationIdConfirmErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsMeChildrenPhoneLinkByConfirmationIdConfirmError = PostApiV1ClientsMeChildrenPhoneLinkByConfirmationIdConfirmErrors[keyof PostApiV1ClientsMeChildrenPhoneLinkByConfirmationIdConfirmErrors];

export type PostApiV1ClientsMeChildrenPhoneLinkByConfirmationIdConfirmResponses = {
    /**
     * OK
     */
    200: ChildDto;
};

export type PostApiV1ClientsMeChildrenPhoneLinkByConfirmationIdConfirmResponse = PostApiV1ClientsMeChildrenPhoneLinkByConfirmationIdConfirmResponses[keyof PostApiV1ClientsMeChildrenPhoneLinkByConfirmationIdConfirmResponses];

export type DeleteApiV1ClientsMeChildrenByChildIdData = {
    body?: never;
    path: {
        childId: string;
    };
    query?: never;
    url: '/api/v1/clients/me/children/{childId}';
};

export type DeleteApiV1ClientsMeChildrenByChildIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1ClientsMeChildrenByChildIdError = DeleteApiV1ClientsMeChildrenByChildIdErrors[keyof DeleteApiV1ClientsMeChildrenByChildIdErrors];

export type DeleteApiV1ClientsMeChildrenByChildIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1ClientsMeChildrenByChildIdResponse = DeleteApiV1ClientsMeChildrenByChildIdResponses[keyof DeleteApiV1ClientsMeChildrenByChildIdResponses];

export type PutApiV1ClientsMeChildrenByChildIdCategoriesData = {
    body: ChildCategoriesDto;
    path: {
        childId: string;
    };
    query?: never;
    url: '/api/v1/clients/me/children/{childId}/categories';
};

export type PutApiV1ClientsMeChildrenByChildIdCategoriesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1ClientsMeChildrenByChildIdCategoriesError = PutApiV1ClientsMeChildrenByChildIdCategoriesErrors[keyof PutApiV1ClientsMeChildrenByChildIdCategoriesErrors];

export type PutApiV1ClientsMeChildrenByChildIdCategoriesResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1ClientsMeChildrenByChildIdCategoriesResponse = PutApiV1ClientsMeChildrenByChildIdCategoriesResponses[keyof PutApiV1ClientsMeChildrenByChildIdCategoriesResponses];

export type PostApiV1ClientsMeGuestsData = {
    body: MobileGuestRequest;
    path?: never;
    query?: never;
    url: '/api/v1/clients/me/guests';
};

export type PostApiV1ClientsMeGuestsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsMeGuestsError = PostApiV1ClientsMeGuestsErrors[keyof PostApiV1ClientsMeGuestsErrors];

export type PostApiV1ClientsMeGuestsResponses = {
    /**
     * OK
     */
    200: GuestDto;
};

export type PostApiV1ClientsMeGuestsResponse = PostApiV1ClientsMeGuestsResponses[keyof PostApiV1ClientsMeGuestsResponses];

export type GetApiV1ClientsMeOverviewData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/clients/me/overview';
};

export type GetApiV1ClientsMeOverviewErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsMeOverviewError = GetApiV1ClientsMeOverviewErrors[keyof GetApiV1ClientsMeOverviewErrors];

export type GetApiV1ClientsMeOverviewResponses = {
    /**
     * OK
     */
    200: MyOverviewResponse;
};

export type GetApiV1ClientsMeOverviewResponse = GetApiV1ClientsMeOverviewResponses[keyof GetApiV1ClientsMeOverviewResponses];

export type GetApiV1ClientsMeProfileData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/clients/me/profile';
};

export type GetApiV1ClientsMeProfileErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsMeProfileError = GetApiV1ClientsMeProfileErrors[keyof GetApiV1ClientsMeProfileErrors];

export type GetApiV1ClientsMeProfileResponses = {
    /**
     * OK
     */
    200: MyProfileResponse;
};

export type GetApiV1ClientsMeProfileResponse = GetApiV1ClientsMeProfileResponses[keyof GetApiV1ClientsMeProfileResponses];

export type PutApiV1ClientsMeProfileData = {
    body: UpdateMyProfileRequest;
    path?: never;
    query?: never;
    url: '/api/v1/clients/me/profile';
};

export type PutApiV1ClientsMeProfileErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1ClientsMeProfileError = PutApiV1ClientsMeProfileErrors[keyof PutApiV1ClientsMeProfileErrors];

export type PutApiV1ClientsMeProfileResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1ClientsMeProfileResponse = PutApiV1ClientsMeProfileResponses[keyof PutApiV1ClientsMeProfileResponses];

export type GetApiV1ClientsMeSplitDebtData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/clients/me/split-debt';
};

export type GetApiV1ClientsMeSplitDebtErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsMeSplitDebtError = GetApiV1ClientsMeSplitDebtErrors[keyof GetApiV1ClientsMeSplitDebtErrors];

export type GetApiV1ClientsMeSplitDebtResponses = {
    /**
     * OK
     */
    200: MySplitDebtResponse;
};

export type GetApiV1ClientsMeSplitDebtResponse = GetApiV1ClientsMeSplitDebtResponses[keyof GetApiV1ClientsMeSplitDebtResponses];

export type GetApiV1ClientsRecentData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/clients/recent';
};

export type GetApiV1ClientsRecentErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsRecentError = GetApiV1ClientsRecentErrors[keyof GetApiV1ClientsRecentErrors];

export type GetApiV1ClientsRecentResponses = {
    /**
     * OK
     */
    200: ClientSearchResponse;
};

export type GetApiV1ClientsRecentResponse = GetApiV1ClientsRecentResponses[keyof GetApiV1ClientsRecentResponses];

export type GetApiV1ClientsSearchData = {
    body?: never;
    path?: never;
    query?: {
        q?: string;
        limit?: number;
    };
    url: '/api/v1/clients/search';
};

export type GetApiV1ClientsSearchErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsSearchError = GetApiV1ClientsSearchErrors[keyof GetApiV1ClientsSearchErrors];

export type GetApiV1ClientsSearchResponses = {
    /**
     * OK
     */
    200: ClientSearchResponse;
};

export type GetApiV1ClientsSearchResponse = GetApiV1ClientsSearchResponses[keyof GetApiV1ClientsSearchResponses];

export type PostApiV1ClientsByClientIdAdvanceCorrectionData = {
    body: AdvanceCorrectionPayload;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/clients/{clientId}/advance/correction';
};

export type PostApiV1ClientsByClientIdAdvanceCorrectionErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsByClientIdAdvanceCorrectionError = PostApiV1ClientsByClientIdAdvanceCorrectionErrors[keyof PostApiV1ClientsByClientIdAdvanceCorrectionErrors];

export type PostApiV1ClientsByClientIdAdvanceCorrectionResponses = {
    /**
     * OK
     */
    200: AdvanceCorrectionResult;
};

export type PostApiV1ClientsByClientIdAdvanceCorrectionResponse = PostApiV1ClientsByClientIdAdvanceCorrectionResponses[keyof PostApiV1ClientsByClientIdAdvanceCorrectionResponses];

export type PostApiV1ClientsByClientIdAdvanceTransferToBonusData = {
    body: TransferToBonusPayload;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/clients/{clientId}/advance/transfer-to-bonus';
};

export type PostApiV1ClientsByClientIdAdvanceTransferToBonusErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsByClientIdAdvanceTransferToBonusError = PostApiV1ClientsByClientIdAdvanceTransferToBonusErrors[keyof PostApiV1ClientsByClientIdAdvanceTransferToBonusErrors];

export type PostApiV1ClientsByClientIdAdvanceTransferToBonusResponses = {
    /**
     * OK
     */
    200: TransferAdvanceToBonusResult;
};

export type PostApiV1ClientsByClientIdAdvanceTransferToBonusResponse = PostApiV1ClientsByClientIdAdvanceTransferToBonusResponses[keyof PostApiV1ClientsByClientIdAdvanceTransferToBonusResponses];

export type GetApiV1ClientsByClientIdBonusesData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: {
        limit?: number;
    };
    url: '/api/v1/clients/{clientId}/bonuses';
};

export type GetApiV1ClientsByClientIdBonusesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsByClientIdBonusesError = GetApiV1ClientsByClientIdBonusesErrors[keyof GetApiV1ClientsByClientIdBonusesErrors];

export type GetApiV1ClientsByClientIdBonusesResponses = {
    /**
     * OK
     */
    200: ClientBonusesResponse;
};

export type GetApiV1ClientsByClientIdBonusesResponse = GetApiV1ClientsByClientIdBonusesResponses[keyof GetApiV1ClientsByClientIdBonusesResponses];

export type PostApiV1ClientsByClientIdBonusesCreditData = {
    body: BonusCreditPayload;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/clients/{clientId}/bonuses/credit';
};

export type PostApiV1ClientsByClientIdBonusesCreditErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsByClientIdBonusesCreditError = PostApiV1ClientsByClientIdBonusesCreditErrors[keyof PostApiV1ClientsByClientIdBonusesCreditErrors];

export type PostApiV1ClientsByClientIdBonusesCreditResponses = {
    /**
     * Created
     */
    201: BonusTransactionDto;
};

export type PostApiV1ClientsByClientIdBonusesCreditResponse = PostApiV1ClientsByClientIdBonusesCreditResponses[keyof PostApiV1ClientsByClientIdBonusesCreditResponses];

export type PostApiV1ClientsByClientIdBonusesDebitData = {
    body: BonusAdjustPayload;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/clients/{clientId}/bonuses/debit';
};

export type PostApiV1ClientsByClientIdBonusesDebitErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsByClientIdBonusesDebitError = PostApiV1ClientsByClientIdBonusesDebitErrors[keyof PostApiV1ClientsByClientIdBonusesDebitErrors];

export type PostApiV1ClientsByClientIdBonusesDebitResponses = {
    /**
     * Created
     */
    201: BonusTransactionDto;
};

export type PostApiV1ClientsByClientIdBonusesDebitResponse = PostApiV1ClientsByClientIdBonusesDebitResponses[keyof PostApiV1ClientsByClientIdBonusesDebitResponses];

export type PostApiV1ClientsByClientIdDefaultedSplitsBySplitIdForgiveData = {
    body?: never;
    path: {
        clientId: string;
        splitId: string;
    };
    query?: never;
    url: '/api/v1/clients/{clientId}/defaulted-splits/{splitId}/forgive';
};

export type PostApiV1ClientsByClientIdDefaultedSplitsBySplitIdForgiveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsByClientIdDefaultedSplitsBySplitIdForgiveError = PostApiV1ClientsByClientIdDefaultedSplitsBySplitIdForgiveErrors[keyof PostApiV1ClientsByClientIdDefaultedSplitsBySplitIdForgiveErrors];

export type PostApiV1ClientsByClientIdDefaultedSplitsBySplitIdForgiveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ClientsByClientIdDefaultedSplitsBySplitIdForgiveResponse = PostApiV1ClientsByClientIdDefaultedSplitsBySplitIdForgiveResponses[keyof PostApiV1ClientsByClientIdDefaultedSplitsBySplitIdForgiveResponses];

export type GetApiV1ClientsByClientIdFriendsData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/clients/{clientId}/friends';
};

export type GetApiV1ClientsByClientIdFriendsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsByClientIdFriendsError = GetApiV1ClientsByClientIdFriendsErrors[keyof GetApiV1ClientsByClientIdFriendsErrors];

export type GetApiV1ClientsByClientIdFriendsResponses = {
    /**
     * OK
     */
    200: ClientFriendsResponse;
};

export type GetApiV1ClientsByClientIdFriendsResponse = GetApiV1ClientsByClientIdFriendsResponses[keyof GetApiV1ClientsByClientIdFriendsResponses];

export type GetApiV1ClientsByClientIdMembershipCardData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/clients/{clientId}/membership-card';
};

export type GetApiV1ClientsByClientIdMembershipCardErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsByClientIdMembershipCardError = GetApiV1ClientsByClientIdMembershipCardErrors[keyof GetApiV1ClientsByClientIdMembershipCardErrors];

export type GetApiV1ClientsByClientIdMembershipCardResponses = {
    /**
     * OK
     */
    200: MembershipCardStatusDto;
    /**
     * No Content
     */
    204: void;
};

export type GetApiV1ClientsByClientIdMembershipCardResponse = GetApiV1ClientsByClientIdMembershipCardResponses[keyof GetApiV1ClientsByClientIdMembershipCardResponses];

export type PatchApiV1ClientsByClientIdMembershipCardData = {
    body: MembershipCardPatchPayload;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/clients/{clientId}/membership-card';
};

export type PatchApiV1ClientsByClientIdMembershipCardErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1ClientsByClientIdMembershipCardError = PatchApiV1ClientsByClientIdMembershipCardErrors[keyof PatchApiV1ClientsByClientIdMembershipCardErrors];

export type PatchApiV1ClientsByClientIdMembershipCardResponses = {
    /**
     * OK
     */
    200: MembershipCardStatusDto;
};

export type PatchApiV1ClientsByClientIdMembershipCardResponse = PatchApiV1ClientsByClientIdMembershipCardResponses[keyof PatchApiV1ClientsByClientIdMembershipCardResponses];

export type PostApiV1ClientsByClientIdMembershipCardData = {
    body: IssueMembershipCardPayload;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/clients/{clientId}/membership-card';
};

export type PostApiV1ClientsByClientIdMembershipCardErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsByClientIdMembershipCardError = PostApiV1ClientsByClientIdMembershipCardErrors[keyof PostApiV1ClientsByClientIdMembershipCardErrors];

export type PostApiV1ClientsByClientIdMembershipCardResponses = {
    /**
     * Created
     */
    201: MembershipCardStatusDto;
};

export type PostApiV1ClientsByClientIdMembershipCardResponse = PostApiV1ClientsByClientIdMembershipCardResponses[keyof PostApiV1ClientsByClientIdMembershipCardResponses];

export type GetApiV1ClientsByClientIdSubscriptionsData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: {
        activeOnly?: boolean;
    };
    url: '/api/v1/clients/{clientId}/subscriptions';
};

export type GetApiV1ClientsByClientIdSubscriptionsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsByClientIdSubscriptionsError = GetApiV1ClientsByClientIdSubscriptionsErrors[keyof GetApiV1ClientsByClientIdSubscriptionsErrors];

export type GetApiV1ClientsByClientIdSubscriptionsResponses = {
    /**
     * OK
     */
    200: SubscriptionListResponse;
};

export type GetApiV1ClientsByClientIdSubscriptionsResponse = GetApiV1ClientsByClientIdSubscriptionsResponses[keyof GetApiV1ClientsByClientIdSubscriptionsResponses];

export type PostApiV1ClientsByClientIdSubscriptionsData = {
    body: IssueSubscriptionPayload;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/clients/{clientId}/subscriptions';
};

export type PostApiV1ClientsByClientIdSubscriptionsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsByClientIdSubscriptionsError = PostApiV1ClientsByClientIdSubscriptionsErrors[keyof PostApiV1ClientsByClientIdSubscriptionsErrors];

export type PostApiV1ClientsByClientIdSubscriptionsResponses = {
    /**
     * Created
     */
    201: SubscriptionDto;
};

export type PostApiV1ClientsByClientIdSubscriptionsResponse = PostApiV1ClientsByClientIdSubscriptionsResponses[keyof PostApiV1ClientsByClientIdSubscriptionsResponses];

export type GetApiV1ClientsByClientIdSubscriptionsForCheckoutData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/clients/{clientId}/subscriptions/for-checkout';
};

export type GetApiV1ClientsByClientIdSubscriptionsForCheckoutErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsByClientIdSubscriptionsForCheckoutError = GetApiV1ClientsByClientIdSubscriptionsForCheckoutErrors[keyof GetApiV1ClientsByClientIdSubscriptionsForCheckoutErrors];

export type GetApiV1ClientsByClientIdSubscriptionsForCheckoutResponses = {
    /**
     * OK
     */
    200: MySubscriptionsResponse;
};

export type GetApiV1ClientsByClientIdSubscriptionsForCheckoutResponse = GetApiV1ClientsByClientIdSubscriptionsForCheckoutResponses[keyof GetApiV1ClientsByClientIdSubscriptionsForCheckoutResponses];

export type GetApiV1ClientsByClientIdWalletTopupsData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: {
        Limit?: number;
        Cursor?: string;
    };
    url: '/api/v1/clients/{clientId}/wallet/topups';
};

export type GetApiV1ClientsByClientIdWalletTopupsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsByClientIdWalletTopupsError = GetApiV1ClientsByClientIdWalletTopupsErrors[keyof GetApiV1ClientsByClientIdWalletTopupsErrors];

export type GetApiV1ClientsByClientIdWalletTopupsResponses = {
    /**
     * OK
     */
    200: PagedListOfWalletTopupDto;
};

export type GetApiV1ClientsByClientIdWalletTopupsResponse = GetApiV1ClientsByClientIdWalletTopupsResponses[keyof GetApiV1ClientsByClientIdWalletTopupsResponses];

export type GetApiV1ClientsByClientIdWalletTransactionsData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: {
        Type?: DepositTransactionType;
        Limit?: number;
        Cursor?: string;
    };
    url: '/api/v1/clients/{clientId}/wallet/transactions';
};

export type GetApiV1ClientsByClientIdWalletTransactionsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsByClientIdWalletTransactionsError = GetApiV1ClientsByClientIdWalletTransactionsErrors[keyof GetApiV1ClientsByClientIdWalletTransactionsErrors];

export type GetApiV1ClientsByClientIdWalletTransactionsResponses = {
    /**
     * OK
     */
    200: PagedListOfDepositTransactionDto;
};

export type GetApiV1ClientsByClientIdWalletTransactionsResponse = GetApiV1ClientsByClientIdWalletTransactionsResponses[keyof GetApiV1ClientsByClientIdWalletTransactionsResponses];

export type GetApiV1ClientsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/clients/{id}';
};

export type GetApiV1ClientsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsByIdError = GetApiV1ClientsByIdErrors[keyof GetApiV1ClientsByIdErrors];

export type GetApiV1ClientsByIdResponses = {
    /**
     * OK
     */
    200: ClientDetailDto;
};

export type GetApiV1ClientsByIdResponse = GetApiV1ClientsByIdResponses[keyof GetApiV1ClientsByIdResponses];

export type DeleteApiV1ClientsByIdAvatarData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/clients/{id}/avatar';
};

export type DeleteApiV1ClientsByIdAvatarErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1ClientsByIdAvatarError = DeleteApiV1ClientsByIdAvatarErrors[keyof DeleteApiV1ClientsByIdAvatarErrors];

export type DeleteApiV1ClientsByIdAvatarResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1ClientsByIdAvatarResponse = DeleteApiV1ClientsByIdAvatarResponses[keyof DeleteApiV1ClientsByIdAvatarResponses];

export type PutApiV1ClientsByIdCategoryData = {
    body: AssignClientCategoryPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/clients/{id}/category';
};

export type PutApiV1ClientsByIdCategoryErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1ClientsByIdCategoryError = PutApiV1ClientsByIdCategoryErrors[keyof PutApiV1ClientsByIdCategoryErrors];

export type PutApiV1ClientsByIdCategoryResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1ClientsByIdCategoryResponse = PutApiV1ClientsByIdCategoryResponses[keyof PutApiV1ClientsByIdCategoryResponses];

export type PostApiV1ClientsByIdForgetData = {
    body: ForgetClientBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/clients/{id}/forget';
};

export type PostApiV1ClientsByIdForgetErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsByIdForgetError = PostApiV1ClientsByIdForgetErrors[keyof PostApiV1ClientsByIdForgetErrors];

export type PostApiV1ClientsByIdForgetResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ClientsByIdForgetResponse = PostApiV1ClientsByIdForgetResponses[keyof PostApiV1ClientsByIdForgetResponses];

export type GetApiV1ClientsByIdGuestsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/clients/{id}/guests';
};

export type GetApiV1ClientsByIdGuestsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsByIdGuestsError = GetApiV1ClientsByIdGuestsErrors[keyof GetApiV1ClientsByIdGuestsErrors];

export type GetApiV1ClientsByIdGuestsResponses = {
    /**
     * OK
     */
    200: Array<GuestDto>;
};

export type GetApiV1ClientsByIdGuestsResponse = GetApiV1ClientsByIdGuestsResponses[keyof GetApiV1ClientsByIdGuestsResponses];

export type PatchApiV1ClientsByIdHighlightData = {
    body: UpdateClientHighlightPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/clients/{id}/highlight';
};

export type PatchApiV1ClientsByIdHighlightErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1ClientsByIdHighlightError = PatchApiV1ClientsByIdHighlightErrors[keyof PatchApiV1ClientsByIdHighlightErrors];

export type PatchApiV1ClientsByIdHighlightResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1ClientsByIdHighlightResponse = PatchApiV1ClientsByIdHighlightResponses[keyof PatchApiV1ClientsByIdHighlightResponses];

export type PostApiV1ClientsByIdLinkAccountData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/clients/{id}/link-account';
};

export type PostApiV1ClientsByIdLinkAccountErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsByIdLinkAccountError = PostApiV1ClientsByIdLinkAccountErrors[keyof PostApiV1ClientsByIdLinkAccountErrors];

export type PostApiV1ClientsByIdLinkAccountResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ClientsByIdLinkAccountResponse = PostApiV1ClientsByIdLinkAccountResponses[keyof PostApiV1ClientsByIdLinkAccountResponses];

export type PostApiV1ClientsByIdLoginCodeData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/clients/{id}/login-code';
};

export type PostApiV1ClientsByIdLoginCodeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsByIdLoginCodeError = PostApiV1ClientsByIdLoginCodeErrors[keyof PostApiV1ClientsByIdLoginCodeErrors];

export type PostApiV1ClientsByIdLoginCodeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ClientsByIdLoginCodeResponse = PostApiV1ClientsByIdLoginCodeResponses[keyof PostApiV1ClientsByIdLoginCodeResponses];

export type PatchApiV1ClientsByIdNoteData = {
    body: UpdateClientNotePayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/clients/{id}/note';
};

export type PatchApiV1ClientsByIdNoteErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1ClientsByIdNoteError = PatchApiV1ClientsByIdNoteErrors[keyof PatchApiV1ClientsByIdNoteErrors];

export type PatchApiV1ClientsByIdNoteResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1ClientsByIdNoteResponse = PatchApiV1ClientsByIdNoteResponses[keyof PatchApiV1ClientsByIdNoteResponses];

export type PutApiV1ClientsByIdParallelCourtsData = {
    body: SetClientParallelCourtsPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/clients/{id}/parallel-courts';
};

export type PutApiV1ClientsByIdParallelCourtsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1ClientsByIdParallelCourtsError = PutApiV1ClientsByIdParallelCourtsErrors[keyof PutApiV1ClientsByIdParallelCourtsErrors];

export type PutApiV1ClientsByIdParallelCourtsResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1ClientsByIdParallelCourtsResponse = PutApiV1ClientsByIdParallelCourtsResponses[keyof PutApiV1ClientsByIdParallelCourtsResponses];

export type GetApiV1ClientsByParentIdChildrenData = {
    body?: never;
    path: {
        parentId: string;
    };
    query?: never;
    url: '/api/v1/clients/{parentId}/children';
};

export type GetApiV1ClientsByParentIdChildrenErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClientsByParentIdChildrenError = GetApiV1ClientsByParentIdChildrenErrors[keyof GetApiV1ClientsByParentIdChildrenErrors];

export type GetApiV1ClientsByParentIdChildrenResponses = {
    /**
     * OK
     */
    200: Array<ChildDto>;
};

export type GetApiV1ClientsByParentIdChildrenResponse = GetApiV1ClientsByParentIdChildrenResponses[keyof GetApiV1ClientsByParentIdChildrenResponses];

export type PostApiV1ClientsByParentIdChildrenData = {
    body: LinkChildAtDeskRequest;
    path: {
        parentId: string;
    };
    query?: never;
    url: '/api/v1/clients/{parentId}/children';
};

export type PostApiV1ClientsByParentIdChildrenErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClientsByParentIdChildrenError = PostApiV1ClientsByParentIdChildrenErrors[keyof PostApiV1ClientsByParentIdChildrenErrors];

export type PostApiV1ClientsByParentIdChildrenResponses = {
    /**
     * OK
     */
    200: ChildDto;
};

export type PostApiV1ClientsByParentIdChildrenResponse = PostApiV1ClientsByParentIdChildrenResponses[keyof PostApiV1ClientsByParentIdChildrenResponses];

export type DeleteApiV1ClientsByParentIdChildrenByChildIdData = {
    body?: never;
    path: {
        parentId: string;
        childId: string;
    };
    query?: never;
    url: '/api/v1/clients/{parentId}/children/{childId}';
};

export type DeleteApiV1ClientsByParentIdChildrenByChildIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1ClientsByParentIdChildrenByChildIdError = DeleteApiV1ClientsByParentIdChildrenByChildIdErrors[keyof DeleteApiV1ClientsByParentIdChildrenByChildIdErrors];

export type DeleteApiV1ClientsByParentIdChildrenByChildIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1ClientsByParentIdChildrenByChildIdResponse = DeleteApiV1ClientsByParentIdChildrenByChildIdResponses[keyof DeleteApiV1ClientsByParentIdChildrenByChildIdResponses];

export type PutApiV1ClientsByParentIdChildrenByChildIdCategoriesData = {
    body: ChildCategoriesDto;
    path: {
        parentId: string;
        childId: string;
    };
    query?: never;
    url: '/api/v1/clients/{parentId}/children/{childId}/categories';
};

export type PutApiV1ClientsByParentIdChildrenByChildIdCategoriesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1ClientsByParentIdChildrenByChildIdCategoriesError = PutApiV1ClientsByParentIdChildrenByChildIdCategoriesErrors[keyof PutApiV1ClientsByParentIdChildrenByChildIdCategoriesErrors];

export type PutApiV1ClientsByParentIdChildrenByChildIdCategoriesResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1ClientsByParentIdChildrenByChildIdCategoriesResponse = PutApiV1ClientsByParentIdChildrenByChildIdCategoriesResponses[keyof PutApiV1ClientsByParentIdChildrenByChildIdCategoriesResponses];

export type GetApiV1ClubStaffData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/club/staff';
};

export type GetApiV1ClubStaffErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClubStaffError = GetApiV1ClubStaffErrors[keyof GetApiV1ClubStaffErrors];

export type GetApiV1ClubStaffResponses = {
    /**
     * OK
     */
    200: Array<ClubStaffMemberDto>;
};

export type GetApiV1ClubStaffResponse = GetApiV1ClubStaffResponses[keyof GetApiV1ClubStaffResponses];

export type PostApiV1ClubStaffData = {
    body: RegisterClubStaffBody;
    path?: never;
    query?: never;
    url: '/api/v1/club/staff';
};

export type PostApiV1ClubStaffErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClubStaffError = PostApiV1ClubStaffErrors[keyof PostApiV1ClubStaffErrors];

export type PostApiV1ClubStaffResponses = {
    /**
     * OK
     */
    200: ClubStaffMemberDto;
};

export type PostApiV1ClubStaffResponse = PostApiV1ClubStaffResponses[keyof PostApiV1ClubStaffResponses];

export type GetApiV1ClubStaffRolesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/club/staff/roles';
};

export type GetApiV1ClubStaffRolesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClubStaffRolesError = GetApiV1ClubStaffRolesErrors[keyof GetApiV1ClubStaffRolesErrors];

export type GetApiV1ClubStaffRolesResponses = {
    /**
     * OK
     */
    200: Array<AssignableClubRoleDto>;
};

export type GetApiV1ClubStaffRolesResponse = GetApiV1ClubStaffRolesResponses[keyof GetApiV1ClubStaffRolesResponses];

export type GetApiV1ClubStaffTrainerCardsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/club/staff/trainer-cards';
};

export type GetApiV1ClubStaffTrainerCardsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ClubStaffTrainerCardsError = GetApiV1ClubStaffTrainerCardsErrors[keyof GetApiV1ClubStaffTrainerCardsErrors];

export type GetApiV1ClubStaffTrainerCardsResponses = {
    /**
     * OK
     */
    200: Array<TrainerCardWithoutLogin>;
};

export type GetApiV1ClubStaffTrainerCardsResponse = GetApiV1ClubStaffTrainerCardsResponses[keyof GetApiV1ClubStaffTrainerCardsResponses];

export type PatchApiV1ClubStaffByUserIdContactsData = {
    body: ChangeClubStaffContactsBody;
    path: {
        userId: string;
    };
    query?: never;
    url: '/api/v1/club/staff/{userId}/contacts';
};

export type PatchApiV1ClubStaffByUserIdContactsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1ClubStaffByUserIdContactsError = PatchApiV1ClubStaffByUserIdContactsErrors[keyof PatchApiV1ClubStaffByUserIdContactsErrors];

export type PatchApiV1ClubStaffByUserIdContactsResponses = {
    /**
     * OK
     */
    200: ClubStaffContactsChanged;
};

export type PatchApiV1ClubStaffByUserIdContactsResponse = PatchApiV1ClubStaffByUserIdContactsResponses[keyof PatchApiV1ClubStaffByUserIdContactsResponses];

export type PostApiV1ClubStaffByUserIdDismissData = {
    body?: never;
    path: {
        userId: string;
    };
    query?: never;
    url: '/api/v1/club/staff/{userId}/dismiss';
};

export type PostApiV1ClubStaffByUserIdDismissErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ClubStaffByUserIdDismissError = PostApiV1ClubStaffByUserIdDismissErrors[keyof PostApiV1ClubStaffByUserIdDismissErrors];

export type PostApiV1ClubStaffByUserIdDismissResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ClubStaffByUserIdDismissResponse = PostApiV1ClubStaffByUserIdDismissResponses[keyof PostApiV1ClubStaffByUserIdDismissResponses];

export type PatchApiV1ClubStaffByUserIdRoleData = {
    body: ChangeClubStaffRoleBody;
    path: {
        userId: string;
    };
    query?: never;
    url: '/api/v1/club/staff/{userId}/role';
};

export type PatchApiV1ClubStaffByUserIdRoleErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1ClubStaffByUserIdRoleError = PatchApiV1ClubStaffByUserIdRoleErrors[keyof PatchApiV1ClubStaffByUserIdRoleErrors];

export type PatchApiV1ClubStaffByUserIdRoleResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1ClubStaffByUserIdRoleResponse = PatchApiV1ClubStaffByUserIdRoleResponses[keyof PatchApiV1ClubStaffByUserIdRoleResponses];

export type GetApiV1DashboardBalancesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/dashboard/balances';
};

export type GetApiV1DashboardBalancesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1DashboardBalancesError = GetApiV1DashboardBalancesErrors[keyof GetApiV1DashboardBalancesErrors];

export type GetApiV1DashboardBalancesResponses = {
    /**
     * OK
     */
    200: DashboardBalancesResponse;
};

export type GetApiV1DashboardBalancesResponse = GetApiV1DashboardBalancesResponses[keyof GetApiV1DashboardBalancesResponses];

export type GetApiV1DashboardClientData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/dashboard/client';
};

export type GetApiV1DashboardClientErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1DashboardClientError = GetApiV1DashboardClientErrors[keyof GetApiV1DashboardClientErrors];

export type GetApiV1DashboardClientResponses = {
    /**
     * OK
     */
    200: ClientDashboardResponse;
};

export type GetApiV1DashboardClientResponse = GetApiV1DashboardClientResponses[keyof GetApiV1DashboardClientResponses];

export type GetApiV1DashboardOccupancyHeatmapData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/dashboard/occupancy-heatmap';
};

export type GetApiV1DashboardOccupancyHeatmapErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1DashboardOccupancyHeatmapError = GetApiV1DashboardOccupancyHeatmapErrors[keyof GetApiV1DashboardOccupancyHeatmapErrors];

export type GetApiV1DashboardOccupancyHeatmapResponses = {
    /**
     * OK
     */
    200: OccupancyHeatmapResponse;
};

export type GetApiV1DashboardOccupancyHeatmapResponse = GetApiV1DashboardOccupancyHeatmapResponses[keyof GetApiV1DashboardOccupancyHeatmapResponses];

export type GetApiV1DashboardSummaryData = {
    body?: never;
    path?: never;
    query?: {
        range?: string;
        from?: string;
        to?: string;
    };
    url: '/api/v1/dashboard/summary';
};

export type GetApiV1DashboardSummaryErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1DashboardSummaryError = GetApiV1DashboardSummaryErrors[keyof GetApiV1DashboardSummaryErrors];

export type GetApiV1DashboardSummaryResponses = {
    /**
     * OK
     */
    200: DashboardSummaryResponse;
};

export type GetApiV1DashboardSummaryResponse = GetApiV1DashboardSummaryResponses[keyof GetApiV1DashboardSummaryResponses];

export type GetApiV1DashboardTasksData = {
    body?: never;
    path?: never;
    query?: {
        box?: string;
        includeCompleted?: boolean;
    };
    url: '/api/v1/dashboard/tasks';
};

export type GetApiV1DashboardTasksErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1DashboardTasksError = GetApiV1DashboardTasksErrors[keyof GetApiV1DashboardTasksErrors];

export type GetApiV1DashboardTasksResponses = {
    /**
     * OK
     */
    200: DashboardTasksResponse;
};

export type GetApiV1DashboardTasksResponse = GetApiV1DashboardTasksResponses[keyof GetApiV1DashboardTasksResponses];

export type PostApiV1DashboardTasksData = {
    body: CreateTaskPayload;
    path?: never;
    query?: never;
    url: '/api/v1/dashboard/tasks';
};

export type PostApiV1DashboardTasksErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1DashboardTasksError = PostApiV1DashboardTasksErrors[keyof PostApiV1DashboardTasksErrors];

export type PostApiV1DashboardTasksResponses = {
    /**
     * OK
     */
    200: DashboardTaskDto;
};

export type PostApiV1DashboardTasksResponse = PostApiV1DashboardTasksResponses[keyof PostApiV1DashboardTasksResponses];

export type GetApiV1DashboardTasksAssigneesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/dashboard/tasks/assignees';
};

export type GetApiV1DashboardTasksAssigneesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1DashboardTasksAssigneesError = GetApiV1DashboardTasksAssigneesErrors[keyof GetApiV1DashboardTasksAssigneesErrors];

export type GetApiV1DashboardTasksAssigneesResponses = {
    /**
     * OK
     */
    200: TaskAssigneesResponse;
};

export type GetApiV1DashboardTasksAssigneesResponse = GetApiV1DashboardTasksAssigneesResponses[keyof GetApiV1DashboardTasksAssigneesResponses];

export type PutApiV1DashboardTasksByIdCompleteData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/dashboard/tasks/{id}/complete';
};

export type PutApiV1DashboardTasksByIdCompleteErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1DashboardTasksByIdCompleteError = PutApiV1DashboardTasksByIdCompleteErrors[keyof PutApiV1DashboardTasksByIdCompleteErrors];

export type PutApiV1DashboardTasksByIdCompleteResponses = {
    /**
     * OK
     */
    200: DashboardTaskDto;
};

export type PutApiV1DashboardTasksByIdCompleteResponse = PutApiV1DashboardTasksByIdCompleteResponses[keyof PutApiV1DashboardTasksByIdCompleteResponses];

export type PutApiV1DashboardTasksByIdReadData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/dashboard/tasks/{id}/read';
};

export type PutApiV1DashboardTasksByIdReadErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1DashboardTasksByIdReadError = PutApiV1DashboardTasksByIdReadErrors[keyof PutApiV1DashboardTasksByIdReadErrors];

export type PutApiV1DashboardTasksByIdReadResponses = {
    /**
     * OK
     */
    200: boolean;
};

export type PutApiV1DashboardTasksByIdReadResponse = PutApiV1DashboardTasksByIdReadResponses[keyof PutApiV1DashboardTasksByIdReadResponses];

export type PutApiV1DashboardTasksByIdStartData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/dashboard/tasks/{id}/start';
};

export type PutApiV1DashboardTasksByIdStartErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1DashboardTasksByIdStartError = PutApiV1DashboardTasksByIdStartErrors[keyof PutApiV1DashboardTasksByIdStartErrors];

export type PutApiV1DashboardTasksByIdStartResponses = {
    /**
     * OK
     */
    200: DashboardTaskDto;
};

export type PutApiV1DashboardTasksByIdStartResponse = PutApiV1DashboardTasksByIdStartResponses[keyof PutApiV1DashboardTasksByIdStartResponses];

export type PostApiV1DepositTopupData = {
    body: TopupDepositBody;
    path?: never;
    query?: never;
    url: '/api/v1/deposit/topup';
};

export type PostApiV1DepositTopupErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1DepositTopupError = PostApiV1DepositTopupErrors[keyof PostApiV1DepositTopupErrors];

export type PostApiV1DepositTopupResponses = {
    /**
     * Created
     */
    201: TopupDepositResponse;
};

export type PostApiV1DepositTopupResponse = PostApiV1DepositTopupResponses[keyof PostApiV1DepositTopupResponses];

export type GetApiV1DepositTransactionsData = {
    body?: never;
    path?: never;
    query?: {
        Type?: DepositTransactionType;
        Limit?: number;
        Cursor?: string;
    };
    url: '/api/v1/deposit/transactions';
};

export type GetApiV1DepositTransactionsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1DepositTransactionsError = GetApiV1DepositTransactionsErrors[keyof GetApiV1DepositTransactionsErrors];

export type GetApiV1DepositTransactionsResponses = {
    /**
     * OK
     */
    200: PagedListOfDepositTransactionDto;
};

export type GetApiV1DepositTransactionsResponse = GetApiV1DepositTransactionsResponses[keyof GetApiV1DepositTransactionsResponses];

export type GetApiV1DevicesMeData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/devices/me';
};

export type GetApiV1DevicesMeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1DevicesMeError = GetApiV1DevicesMeErrors[keyof GetApiV1DevicesMeErrors];

export type GetApiV1DevicesMeResponses = {
    /**
     * OK
     */
    200: ListMyDevicesResponse;
};

export type GetApiV1DevicesMeResponse = GetApiV1DevicesMeResponses[keyof GetApiV1DevicesMeResponses];

export type PostApiV1DevicesRegisterData = {
    body: RegisterDevicePayload;
    path?: never;
    query?: never;
    url: '/api/v1/devices/register';
};

export type PostApiV1DevicesRegisterErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1DevicesRegisterError = PostApiV1DevicesRegisterErrors[keyof PostApiV1DevicesRegisterErrors];

export type PostApiV1DevicesRegisterResponses = {
    /**
     * OK
     */
    200: RegisterDeviceResponse;
};

export type PostApiV1DevicesRegisterResponse = PostApiV1DevicesRegisterResponses[keyof PostApiV1DevicesRegisterResponses];

export type DeleteApiV1DevicesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/devices/{id}';
};

export type DeleteApiV1DevicesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1DevicesByIdError = DeleteApiV1DevicesByIdErrors[keyof DeleteApiV1DevicesByIdErrors];

export type DeleteApiV1DevicesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1DevicesByIdResponse = DeleteApiV1DevicesByIdResponses[keyof DeleteApiV1DevicesByIdResponses];

export type GetApiV1FinanceCashFlowData = {
    body?: never;
    path?: never;
    query: {
        from: string;
        to: string;
    };
    url: '/api/v1/finance/cash-flow';
};

export type GetApiV1FinanceCashFlowErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1FinanceCashFlowError = GetApiV1FinanceCashFlowErrors[keyof GetApiV1FinanceCashFlowErrors];

export type GetApiV1FinanceCashFlowResponses = {
    /**
     * OK
     */
    200: CashFlowResponse;
};

export type GetApiV1FinanceCashFlowResponse = GetApiV1FinanceCashFlowResponses[keyof GetApiV1FinanceCashFlowResponses];

export type GetApiV1FinanceExpensesData = {
    body?: never;
    path?: never;
    query?: {
        From?: string;
        To?: string;
        Category?: ExpenseCategory;
        Status?: ExpenseStatus;
        Page?: number;
        PageSize?: number;
    };
    url: '/api/v1/finance/expenses';
};

export type GetApiV1FinanceExpensesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1FinanceExpensesError = GetApiV1FinanceExpensesErrors[keyof GetApiV1FinanceExpensesErrors];

export type GetApiV1FinanceExpensesResponses = {
    /**
     * OK
     */
    200: ListExpensesResponse;
};

export type GetApiV1FinanceExpensesResponse = GetApiV1FinanceExpensesResponses[keyof GetApiV1FinanceExpensesResponses];

export type PostApiV1FinanceExpensesData = {
    body: CreateExpenseBody;
    path?: never;
    query?: never;
    url: '/api/v1/finance/expenses';
};

export type PostApiV1FinanceExpensesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1FinanceExpensesError = PostApiV1FinanceExpensesErrors[keyof PostApiV1FinanceExpensesErrors];

export type PostApiV1FinanceExpensesResponses = {
    /**
     * Created
     */
    201: CreateExpenseResponse;
};

export type PostApiV1FinanceExpensesResponse = PostApiV1FinanceExpensesResponses[keyof PostApiV1FinanceExpensesResponses];

export type DeleteApiV1FinanceExpensesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/expenses/{id}';
};

export type DeleteApiV1FinanceExpensesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1FinanceExpensesByIdError = DeleteApiV1FinanceExpensesByIdErrors[keyof DeleteApiV1FinanceExpensesByIdErrors];

export type DeleteApiV1FinanceExpensesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1FinanceExpensesByIdResponse = DeleteApiV1FinanceExpensesByIdResponses[keyof DeleteApiV1FinanceExpensesByIdResponses];

export type PostApiV1FinanceExpensesByIdApproveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/expenses/{id}/approve';
};

export type PostApiV1FinanceExpensesByIdApproveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1FinanceExpensesByIdApproveError = PostApiV1FinanceExpensesByIdApproveErrors[keyof PostApiV1FinanceExpensesByIdApproveErrors];

export type PostApiV1FinanceExpensesByIdApproveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1FinanceExpensesByIdApproveResponse = PostApiV1FinanceExpensesByIdApproveResponses[keyof PostApiV1FinanceExpensesByIdApproveResponses];

export type PostApiV1FinanceExpensesByIdPayData = {
    body: PayExpenseBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/expenses/{id}/pay';
};

export type PostApiV1FinanceExpensesByIdPayErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1FinanceExpensesByIdPayError = PostApiV1FinanceExpensesByIdPayErrors[keyof PostApiV1FinanceExpensesByIdPayErrors];

export type PostApiV1FinanceExpensesByIdPayResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1FinanceExpensesByIdPayResponse = PostApiV1FinanceExpensesByIdPayResponses[keyof PostApiV1FinanceExpensesByIdPayResponses];

export type PostApiV1FinanceExpensesByIdRejectData = {
    body: RejectExpenseBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/expenses/{id}/reject';
};

export type PostApiV1FinanceExpensesByIdRejectErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1FinanceExpensesByIdRejectError = PostApiV1FinanceExpensesByIdRejectErrors[keyof PostApiV1FinanceExpensesByIdRejectErrors];

export type PostApiV1FinanceExpensesByIdRejectResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1FinanceExpensesByIdRejectResponse = PostApiV1FinanceExpensesByIdRejectResponses[keyof PostApiV1FinanceExpensesByIdRejectResponses];

export type GetApiV1FinancePayoutsData = {
    body?: never;
    path?: never;
    query?: {
        from?: string;
        to?: string;
        status?: string;
    };
    url: '/api/v1/finance/payouts';
};

export type GetApiV1FinancePayoutsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1FinancePayoutsError = GetApiV1FinancePayoutsErrors[keyof GetApiV1FinancePayoutsErrors];

export type GetApiV1FinancePayoutsResponses = {
    /**
     * OK
     */
    200: PayoutsResponse;
};

export type GetApiV1FinancePayoutsResponse = GetApiV1FinancePayoutsResponses[keyof GetApiV1FinancePayoutsResponses];

export type GetApiV1FinancePnlData = {
    body?: never;
    path?: never;
    query: {
        from: string;
        to: string;
    };
    url: '/api/v1/finance/pnl';
};

export type GetApiV1FinancePnlErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1FinancePnlError = GetApiV1FinancePnlErrors[keyof GetApiV1FinancePnlErrors];

export type GetApiV1FinancePnlResponses = {
    /**
     * OK
     */
    200: PnlResponse;
};

export type GetApiV1FinancePnlResponse = GetApiV1FinancePnlResponses[keyof GetApiV1FinancePnlResponses];

export type GetApiV1FitnessClassesData = {
    body?: never;
    path?: never;
    query?: {
        includeInactive?: boolean;
    };
    url: '/api/v1/fitness-classes';
};

export type GetApiV1FitnessClassesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1FitnessClassesError = GetApiV1FitnessClassesErrors[keyof GetApiV1FitnessClassesErrors];

export type GetApiV1FitnessClassesResponses = {
    /**
     * OK
     */
    200: Array<FitnessClassDto>;
};

export type GetApiV1FitnessClassesResponse = GetApiV1FitnessClassesResponses[keyof GetApiV1FitnessClassesResponses];

export type PostApiV1FitnessClassesData = {
    body: CreateFitnessClassCommand;
    path?: never;
    query?: never;
    url: '/api/v1/fitness-classes';
};

export type PostApiV1FitnessClassesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1FitnessClassesError = PostApiV1FitnessClassesErrors[keyof PostApiV1FitnessClassesErrors];

export type PostApiV1FitnessClassesResponses = {
    /**
     * OK
     */
    200: FitnessClassDto;
};

export type PostApiV1FitnessClassesResponse = PostApiV1FitnessClassesResponses[keyof PostApiV1FitnessClassesResponses];

export type DeleteApiV1FitnessClassesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/fitness-classes/{id}';
};

export type DeleteApiV1FitnessClassesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1FitnessClassesByIdError = DeleteApiV1FitnessClassesByIdErrors[keyof DeleteApiV1FitnessClassesByIdErrors];

export type DeleteApiV1FitnessClassesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1FitnessClassesByIdResponse = DeleteApiV1FitnessClassesByIdResponses[keyof DeleteApiV1FitnessClassesByIdResponses];

export type PatchApiV1FitnessClassesByIdData = {
    body: FitnessClassPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/fitness-classes/{id}';
};

export type PatchApiV1FitnessClassesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1FitnessClassesByIdError = PatchApiV1FitnessClassesByIdErrors[keyof PatchApiV1FitnessClassesByIdErrors];

export type PatchApiV1FitnessClassesByIdResponses = {
    /**
     * OK
     */
    200: FitnessClassDto;
};

export type PatchApiV1FitnessClassesByIdResponse = PatchApiV1FitnessClassesByIdResponses[keyof PatchApiV1FitnessClassesByIdResponses];

export type GetApiV1FriendsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/friends';
};

export type GetApiV1FriendsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1FriendsError = GetApiV1FriendsErrors[keyof GetApiV1FriendsErrors];

export type GetApiV1FriendsResponses = {
    /**
     * OK
     */
    200: FriendsListResponse;
};

export type GetApiV1FriendsResponse = GetApiV1FriendsResponses[keyof GetApiV1FriendsResponses];

export type GetApiV1FriendsBlocksData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/friends/blocks';
};

export type GetApiV1FriendsBlocksErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1FriendsBlocksError = GetApiV1FriendsBlocksErrors[keyof GetApiV1FriendsBlocksErrors];

export type GetApiV1FriendsBlocksResponses = {
    /**
     * OK
     */
    200: BlocksResponse;
};

export type GetApiV1FriendsBlocksResponse = GetApiV1FriendsBlocksResponses[keyof GetApiV1FriendsBlocksResponses];

export type PostApiV1FriendsBlocksData = {
    body: BlockBody;
    path?: never;
    query?: never;
    url: '/api/v1/friends/blocks';
};

export type PostApiV1FriendsBlocksErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1FriendsBlocksError = PostApiV1FriendsBlocksErrors[keyof PostApiV1FriendsBlocksErrors];

export type PostApiV1FriendsBlocksResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1FriendsBlocksResponse = PostApiV1FriendsBlocksResponses[keyof PostApiV1FriendsBlocksResponses];

export type DeleteApiV1FriendsBlocksByClientIdData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/friends/blocks/{clientId}';
};

export type DeleteApiV1FriendsBlocksByClientIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1FriendsBlocksByClientIdError = DeleteApiV1FriendsBlocksByClientIdErrors[keyof DeleteApiV1FriendsBlocksByClientIdErrors];

export type DeleteApiV1FriendsBlocksByClientIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1FriendsBlocksByClientIdResponse = DeleteApiV1FriendsBlocksByClientIdResponses[keyof DeleteApiV1FriendsBlocksByClientIdResponses];

export type PostApiV1FriendsInvitesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/friends/invites';
};

export type PostApiV1FriendsInvitesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1FriendsInvitesError = PostApiV1FriendsInvitesErrors[keyof PostApiV1FriendsInvitesErrors];

export type PostApiV1FriendsInvitesResponses = {
    /**
     * OK
     */
    200: CreateInviteResponse;
};

export type PostApiV1FriendsInvitesResponse = PostApiV1FriendsInvitesResponses[keyof PostApiV1FriendsInvitesResponses];

export type DeleteApiV1FriendsInvitesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/friends/invites/{id}';
};

export type DeleteApiV1FriendsInvitesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1FriendsInvitesByIdError = DeleteApiV1FriendsInvitesByIdErrors[keyof DeleteApiV1FriendsInvitesByIdErrors];

export type DeleteApiV1FriendsInvitesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1FriendsInvitesByIdResponse = DeleteApiV1FriendsInvitesByIdResponses[keyof DeleteApiV1FriendsInvitesByIdResponses];

export type PostApiV1FriendsInvitesByTokenClaimData = {
    body?: never;
    path: {
        token: string;
    };
    query?: never;
    url: '/api/v1/friends/invites/{token}/claim';
};

export type PostApiV1FriendsInvitesByTokenClaimErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1FriendsInvitesByTokenClaimError = PostApiV1FriendsInvitesByTokenClaimErrors[keyof PostApiV1FriendsInvitesByTokenClaimErrors];

export type PostApiV1FriendsInvitesByTokenClaimResponses = {
    /**
     * OK
     */
    200: ClaimInviteResponse;
};

export type PostApiV1FriendsInvitesByTokenClaimResponse = PostApiV1FriendsInvitesByTokenClaimResponses[keyof PostApiV1FriendsInvitesByTokenClaimResponses];

export type GetApiV1FriendsMeChildrenSettingsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/friends/me/children/settings';
};

export type GetApiV1FriendsMeChildrenSettingsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1FriendsMeChildrenSettingsError = GetApiV1FriendsMeChildrenSettingsErrors[keyof GetApiV1FriendsMeChildrenSettingsErrors];

export type GetApiV1FriendsMeChildrenSettingsResponses = {
    /**
     * OK
     */
    200: ChildrenSocialResponse;
};

export type GetApiV1FriendsMeChildrenSettingsResponse = GetApiV1FriendsMeChildrenSettingsResponses[keyof GetApiV1FriendsMeChildrenSettingsResponses];

export type PutApiV1FriendsMeChildrenByClientIdSettingsData = {
    body: ChildSocialBody;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/friends/me/children/{clientId}/settings';
};

export type PutApiV1FriendsMeChildrenByClientIdSettingsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1FriendsMeChildrenByClientIdSettingsError = PutApiV1FriendsMeChildrenByClientIdSettingsErrors[keyof PutApiV1FriendsMeChildrenByClientIdSettingsErrors];

export type PutApiV1FriendsMeChildrenByClientIdSettingsResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1FriendsMeChildrenByClientIdSettingsResponse = PutApiV1FriendsMeChildrenByClientIdSettingsResponses[keyof PutApiV1FriendsMeChildrenByClientIdSettingsResponses];

export type GetApiV1FriendsMeSettingsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/friends/me/settings';
};

export type GetApiV1FriendsMeSettingsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1FriendsMeSettingsError = GetApiV1FriendsMeSettingsErrors[keyof GetApiV1FriendsMeSettingsErrors];

export type GetApiV1FriendsMeSettingsResponses = {
    /**
     * OK
     */
    200: FriendSettingsResponse;
};

export type GetApiV1FriendsMeSettingsResponse = GetApiV1FriendsMeSettingsResponses[keyof GetApiV1FriendsMeSettingsResponses];

export type PutApiV1FriendsMeSettingsData = {
    body: UpdateSettingsBody;
    path?: never;
    query?: never;
    url: '/api/v1/friends/me/settings';
};

export type PutApiV1FriendsMeSettingsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1FriendsMeSettingsError = PutApiV1FriendsMeSettingsErrors[keyof PutApiV1FriendsMeSettingsErrors];

export type PutApiV1FriendsMeSettingsResponses = {
    /**
     * OK
     */
    200: FriendSettingsResponse;
};

export type PutApiV1FriendsMeSettingsResponse = PutApiV1FriendsMeSettingsResponses[keyof PutApiV1FriendsMeSettingsResponses];

export type PostApiV1FriendsMeSettingsRegenerateCodeData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/friends/me/settings/regenerate-code';
};

export type PostApiV1FriendsMeSettingsRegenerateCodeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1FriendsMeSettingsRegenerateCodeError = PostApiV1FriendsMeSettingsRegenerateCodeErrors[keyof PostApiV1FriendsMeSettingsRegenerateCodeErrors];

export type PostApiV1FriendsMeSettingsRegenerateCodeResponses = {
    /**
     * OK
     */
    200: RegenerateCodeResponse;
};

export type PostApiV1FriendsMeSettingsRegenerateCodeResponse = PostApiV1FriendsMeSettingsRegenerateCodeResponses[keyof PostApiV1FriendsMeSettingsRegenerateCodeResponses];

export type GetApiV1FriendsPreviewData = {
    body?: never;
    path?: never;
    query: {
        code: string;
    };
    url: '/api/v1/friends/preview';
};

export type GetApiV1FriendsPreviewErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1FriendsPreviewError = GetApiV1FriendsPreviewErrors[keyof GetApiV1FriendsPreviewErrors];

export type GetApiV1FriendsPreviewResponses = {
    /**
     * OK
     */
    200: PreviewResponse;
};

export type GetApiV1FriendsPreviewResponse = GetApiV1FriendsPreviewResponses[keyof GetApiV1FriendsPreviewResponses];

export type GetApiV1FriendsReportsData = {
    body?: never;
    path?: never;
    query?: {
        includeResolved?: boolean;
    };
    url: '/api/v1/friends/reports';
};

export type GetApiV1FriendsReportsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1FriendsReportsError = GetApiV1FriendsReportsErrors[keyof GetApiV1FriendsReportsErrors];

export type GetApiV1FriendsReportsResponses = {
    /**
     * OK
     */
    200: Array<FriendReportListItemDto>;
};

export type GetApiV1FriendsReportsResponse = GetApiV1FriendsReportsResponses[keyof GetApiV1FriendsReportsResponses];

export type GetApiV1FriendsReportsByIdContextData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/friends/reports/{id}/context';
};

export type GetApiV1FriendsReportsByIdContextErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1FriendsReportsByIdContextError = GetApiV1FriendsReportsByIdContextErrors[keyof GetApiV1FriendsReportsByIdContextErrors];

export type GetApiV1FriendsReportsByIdContextResponses = {
    /**
     * OK
     */
    200: Array<FriendReportContextLineDto>;
};

export type GetApiV1FriendsReportsByIdContextResponse = GetApiV1FriendsReportsByIdContextResponses[keyof GetApiV1FriendsReportsByIdContextResponses];

export type PostApiV1FriendsReportsByIdResolveData = {
    body: ResolveReportBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/friends/reports/{id}/resolve';
};

export type PostApiV1FriendsReportsByIdResolveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1FriendsReportsByIdResolveError = PostApiV1FriendsReportsByIdResolveErrors[keyof PostApiV1FriendsReportsByIdResolveErrors];

export type PostApiV1FriendsReportsByIdResolveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1FriendsReportsByIdResolveResponse = PostApiV1FriendsReportsByIdResolveResponses[keyof PostApiV1FriendsReportsByIdResolveResponses];

export type GetApiV1FriendsRequestsData = {
    body?: never;
    path?: never;
    query?: {
        direction?: string;
    };
    url: '/api/v1/friends/requests';
};

export type GetApiV1FriendsRequestsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1FriendsRequestsError = GetApiV1FriendsRequestsErrors[keyof GetApiV1FriendsRequestsErrors];

export type GetApiV1FriendsRequestsResponses = {
    /**
     * OK
     */
    200: FriendRequestsResponse;
};

export type GetApiV1FriendsRequestsResponse = GetApiV1FriendsRequestsResponses[keyof GetApiV1FriendsRequestsResponses];

export type PostApiV1FriendsRequestsData = {
    body: CreateRequestBody;
    path?: never;
    query?: never;
    url: '/api/v1/friends/requests';
};

export type PostApiV1FriendsRequestsResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type DeleteApiV1FriendsRequestsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/friends/requests/{id}';
};

export type DeleteApiV1FriendsRequestsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1FriendsRequestsByIdError = DeleteApiV1FriendsRequestsByIdErrors[keyof DeleteApiV1FriendsRequestsByIdErrors];

export type DeleteApiV1FriendsRequestsByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1FriendsRequestsByIdResponse = DeleteApiV1FriendsRequestsByIdResponses[keyof DeleteApiV1FriendsRequestsByIdResponses];

export type PostApiV1FriendsRequestsByIdAcceptData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/friends/requests/{id}/accept';
};

export type PostApiV1FriendsRequestsByIdAcceptErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1FriendsRequestsByIdAcceptError = PostApiV1FriendsRequestsByIdAcceptErrors[keyof PostApiV1FriendsRequestsByIdAcceptErrors];

export type PostApiV1FriendsRequestsByIdAcceptResponses = {
    /**
     * OK
     */
    200: AcceptRequestResponse;
};

export type PostApiV1FriendsRequestsByIdAcceptResponse = PostApiV1FriendsRequestsByIdAcceptResponses[keyof PostApiV1FriendsRequestsByIdAcceptResponses];

export type PostApiV1FriendsRequestsByIdDeclineData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/friends/requests/{id}/decline';
};

export type PostApiV1FriendsRequestsByIdDeclineErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1FriendsRequestsByIdDeclineError = PostApiV1FriendsRequestsByIdDeclineErrors[keyof PostApiV1FriendsRequestsByIdDeclineErrors];

export type PostApiV1FriendsRequestsByIdDeclineResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1FriendsRequestsByIdDeclineResponse = PostApiV1FriendsRequestsByIdDeclineResponses[keyof PostApiV1FriendsRequestsByIdDeclineResponses];

export type DeleteApiV1FriendsByClientIdData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/friends/{clientId}';
};

export type DeleteApiV1FriendsByClientIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1FriendsByClientIdError = DeleteApiV1FriendsByClientIdErrors[keyof DeleteApiV1FriendsByClientIdErrors];

export type DeleteApiV1FriendsByClientIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1FriendsByClientIdResponse = DeleteApiV1FriendsByClientIdResponses[keyof DeleteApiV1FriendsByClientIdResponses];

export type GetApiV1FriendsByClientIdProfileData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/friends/{clientId}/profile';
};

export type GetApiV1FriendsByClientIdProfileErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1FriendsByClientIdProfileError = GetApiV1FriendsByClientIdProfileErrors[keyof GetApiV1FriendsByClientIdProfileErrors];

export type GetApiV1FriendsByClientIdProfileResponses = {
    /**
     * OK
     */
    200: FriendProfileResponse;
};

export type GetApiV1FriendsByClientIdProfileResponse = GetApiV1FriendsByClientIdProfileResponses[keyof GetApiV1FriendsByClientIdProfileResponses];

export type PostApiV1FriendsByClientIdReportData = {
    body: ReportBody;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/friends/{clientId}/report';
};

export type PostApiV1FriendsByClientIdReportResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1GameInvitesData = {
    body: CreateGameInvitesBody;
    path?: never;
    query?: never;
    url: '/api/v1/game-invites';
};

export type PostApiV1GameInvitesResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetApiV1GameInvitesClubData = {
    body?: never;
    path?: never;
    query: {
        subjectKind?: GameInviteSubjectKind;
        subjectId: string;
    };
    url: '/api/v1/game-invites/club';
};

export type GetApiV1GameInvitesClubErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1GameInvitesClubError = GetApiV1GameInvitesClubErrors[keyof GetApiV1GameInvitesClubErrors];

export type GetApiV1GameInvitesClubResponses = {
    /**
     * OK
     */
    200: ClubGameInviteListResponse;
};

export type GetApiV1GameInvitesClubResponse = GetApiV1GameInvitesClubResponses[keyof GetApiV1GameInvitesClubResponses];

export type PostApiV1GameInvitesClubData = {
    body: CreateGameInvitesBody;
    path?: never;
    query?: never;
    url: '/api/v1/game-invites/club';
};

export type PostApiV1GameInvitesClubErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GameInvitesClubError = PostApiV1GameInvitesClubErrors[keyof PostApiV1GameInvitesClubErrors];

export type PostApiV1GameInvitesClubResponses = {
    /**
     * OK
     */
    200: ClubGameInvitesResponse;
};

export type PostApiV1GameInvitesClubResponse = PostApiV1GameInvitesClubResponses[keyof PostApiV1GameInvitesClubResponses];

export type DeleteApiV1GameInvitesClubByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/game-invites/club/{id}';
};

export type DeleteApiV1GameInvitesClubByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1GameInvitesClubByIdError = DeleteApiV1GameInvitesClubByIdErrors[keyof DeleteApiV1GameInvitesClubByIdErrors];

export type DeleteApiV1GameInvitesClubByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1GameInvitesClubByIdResponse = DeleteApiV1GameInvitesClubByIdResponses[keyof DeleteApiV1GameInvitesClubByIdResponses];

export type GetApiV1GameInvitesMeData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/game-invites/me';
};

export type GetApiV1GameInvitesMeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1GameInvitesMeError = GetApiV1GameInvitesMeErrors[keyof GetApiV1GameInvitesMeErrors];

export type GetApiV1GameInvitesMeResponses = {
    /**
     * OK
     */
    200: GameInvitesResponse;
};

export type GetApiV1GameInvitesMeResponse = GetApiV1GameInvitesMeResponses[keyof GetApiV1GameInvitesMeResponses];

export type PostApiV1GameInvitesRemindData = {
    body: RemindGameInvitesBody;
    path?: never;
    query?: never;
    url: '/api/v1/game-invites/remind';
};

export type PostApiV1GameInvitesRemindResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type DeleteApiV1GameInvitesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/game-invites/{id}';
};

export type DeleteApiV1GameInvitesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1GameInvitesByIdError = DeleteApiV1GameInvitesByIdErrors[keyof DeleteApiV1GameInvitesByIdErrors];

export type DeleteApiV1GameInvitesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1GameInvitesByIdResponse = DeleteApiV1GameInvitesByIdResponses[keyof DeleteApiV1GameInvitesByIdResponses];

export type GetApiV1GameInvitesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/game-invites/{id}';
};

export type GetApiV1GameInvitesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1GameInvitesByIdError = GetApiV1GameInvitesByIdErrors[keyof GetApiV1GameInvitesByIdErrors];

export type GetApiV1GameInvitesByIdResponses = {
    /**
     * OK
     */
    200: GameInviteDto;
};

export type GetApiV1GameInvitesByIdResponse = GetApiV1GameInvitesByIdResponses[keyof GetApiV1GameInvitesByIdResponses];

export type PostApiV1GameInvitesByIdDeclineData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/game-invites/{id}/decline';
};

export type PostApiV1GameInvitesByIdDeclineErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GameInvitesByIdDeclineError = PostApiV1GameInvitesByIdDeclineErrors[keyof PostApiV1GameInvitesByIdDeclineErrors];

export type PostApiV1GameInvitesByIdDeclineResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1GameInvitesByIdDeclineResponse = PostApiV1GameInvitesByIdDeclineResponses[keyof PostApiV1GameInvitesByIdDeclineResponses];

export type GetApiV1GroupSessionsData = {
    body?: never;
    path?: never;
    query?: {
        Date?: string;
        SportType?: string;
        TrainerId?: string;
        Status?: SessionStatus;
        Direction?: ActivityDirection;
        From?: string;
        To?: string;
        Limit?: number;
    };
    url: '/api/v1/group-sessions';
};

export type GetApiV1GroupSessionsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1GroupSessionsError = GetApiV1GroupSessionsErrors[keyof GetApiV1GroupSessionsErrors];

export type GetApiV1GroupSessionsResponses = {
    /**
     * OK
     */
    200: Array<GroupSessionDto>;
};

export type GetApiV1GroupSessionsResponse = GetApiV1GroupSessionsResponses[keyof GetApiV1GroupSessionsResponses];

export type PostApiV1GroupSessionsPersonalData = {
    body: BookPersonalTrainingBody;
    path?: never;
    query?: never;
    url: '/api/v1/group-sessions/personal';
};

export type PostApiV1GroupSessionsPersonalErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GroupSessionsPersonalError = PostApiV1GroupSessionsPersonalErrors[keyof PostApiV1GroupSessionsPersonalErrors];

export type PostApiV1GroupSessionsPersonalResponses = {
    /**
     * Created
     */
    201: PersonalTrainingBookedResponse;
};

export type PostApiV1GroupSessionsPersonalResponse = PostApiV1GroupSessionsPersonalResponses[keyof PostApiV1GroupSessionsPersonalResponses];

export type GetApiV1GroupSessionsPersonalQuoteData = {
    body?: never;
    path?: never;
    query: {
        trainerId: string;
        placeId: string;
        date: string;
        startTime: string;
        durationMinutes: number;
    };
    url: '/api/v1/group-sessions/personal/quote';
};

export type GetApiV1GroupSessionsPersonalQuoteErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1GroupSessionsPersonalQuoteError = GetApiV1GroupSessionsPersonalQuoteErrors[keyof GetApiV1GroupSessionsPersonalQuoteErrors];

export type GetApiV1GroupSessionsPersonalQuoteResponses = {
    /**
     * OK
     */
    200: PersonalTrainingQuoteResponse;
};

export type GetApiV1GroupSessionsPersonalQuoteResponse = GetApiV1GroupSessionsPersonalQuoteResponses[keyof GetApiV1GroupSessionsPersonalQuoteResponses];

export type GetApiV1GroupSessionsPersonalSlotsData = {
    body?: never;
    path?: never;
    query: {
        trainerId: string;
        date: string;
        durationMinutes: number;
        placeId?: string;
    };
    url: '/api/v1/group-sessions/personal/slots';
};

export type GetApiV1GroupSessionsPersonalSlotsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1GroupSessionsPersonalSlotsError = GetApiV1GroupSessionsPersonalSlotsErrors[keyof GetApiV1GroupSessionsPersonalSlotsErrors];

export type GetApiV1GroupSessionsPersonalSlotsResponses = {
    /**
     * OK
     */
    200: PersonalTrainingSlotsResponse;
};

export type GetApiV1GroupSessionsPersonalSlotsResponse = GetApiV1GroupSessionsPersonalSlotsResponses[keyof GetApiV1GroupSessionsPersonalSlotsResponses];

export type GetApiV1GroupSessionsPlanningData = {
    body?: never;
    path?: never;
    query: {
        date: string;
        trainerId?: string;
        durationHours?: number;
    };
    url: '/api/v1/group-sessions/planning';
};

export type GetApiV1GroupSessionsPlanningErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1GroupSessionsPlanningError = GetApiV1GroupSessionsPlanningErrors[keyof GetApiV1GroupSessionsPlanningErrors];

export type GetApiV1GroupSessionsPlanningResponses = {
    /**
     * OK
     */
    200: SessionPlanningResponse;
};

export type GetApiV1GroupSessionsPlanningResponse = GetApiV1GroupSessionsPlanningResponses[keyof GetApiV1GroupSessionsPlanningResponses];

export type GetApiV1GroupSessionsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}';
};

export type GetApiV1GroupSessionsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1GroupSessionsByIdError = GetApiV1GroupSessionsByIdErrors[keyof GetApiV1GroupSessionsByIdErrors];

export type GetApiV1GroupSessionsByIdResponses = {
    /**
     * OK
     */
    200: GroupSessionDetailDto;
};

export type GetApiV1GroupSessionsByIdResponse = GetApiV1GroupSessionsByIdResponses[keyof GetApiV1GroupSessionsByIdResponses];

export type PostApiV1GroupSessionsByIdCancelData = {
    body: CancelGroupSessionBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/cancel';
};

export type PostApiV1GroupSessionsByIdCancelErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GroupSessionsByIdCancelError = PostApiV1GroupSessionsByIdCancelErrors[keyof PostApiV1GroupSessionsByIdCancelErrors];

export type PostApiV1GroupSessionsByIdCancelResponses = {
    /**
     * OK
     */
    200: BulkGroupSessionActionResponse;
};

export type PostApiV1GroupSessionsByIdCancelResponse = PostApiV1GroupSessionsByIdCancelResponses[keyof PostApiV1GroupSessionsByIdCancelResponses];

export type GetApiV1GroupSessionsByIdClientBriefsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/client-briefs';
};

export type GetApiV1GroupSessionsByIdClientBriefsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1GroupSessionsByIdClientBriefsError = GetApiV1GroupSessionsByIdClientBriefsErrors[keyof GetApiV1GroupSessionsByIdClientBriefsErrors];

export type GetApiV1GroupSessionsByIdClientBriefsResponses = {
    /**
     * OK
     */
    200: ClientBriefsResponse;
};

export type GetApiV1GroupSessionsByIdClientBriefsResponse = GetApiV1GroupSessionsByIdClientBriefsResponses[keyof GetApiV1GroupSessionsByIdClientBriefsResponses];

export type PostApiV1GroupSessionsByIdCompleteData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/complete';
};

export type PostApiV1GroupSessionsByIdCompleteErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GroupSessionsByIdCompleteError = PostApiV1GroupSessionsByIdCompleteErrors[keyof PostApiV1GroupSessionsByIdCompleteErrors];

export type PostApiV1GroupSessionsByIdCompleteResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1GroupSessionsByIdCompleteResponse = PostApiV1GroupSessionsByIdCompleteResponses[keyof PostApiV1GroupSessionsByIdCompleteResponses];

export type PostApiV1GroupSessionsByIdParticipantsByParticipantIdCheckInData = {
    body?: never;
    path: {
        id: string;
        participantId: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/participants/{participantId}/check-in';
};

export type PostApiV1GroupSessionsByIdParticipantsByParticipantIdCheckInErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GroupSessionsByIdParticipantsByParticipantIdCheckInError = PostApiV1GroupSessionsByIdParticipantsByParticipantIdCheckInErrors[keyof PostApiV1GroupSessionsByIdParticipantsByParticipantIdCheckInErrors];

export type PostApiV1GroupSessionsByIdParticipantsByParticipantIdCheckInResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1GroupSessionsByIdParticipantsByParticipantIdCheckInResponse = PostApiV1GroupSessionsByIdParticipantsByParticipantIdCheckInResponses[keyof PostApiV1GroupSessionsByIdParticipantsByParticipantIdCheckInResponses];

export type DeleteApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowData = {
    body?: never;
    path: {
        id: string;
        participantId: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/participants/{participantId}/no-show';
};

export type DeleteApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowError = DeleteApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowErrors[keyof DeleteApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowErrors];

export type DeleteApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowResponse = DeleteApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowResponses[keyof DeleteApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowResponses];

export type PostApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowData = {
    body?: never;
    path: {
        id: string;
        participantId: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/participants/{participantId}/no-show';
};

export type PostApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowError = PostApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowErrors[keyof PostApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowErrors];

export type PostApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowResponse = PostApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowResponses[keyof PostApiV1GroupSessionsByIdParticipantsByParticipantIdNoShowResponses];

export type PostApiV1GroupSessionsByIdParticipantsByParticipantIdRemoveData = {
    body: RemoveSessionParticipantBody;
    path: {
        id: string;
        participantId: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/participants/{participantId}/remove';
};

export type PostApiV1GroupSessionsByIdParticipantsByParticipantIdRemoveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GroupSessionsByIdParticipantsByParticipantIdRemoveError = PostApiV1GroupSessionsByIdParticipantsByParticipantIdRemoveErrors[keyof PostApiV1GroupSessionsByIdParticipantsByParticipantIdRemoveErrors];

export type PostApiV1GroupSessionsByIdParticipantsByParticipantIdRemoveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1GroupSessionsByIdParticipantsByParticipantIdRemoveResponse = PostApiV1GroupSessionsByIdParticipantsByParticipantIdRemoveResponses[keyof PostApiV1GroupSessionsByIdParticipantsByParticipantIdRemoveResponses];

export type GetApiV1GroupSessionsByIdPaymentPlanData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        useBonuses?: boolean;
        bonusKopecks?: number;
        useAdvance?: boolean;
    };
    url: '/api/v1/group-sessions/{id}/payment-plan';
};

export type GetApiV1GroupSessionsByIdPaymentPlanErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1GroupSessionsByIdPaymentPlanError = GetApiV1GroupSessionsByIdPaymentPlanErrors[keyof GetApiV1GroupSessionsByIdPaymentPlanErrors];

export type GetApiV1GroupSessionsByIdPaymentPlanResponses = {
    /**
     * OK
     */
    200: SeatPaymentPlanDto;
};

export type GetApiV1GroupSessionsByIdPaymentPlanResponse = GetApiV1GroupSessionsByIdPaymentPlanResponses[keyof GetApiV1GroupSessionsByIdPaymentPlanResponses];

export type DeleteApiV1GroupSessionsByIdRegisterData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/register';
};

export type DeleteApiV1GroupSessionsByIdRegisterErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1GroupSessionsByIdRegisterError = DeleteApiV1GroupSessionsByIdRegisterErrors[keyof DeleteApiV1GroupSessionsByIdRegisterErrors];

export type DeleteApiV1GroupSessionsByIdRegisterResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1GroupSessionsByIdRegisterResponse = DeleteApiV1GroupSessionsByIdRegisterResponses[keyof DeleteApiV1GroupSessionsByIdRegisterResponses];

export type PostApiV1GroupSessionsByIdRegisterData = {
    body?: null | RegisterForSessionBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/register';
};

export type PostApiV1GroupSessionsByIdRegisterErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GroupSessionsByIdRegisterError = PostApiV1GroupSessionsByIdRegisterErrors[keyof PostApiV1GroupSessionsByIdRegisterErrors];

export type PostApiV1GroupSessionsByIdRegisterResponses = {
    /**
     * Created
     */
    201: EntityIdResponse;
};

export type PostApiV1GroupSessionsByIdRegisterResponse = PostApiV1GroupSessionsByIdRegisterResponses[keyof PostApiV1GroupSessionsByIdRegisterResponses];

export type PostApiV1GroupSessionsByIdReviewData = {
    body: ReviewGroupSessionBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/review';
};

export type PostApiV1GroupSessionsByIdReviewErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GroupSessionsByIdReviewError = PostApiV1GroupSessionsByIdReviewErrors[keyof PostApiV1GroupSessionsByIdReviewErrors];

export type PostApiV1GroupSessionsByIdReviewResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1GroupSessionsByIdReviewResponse = PostApiV1GroupSessionsByIdReviewResponses[keyof PostApiV1GroupSessionsByIdReviewResponses];

export type PostApiV1GroupSessionsByIdStartData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/start';
};

export type PostApiV1GroupSessionsByIdStartErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GroupSessionsByIdStartError = PostApiV1GroupSessionsByIdStartErrors[keyof PostApiV1GroupSessionsByIdStartErrors];

export type PostApiV1GroupSessionsByIdStartResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1GroupSessionsByIdStartResponse = PostApiV1GroupSessionsByIdStartResponses[keyof PostApiV1GroupSessionsByIdStartResponses];

export type DeleteApiV1GroupSessionsByIdWaitlistData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/waitlist';
};

export type DeleteApiV1GroupSessionsByIdWaitlistErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1GroupSessionsByIdWaitlistError = DeleteApiV1GroupSessionsByIdWaitlistErrors[keyof DeleteApiV1GroupSessionsByIdWaitlistErrors];

export type DeleteApiV1GroupSessionsByIdWaitlistResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1GroupSessionsByIdWaitlistResponse = DeleteApiV1GroupSessionsByIdWaitlistResponses[keyof DeleteApiV1GroupSessionsByIdWaitlistResponses];

export type PostApiV1GroupSessionsByIdWaitlistData = {
    body?: null | RegisterForSessionBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/waitlist';
};

export type PostApiV1GroupSessionsByIdWaitlistErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GroupSessionsByIdWaitlistError = PostApiV1GroupSessionsByIdWaitlistErrors[keyof PostApiV1GroupSessionsByIdWaitlistErrors];

export type PostApiV1GroupSessionsByIdWaitlistResponses = {
    /**
     * Created
     */
    201: EntityIdResponse;
};

export type PostApiV1GroupSessionsByIdWaitlistResponse = PostApiV1GroupSessionsByIdWaitlistResponses[keyof PostApiV1GroupSessionsByIdWaitlistResponses];

export type PostApiV1GroupSessionsByIdWaitlistAcceptData = {
    body?: null | RegisterForSessionBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/waitlist/accept';
};

export type PostApiV1GroupSessionsByIdWaitlistAcceptErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GroupSessionsByIdWaitlistAcceptError = PostApiV1GroupSessionsByIdWaitlistAcceptErrors[keyof PostApiV1GroupSessionsByIdWaitlistAcceptErrors];

export type PostApiV1GroupSessionsByIdWaitlistAcceptResponses = {
    /**
     * Created
     */
    201: EntityIdResponse;
};

export type PostApiV1GroupSessionsByIdWaitlistAcceptResponse = PostApiV1GroupSessionsByIdWaitlistAcceptResponses[keyof PostApiV1GroupSessionsByIdWaitlistAcceptResponses];

export type PostApiV1GroupSessionsByIdWaitlistDeclineData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/waitlist/decline';
};

export type PostApiV1GroupSessionsByIdWaitlistDeclineErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GroupSessionsByIdWaitlistDeclineError = PostApiV1GroupSessionsByIdWaitlistDeclineErrors[keyof PostApiV1GroupSessionsByIdWaitlistDeclineErrors];

export type PostApiV1GroupSessionsByIdWaitlistDeclineResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1GroupSessionsByIdWaitlistDeclineResponse = PostApiV1GroupSessionsByIdWaitlistDeclineResponses[keyof PostApiV1GroupSessionsByIdWaitlistDeclineResponses];

export type GetApiV1GroupSessionsByIdWaitlistMeData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/waitlist/me';
};

export type GetApiV1GroupSessionsByIdWaitlistMeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1GroupSessionsByIdWaitlistMeError = GetApiV1GroupSessionsByIdWaitlistMeErrors[keyof GetApiV1GroupSessionsByIdWaitlistMeErrors];

export type GetApiV1GroupSessionsByIdWaitlistMeResponses = {
    /**
     * OK
     */
    200: MyWaitlistPlaceDto;
};

export type GetApiV1GroupSessionsByIdWaitlistMeResponse = GetApiV1GroupSessionsByIdWaitlistMeResponses[keyof GetApiV1GroupSessionsByIdWaitlistMeResponses];

export type PostApiV1GroupSessionsByIdWalkInData = {
    body?: null | RegisterForSessionBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/group-sessions/{id}/walk-in';
};

export type PostApiV1GroupSessionsByIdWalkInErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GroupSessionsByIdWalkInError = PostApiV1GroupSessionsByIdWalkInErrors[keyof PostApiV1GroupSessionsByIdWalkInErrors];

export type PostApiV1GroupSessionsByIdWalkInResponses = {
    /**
     * Created
     */
    201: EntityIdResponse;
};

export type PostApiV1GroupSessionsByIdWalkInResponse = PostApiV1GroupSessionsByIdWalkInResponses[keyof PostApiV1GroupSessionsByIdWalkInResponses];

export type GetApiV1GuestsData = {
    body?: never;
    path?: never;
    query?: {
        search?: string;
        status?: GuestStatus;
        page?: number;
        pageSize?: number;
    };
    url: '/api/v1/guests';
};

export type GetApiV1GuestsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1GuestsError = GetApiV1GuestsErrors[keyof GetApiV1GuestsErrors];

export type GetApiV1GuestsResponses = {
    /**
     * OK
     */
    200: GuestListResponse;
};

export type GetApiV1GuestsResponse = GetApiV1GuestsResponses[keyof GetApiV1GuestsResponses];

export type PostApiV1GuestsData = {
    body: CreateGuestRequest;
    path?: never;
    query?: never;
    url: '/api/v1/guests';
};

export type PostApiV1GuestsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GuestsError = PostApiV1GuestsErrors[keyof PostApiV1GuestsErrors];

export type PostApiV1GuestsResponses = {
    /**
     * Created
     */
    201: GuestDto;
};

export type PostApiV1GuestsResponse = PostApiV1GuestsResponses[keyof PostApiV1GuestsResponses];

export type DeleteApiV1GuestsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/guests/{id}';
};

export type DeleteApiV1GuestsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1GuestsByIdError = DeleteApiV1GuestsByIdErrors[keyof DeleteApiV1GuestsByIdErrors];

export type DeleteApiV1GuestsByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1GuestsByIdResponse = DeleteApiV1GuestsByIdResponses[keyof DeleteApiV1GuestsByIdResponses];

export type GetApiV1GuestsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/guests/{id}';
};

export type GetApiV1GuestsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1GuestsByIdError = GetApiV1GuestsByIdErrors[keyof GetApiV1GuestsByIdErrors];

export type GetApiV1GuestsByIdResponses = {
    /**
     * OK
     */
    200: GuestDto;
};

export type GetApiV1GuestsByIdResponse = GetApiV1GuestsByIdResponses[keyof GetApiV1GuestsByIdResponses];

export type PutApiV1GuestsByIdData = {
    body: UpdateGuestRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/guests/{id}';
};

export type PutApiV1GuestsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1GuestsByIdError = PutApiV1GuestsByIdErrors[keyof PutApiV1GuestsByIdErrors];

export type PutApiV1GuestsByIdResponses = {
    /**
     * OK
     */
    200: GuestDto;
};

export type PutApiV1GuestsByIdResponse = PutApiV1GuestsByIdResponses[keyof PutApiV1GuestsByIdResponses];

export type PostApiV1GuestsByIdVisitData = {
    body: RegisterGuestVisitRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/guests/{id}/visit';
};

export type PostApiV1GuestsByIdVisitErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1GuestsByIdVisitError = PostApiV1GuestsByIdVisitErrors[keyof PostApiV1GuestsByIdVisitErrors];

export type PostApiV1GuestsByIdVisitResponses = {
    /**
     * OK
     */
    200: GuestDto;
};

export type PostApiV1GuestsByIdVisitResponse = PostApiV1GuestsByIdVisitResponses[keyof PostApiV1GuestsByIdVisitResponses];

export type GetApiV1LoyaltyBonusAvailabilityData = {
    body?: never;
    path?: never;
    query?: {
        clientIds?: Array<string>;
    };
    url: '/api/v1/loyalty/bonus-availability';
};

export type GetApiV1LoyaltyBonusAvailabilityErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1LoyaltyBonusAvailabilityError = GetApiV1LoyaltyBonusAvailabilityErrors[keyof GetApiV1LoyaltyBonusAvailabilityErrors];

export type GetApiV1LoyaltyBonusAvailabilityResponses = {
    /**
     * OK
     */
    200: BonusAvailabilityListResponse;
};

export type GetApiV1LoyaltyBonusAvailabilityResponse = GetApiV1LoyaltyBonusAvailabilityResponses[keyof GetApiV1LoyaltyBonusAvailabilityResponses];

export type GetApiV1LoyaltyBonusPaymentPolicyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/loyalty/bonus-payment-policy';
};

export type GetApiV1LoyaltyBonusPaymentPolicyErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1LoyaltyBonusPaymentPolicyError = GetApiV1LoyaltyBonusPaymentPolicyErrors[keyof GetApiV1LoyaltyBonusPaymentPolicyErrors];

export type GetApiV1LoyaltyBonusPaymentPolicyResponses = {
    /**
     * OK
     */
    200: BonusPaymentPolicyDto;
};

export type GetApiV1LoyaltyBonusPaymentPolicyResponse = GetApiV1LoyaltyBonusPaymentPolicyResponses[keyof GetApiV1LoyaltyBonusPaymentPolicyResponses];

export type GetApiV1LoyaltyBonusProgramData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/loyalty/bonus-program';
};

export type GetApiV1LoyaltyBonusProgramErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1LoyaltyBonusProgramError = GetApiV1LoyaltyBonusProgramErrors[keyof GetApiV1LoyaltyBonusProgramErrors];

export type GetApiV1LoyaltyBonusProgramResponses = {
    /**
     * OK
     */
    200: BonusProgramDto;
};

export type GetApiV1LoyaltyBonusProgramResponse = GetApiV1LoyaltyBonusProgramResponses[keyof GetApiV1LoyaltyBonusProgramResponses];

export type PatchApiV1LoyaltyBonusProgramData = {
    body: PatchBonusProgramPayload;
    path?: never;
    query?: never;
    url: '/api/v1/loyalty/bonus-program';
};

export type PatchApiV1LoyaltyBonusProgramErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1LoyaltyBonusProgramError = PatchApiV1LoyaltyBonusProgramErrors[keyof PatchApiV1LoyaltyBonusProgramErrors];

export type PatchApiV1LoyaltyBonusProgramResponses = {
    /**
     * OK
     */
    200: BonusProgramDto;
};

export type PatchApiV1LoyaltyBonusProgramResponse = PatchApiV1LoyaltyBonusProgramResponses[keyof PatchApiV1LoyaltyBonusProgramResponses];

export type GetApiV1LoyaltyMeBonusSpendData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/loyalty/me/bonus-spend';
};

export type GetApiV1LoyaltyMeBonusSpendErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1LoyaltyMeBonusSpendError = GetApiV1LoyaltyMeBonusSpendErrors[keyof GetApiV1LoyaltyMeBonusSpendErrors];

export type GetApiV1LoyaltyMeBonusSpendResponses = {
    /**
     * OK
     */
    200: MyBonusSpendDto;
};

export type GetApiV1LoyaltyMeBonusSpendResponse = GetApiV1LoyaltyMeBonusSpendResponses[keyof GetApiV1LoyaltyMeBonusSpendResponses];

export type GetApiV1LoyaltyMeBonusesData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
    };
    url: '/api/v1/loyalty/me/bonuses';
};

export type GetApiV1LoyaltyMeBonusesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1LoyaltyMeBonusesError = GetApiV1LoyaltyMeBonusesErrors[keyof GetApiV1LoyaltyMeBonusesErrors];

export type GetApiV1LoyaltyMeBonusesResponses = {
    /**
     * OK
     */
    200: MyBonusesResponse;
};

export type GetApiV1LoyaltyMeBonusesResponse = GetApiV1LoyaltyMeBonusesResponses[keyof GetApiV1LoyaltyMeBonusesResponses];

export type GetApiV1LoyaltyMeCardData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/loyalty/me/card';
};

export type GetApiV1LoyaltyMeCardErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1LoyaltyMeCardError = GetApiV1LoyaltyMeCardErrors[keyof GetApiV1LoyaltyMeCardErrors];

export type GetApiV1LoyaltyMeCardResponses = {
    /**
     * OK
     */
    200: MembershipCardDto;
};

export type GetApiV1LoyaltyMeCardResponse = GetApiV1LoyaltyMeCardResponses[keyof GetApiV1LoyaltyMeCardResponses];

export type GetApiV1LoyaltyMeObligationsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/loyalty/me/obligations';
};

export type GetApiV1LoyaltyMeObligationsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1LoyaltyMeObligationsError = GetApiV1LoyaltyMeObligationsErrors[keyof GetApiV1LoyaltyMeObligationsErrors];

export type GetApiV1LoyaltyMeObligationsResponses = {
    /**
     * OK
     */
    200: Array<ClientObligationView>;
};

export type GetApiV1LoyaltyMeObligationsResponse = GetApiV1LoyaltyMeObligationsResponses[keyof GetApiV1LoyaltyMeObligationsResponses];

export type GetApiV1LoyaltyOverviewData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/loyalty/overview';
};

export type GetApiV1LoyaltyOverviewErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1LoyaltyOverviewError = GetApiV1LoyaltyOverviewErrors[keyof GetApiV1LoyaltyOverviewErrors];

export type GetApiV1LoyaltyOverviewResponses = {
    /**
     * OK
     */
    200: LoyaltyOverviewResponse;
};

export type GetApiV1LoyaltyOverviewResponse = GetApiV1LoyaltyOverviewResponses[keyof GetApiV1LoyaltyOverviewResponses];

export type PostApiV1MatchesData = {
    body: SubmitMatchPayload;
    path?: never;
    query?: never;
    url: '/api/v1/matches';
};

export type PostApiV1MatchesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1MatchesError = PostApiV1MatchesErrors[keyof PostApiV1MatchesErrors];

export type PostApiV1MatchesResponses = {
    /**
     * Created
     */
    201: RecordedMatchDto;
};

export type PostApiV1MatchesResponse = PostApiV1MatchesResponses[keyof PostApiV1MatchesResponses];

export type GetApiV1MatchesClientByClientIdData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/matches/client/{clientId}';
};

export type GetApiV1MatchesClientByClientIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1MatchesClientByClientIdError = GetApiV1MatchesClientByClientIdErrors[keyof GetApiV1MatchesClientByClientIdErrors];

export type GetApiV1MatchesClientByClientIdResponses = {
    /**
     * OK
     */
    200: Array<RatingMatchDto>;
};

export type GetApiV1MatchesClientByClientIdResponse = GetApiV1MatchesClientByClientIdResponses[keyof GetApiV1MatchesClientByClientIdResponses];

export type GetApiV1MatchesDisputedData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/matches/disputed';
};

export type GetApiV1MatchesDisputedErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1MatchesDisputedError = GetApiV1MatchesDisputedErrors[keyof GetApiV1MatchesDisputedErrors];

export type GetApiV1MatchesDisputedResponses = {
    /**
     * OK
     */
    200: Array<RatingMatchDto>;
};

export type GetApiV1MatchesDisputedResponse = GetApiV1MatchesDisputedResponses[keyof GetApiV1MatchesDisputedResponses];

export type GetApiV1MatchesMineData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/matches/mine';
};

export type GetApiV1MatchesMineErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1MatchesMineError = GetApiV1MatchesMineErrors[keyof GetApiV1MatchesMineErrors];

export type GetApiV1MatchesMineResponses = {
    /**
     * OK
     */
    200: Array<RatingMatchDto>;
};

export type GetApiV1MatchesMineResponse = GetApiV1MatchesMineResponses[keyof GetApiV1MatchesMineResponses];

export type GetApiV1MatchesOpponentData = {
    body?: never;
    path?: never;
    query: {
        shortId: string;
    };
    url: '/api/v1/matches/opponent';
};

export type GetApiV1MatchesOpponentErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1MatchesOpponentError = GetApiV1MatchesOpponentErrors[keyof GetApiV1MatchesOpponentErrors];

export type GetApiV1MatchesOpponentResponses = {
    /**
     * OK
     */
    200: OpponentCardDto;
};

export type GetApiV1MatchesOpponentResponse = GetApiV1MatchesOpponentResponses[keyof GetApiV1MatchesOpponentResponses];

export type PostApiV1MatchesByIdConfirmData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/matches/{id}/confirm';
};

export type PostApiV1MatchesByIdConfirmErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1MatchesByIdConfirmError = PostApiV1MatchesByIdConfirmErrors[keyof PostApiV1MatchesByIdConfirmErrors];

export type PostApiV1MatchesByIdConfirmResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1MatchesByIdConfirmResponse = PostApiV1MatchesByIdConfirmResponses[keyof PostApiV1MatchesByIdConfirmResponses];

export type PostApiV1MatchesByIdDisputeData = {
    body?: null | DisputeMatchPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/matches/{id}/dispute';
};

export type PostApiV1MatchesByIdDisputeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1MatchesByIdDisputeError = PostApiV1MatchesByIdDisputeErrors[keyof PostApiV1MatchesByIdDisputeErrors];

export type PostApiV1MatchesByIdDisputeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1MatchesByIdDisputeResponse = PostApiV1MatchesByIdDisputeResponses[keyof PostApiV1MatchesByIdDisputeResponses];

export type PostApiV1MatchesByIdResolveData = {
    body: ResolveMatchPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/matches/{id}/resolve';
};

export type PostApiV1MatchesByIdResolveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1MatchesByIdResolveError = PostApiV1MatchesByIdResolveErrors[keyof PostApiV1MatchesByIdResolveErrors];

export type PostApiV1MatchesByIdResolveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1MatchesByIdResolveResponse = PostApiV1MatchesByIdResolveResponses[keyof PostApiV1MatchesByIdResolveResponses];

export type PostApiV1MatchesByIdVoidData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/matches/{id}/void';
};

export type PostApiV1MatchesByIdVoidErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1MatchesByIdVoidError = PostApiV1MatchesByIdVoidErrors[keyof PostApiV1MatchesByIdVoidErrors];

export type PostApiV1MatchesByIdVoidResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1MatchesByIdVoidResponse = PostApiV1MatchesByIdVoidResponses[keyof PostApiV1MatchesByIdVoidResponses];

export type GetApiV1MeClubDocumentsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/me/club-documents';
};

export type GetApiV1MeClubDocumentsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1MeClubDocumentsError = GetApiV1MeClubDocumentsErrors[keyof GetApiV1MeClubDocumentsErrors];

export type GetApiV1MeClubDocumentsResponses = {
    /**
     * OK
     */
    200: ClubDocumentsResponse;
};

export type GetApiV1MeClubDocumentsResponse = GetApiV1MeClubDocumentsResponses[keyof GetApiV1MeClubDocumentsResponses];

export type PostApiV1MeClubDocumentsConsentsData = {
    body: ClubConsentsBody;
    path?: never;
    query?: never;
    url: '/api/v1/me/club-documents/consents';
};

export type PostApiV1MeClubDocumentsConsentsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1MeClubDocumentsConsentsError = PostApiV1MeClubDocumentsConsentsErrors[keyof PostApiV1MeClubDocumentsConsentsErrors];

export type PostApiV1MeClubDocumentsConsentsResponses = {
    /**
     * OK
     */
    200: ClubDocumentsResponse;
};

export type PostApiV1MeClubDocumentsConsentsResponse = PostApiV1MeClubDocumentsConsentsResponses[keyof PostApiV1MeClubDocumentsConsentsResponses];

export type GetApiV1MeCorporateEligibilityData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/me/corporate-eligibility';
};

export type GetApiV1MeCorporateEligibilityErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1MeCorporateEligibilityError = GetApiV1MeCorporateEligibilityErrors[keyof GetApiV1MeCorporateEligibilityErrors];

export type GetApiV1MeCorporateEligibilityResponses = {
    /**
     * OK
     */
    200: CorporateEligibilityDto;
};

export type GetApiV1MeCorporateEligibilityResponse = GetApiV1MeCorporateEligibilityResponses[keyof GetApiV1MeCorporateEligibilityResponses];

export type GetApiV1MeDashboardLayoutData = {
    body?: never;
    path?: never;
    query?: {
        defaults?: boolean;
    };
    url: '/api/v1/me/dashboard-layout';
};

export type GetApiV1MeDashboardLayoutErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1MeDashboardLayoutError = GetApiV1MeDashboardLayoutErrors[keyof GetApiV1MeDashboardLayoutErrors];

export type GetApiV1MeDashboardLayoutResponses = {
    /**
     * OK
     */
    200: DashboardLayoutDto;
};

export type GetApiV1MeDashboardLayoutResponse = GetApiV1MeDashboardLayoutResponses[keyof GetApiV1MeDashboardLayoutResponses];

export type PutApiV1MeDashboardLayoutData = {
    body: SaveLayoutPayload;
    path?: never;
    query?: never;
    url: '/api/v1/me/dashboard-layout';
};

export type PutApiV1MeDashboardLayoutErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1MeDashboardLayoutError = PutApiV1MeDashboardLayoutErrors[keyof PutApiV1MeDashboardLayoutErrors];

export type PutApiV1MeDashboardLayoutResponses = {
    /**
     * OK
     */
    200: DashboardLayoutDto;
};

export type PutApiV1MeDashboardLayoutResponse = PutApiV1MeDashboardLayoutResponses[keyof PutApiV1MeDashboardLayoutResponses];

export type GetApiV1MeReviewsPendingData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/me/reviews/pending';
};

export type GetApiV1MeReviewsPendingErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1MeReviewsPendingError = GetApiV1MeReviewsPendingErrors[keyof GetApiV1MeReviewsPendingErrors];

export type GetApiV1MeReviewsPendingResponses = {
    /**
     * OK
     */
    200: ReviewPromptsResponse;
};

export type GetApiV1MeReviewsPendingResponse = GetApiV1MeReviewsPendingResponses[keyof GetApiV1MeReviewsPendingResponses];

export type PostApiV1MediaData = {
    body: {
        file?: IFormFile;
    };
    path?: never;
    query?: never;
    url: '/api/v1/media';
};

export type PostApiV1MediaErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1MediaError = PostApiV1MediaErrors[keyof PostApiV1MediaErrors];

export type PostApiV1MediaResponses = {
    /**
     * OK
     */
    200: MediaDescription;
};

export type PostApiV1MediaResponse = PostApiV1MediaResponses[keyof PostApiV1MediaResponses];

export type GetApiV1MobileBookingContextData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/mobile/booking-context';
};

export type GetApiV1MobileBookingContextErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1MobileBookingContextError = GetApiV1MobileBookingContextErrors[keyof GetApiV1MobileBookingContextErrors];

export type GetApiV1MobileBookingContextResponses = {
    /**
     * OK
     */
    200: BookingContextResponse;
};

export type GetApiV1MobileBookingContextResponse = GetApiV1MobileBookingContextResponses[keyof GetApiV1MobileBookingContextResponses];

export type GetApiV1NewsData = {
    body?: never;
    path?: never;
    query?: {
        cursor?: string;
        take?: number;
    };
    url: '/api/v1/news';
};

export type GetApiV1NewsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1NewsError = GetApiV1NewsErrors[keyof GetApiV1NewsErrors];

export type GetApiV1NewsResponses = {
    /**
     * OK
     */
    200: NewsFeedPage;
};

export type GetApiV1NewsResponse = GetApiV1NewsResponses[keyof GetApiV1NewsResponses];

export type GetApiV1NewsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/news/{id}';
};

export type GetApiV1NewsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1NewsByIdError = GetApiV1NewsByIdErrors[keyof GetApiV1NewsByIdErrors];

export type GetApiV1NewsByIdResponses = {
    /**
     * OK
     */
    200: NewsItemDto;
};

export type GetApiV1NewsByIdResponse = GetApiV1NewsByIdResponses[keyof GetApiV1NewsByIdResponses];

export type GetApiV1NotificationsData = {
    body?: never;
    path?: never;
    query?: {
        Category?: NotificationCategory;
        IsRead?: boolean;
        Limit?: number;
        Cursor?: string;
    };
    url: '/api/v1/notifications';
};

export type GetApiV1NotificationsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1NotificationsError = GetApiV1NotificationsErrors[keyof GetApiV1NotificationsErrors];

export type GetApiV1NotificationsResponses = {
    /**
     * OK
     */
    200: PagedListOfNotificationDto;
};

export type GetApiV1NotificationsResponse = GetApiV1NotificationsResponses[keyof GetApiV1NotificationsResponses];

export type PostApiV1NotificationsAudiencePreviewData = {
    body: PreviewNotificationAudienceRequest;
    path?: never;
    query?: never;
    url: '/api/v1/notifications/audience/preview';
};

export type PostApiV1NotificationsAudiencePreviewErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1NotificationsAudiencePreviewError = PostApiV1NotificationsAudiencePreviewErrors[keyof PostApiV1NotificationsAudiencePreviewErrors];

export type PostApiV1NotificationsAudiencePreviewResponses = {
    /**
     * OK
     */
    200: AudiencePreviewResponse;
};

export type PostApiV1NotificationsAudiencePreviewResponse = PostApiV1NotificationsAudiencePreviewResponses[keyof PostApiV1NotificationsAudiencePreviewResponses];

export type PostApiV1NotificationsAudienceSendData = {
    body: SendAudienceNotificationRequest;
    path?: never;
    query?: never;
    url: '/api/v1/notifications/audience/send';
};

export type PostApiV1NotificationsAudienceSendErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1NotificationsAudienceSendError = PostApiV1NotificationsAudienceSendErrors[keyof PostApiV1NotificationsAudienceSendErrors];

export type PostApiV1NotificationsAudienceSendResponses = {
    /**
     * OK
     */
    200: AudienceSendResponse;
};

export type PostApiV1NotificationsAudienceSendResponse = PostApiV1NotificationsAudienceSendResponses[keyof PostApiV1NotificationsAudienceSendResponses];

export type GetApiV1NotificationsPreferencesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/notifications/preferences';
};

export type GetApiV1NotificationsPreferencesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1NotificationsPreferencesError = GetApiV1NotificationsPreferencesErrors[keyof GetApiV1NotificationsPreferencesErrors];

export type GetApiV1NotificationsPreferencesResponses = {
    /**
     * OK
     */
    200: DeliveryPreferencesDto;
};

export type GetApiV1NotificationsPreferencesResponse = GetApiV1NotificationsPreferencesResponses[keyof GetApiV1NotificationsPreferencesResponses];

export type PutApiV1NotificationsPreferencesData = {
    body: UpdateDeliveryPreferencesPayload;
    path?: never;
    query?: never;
    url: '/api/v1/notifications/preferences';
};

export type PutApiV1NotificationsPreferencesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1NotificationsPreferencesError = PutApiV1NotificationsPreferencesErrors[keyof PutApiV1NotificationsPreferencesErrors];

export type PutApiV1NotificationsPreferencesResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1NotificationsPreferencesResponse = PutApiV1NotificationsPreferencesResponses[keyof PutApiV1NotificationsPreferencesResponses];

export type PostApiV1NotificationsReadAllData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/notifications/read-all';
};

export type PostApiV1NotificationsReadAllErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1NotificationsReadAllError = PostApiV1NotificationsReadAllErrors[keyof PostApiV1NotificationsReadAllErrors];

export type PostApiV1NotificationsReadAllResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1NotificationsReadAllResponse = PostApiV1NotificationsReadAllResponses[keyof PostApiV1NotificationsReadAllResponses];

export type PostApiV1NotificationsSendData = {
    body: SendAdminMessageCommand;
    path?: never;
    query?: never;
    url: '/api/v1/notifications/send';
};

export type PostApiV1NotificationsSendErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1NotificationsSendError = PostApiV1NotificationsSendErrors[keyof PostApiV1NotificationsSendErrors];

export type PostApiV1NotificationsSendResponses = {
    /**
     * OK
     */
    200: SendAdminMessageResponse;
};

export type PostApiV1NotificationsSendResponse = PostApiV1NotificationsSendResponses[keyof PostApiV1NotificationsSendResponses];

export type GetApiV1NotificationsUnreadCountData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/notifications/unread-count';
};

export type GetApiV1NotificationsUnreadCountErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1NotificationsUnreadCountError = GetApiV1NotificationsUnreadCountErrors[keyof GetApiV1NotificationsUnreadCountErrors];

export type GetApiV1NotificationsUnreadCountResponses = {
    /**
     * OK
     */
    200: UnreadCountDto;
};

export type GetApiV1NotificationsUnreadCountResponse = GetApiV1NotificationsUnreadCountResponses[keyof GetApiV1NotificationsUnreadCountResponses];

export type PostApiV1NotificationsByIdReadData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/notifications/{id}/read';
};

export type PostApiV1NotificationsByIdReadErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1NotificationsByIdReadError = PostApiV1NotificationsByIdReadErrors[keyof PostApiV1NotificationsByIdReadErrors];

export type PostApiV1NotificationsByIdReadResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1NotificationsByIdReadResponse = PostApiV1NotificationsByIdReadResponses[keyof PostApiV1NotificationsByIdReadResponses];

export type GetApiV1OpenMatchesData = {
    body?: never;
    path?: never;
    query?: {
        sport?: string;
    };
    url: '/api/v1/open-matches';
};

export type GetApiV1OpenMatchesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OpenMatchesError = GetApiV1OpenMatchesErrors[keyof GetApiV1OpenMatchesErrors];

export type GetApiV1OpenMatchesResponses = {
    /**
     * OK
     */
    200: ListOpenMatchesResponse;
};

export type GetApiV1OpenMatchesResponse = GetApiV1OpenMatchesResponses[keyof GetApiV1OpenMatchesResponses];

export type PostApiV1OpenMatchesData = {
    body: CreateOpenMatchPayload;
    path?: never;
    query?: never;
    url: '/api/v1/open-matches';
};

export type PostApiV1OpenMatchesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1OpenMatchesError = PostApiV1OpenMatchesErrors[keyof PostApiV1OpenMatchesErrors];

export type PostApiV1OpenMatchesResponses = {
    /**
     * Created
     */
    201: EntityIdResponse;
};

export type PostApiV1OpenMatchesResponse = PostApiV1OpenMatchesResponses[keyof PostApiV1OpenMatchesResponses];

export type GetApiV1OpenMatchesAdminData = {
    body?: never;
    path?: never;
    query?: {
        Sport?: string;
        Status?: OpenMatchStatus;
        Page?: number;
        PageSize?: number;
        MatchId?: string;
    };
    url: '/api/v1/open-matches/admin';
};

export type GetApiV1OpenMatchesAdminErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OpenMatchesAdminError = GetApiV1OpenMatchesAdminErrors[keyof GetApiV1OpenMatchesAdminErrors];

export type GetApiV1OpenMatchesAdminResponses = {
    /**
     * OK
     */
    200: ListOpenMatchesAdminResponse;
};

export type GetApiV1OpenMatchesAdminResponse = GetApiV1OpenMatchesAdminResponses[keyof GetApiV1OpenMatchesAdminResponses];

export type PostApiV1OpenMatchesOrganizerPlanData = {
    body: PlanOpenMatchPayload;
    path?: never;
    query?: never;
    url: '/api/v1/open-matches/organizer-plan';
};

export type PostApiV1OpenMatchesOrganizerPlanErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1OpenMatchesOrganizerPlanError = PostApiV1OpenMatchesOrganizerPlanErrors[keyof PostApiV1OpenMatchesOrganizerPlanErrors];

export type PostApiV1OpenMatchesOrganizerPlanResponses = {
    /**
     * OK
     */
    200: OrganizerSharePlanDto;
};

export type PostApiV1OpenMatchesOrganizerPlanResponse = PostApiV1OpenMatchesOrganizerPlanResponses[keyof PostApiV1OpenMatchesOrganizerPlanResponses];

export type GetApiV1OpenMatchesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/open-matches/{id}';
};

export type GetApiV1OpenMatchesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OpenMatchesByIdError = GetApiV1OpenMatchesByIdErrors[keyof GetApiV1OpenMatchesByIdErrors];

export type GetApiV1OpenMatchesByIdResponses = {
    /**
     * OK
     */
    200: OpenMatchDetailDto;
};

export type GetApiV1OpenMatchesByIdResponse = GetApiV1OpenMatchesByIdResponses[keyof GetApiV1OpenMatchesByIdResponses];

export type PostApiV1OpenMatchesByIdAttendanceData = {
    body: OverrideAttendancePayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/open-matches/{id}/attendance';
};

export type PostApiV1OpenMatchesByIdAttendanceErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1OpenMatchesByIdAttendanceError = PostApiV1OpenMatchesByIdAttendanceErrors[keyof PostApiV1OpenMatchesByIdAttendanceErrors];

export type PostApiV1OpenMatchesByIdAttendanceResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1OpenMatchesByIdAttendanceResponse = PostApiV1OpenMatchesByIdAttendanceResponses[keyof PostApiV1OpenMatchesByIdAttendanceResponses];

export type PostApiV1OpenMatchesByIdCancelData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/open-matches/{id}/cancel';
};

export type PostApiV1OpenMatchesByIdCancelErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1OpenMatchesByIdCancelError = PostApiV1OpenMatchesByIdCancelErrors[keyof PostApiV1OpenMatchesByIdCancelErrors];

export type PostApiV1OpenMatchesByIdCancelResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1OpenMatchesByIdCancelResponse = PostApiV1OpenMatchesByIdCancelResponses[keyof PostApiV1OpenMatchesByIdCancelResponses];

export type PostApiV1OpenMatchesByIdCancelManageData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/open-matches/{id}/cancel/manage';
};

export type PostApiV1OpenMatchesByIdCancelManageErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1OpenMatchesByIdCancelManageError = PostApiV1OpenMatchesByIdCancelManageErrors[keyof PostApiV1OpenMatchesByIdCancelManageErrors];

export type PostApiV1OpenMatchesByIdCancelManageResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1OpenMatchesByIdCancelManageResponse = PostApiV1OpenMatchesByIdCancelManageResponses[keyof PostApiV1OpenMatchesByIdCancelManageResponses];

export type DeleteApiV1OpenMatchesByIdJoinData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/open-matches/{id}/join';
};

export type DeleteApiV1OpenMatchesByIdJoinErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1OpenMatchesByIdJoinError = DeleteApiV1OpenMatchesByIdJoinErrors[keyof DeleteApiV1OpenMatchesByIdJoinErrors];

export type DeleteApiV1OpenMatchesByIdJoinResponses = {
    /**
     * OK
     */
    200: LeaveOpenMatchResponse;
};

export type DeleteApiV1OpenMatchesByIdJoinResponse = DeleteApiV1OpenMatchesByIdJoinResponses[keyof DeleteApiV1OpenMatchesByIdJoinResponses];

export type PostApiV1OpenMatchesByIdJoinData = {
    body?: null | JoinOpenMatchPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/open-matches/{id}/join';
};

export type PostApiV1OpenMatchesByIdJoinErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1OpenMatchesByIdJoinError = PostApiV1OpenMatchesByIdJoinErrors[keyof PostApiV1OpenMatchesByIdJoinErrors];

export type PostApiV1OpenMatchesByIdJoinResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1OpenMatchesByIdJoinResponse = PostApiV1OpenMatchesByIdJoinResponses[keyof PostApiV1OpenMatchesByIdJoinResponses];

export type GetApiV1OpenMatchesByIdPaymentPlanData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        bonusKopecks?: number;
    };
    url: '/api/v1/open-matches/{id}/payment-plan';
};

export type GetApiV1OpenMatchesByIdPaymentPlanErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OpenMatchesByIdPaymentPlanError = GetApiV1OpenMatchesByIdPaymentPlanErrors[keyof GetApiV1OpenMatchesByIdPaymentPlanErrors];

export type GetApiV1OpenMatchesByIdPaymentPlanResponses = {
    /**
     * OK
     */
    200: SplitSharePlanDto;
};

export type GetApiV1OpenMatchesByIdPaymentPlanResponse = GetApiV1OpenMatchesByIdPaymentPlanResponses[keyof GetApiV1OpenMatchesByIdPaymentPlanResponses];

export type PostApiV1OrdersCheckoutData = {
    body: OrderCheckoutPayload;
    path?: never;
    query?: never;
    url: '/api/v1/orders/checkout';
};

export type PostApiV1OrdersCheckoutErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1OrdersCheckoutError = PostApiV1OrdersCheckoutErrors[keyof PostApiV1OrdersCheckoutErrors];

export type PostApiV1OrdersCheckoutResponses = {
    /**
     * Created
     */
    201: OrderCheckoutResponse;
};

export type PostApiV1OrdersCheckoutResponse = PostApiV1OrdersCheckoutResponses[keyof PostApiV1OrdersCheckoutResponses];

export type GetApiV1OrdersMyData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
    };
    url: '/api/v1/orders/my';
};

export type GetApiV1OrdersMyErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OrdersMyError = GetApiV1OrdersMyErrors[keyof GetApiV1OrdersMyErrors];

export type GetApiV1OrdersMyResponses = {
    /**
     * OK
     */
    200: MyOrdersResponse;
};

export type GetApiV1OrdersMyResponse = GetApiV1OrdersMyResponses[keyof GetApiV1OrdersMyResponses];

export type GetApiV1OrdersMyAwaitingData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/orders/my/awaiting';
};

export type GetApiV1OrdersMyAwaitingErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OrdersMyAwaitingError = GetApiV1OrdersMyAwaitingErrors[keyof GetApiV1OrdersMyAwaitingErrors];

export type GetApiV1OrdersMyAwaitingResponses = {
    /**
     * OK
     */
    200: MyAwaitingOrdersResponse;
};

export type GetApiV1OrdersMyAwaitingResponse = GetApiV1OrdersMyAwaitingResponses[keyof GetApiV1OrdersMyAwaitingResponses];

export type GetApiV1OrdersByOrderIdData = {
    body?: never;
    path: {
        orderId: string;
    };
    query?: never;
    url: '/api/v1/orders/{orderId}';
};

export type GetApiV1OrdersByOrderIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OrdersByOrderIdError = GetApiV1OrdersByOrderIdErrors[keyof GetApiV1OrdersByOrderIdErrors];

export type GetApiV1OrdersByOrderIdResponses = {
    /**
     * OK
     */
    200: OrderDto;
};

export type GetApiV1OrdersByOrderIdResponse = GetApiV1OrdersByOrderIdResponses[keyof GetApiV1OrdersByOrderIdResponses];

export type PostApiV1OrdersByOrderIdPayData = {
    body: PayOrderPayload;
    path: {
        orderId: string;
    };
    query?: never;
    url: '/api/v1/orders/{orderId}/pay';
};

export type PostApiV1OrdersByOrderIdPayErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1OrdersByOrderIdPayError = PostApiV1OrdersByOrderIdPayErrors[keyof PostApiV1OrdersByOrderIdPayErrors];

export type PostApiV1OrdersByOrderIdPayResponses = {
    /**
     * OK
     */
    200: PayOrderResponse;
};

export type PostApiV1OrdersByOrderIdPayResponse = PostApiV1OrdersByOrderIdPayResponses[keyof PostApiV1OrdersByOrderIdPayResponses];

export type PostApiV1OrdersByOrderIdSettleData = {
    body: SettleOrderPayload;
    path: {
        orderId: string;
    };
    query?: never;
    url: '/api/v1/orders/{orderId}/settle';
};

export type PostApiV1OrdersByOrderIdSettleErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1OrdersByOrderIdSettleError = PostApiV1OrdersByOrderIdSettleErrors[keyof PostApiV1OrdersByOrderIdSettleErrors];

export type PostApiV1OrdersByOrderIdSettleResponses = {
    /**
     * OK
     */
    200: SettleOrderResponse;
};

export type PostApiV1OrdersByOrderIdSettleResponse = PostApiV1OrdersByOrderIdSettleResponses[keyof PostApiV1OrdersByOrderIdSettleResponses];

export type GetApiV1OrgPortalMeData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/org-portal/me';
};

export type GetApiV1OrgPortalMeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OrgPortalMeError = GetApiV1OrgPortalMeErrors[keyof GetApiV1OrgPortalMeErrors];

export type GetApiV1OrgPortalMeResponses = {
    /**
     * OK
     */
    200: OrganizationDetailDto;
};

export type GetApiV1OrgPortalMeResponse = GetApiV1OrgPortalMeResponses[keyof GetApiV1OrgPortalMeResponses];

export type GetApiV1OrgPortalMeEmployeesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/org-portal/me/employees';
};

export type GetApiV1OrgPortalMeEmployeesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OrgPortalMeEmployeesError = GetApiV1OrgPortalMeEmployeesErrors[keyof GetApiV1OrgPortalMeEmployeesErrors];

export type GetApiV1OrgPortalMeEmployeesResponses = {
    /**
     * OK
     */
    200: Array<OrganizationEmployeeDto>;
};

export type GetApiV1OrgPortalMeEmployeesResponse = GetApiV1OrgPortalMeEmployeesResponses[keyof GetApiV1OrgPortalMeEmployeesResponses];

export type PostApiV1OrgPortalMeEmployeesData = {
    body: AddEmployeeBody;
    path?: never;
    query?: never;
    url: '/api/v1/org-portal/me/employees';
};

export type PostApiV1OrgPortalMeEmployeesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1OrgPortalMeEmployeesError = PostApiV1OrgPortalMeEmployeesErrors[keyof PostApiV1OrgPortalMeEmployeesErrors];

export type PostApiV1OrgPortalMeEmployeesResponses = {
    /**
     * OK
     */
    200: AddEmployeeResponse;
};

export type PostApiV1OrgPortalMeEmployeesResponse = PostApiV1OrgPortalMeEmployeesResponses[keyof PostApiV1OrgPortalMeEmployeesResponses];

export type DeleteApiV1OrgPortalMeEmployeesByMemberIdData = {
    body?: never;
    path: {
        memberId: string;
    };
    query?: never;
    url: '/api/v1/org-portal/me/employees/{memberId}';
};

export type DeleteApiV1OrgPortalMeEmployeesByMemberIdResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PutApiV1OrgPortalMeEmployeesByMemberIdLimitData = {
    body: LimitBody;
    path: {
        memberId: string;
    };
    query?: never;
    url: '/api/v1/org-portal/me/employees/{memberId}/limit';
};

export type PutApiV1OrgPortalMeEmployeesByMemberIdLimitResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1OrgPortalMeEmployeesByMemberIdSuspendData = {
    body: SuspendBody;
    path: {
        memberId: string;
    };
    query?: never;
    url: '/api/v1/org-portal/me/employees/{memberId}/suspend';
};

export type PostApiV1OrgPortalMeEmployeesByMemberIdSuspendResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetApiV1OrgPortalMeStatementData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
        offset?: number;
    };
    url: '/api/v1/org-portal/me/statement';
};

export type GetApiV1OrgPortalMeStatementErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OrgPortalMeStatementError = GetApiV1OrgPortalMeStatementErrors[keyof GetApiV1OrgPortalMeStatementErrors];

export type GetApiV1OrgPortalMeStatementResponses = {
    /**
     * OK
     */
    200: Array<OrganizationTransactionDto>;
};

export type GetApiV1OrgPortalMeStatementResponse = GetApiV1OrgPortalMeStatementResponses[keyof GetApiV1OrgPortalMeStatementResponses];

export type GetApiV1OrgPortalMeStatementExportData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/org-portal/me/statement/export';
};

export type GetApiV1OrgPortalMeStatementExportResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1OrgPortalMeTopupData = {
    body: TopupBody;
    path?: never;
    query?: never;
    url: '/api/v1/org-portal/me/topup';
};

export type PostApiV1OrgPortalMeTopupErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1OrgPortalMeTopupError = PostApiV1OrgPortalMeTopupErrors[keyof PostApiV1OrgPortalMeTopupErrors];

export type PostApiV1OrgPortalMeTopupResponses = {
    /**
     * OK
     */
    200: TopupOrganizationResponse;
};

export type PostApiV1OrgPortalMeTopupResponse = PostApiV1OrgPortalMeTopupResponses[keyof PostApiV1OrgPortalMeTopupResponses];

export type GetApiV1OrganizationsData = {
    body?: never;
    path?: never;
    query?: {
        search?: string;
        limit?: number;
        offset?: number;
    };
    url: '/api/v1/organizations';
};

export type GetApiV1OrganizationsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OrganizationsError = GetApiV1OrganizationsErrors[keyof GetApiV1OrganizationsErrors];

export type GetApiV1OrganizationsResponses = {
    /**
     * OK
     */
    200: Array<OrganizationListItemDto>;
};

export type GetApiV1OrganizationsResponse = GetApiV1OrganizationsResponses[keyof GetApiV1OrganizationsResponses];

export type PostApiV1OrganizationsData = {
    body: CreateOrganizationCommand;
    path?: never;
    query?: never;
    url: '/api/v1/organizations';
};

export type PostApiV1OrganizationsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1OrganizationsError = PostApiV1OrganizationsErrors[keyof PostApiV1OrganizationsErrors];

export type PostApiV1OrganizationsResponses = {
    /**
     * Created
     */
    201: CreateOrganizationResponse;
};

export type PostApiV1OrganizationsResponse = PostApiV1OrganizationsResponses[keyof PostApiV1OrganizationsResponses];

export type GetApiV1OrganizationsOfClientByClientIdData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/organizations/of-client/{clientId}';
};

export type GetApiV1OrganizationsOfClientByClientIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OrganizationsOfClientByClientIdError = GetApiV1OrganizationsOfClientByClientIdErrors[keyof GetApiV1OrganizationsOfClientByClientIdErrors];

export type GetApiV1OrganizationsOfClientByClientIdResponses = {
    /**
     * OK
     */
    200: ClientOrganizationResponse;
};

export type GetApiV1OrganizationsOfClientByClientIdResponse = GetApiV1OrganizationsOfClientByClientIdResponses[keyof GetApiV1OrganizationsOfClientByClientIdResponses];

export type GetApiV1OrganizationsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}';
};

export type GetApiV1OrganizationsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OrganizationsByIdError = GetApiV1OrganizationsByIdErrors[keyof GetApiV1OrganizationsByIdErrors];

export type GetApiV1OrganizationsByIdResponses = {
    /**
     * OK
     */
    200: OrganizationDetailDto;
};

export type GetApiV1OrganizationsByIdResponse = GetApiV1OrganizationsByIdResponses[keyof GetApiV1OrganizationsByIdResponses];

export type PutApiV1OrganizationsByIdData = {
    body: UpdateOrganizationBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}';
};

export type PutApiV1OrganizationsByIdResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1OrganizationsByIdActiveData = {
    body: SetActiveBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/active';
};

export type PostApiV1OrganizationsByIdActiveResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetApiV1OrganizationsByIdAdminsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/admins';
};

export type GetApiV1OrganizationsByIdAdminsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OrganizationsByIdAdminsError = GetApiV1OrganizationsByIdAdminsErrors[keyof GetApiV1OrganizationsByIdAdminsErrors];

export type GetApiV1OrganizationsByIdAdminsResponses = {
    /**
     * OK
     */
    200: Array<OrganizationAdminDto>;
};

export type GetApiV1OrganizationsByIdAdminsResponse = GetApiV1OrganizationsByIdAdminsResponses[keyof GetApiV1OrganizationsByIdAdminsResponses];

export type PostApiV1OrganizationsByIdAdminsData = {
    body: ProvisionBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/admins';
};

export type PostApiV1OrganizationsByIdAdminsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1OrganizationsByIdAdminsError = PostApiV1OrganizationsByIdAdminsErrors[keyof PostApiV1OrganizationsByIdAdminsErrors];

export type PostApiV1OrganizationsByIdAdminsResponses = {
    /**
     * OK
     */
    200: ProvisionOrgAdminResponse;
};

export type PostApiV1OrganizationsByIdAdminsResponse = PostApiV1OrganizationsByIdAdminsResponses[keyof PostApiV1OrganizationsByIdAdminsResponses];

export type DeleteApiV1OrganizationsByIdAdminsByUserIdData = {
    body?: never;
    path: {
        id: string;
        userId: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/admins/{userId}';
};

export type DeleteApiV1OrganizationsByIdAdminsByUserIdResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1OrganizationsByIdCreditData = {
    body: CreditBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/credit';
};

export type PostApiV1OrganizationsByIdCreditErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1OrganizationsByIdCreditError = PostApiV1OrganizationsByIdCreditErrors[keyof PostApiV1OrganizationsByIdCreditErrors];

export type PostApiV1OrganizationsByIdCreditResponses = {
    /**
     * OK
     */
    200: OrganizationBalanceDto;
};

export type PostApiV1OrganizationsByIdCreditResponse = PostApiV1OrganizationsByIdCreditResponses[keyof PostApiV1OrganizationsByIdCreditResponses];

export type GetApiV1OrganizationsByIdEmployeesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/employees';
};

export type GetApiV1OrganizationsByIdEmployeesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OrganizationsByIdEmployeesError = GetApiV1OrganizationsByIdEmployeesErrors[keyof GetApiV1OrganizationsByIdEmployeesErrors];

export type GetApiV1OrganizationsByIdEmployeesResponses = {
    /**
     * OK
     */
    200: Array<OrganizationEmployeeDto>;
};

export type GetApiV1OrganizationsByIdEmployeesResponse = GetApiV1OrganizationsByIdEmployeesResponses[keyof GetApiV1OrganizationsByIdEmployeesResponses];

export type PostApiV1OrganizationsByIdEmployeesData = {
    body: AddEmployeeBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/employees';
};

export type PostApiV1OrganizationsByIdEmployeesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1OrganizationsByIdEmployeesError = PostApiV1OrganizationsByIdEmployeesErrors[keyof PostApiV1OrganizationsByIdEmployeesErrors];

export type PostApiV1OrganizationsByIdEmployeesResponses = {
    /**
     * OK
     */
    200: AddEmployeeResponse;
};

export type PostApiV1OrganizationsByIdEmployeesResponse = PostApiV1OrganizationsByIdEmployeesResponses[keyof PostApiV1OrganizationsByIdEmployeesResponses];

export type DeleteApiV1OrganizationsByIdEmployeesByMemberIdData = {
    body?: never;
    path: {
        id: string;
        memberId: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/employees/{memberId}';
};

export type DeleteApiV1OrganizationsByIdEmployeesByMemberIdResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PutApiV1OrganizationsByIdEmployeesByMemberIdLimitData = {
    body: LimitBody;
    path: {
        id: string;
        memberId: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/employees/{memberId}/limit';
};

export type PutApiV1OrganizationsByIdEmployeesByMemberIdLimitResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1OrganizationsByIdEmployeesByMemberIdSuspendData = {
    body: SuspendBody;
    path: {
        id: string;
        memberId: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/employees/{memberId}/suspend';
};

export type PostApiV1OrganizationsByIdEmployeesByMemberIdSuspendResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetApiV1OrganizationsByIdTransactionsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        limit?: number;
        offset?: number;
    };
    url: '/api/v1/organizations/{id}/transactions';
};

export type GetApiV1OrganizationsByIdTransactionsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1OrganizationsByIdTransactionsError = GetApiV1OrganizationsByIdTransactionsErrors[keyof GetApiV1OrganizationsByIdTransactionsErrors];

export type GetApiV1OrganizationsByIdTransactionsResponses = {
    /**
     * OK
     */
    200: Array<OrganizationTransactionDto>;
};

export type GetApiV1OrganizationsByIdTransactionsResponse = GetApiV1OrganizationsByIdTransactionsResponses[keyof GetApiV1OrganizationsByIdTransactionsResponses];

export type GetApiV1OrganizationsByIdTransactionsExportData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/transactions/export';
};

export type GetApiV1OrganizationsByIdTransactionsExportResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetApiV1PartnerRequestsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/partner-requests';
};

export type GetApiV1PartnerRequestsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PartnerRequestsError = GetApiV1PartnerRequestsErrors[keyof GetApiV1PartnerRequestsErrors];

export type GetApiV1PartnerRequestsResponses = {
    /**
     * OK
     */
    200: PartnerRequestsResponse;
};

export type GetApiV1PartnerRequestsResponse = GetApiV1PartnerRequestsResponses[keyof GetApiV1PartnerRequestsResponses];

export type PostApiV1PartnerRequestsData = {
    body: CreatePartnerRequestPayload;
    path?: never;
    query?: never;
    url: '/api/v1/partner-requests';
};

export type PostApiV1PartnerRequestsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PartnerRequestsError = PostApiV1PartnerRequestsErrors[keyof PostApiV1PartnerRequestsErrors];

export type PostApiV1PartnerRequestsResponses = {
    /**
     * Created
     */
    201: EntityIdResponse;
};

export type PostApiV1PartnerRequestsResponse = PostApiV1PartnerRequestsResponses[keyof PostApiV1PartnerRequestsResponses];

export type GetApiV1PartnerRequestsCountData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/partner-requests/count';
};

export type GetApiV1PartnerRequestsCountErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PartnerRequestsCountError = GetApiV1PartnerRequestsCountErrors[keyof GetApiV1PartnerRequestsCountErrors];

export type GetApiV1PartnerRequestsCountResponses = {
    /**
     * OK
     */
    200: PartnerRequestsCountResponse;
};

export type GetApiV1PartnerRequestsCountResponse = GetApiV1PartnerRequestsCountResponses[keyof GetApiV1PartnerRequestsCountResponses];

export type GetApiV1PartnerRequestsMineData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/partner-requests/mine';
};

export type GetApiV1PartnerRequestsMineErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PartnerRequestsMineError = GetApiV1PartnerRequestsMineErrors[keyof GetApiV1PartnerRequestsMineErrors];

export type GetApiV1PartnerRequestsMineResponses = {
    /**
     * OK
     */
    200: PartnerRequestsResponse;
};

export type GetApiV1PartnerRequestsMineResponse = GetApiV1PartnerRequestsMineResponses[keyof GetApiV1PartnerRequestsMineResponses];

export type DeleteApiV1PartnerRequestsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/partner-requests/{id}';
};

export type DeleteApiV1PartnerRequestsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1PartnerRequestsByIdError = DeleteApiV1PartnerRequestsByIdErrors[keyof DeleteApiV1PartnerRequestsByIdErrors];

export type DeleteApiV1PartnerRequestsByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1PartnerRequestsByIdResponse = DeleteApiV1PartnerRequestsByIdResponses[keyof DeleteApiV1PartnerRequestsByIdResponses];

export type PostApiV1PartnerRequestsByIdRespondData = {
    body?: null | RespondToPartnerRequestPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/partner-requests/{id}/respond';
};

export type PostApiV1PartnerRequestsByIdRespondErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PartnerRequestsByIdRespondError = PostApiV1PartnerRequestsByIdRespondErrors[keyof PostApiV1PartnerRequestsByIdRespondErrors];

export type PostApiV1PartnerRequestsByIdRespondResponses = {
    /**
     * OK
     */
    200: PartnerRequestRespondedResponse;
};

export type PostApiV1PartnerRequestsByIdRespondResponse = PostApiV1PartnerRequestsByIdRespondResponses[keyof PostApiV1PartnerRequestsByIdRespondResponses];

export type GetApiV1PartnerRequestsByIdRespondPlanData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        bonusKopecks?: number;
    };
    url: '/api/v1/partner-requests/{id}/respond-plan';
};

export type GetApiV1PartnerRequestsByIdRespondPlanErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PartnerRequestsByIdRespondPlanError = GetApiV1PartnerRequestsByIdRespondPlanErrors[keyof GetApiV1PartnerRequestsByIdRespondPlanErrors];

export type GetApiV1PartnerRequestsByIdRespondPlanResponses = {
    /**
     * OK
     */
    200: OrganizerSharePlanDto;
};

export type GetApiV1PartnerRequestsByIdRespondPlanResponse = GetApiV1PartnerRequestsByIdRespondPlanResponses[keyof GetApiV1PartnerRequestsByIdRespondPlanResponses];

export type PostApiV1PaymentsData = {
    body: CreatePaymentBody;
    path?: never;
    query?: never;
    url: '/api/v1/payments';
};

export type PostApiV1PaymentsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PaymentsError = PostApiV1PaymentsErrors[keyof PostApiV1PaymentsErrors];

export type PostApiV1PaymentsResponses = {
    /**
     * Created
     */
    201: CreatePaymentResponse;
};

export type PostApiV1PaymentsResponse = PostApiV1PaymentsResponses[keyof PostApiV1PaymentsResponses];

export type GetApiV1PaymentsMeChildRequestsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/payments/me/child-requests';
};

export type GetApiV1PaymentsMeChildRequestsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PaymentsMeChildRequestsError = GetApiV1PaymentsMeChildRequestsErrors[keyof GetApiV1PaymentsMeChildRequestsErrors];

export type GetApiV1PaymentsMeChildRequestsResponses = {
    /**
     * OK
     */
    200: Array<ChildChargeRequestItem>;
};

export type GetApiV1PaymentsMeChildRequestsResponse = GetApiV1PaymentsMeChildRequestsResponses[keyof GetApiV1PaymentsMeChildRequestsResponses];

export type GetApiV1PaymentsMePendingData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/payments/me/pending';
};

export type GetApiV1PaymentsMePendingErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PaymentsMePendingError = GetApiV1PaymentsMePendingErrors[keyof GetApiV1PaymentsMePendingErrors];

export type GetApiV1PaymentsMePendingResponses = {
    /**
     * OK
     */
    200: Array<PendingChargeListItem>;
};

export type GetApiV1PaymentsMePendingResponse = GetApiV1PaymentsMePendingResponses[keyof GetApiV1PaymentsMePendingResponses];

export type GetApiV1PaymentsOnlineReceiptsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/payments/online-receipts';
};

export type GetApiV1PaymentsOnlineReceiptsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PaymentsOnlineReceiptsError = GetApiV1PaymentsOnlineReceiptsErrors[keyof GetApiV1PaymentsOnlineReceiptsErrors];

export type GetApiV1PaymentsOnlineReceiptsResponses = {
    /**
     * OK
     */
    200: Array<OnlineReceiptAttentionDto>;
};

export type GetApiV1PaymentsOnlineReceiptsResponse = GetApiV1PaymentsOnlineReceiptsResponses[keyof GetApiV1PaymentsOnlineReceiptsResponses];

export type PostApiV1PaymentsPendingChargeData = {
    body: CreateDepositChargeBody;
    path?: never;
    query?: never;
    url: '/api/v1/payments/pending-charge';
};

export type PostApiV1PaymentsPendingChargeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PaymentsPendingChargeError = PostApiV1PaymentsPendingChargeErrors[keyof PostApiV1PaymentsPendingChargeErrors];

export type PostApiV1PaymentsPendingChargeResponses = {
    /**
     * Created
     */
    201: PendingChargeResult;
};

export type PostApiV1PaymentsPendingChargeResponse = PostApiV1PaymentsPendingChargeResponses[keyof PostApiV1PaymentsPendingChargeResponses];

export type PostApiV1PaymentsSplitDebtData = {
    body: CreateSplitDebtPaymentBody;
    path?: never;
    query?: never;
    url: '/api/v1/payments/split-debt';
};

export type PostApiV1PaymentsSplitDebtErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PaymentsSplitDebtError = PostApiV1PaymentsSplitDebtErrors[keyof PostApiV1PaymentsSplitDebtErrors];

export type PostApiV1PaymentsSplitDebtResponses = {
    /**
     * Created
     */
    201: CreateSplitDebtPaymentResponse;
};

export type PostApiV1PaymentsSplitDebtResponse = PostApiV1PaymentsSplitDebtResponses[keyof PostApiV1PaymentsSplitDebtResponses];

export type PostApiV1PaymentsSplitRemainderData = {
    body: CreateSplitRemainderPaymentBody;
    path?: never;
    query?: never;
    url: '/api/v1/payments/split-remainder';
};

export type PostApiV1PaymentsSplitRemainderErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PaymentsSplitRemainderError = PostApiV1PaymentsSplitRemainderErrors[keyof PostApiV1PaymentsSplitRemainderErrors];

export type PostApiV1PaymentsSplitRemainderResponses = {
    /**
     * Created
     */
    201: CreateSplitRemainderPaymentResponse;
};

export type PostApiV1PaymentsSplitRemainderResponse = PostApiV1PaymentsSplitRemainderResponses[keyof PostApiV1PaymentsSplitRemainderResponses];

export type PostApiV1PaymentsSplitShareData = {
    body: CreateSplitSharePaymentBody;
    path?: never;
    query?: never;
    url: '/api/v1/payments/split-share';
};

export type PostApiV1PaymentsSplitShareErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PaymentsSplitShareError = PostApiV1PaymentsSplitShareErrors[keyof PostApiV1PaymentsSplitShareErrors];

export type PostApiV1PaymentsSplitShareResponses = {
    /**
     * Created
     */
    201: CreateSplitSharePaymentResponse;
};

export type PostApiV1PaymentsSplitShareResponse = PostApiV1PaymentsSplitShareResponses[keyof PostApiV1PaymentsSplitShareResponses];

export type GetApiV1PaymentsTPayData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/payments/t-pay';
};

export type GetApiV1PaymentsTPayErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PaymentsTPayError = GetApiV1PaymentsTPayErrors[keyof GetApiV1PaymentsTPayErrors];

export type GetApiV1PaymentsTPayResponses = {
    /**
     * OK
     */
    200: TPayDto;
};

export type GetApiV1PaymentsTPayResponse = GetApiV1PaymentsTPayResponses[keyof GetApiV1PaymentsTPayResponses];

export type PostApiV1PaymentsWebhookCloudpaymentsByTokenReceiptData = {
    body?: never;
    path: {
        token: string;
    };
    query?: never;
    url: '/api/v1/payments/webhook/cloudpayments/{token}/receipt';
};

export type PostApiV1PaymentsWebhookCloudpaymentsByTokenReceiptErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PaymentsWebhookCloudpaymentsByTokenReceiptError = PostApiV1PaymentsWebhookCloudpaymentsByTokenReceiptErrors[keyof PostApiV1PaymentsWebhookCloudpaymentsByTokenReceiptErrors];

export type PostApiV1PaymentsWebhookByProviderData = {
    body?: never;
    path: {
        provider: string;
    };
    query?: never;
    url: '/api/v1/payments/webhook/{provider}';
};

export type PostApiV1PaymentsWebhookByProviderErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PaymentsWebhookByProviderError = PostApiV1PaymentsWebhookByProviderErrors[keyof PostApiV1PaymentsWebhookByProviderErrors];

export type PostApiV1PaymentsWebhookByProviderByTokenData = {
    body?: never;
    path: {
        provider: string;
        token: string;
    };
    query?: never;
    url: '/api/v1/payments/webhook/{provider}/{token}';
};

export type PostApiV1PaymentsWebhookByProviderByTokenErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PaymentsWebhookByProviderByTokenError = PostApiV1PaymentsWebhookByProviderByTokenErrors[keyof PostApiV1PaymentsWebhookByProviderByTokenErrors];

export type GetApiV1PaymentsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/payments/{id}';
};

export type GetApiV1PaymentsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PaymentsByIdError = GetApiV1PaymentsByIdErrors[keyof GetApiV1PaymentsByIdErrors];

export type GetApiV1PaymentsByIdResponses = {
    /**
     * OK
     */
    200: PaymentDetailDto;
};

export type GetApiV1PaymentsByIdResponse = GetApiV1PaymentsByIdResponses[keyof GetApiV1PaymentsByIdResponses];

export type PostApiV1PaymentsByIdApproveChildData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/payments/{id}/approve-child';
};

export type PostApiV1PaymentsByIdApproveChildErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PaymentsByIdApproveChildError = PostApiV1PaymentsByIdApproveChildErrors[keyof PostApiV1PaymentsByIdApproveChildErrors];

export type PostApiV1PaymentsByIdApproveChildResponses = {
    /**
     * OK
     */
    200: ApproveChildChargeResponse;
};

export type PostApiV1PaymentsByIdApproveChildResponse = PostApiV1PaymentsByIdApproveChildResponses[keyof PostApiV1PaymentsByIdApproveChildResponses];

export type PostApiV1PaymentsByIdCancelData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/payments/{id}/cancel';
};

export type PostApiV1PaymentsByIdCancelErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PaymentsByIdCancelError = PostApiV1PaymentsByIdCancelErrors[keyof PostApiV1PaymentsByIdCancelErrors];

export type PostApiV1PaymentsByIdCancelResponses = {
    /**
     * OK
     */
    200: CancelPendingChargeResponse;
};

export type PostApiV1PaymentsByIdCancelResponse = PostApiV1PaymentsByIdCancelResponses[keyof PostApiV1PaymentsByIdCancelResponses];

export type PostApiV1PaymentsByIdDeclineChildData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/payments/{id}/decline-child';
};

export type PostApiV1PaymentsByIdDeclineChildErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PaymentsByIdDeclineChildError = PostApiV1PaymentsByIdDeclineChildErrors[keyof PostApiV1PaymentsByIdDeclineChildErrors];

export type PostApiV1PaymentsByIdDeclineChildResponses = {
    /**
     * OK
     */
    200: DeclineChildChargeResponse;
};

export type PostApiV1PaymentsByIdDeclineChildResponse = PostApiV1PaymentsByIdDeclineChildResponses[keyof PostApiV1PaymentsByIdDeclineChildResponses];

export type PostApiV1PaymentsByIdOnlineReceiptReissueData = {
    body: ReissueOnlineReceiptBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/payments/{id}/online-receipt/reissue';
};

export type PostApiV1PaymentsByIdOnlineReceiptReissueErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PaymentsByIdOnlineReceiptReissueError = PostApiV1PaymentsByIdOnlineReceiptReissueErrors[keyof PostApiV1PaymentsByIdOnlineReceiptReissueErrors];

export type PostApiV1PaymentsByIdOnlineReceiptReissueResponses = {
    /**
     * OK
     */
    200: OnlineReceiptReissuedDto;
};

export type PostApiV1PaymentsByIdOnlineReceiptReissueResponse = PostApiV1PaymentsByIdOnlineReceiptReissueResponses[keyof PostApiV1PaymentsByIdOnlineReceiptReissueResponses];

export type PostApiV1PaymentsByIdPayFromAdvanceData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/payments/{id}/pay-from-advance';
};

export type PostApiV1PaymentsByIdPayFromAdvanceErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PaymentsByIdPayFromAdvanceError = PostApiV1PaymentsByIdPayFromAdvanceErrors[keyof PostApiV1PaymentsByIdPayFromAdvanceErrors];

export type PostApiV1PaymentsByIdPayFromAdvanceResponses = {
    /**
     * OK
     */
    200: PayChargeFromAdvanceResponse;
};

export type PostApiV1PaymentsByIdPayFromAdvanceResponse = PostApiV1PaymentsByIdPayFromAdvanceResponses[keyof PostApiV1PaymentsByIdPayFromAdvanceResponses];

export type PostApiV1PaymentsByIdPayFromCorporateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/payments/{id}/pay-from-corporate';
};

export type PostApiV1PaymentsByIdPayFromCorporateErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PaymentsByIdPayFromCorporateError = PostApiV1PaymentsByIdPayFromCorporateErrors[keyof PostApiV1PaymentsByIdPayFromCorporateErrors];

export type PostApiV1PaymentsByIdPayFromCorporateResponses = {
    /**
     * OK
     */
    200: PayChargeFromCorporateResponse;
};

export type PostApiV1PaymentsByIdPayFromCorporateResponse = PostApiV1PaymentsByIdPayFromCorporateResponses[keyof PostApiV1PaymentsByIdPayFromCorporateResponses];

export type GetApiV1PaymentsByIdPendingChargeData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/payments/{id}/pending-charge';
};

export type GetApiV1PaymentsByIdPendingChargeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PaymentsByIdPendingChargeError = GetApiV1PaymentsByIdPendingChargeErrors[keyof GetApiV1PaymentsByIdPendingChargeErrors];

export type GetApiV1PaymentsByIdPendingChargeResponses = {
    /**
     * OK
     */
    200: PendingChargeDto;
};

export type GetApiV1PaymentsByIdPendingChargeResponse = GetApiV1PaymentsByIdPendingChargeResponses[keyof GetApiV1PaymentsByIdPendingChargeResponses];

export type PostApiV1PaymentsByIdTPayLinkData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/payments/{id}/t-pay-link';
};

export type PostApiV1PaymentsByIdTPayLinkErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PaymentsByIdTPayLinkError = PostApiV1PaymentsByIdTPayLinkErrors[keyof PostApiV1PaymentsByIdTPayLinkErrors];

export type PostApiV1PaymentsByIdTPayLinkResponses = {
    /**
     * OK
     */
    200: TPayLinkDto;
};

export type PostApiV1PaymentsByIdTPayLinkResponse = PostApiV1PaymentsByIdTPayLinkResponses[keyof PostApiV1PaymentsByIdTPayLinkResponses];

export type GetApiV1PlatformAcquiringData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/platform/acquiring';
};

export type GetApiV1PlatformAcquiringErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PlatformAcquiringError = GetApiV1PlatformAcquiringErrors[keyof GetApiV1PlatformAcquiringErrors];

export type GetApiV1PlatformAcquiringResponses = {
    /**
     * OK
     */
    200: PlatformAcquiringDto;
};

export type GetApiV1PlatformAcquiringResponse = GetApiV1PlatformAcquiringResponses[keyof GetApiV1PlatformAcquiringResponses];

export type PutApiV1PlatformAcquiringData = {
    body: UpdatePlatformAcquiringRequest;
    path?: never;
    query?: never;
    url: '/api/v1/platform/acquiring';
};

export type PutApiV1PlatformAcquiringErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1PlatformAcquiringError = PutApiV1PlatformAcquiringErrors[keyof PutApiV1PlatformAcquiringErrors];

export type PutApiV1PlatformAcquiringResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1PlatformAcquiringResponse = PutApiV1PlatformAcquiringResponses[keyof PutApiV1PlatformAcquiringResponses];

export type GetApiV1PlatformAuditData = {
    body?: never;
    path?: never;
    query?: {
        action?: string;
        userId?: string;
        entityId?: string;
        from?: string;
        to?: string;
        cursor?: string;
        limit?: number;
    };
    url: '/api/v1/platform/audit';
};

export type GetApiV1PlatformAuditErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PlatformAuditError = GetApiV1PlatformAuditErrors[keyof GetApiV1PlatformAuditErrors];

export type GetApiV1PlatformAuditResponses = {
    /**
     * OK
     */
    200: PlatformAuditResponse;
};

export type GetApiV1PlatformAuditResponse = GetApiV1PlatformAuditResponses[keyof GetApiV1PlatformAuditResponses];

export type GetApiV1PlatformBillingAwaitingTransferData = {
    body?: never;
    path?: never;
    query?: {
        search?: string;
    };
    url: '/api/v1/platform/billing/awaiting-transfer';
};

export type GetApiV1PlatformBillingAwaitingTransferErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PlatformBillingAwaitingTransferError = GetApiV1PlatformBillingAwaitingTransferErrors[keyof GetApiV1PlatformBillingAwaitingTransferErrors];

export type GetApiV1PlatformBillingAwaitingTransferResponses = {
    /**
     * OK
     */
    200: AwaitingTransferInvoicesDto;
};

export type GetApiV1PlatformBillingAwaitingTransferResponse = GetApiV1PlatformBillingAwaitingTransferResponses[keyof GetApiV1PlatformBillingAwaitingTransferResponses];

export type GetApiV1PlatformBillingIncidentsData = {
    body?: never;
    path?: never;
    query?: {
        includeResolved?: boolean;
    };
    url: '/api/v1/platform/billing/incidents';
};

export type GetApiV1PlatformBillingIncidentsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PlatformBillingIncidentsError = GetApiV1PlatformBillingIncidentsErrors[keyof GetApiV1PlatformBillingIncidentsErrors];

export type GetApiV1PlatformBillingIncidentsResponses = {
    /**
     * OK
     */
    200: PaymentIncidentsDto;
};

export type GetApiV1PlatformBillingIncidentsResponse = GetApiV1PlatformBillingIncidentsResponses[keyof GetApiV1PlatformBillingIncidentsResponses];

export type PostApiV1PlatformBillingIncidentsByIncidentIdResolveData = {
    body: ResolvePaymentIncidentRequest;
    path: {
        incidentId: string;
    };
    query?: never;
    url: '/api/v1/platform/billing/incidents/{incidentId}/resolve';
};

export type PostApiV1PlatformBillingIncidentsByIncidentIdResolveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformBillingIncidentsByIncidentIdResolveError = PostApiV1PlatformBillingIncidentsByIncidentIdResolveErrors[keyof PostApiV1PlatformBillingIncidentsByIncidentIdResolveErrors];

export type PostApiV1PlatformBillingIncidentsByIncidentIdResolveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformBillingIncidentsByIncidentIdResolveResponse = PostApiV1PlatformBillingIncidentsByIncidentIdResolveResponses[keyof PostApiV1PlatformBillingIncidentsByIncidentIdResolveResponses];

export type PostApiV1PlatformBillingInvoicesByInvoiceIdReissueDocumentData = {
    body?: never;
    path: {
        invoiceId: string;
    };
    query?: never;
    url: '/api/v1/platform/billing/invoices/{invoiceId}/reissue-document';
};

export type PostApiV1PlatformBillingInvoicesByInvoiceIdReissueDocumentErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformBillingInvoicesByInvoiceIdReissueDocumentError = PostApiV1PlatformBillingInvoicesByInvoiceIdReissueDocumentErrors[keyof PostApiV1PlatformBillingInvoicesByInvoiceIdReissueDocumentErrors];

export type PostApiV1PlatformBillingInvoicesByInvoiceIdReissueDocumentResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformBillingInvoicesByInvoiceIdReissueDocumentResponse = PostApiV1PlatformBillingInvoicesByInvoiceIdReissueDocumentResponses[keyof PostApiV1PlatformBillingInvoicesByInvoiceIdReissueDocumentResponses];

export type PostApiV1PlatformBillingInvoicesByInvoiceIdSettleData = {
    body?: never;
    path: {
        invoiceId: string;
    };
    query?: never;
    url: '/api/v1/platform/billing/invoices/{invoiceId}/settle';
};

export type PostApiV1PlatformBillingInvoicesByInvoiceIdSettleErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformBillingInvoicesByInvoiceIdSettleError = PostApiV1PlatformBillingInvoicesByInvoiceIdSettleErrors[keyof PostApiV1PlatformBillingInvoicesByInvoiceIdSettleErrors];

export type PostApiV1PlatformBillingInvoicesByInvoiceIdSettleResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformBillingInvoicesByInvoiceIdSettleResponse = PostApiV1PlatformBillingInvoicesByInvoiceIdSettleResponses[keyof PostApiV1PlatformBillingInvoicesByInvoiceIdSettleResponses];

export type PostApiV1PlatformBillingInvoicesByInvoiceIdSettleTransferData = {
    body: SettleInvoiceByTransferRequest;
    path: {
        invoiceId: string;
    };
    query?: never;
    url: '/api/v1/platform/billing/invoices/{invoiceId}/settle-transfer';
};

export type PostApiV1PlatformBillingInvoicesByInvoiceIdSettleTransferErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformBillingInvoicesByInvoiceIdSettleTransferError = PostApiV1PlatformBillingInvoicesByInvoiceIdSettleTransferErrors[keyof PostApiV1PlatformBillingInvoicesByInvoiceIdSettleTransferErrors];

export type PostApiV1PlatformBillingInvoicesByInvoiceIdSettleTransferResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformBillingInvoicesByInvoiceIdSettleTransferResponse = PostApiV1PlatformBillingInvoicesByInvoiceIdSettleTransferResponses[keyof PostApiV1PlatformBillingInvoicesByInvoiceIdSettleTransferResponses];

export type PostApiV1PlatformBillingInvoicesByInvoiceIdVoidData = {
    body?: never;
    path: {
        invoiceId: string;
    };
    query?: never;
    url: '/api/v1/platform/billing/invoices/{invoiceId}/void';
};

export type PostApiV1PlatformBillingInvoicesByInvoiceIdVoidErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformBillingInvoicesByInvoiceIdVoidError = PostApiV1PlatformBillingInvoicesByInvoiceIdVoidErrors[keyof PostApiV1PlatformBillingInvoicesByInvoiceIdVoidErrors];

export type PostApiV1PlatformBillingInvoicesByInvoiceIdVoidResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformBillingInvoicesByInvoiceIdVoidResponse = PostApiV1PlatformBillingInvoicesByInvoiceIdVoidResponses[keyof PostApiV1PlatformBillingInvoicesByInvoiceIdVoidResponses];

export type GetApiV1PlatformBillingReceiptsData = {
    body?: never;
    path?: never;
    query?: {
        includeResolved?: boolean;
    };
    url: '/api/v1/platform/billing/receipts';
};

export type GetApiV1PlatformBillingReceiptsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PlatformBillingReceiptsError = GetApiV1PlatformBillingReceiptsErrors[keyof GetApiV1PlatformBillingReceiptsErrors];

export type GetApiV1PlatformBillingReceiptsResponses = {
    /**
     * OK
     */
    200: PlatformReceiptsDto;
};

export type GetApiV1PlatformBillingReceiptsResponse = GetApiV1PlatformBillingReceiptsResponses[keyof GetApiV1PlatformBillingReceiptsResponses];

export type PostApiV1PlatformBillingReceiptsByReceiptIdResolveData = {
    body: ResolvePlatformReceiptRequest;
    path: {
        receiptId: string;
    };
    query?: never;
    url: '/api/v1/platform/billing/receipts/{receiptId}/resolve';
};

export type PostApiV1PlatformBillingReceiptsByReceiptIdResolveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformBillingReceiptsByReceiptIdResolveError = PostApiV1PlatformBillingReceiptsByReceiptIdResolveErrors[keyof PostApiV1PlatformBillingReceiptsByReceiptIdResolveErrors];

export type PostApiV1PlatformBillingReceiptsByReceiptIdResolveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformBillingReceiptsByReceiptIdResolveResponse = PostApiV1PlatformBillingReceiptsByReceiptIdResolveResponses[keyof PostApiV1PlatformBillingReceiptsByReceiptIdResolveResponses];

export type GetApiV1PlatformDashboardData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/platform/dashboard';
};

export type GetApiV1PlatformDashboardErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PlatformDashboardError = GetApiV1PlatformDashboardErrors[keyof GetApiV1PlatformDashboardErrors];

export type GetApiV1PlatformDashboardResponses = {
    /**
     * OK
     */
    200: PlatformDashboardDto;
};

export type GetApiV1PlatformDashboardResponse = GetApiV1PlatformDashboardResponses[keyof GetApiV1PlatformDashboardResponses];

export type PostApiV1PlatformImpersonationExitData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/platform/impersonation/exit';
};

export type PostApiV1PlatformImpersonationExitErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformImpersonationExitError = PostApiV1PlatformImpersonationExitErrors[keyof PostApiV1PlatformImpersonationExitErrors];

export type PostApiV1PlatformImpersonationExitResponses = {
    /**
     * OK
     */
    200: ImpersonationExitResponse;
};

export type PostApiV1PlatformImpersonationExitResponse = PostApiV1PlatformImpersonationExitResponses[keyof PostApiV1PlatformImpersonationExitResponses];

export type PostApiV1PlatformMetricsSnapshotData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/platform/metrics/snapshot';
};

export type PostApiV1PlatformMetricsSnapshotResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetApiV1PlatformOutboxDeadLettersData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
    };
    url: '/api/v1/platform/outbox/dead-letters';
};

export type GetApiV1PlatformOutboxDeadLettersErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PlatformOutboxDeadLettersError = GetApiV1PlatformOutboxDeadLettersErrors[keyof GetApiV1PlatformOutboxDeadLettersErrors];

export type GetApiV1PlatformOutboxDeadLettersResponses = {
    /**
     * OK
     */
    200: OutboxDeadLettersResponse;
};

export type GetApiV1PlatformOutboxDeadLettersResponse = GetApiV1PlatformOutboxDeadLettersResponses[keyof GetApiV1PlatformOutboxDeadLettersResponses];

export type PostApiV1PlatformOutboxDeadLettersRequeueAllData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/platform/outbox/dead-letters/requeue-all';
};

export type PostApiV1PlatformOutboxDeadLettersRequeueAllErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformOutboxDeadLettersRequeueAllError = PostApiV1PlatformOutboxDeadLettersRequeueAllErrors[keyof PostApiV1PlatformOutboxDeadLettersRequeueAllErrors];

export type PostApiV1PlatformOutboxDeadLettersRequeueAllResponses = {
    /**
     * OK
     */
    200: RequeueOutboxResponse;
};

export type PostApiV1PlatformOutboxDeadLettersRequeueAllResponse = PostApiV1PlatformOutboxDeadLettersRequeueAllResponses[keyof PostApiV1PlatformOutboxDeadLettersRequeueAllResponses];

export type PostApiV1PlatformOutboxDeadLettersByIdRequeueData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/outbox/dead-letters/{id}/requeue';
};

export type PostApiV1PlatformOutboxDeadLettersByIdRequeueErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformOutboxDeadLettersByIdRequeueError = PostApiV1PlatformOutboxDeadLettersByIdRequeueErrors[keyof PostApiV1PlatformOutboxDeadLettersByIdRequeueErrors];

export type PostApiV1PlatformOutboxDeadLettersByIdRequeueResponses = {
    /**
     * OK
     */
    200: RequeueOutboxResponse;
};

export type PostApiV1PlatformOutboxDeadLettersByIdRequeueResponse = PostApiV1PlatformOutboxDeadLettersByIdRequeueResponses[keyof PostApiV1PlatformOutboxDeadLettersByIdRequeueResponses];

export type GetApiV1PlatformPlansData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/platform/plans';
};

export type GetApiV1PlatformPlansErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PlatformPlansError = GetApiV1PlatformPlansErrors[keyof GetApiV1PlatformPlansErrors];

export type GetApiV1PlatformPlansResponses = {
    /**
     * OK
     */
    200: PlatformPlansDto;
};

export type GetApiV1PlatformPlansResponse = GetApiV1PlatformPlansResponses[keyof GetApiV1PlatformPlansResponses];

export type PostApiV1PlatformPlansData = {
    body: CreatePlatformPlanRequest;
    path?: never;
    query?: never;
    url: '/api/v1/platform/plans';
};

export type PostApiV1PlatformPlansErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformPlansError = PostApiV1PlatformPlansErrors[keyof PostApiV1PlatformPlansErrors];

export type PostApiV1PlatformPlansResponses = {
    /**
     * OK
     */
    200: PlatformPlanDto;
};

export type PostApiV1PlatformPlansResponse = PostApiV1PlatformPlansResponses[keyof PostApiV1PlatformPlansResponses];

export type PatchApiV1PlatformPlansByIdData = {
    body: UpdatePlatformPlanRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/plans/{id}';
};

export type PatchApiV1PlatformPlansByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1PlatformPlansByIdError = PatchApiV1PlatformPlansByIdErrors[keyof PatchApiV1PlatformPlansByIdErrors];

export type PatchApiV1PlatformPlansByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PlatformPlansByIdResponse = PatchApiV1PlatformPlansByIdResponses[keyof PatchApiV1PlatformPlansByIdResponses];

export type PostApiV1PlatformPlansByIdArchiveData = {
    body: PlatformPlanReasonRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/plans/{id}/archive';
};

export type PostApiV1PlatformPlansByIdArchiveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformPlansByIdArchiveError = PostApiV1PlatformPlansByIdArchiveErrors[keyof PostApiV1PlatformPlansByIdArchiveErrors];

export type PostApiV1PlatformPlansByIdArchiveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformPlansByIdArchiveResponse = PostApiV1PlatformPlansByIdArchiveResponses[keyof PostApiV1PlatformPlansByIdArchiveResponses];

export type PostApiV1PlatformPlansByIdSignupDefaultData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/plans/{id}/signup-default';
};

export type PostApiV1PlatformPlansByIdSignupDefaultErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformPlansByIdSignupDefaultError = PostApiV1PlatformPlansByIdSignupDefaultErrors[keyof PostApiV1PlatformPlansByIdSignupDefaultErrors];

export type PostApiV1PlatformPlansByIdSignupDefaultResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformPlansByIdSignupDefaultResponse = PostApiV1PlatformPlansByIdSignupDefaultResponses[keyof PostApiV1PlatformPlansByIdSignupDefaultResponses];

export type PostApiV1PlatformPlansByIdUnarchiveData = {
    body: PlatformPlanReasonRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/plans/{id}/unarchive';
};

export type PostApiV1PlatformPlansByIdUnarchiveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformPlansByIdUnarchiveError = PostApiV1PlatformPlansByIdUnarchiveErrors[keyof PostApiV1PlatformPlansByIdUnarchiveErrors];

export type PostApiV1PlatformPlansByIdUnarchiveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformPlansByIdUnarchiveResponse = PostApiV1PlatformPlansByIdUnarchiveResponses[keyof PostApiV1PlatformPlansByIdUnarchiveResponses];

export type GetApiV1PlatformRequisitesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/platform/requisites';
};

export type GetApiV1PlatformRequisitesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PlatformRequisitesError = GetApiV1PlatformRequisitesErrors[keyof GetApiV1PlatformRequisitesErrors];

export type GetApiV1PlatformRequisitesResponses = {
    /**
     * OK
     */
    200: PlatformRequisitesDto;
};

export type GetApiV1PlatformRequisitesResponse = GetApiV1PlatformRequisitesResponses[keyof GetApiV1PlatformRequisitesResponses];

export type PutApiV1PlatformRequisitesData = {
    body: UpdatePlatformRequisitesRequest;
    path?: never;
    query?: never;
    url: '/api/v1/platform/requisites';
};

export type PutApiV1PlatformRequisitesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1PlatformRequisitesError = PutApiV1PlatformRequisitesErrors[keyof PutApiV1PlatformRequisitesErrors];

export type PutApiV1PlatformRequisitesResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1PlatformRequisitesResponse = PutApiV1PlatformRequisitesResponses[keyof PutApiV1PlatformRequisitesResponses];

export type GetApiV1PlatformTenantsData = {
    body?: never;
    path?: never;
    query?: {
        search?: string;
        status?: string;
        plan?: string;
        limit?: number;
        offset?: number;
    };
    url: '/api/v1/platform/tenants';
};

export type GetApiV1PlatformTenantsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PlatformTenantsError = GetApiV1PlatformTenantsErrors[keyof GetApiV1PlatformTenantsErrors];

export type GetApiV1PlatformTenantsResponses = {
    /**
     * OK
     */
    200: Array<TenantListItemDto>;
};

export type GetApiV1PlatformTenantsResponse = GetApiV1PlatformTenantsResponses[keyof GetApiV1PlatformTenantsResponses];

export type PostApiV1PlatformTenantsData = {
    body: CreateTenantRequest;
    path?: never;
    query?: never;
    url: '/api/v1/platform/tenants';
};

export type PostApiV1PlatformTenantsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsError = PostApiV1PlatformTenantsErrors[keyof PostApiV1PlatformTenantsErrors];

export type PostApiV1PlatformTenantsResponses = {
    /**
     * OK
     */
    200: CreateTenantResult;
};

export type PostApiV1PlatformTenantsResponse = PostApiV1PlatformTenantsResponses[keyof PostApiV1PlatformTenantsResponses];

export type GetApiV1PlatformTenantsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}';
};

export type GetApiV1PlatformTenantsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PlatformTenantsByIdError = GetApiV1PlatformTenantsByIdErrors[keyof GetApiV1PlatformTenantsByIdErrors];

export type GetApiV1PlatformTenantsByIdResponses = {
    /**
     * OK
     */
    200: TenantDetailDto;
};

export type GetApiV1PlatformTenantsByIdResponse = GetApiV1PlatformTenantsByIdResponses[keyof GetApiV1PlatformTenantsByIdResponses];

export type PostApiV1PlatformTenantsByIdArchiveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/archive';
};

export type PostApiV1PlatformTenantsByIdArchiveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsByIdArchiveError = PostApiV1PlatformTenantsByIdArchiveErrors[keyof PostApiV1PlatformTenantsByIdArchiveErrors];

export type PostApiV1PlatformTenantsByIdArchiveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformTenantsByIdArchiveResponse = PostApiV1PlatformTenantsByIdArchiveResponses[keyof PostApiV1PlatformTenantsByIdArchiveResponses];

export type GetApiV1PlatformTenantsByIdBillingData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/billing';
};

export type GetApiV1PlatformTenantsByIdBillingErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PlatformTenantsByIdBillingError = GetApiV1PlatformTenantsByIdBillingErrors[keyof GetApiV1PlatformTenantsByIdBillingErrors];

export type GetApiV1PlatformTenantsByIdBillingResponses = {
    /**
     * OK
     */
    200: TenantBillingDto;
};

export type GetApiV1PlatformTenantsByIdBillingResponse = GetApiV1PlatformTenantsByIdBillingResponses[keyof GetApiV1PlatformTenantsByIdBillingResponses];

export type PostApiV1PlatformTenantsByIdBillingInvoiceData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/billing/invoice';
};

export type PostApiV1PlatformTenantsByIdBillingInvoiceErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsByIdBillingInvoiceError = PostApiV1PlatformTenantsByIdBillingInvoiceErrors[keyof PostApiV1PlatformTenantsByIdBillingInvoiceErrors];

export type PostApiV1PlatformTenantsByIdBillingInvoiceResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformTenantsByIdBillingInvoiceResponse = PostApiV1PlatformTenantsByIdBillingInvoiceResponses[keyof PostApiV1PlatformTenantsByIdBillingInvoiceResponses];

export type PostApiV1PlatformTenantsByIdChangePlanData = {
    body: ChangePlanRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/change-plan';
};

export type PostApiV1PlatformTenantsByIdChangePlanErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsByIdChangePlanError = PostApiV1PlatformTenantsByIdChangePlanErrors[keyof PostApiV1PlatformTenantsByIdChangePlanErrors];

export type PostApiV1PlatformTenantsByIdChangePlanResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformTenantsByIdChangePlanResponse = PostApiV1PlatformTenantsByIdChangePlanResponses[keyof PostApiV1PlatformTenantsByIdChangePlanResponses];

export type PostApiV1PlatformTenantsByIdClientsSearchData = {
    body: FindDeletedClubClientRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/clients/search';
};

export type PostApiV1PlatformTenantsByIdClientsSearchErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsByIdClientsSearchError = PostApiV1PlatformTenantsByIdClientsSearchErrors[keyof PostApiV1PlatformTenantsByIdClientsSearchErrors];

export type PostApiV1PlatformTenantsByIdClientsSearchResponses = {
    /**
     * OK
     */
    200: Array<ErasureCandidate>;
};

export type PostApiV1PlatformTenantsByIdClientsSearchResponse = PostApiV1PlatformTenantsByIdClientsSearchResponses[keyof PostApiV1PlatformTenantsByIdClientsSearchResponses];

export type PostApiV1PlatformTenantsByIdClientsByClientIdForgetData = {
    body: ForgetDeletedClubClientRequest;
    path: {
        id: string;
        clientId: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/clients/{clientId}/forget';
};

export type PostApiV1PlatformTenantsByIdClientsByClientIdForgetErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsByIdClientsByClientIdForgetError = PostApiV1PlatformTenantsByIdClientsByClientIdForgetErrors[keyof PostApiV1PlatformTenantsByIdClientsByClientIdForgetErrors];

export type PostApiV1PlatformTenantsByIdClientsByClientIdForgetResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformTenantsByIdClientsByClientIdForgetResponse = PostApiV1PlatformTenantsByIdClientsByClientIdForgetResponses[keyof PostApiV1PlatformTenantsByIdClientsByClientIdForgetResponses];

export type PostApiV1PlatformTenantsByIdDeleteData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/delete';
};

export type PostApiV1PlatformTenantsByIdDeleteErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsByIdDeleteError = PostApiV1PlatformTenantsByIdDeleteErrors[keyof PostApiV1PlatformTenantsByIdDeleteErrors];

export type PostApiV1PlatformTenantsByIdDeleteResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformTenantsByIdDeleteResponse = PostApiV1PlatformTenantsByIdDeleteResponses[keyof PostApiV1PlatformTenantsByIdDeleteResponses];

export type GetApiV1PlatformTenantsByIdExportData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/export';
};

export type GetApiV1PlatformTenantsByIdExportResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostApiV1PlatformTenantsByIdExtendTrialData = {
    body: ExtendTrialRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/extend-trial';
};

export type PostApiV1PlatformTenantsByIdExtendTrialErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsByIdExtendTrialError = PostApiV1PlatformTenantsByIdExtendTrialErrors[keyof PostApiV1PlatformTenantsByIdExtendTrialErrors];

export type PostApiV1PlatformTenantsByIdExtendTrialResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformTenantsByIdExtendTrialResponse = PostApiV1PlatformTenantsByIdExtendTrialResponses[keyof PostApiV1PlatformTenantsByIdExtendTrialResponses];

export type PostApiV1PlatformTenantsByIdImpersonateData = {
    body: ImpersonateTenantRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/impersonate';
};

export type PostApiV1PlatformTenantsByIdImpersonateErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsByIdImpersonateError = PostApiV1PlatformTenantsByIdImpersonateErrors[keyof PostApiV1PlatformTenantsByIdImpersonateErrors];

export type PostApiV1PlatformTenantsByIdImpersonateResponses = {
    /**
     * OK
     */
    200: ImpersonationResponse;
};

export type PostApiV1PlatformTenantsByIdImpersonateResponse = PostApiV1PlatformTenantsByIdImpersonateResponses[keyof PostApiV1PlatformTenantsByIdImpersonateResponses];

export type PostApiV1PlatformTenantsByIdJoinCodeData = {
    body: AssignClubJoinCodeRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/join-code';
};

export type PostApiV1PlatformTenantsByIdJoinCodeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsByIdJoinCodeError = PostApiV1PlatformTenantsByIdJoinCodeErrors[keyof PostApiV1PlatformTenantsByIdJoinCodeErrors];

export type PostApiV1PlatformTenantsByIdJoinCodeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformTenantsByIdJoinCodeResponse = PostApiV1PlatformTenantsByIdJoinCodeResponses[keyof PostApiV1PlatformTenantsByIdJoinCodeResponses];

export type GetApiV1PlatformTenantsByIdLimitsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/limits';
};

export type GetApiV1PlatformTenantsByIdLimitsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PlatformTenantsByIdLimitsError = GetApiV1PlatformTenantsByIdLimitsErrors[keyof GetApiV1PlatformTenantsByIdLimitsErrors];

export type GetApiV1PlatformTenantsByIdLimitsResponses = {
    /**
     * OK
     */
    200: TenantLimitsDto;
};

export type GetApiV1PlatformTenantsByIdLimitsResponse = GetApiV1PlatformTenantsByIdLimitsResponses[keyof GetApiV1PlatformTenantsByIdLimitsResponses];

export type PatchApiV1PlatformTenantsByIdLimitsData = {
    body: SetTenantLimitsRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/limits';
};

export type PatchApiV1PlatformTenantsByIdLimitsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1PlatformTenantsByIdLimitsError = PatchApiV1PlatformTenantsByIdLimitsErrors[keyof PatchApiV1PlatformTenantsByIdLimitsErrors];

export type PatchApiV1PlatformTenantsByIdLimitsResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PlatformTenantsByIdLimitsResponse = PatchApiV1PlatformTenantsByIdLimitsResponses[keyof PatchApiV1PlatformTenantsByIdLimitsResponses];

export type GetApiV1PlatformTenantsByIdMembersData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/members';
};

export type GetApiV1PlatformTenantsByIdMembersErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PlatformTenantsByIdMembersError = GetApiV1PlatformTenantsByIdMembersErrors[keyof GetApiV1PlatformTenantsByIdMembersErrors];

export type GetApiV1PlatformTenantsByIdMembersResponses = {
    /**
     * OK
     */
    200: Array<TenantMemberDto>;
};

export type GetApiV1PlatformTenantsByIdMembersResponse = GetApiV1PlatformTenantsByIdMembersResponses[keyof GetApiV1PlatformTenantsByIdMembersResponses];

export type PostApiV1PlatformTenantsByIdMembersData = {
    body: AddTenantMemberRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/members';
};

export type PostApiV1PlatformTenantsByIdMembersErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsByIdMembersError = PostApiV1PlatformTenantsByIdMembersErrors[keyof PostApiV1PlatformTenantsByIdMembersErrors];

export type PostApiV1PlatformTenantsByIdMembersResponses = {
    /**
     * OK
     */
    200: TenantMemberDto;
};

export type PostApiV1PlatformTenantsByIdMembersResponse = PostApiV1PlatformTenantsByIdMembersResponses[keyof PostApiV1PlatformTenantsByIdMembersResponses];

export type DeleteApiV1PlatformTenantsByIdMembersByUserIdData = {
    body?: never;
    path: {
        id: string;
        userId: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/members/{userId}';
};

export type DeleteApiV1PlatformTenantsByIdMembersByUserIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1PlatformTenantsByIdMembersByUserIdError = DeleteApiV1PlatformTenantsByIdMembersByUserIdErrors[keyof DeleteApiV1PlatformTenantsByIdMembersByUserIdErrors];

export type DeleteApiV1PlatformTenantsByIdMembersByUserIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1PlatformTenantsByIdMembersByUserIdResponse = DeleteApiV1PlatformTenantsByIdMembersByUserIdResponses[keyof DeleteApiV1PlatformTenantsByIdMembersByUserIdResponses];

export type PatchApiV1PlatformTenantsByIdMembersByUserIdData = {
    body: UpdateTenantMemberRoleRequest;
    path: {
        id: string;
        userId: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/members/{userId}';
};

export type PatchApiV1PlatformTenantsByIdMembersByUserIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1PlatformTenantsByIdMembersByUserIdError = PatchApiV1PlatformTenantsByIdMembersByUserIdErrors[keyof PatchApiV1PlatformTenantsByIdMembersByUserIdErrors];

export type PatchApiV1PlatformTenantsByIdMembersByUserIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PatchApiV1PlatformTenantsByIdMembersByUserIdResponse = PatchApiV1PlatformTenantsByIdMembersByUserIdResponses[keyof PatchApiV1PlatformTenantsByIdMembersByUserIdResponses];

export type PatchApiV1PlatformTenantsByIdMembersByUserIdContactsData = {
    body: UpdateTenantMemberContactsRequest;
    path: {
        id: string;
        userId: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/members/{userId}/contacts';
};

export type PatchApiV1PlatformTenantsByIdMembersByUserIdContactsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1PlatformTenantsByIdMembersByUserIdContactsError = PatchApiV1PlatformTenantsByIdMembersByUserIdContactsErrors[keyof PatchApiV1PlatformTenantsByIdMembersByUserIdContactsErrors];

export type PatchApiV1PlatformTenantsByIdMembersByUserIdContactsResponses = {
    /**
     * OK
     */
    200: TenantMemberContactsChanged;
};

export type PatchApiV1PlatformTenantsByIdMembersByUserIdContactsResponse = PatchApiV1PlatformTenantsByIdMembersByUserIdContactsResponses[keyof PatchApiV1PlatformTenantsByIdMembersByUserIdContactsResponses];

export type PostApiV1PlatformTenantsByIdReactivateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/reactivate';
};

export type PostApiV1PlatformTenantsByIdReactivateErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsByIdReactivateError = PostApiV1PlatformTenantsByIdReactivateErrors[keyof PostApiV1PlatformTenantsByIdReactivateErrors];

export type PostApiV1PlatformTenantsByIdReactivateResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformTenantsByIdReactivateResponse = PostApiV1PlatformTenantsByIdReactivateResponses[keyof PostApiV1PlatformTenantsByIdReactivateResponses];

export type PostApiV1PlatformTenantsByIdRestoreData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/restore';
};

export type PostApiV1PlatformTenantsByIdRestoreErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsByIdRestoreError = PostApiV1PlatformTenantsByIdRestoreErrors[keyof PostApiV1PlatformTenantsByIdRestoreErrors];

export type PostApiV1PlatformTenantsByIdRestoreResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformTenantsByIdRestoreResponse = PostApiV1PlatformTenantsByIdRestoreResponses[keyof PostApiV1PlatformTenantsByIdRestoreResponses];

export type PostApiV1PlatformTenantsByIdSuspendData = {
    body: SuspendTenantRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/suspend';
};

export type PostApiV1PlatformTenantsByIdSuspendErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsByIdSuspendError = PostApiV1PlatformTenantsByIdSuspendErrors[keyof PostApiV1PlatformTenantsByIdSuspendErrors];

export type PostApiV1PlatformTenantsByIdSuspendResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformTenantsByIdSuspendResponse = PostApiV1PlatformTenantsByIdSuspendResponses[keyof PostApiV1PlatformTenantsByIdSuspendResponses];

export type PostApiV1PlatformTenantsByIdTrialExtensionLimitData = {
    body: SetTrialExtensionLimitRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/trial-extension-limit';
};

export type PostApiV1PlatformTenantsByIdTrialExtensionLimitErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsByIdTrialExtensionLimitError = PostApiV1PlatformTenantsByIdTrialExtensionLimitErrors[keyof PostApiV1PlatformTenantsByIdTrialExtensionLimitErrors];

export type PostApiV1PlatformTenantsByIdTrialExtensionLimitResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformTenantsByIdTrialExtensionLimitResponse = PostApiV1PlatformTenantsByIdTrialExtensionLimitResponses[keyof PostApiV1PlatformTenantsByIdTrialExtensionLimitResponses];

export type PostApiV1PlatformTenantsByIdUndeleteData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/platform/tenants/{id}/undelete';
};

export type PostApiV1PlatformTenantsByIdUndeleteErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PlatformTenantsByIdUndeleteError = PostApiV1PlatformTenantsByIdUndeleteErrors[keyof PostApiV1PlatformTenantsByIdUndeleteErrors];

export type PostApiV1PlatformTenantsByIdUndeleteResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1PlatformTenantsByIdUndeleteResponse = PostApiV1PlatformTenantsByIdUndeleteResponses[keyof PostApiV1PlatformTenantsByIdUndeleteResponses];

export type GetApiV1PosAdminProductsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/pos/admin/products';
};

export type GetApiV1PosAdminProductsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PosAdminProductsError = GetApiV1PosAdminProductsErrors[keyof GetApiV1PosAdminProductsErrors];

export type GetApiV1PosAdminProductsResponses = {
    /**
     * OK
     */
    200: ProductListResponse;
};

export type GetApiV1PosAdminProductsResponse = GetApiV1PosAdminProductsResponses[keyof GetApiV1PosAdminProductsResponses];

export type PostApiV1PosAdminProductsData = {
    body: CreateProductPayload;
    path?: never;
    query?: never;
    url: '/api/v1/pos/admin/products';
};

export type PostApiV1PosAdminProductsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PosAdminProductsError = PostApiV1PosAdminProductsErrors[keyof PostApiV1PosAdminProductsErrors];

export type PostApiV1PosAdminProductsResponses = {
    /**
     * Created
     */
    201: ProductDto;
};

export type PostApiV1PosAdminProductsResponse = PostApiV1PosAdminProductsResponses[keyof PostApiV1PosAdminProductsResponses];

export type DeleteApiV1PosAdminProductsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/pos/admin/products/{id}';
};

export type DeleteApiV1PosAdminProductsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1PosAdminProductsByIdError = DeleteApiV1PosAdminProductsByIdErrors[keyof DeleteApiV1PosAdminProductsByIdErrors];

export type DeleteApiV1PosAdminProductsByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1PosAdminProductsByIdResponse = DeleteApiV1PosAdminProductsByIdResponses[keyof DeleteApiV1PosAdminProductsByIdResponses];

export type PatchApiV1PosAdminProductsByIdData = {
    body: UpdateProductPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/pos/admin/products/{id}';
};

export type PatchApiV1PosAdminProductsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1PosAdminProductsByIdError = PatchApiV1PosAdminProductsByIdErrors[keyof PatchApiV1PosAdminProductsByIdErrors];

export type PatchApiV1PosAdminProductsByIdResponses = {
    /**
     * OK
     */
    200: ProductDto;
};

export type PatchApiV1PosAdminProductsByIdResponse = PatchApiV1PosAdminProductsByIdResponses[keyof PatchApiV1PosAdminProductsByIdResponses];

export type GetApiV1PosAdminRentalBundlesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/pos/admin/rental-bundles';
};

export type GetApiV1PosAdminRentalBundlesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PosAdminRentalBundlesError = GetApiV1PosAdminRentalBundlesErrors[keyof GetApiV1PosAdminRentalBundlesErrors];

export type GetApiV1PosAdminRentalBundlesResponses = {
    /**
     * OK
     */
    200: RentalBundleListResponse;
};

export type GetApiV1PosAdminRentalBundlesResponse = GetApiV1PosAdminRentalBundlesResponses[keyof GetApiV1PosAdminRentalBundlesResponses];

export type PostApiV1PosAdminRentalBundlesData = {
    body: RentalBundlePayload;
    path?: never;
    query?: never;
    url: '/api/v1/pos/admin/rental-bundles';
};

export type PostApiV1PosAdminRentalBundlesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PosAdminRentalBundlesError = PostApiV1PosAdminRentalBundlesErrors[keyof PostApiV1PosAdminRentalBundlesErrors];

export type PostApiV1PosAdminRentalBundlesResponses = {
    /**
     * Created
     */
    201: RentalBundleDto;
};

export type PostApiV1PosAdminRentalBundlesResponse = PostApiV1PosAdminRentalBundlesResponses[keyof PostApiV1PosAdminRentalBundlesResponses];

export type DeleteApiV1PosAdminRentalBundlesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/pos/admin/rental-bundles/{id}';
};

export type DeleteApiV1PosAdminRentalBundlesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1PosAdminRentalBundlesByIdError = DeleteApiV1PosAdminRentalBundlesByIdErrors[keyof DeleteApiV1PosAdminRentalBundlesByIdErrors];

export type DeleteApiV1PosAdminRentalBundlesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1PosAdminRentalBundlesByIdResponse = DeleteApiV1PosAdminRentalBundlesByIdResponses[keyof DeleteApiV1PosAdminRentalBundlesByIdResponses];

export type PatchApiV1PosAdminRentalBundlesByIdData = {
    body: RentalBundlePayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/pos/admin/rental-bundles/{id}';
};

export type PatchApiV1PosAdminRentalBundlesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1PosAdminRentalBundlesByIdError = PatchApiV1PosAdminRentalBundlesByIdErrors[keyof PatchApiV1PosAdminRentalBundlesByIdErrors];

export type PatchApiV1PosAdminRentalBundlesByIdResponses = {
    /**
     * OK
     */
    200: RentalBundleDto;
};

export type PatchApiV1PosAdminRentalBundlesByIdResponse = PatchApiV1PosAdminRentalBundlesByIdResponses[keyof PatchApiV1PosAdminRentalBundlesByIdResponses];

export type GetApiV1PosProductsData = {
    body?: never;
    path?: never;
    query?: {
        includeDisabled?: boolean;
    };
    url: '/api/v1/pos/products';
};

export type GetApiV1PosProductsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PosProductsError = GetApiV1PosProductsErrors[keyof GetApiV1PosProductsErrors];

export type GetApiV1PosProductsResponses = {
    /**
     * OK
     */
    200: ProductListResponse;
};

export type GetApiV1PosProductsResponse = GetApiV1PosProductsResponses[keyof GetApiV1PosProductsResponses];

export type GetApiV1PosRentableBundlesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/pos/rentable/bundles';
};

export type GetApiV1PosRentableBundlesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PosRentableBundlesError = GetApiV1PosRentableBundlesErrors[keyof GetApiV1PosRentableBundlesErrors];

export type GetApiV1PosRentableBundlesResponses = {
    /**
     * OK
     */
    200: RentalBundleListResponse;
};

export type GetApiV1PosRentableBundlesResponse = GetApiV1PosRentableBundlesResponses[keyof GetApiV1PosRentableBundlesResponses];

export type GetApiV1PosRentableProductsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/pos/rentable/products';
};

export type GetApiV1PosRentableProductsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PosRentableProductsError = GetApiV1PosRentableProductsErrors[keyof GetApiV1PosRentableProductsErrors];

export type GetApiV1PosRentableProductsResponses = {
    /**
     * OK
     */
    200: ProductListResponse;
};

export type GetApiV1PosRentableProductsResponse = GetApiV1PosRentableProductsResponses[keyof GetApiV1PosRentableProductsResponses];

export type GetApiV1PosSalesData = {
    body?: never;
    path?: never;
    query?: {
        shiftId?: string;
        from?: string;
        to?: string;
        page?: number;
        pageSize?: number;
        clientId?: string;
    };
    url: '/api/v1/pos/sales';
};

export type GetApiV1PosSalesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PosSalesError = GetApiV1PosSalesErrors[keyof GetApiV1PosSalesErrors];

export type GetApiV1PosSalesResponses = {
    /**
     * OK
     */
    200: SaleListResponse;
};

export type GetApiV1PosSalesResponse = GetApiV1PosSalesResponses[keyof GetApiV1PosSalesResponses];

export type PostApiV1PosSalesData = {
    body: CreateSalePayload;
    path?: never;
    query?: never;
    url: '/api/v1/pos/sales';
};

export type PostApiV1PosSalesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PosSalesError = PostApiV1PosSalesErrors[keyof PostApiV1PosSalesErrors];

export type PostApiV1PosSalesResponses = {
    /**
     * Created
     */
    201: SaleDto;
};

export type PostApiV1PosSalesResponse = PostApiV1PosSalesResponses[keyof PostApiV1PosSalesResponses];

export type PostApiV1PosSalesBonusCapData = {
    body: TillBonusCapPayload;
    path?: never;
    query?: never;
    url: '/api/v1/pos/sales/bonus-cap';
};

export type PostApiV1PosSalesBonusCapErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PosSalesBonusCapError = PostApiV1PosSalesBonusCapErrors[keyof PostApiV1PosSalesBonusCapErrors];

export type PostApiV1PosSalesBonusCapResponses = {
    /**
     * OK
     */
    200: TillBonusCapDto;
};

export type PostApiV1PosSalesBonusCapResponse = PostApiV1PosSalesBonusCapResponses[keyof PostApiV1PosSalesBonusCapResponses];

export type GetApiV1PosSalesCorporateEligibilityData = {
    body?: never;
    path?: never;
    query: {
        clientId: string;
        amountKopecks: number;
    };
    url: '/api/v1/pos/sales/corporate-eligibility';
};

export type GetApiV1PosSalesCorporateEligibilityErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PosSalesCorporateEligibilityError = GetApiV1PosSalesCorporateEligibilityErrors[keyof GetApiV1PosSalesCorporateEligibilityErrors];

export type GetApiV1PosSalesCorporateEligibilityResponses = {
    /**
     * OK
     */
    200: PosCorporateEligibilityDto;
};

export type GetApiV1PosSalesCorporateEligibilityResponse = GetApiV1PosSalesCorporateEligibilityResponses[keyof GetApiV1PosSalesCorporateEligibilityResponses];

export type GetApiV1PosSalesOutstandingSeatsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/pos/sales/outstanding-seats';
};

export type GetApiV1PosSalesOutstandingSeatsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PosSalesOutstandingSeatsError = GetApiV1PosSalesOutstandingSeatsErrors[keyof GetApiV1PosSalesOutstandingSeatsErrors];

export type GetApiV1PosSalesOutstandingSeatsResponses = {
    /**
     * OK
     */
    200: OutstandingSeatsResponse;
};

export type GetApiV1PosSalesOutstandingSeatsResponse = GetApiV1PosSalesOutstandingSeatsResponses[keyof GetApiV1PosSalesOutstandingSeatsResponses];

export type GetApiV1PosSalesOutstandingSurchargesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/pos/sales/outstanding-surcharges';
};

export type GetApiV1PosSalesOutstandingSurchargesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PosSalesOutstandingSurchargesError = GetApiV1PosSalesOutstandingSurchargesErrors[keyof GetApiV1PosSalesOutstandingSurchargesErrors];

export type GetApiV1PosSalesOutstandingSurchargesResponses = {
    /**
     * OK
     */
    200: OutstandingSurchargesResponse;
};

export type GetApiV1PosSalesOutstandingSurchargesResponse = GetApiV1PosSalesOutstandingSurchargesResponses[keyof GetApiV1PosSalesOutstandingSurchargesResponses];

export type GetApiV1PosSalesOutstandingTournamentEntriesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/pos/sales/outstanding-tournament-entries';
};

export type GetApiV1PosSalesOutstandingTournamentEntriesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PosSalesOutstandingTournamentEntriesError = GetApiV1PosSalesOutstandingTournamentEntriesErrors[keyof GetApiV1PosSalesOutstandingTournamentEntriesErrors];

export type GetApiV1PosSalesOutstandingTournamentEntriesResponses = {
    /**
     * OK
     */
    200: OutstandingTournamentEntriesResponse;
};

export type GetApiV1PosSalesOutstandingTournamentEntriesResponse = GetApiV1PosSalesOutstandingTournamentEntriesResponses[keyof GetApiV1PosSalesOutstandingTournamentEntriesResponses];

export type GetApiV1PosSalesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/pos/sales/{id}';
};

export type GetApiV1PosSalesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PosSalesByIdError = GetApiV1PosSalesByIdErrors[keyof GetApiV1PosSalesByIdErrors];

export type GetApiV1PosSalesByIdResponses = {
    /**
     * OK
     */
    200: SaleDto;
};

export type GetApiV1PosSalesByIdResponse = GetApiV1PosSalesByIdResponses[keyof GetApiV1PosSalesByIdResponses];

export type PostApiV1PosSalesByIdRefundData = {
    body?: null | RefundSalePayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/pos/sales/{id}/refund';
};

export type PostApiV1PosSalesByIdRefundErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PosSalesByIdRefundError = PostApiV1PosSalesByIdRefundErrors[keyof PostApiV1PosSalesByIdRefundErrors];

export type PostApiV1PosSalesByIdRefundResponses = {
    /**
     * OK
     */
    200: SaleRefundRequest;
};

export type PostApiV1PosSalesByIdRefundResponse = PostApiV1PosSalesByIdRefundResponses[keyof PostApiV1PosSalesByIdRefundResponses];

export type GetApiV1PosSalesBySaleIdFiscalData = {
    body?: never;
    path: {
        saleId: string;
    };
    query?: never;
    url: '/api/v1/pos/sales/{saleId}/fiscal';
};

export type GetApiV1PosSalesBySaleIdFiscalErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PosSalesBySaleIdFiscalError = GetApiV1PosSalesBySaleIdFiscalErrors[keyof GetApiV1PosSalesBySaleIdFiscalErrors];

export type GetApiV1PosSalesBySaleIdFiscalResponses = {
    /**
     * OK
     */
    200: FiscalReceiptStateResponse;
};

export type GetApiV1PosSalesBySaleIdFiscalResponse = GetApiV1PosSalesBySaleIdFiscalResponses[keyof GetApiV1PosSalesBySaleIdFiscalResponses];

export type PostApiV1PosSalesBySaleIdFiscalConfirmNotIssuedData = {
    body: ConfirmFiscalNotIssuedRequest;
    path: {
        saleId: string;
    };
    query?: never;
    url: '/api/v1/pos/sales/{saleId}/fiscal/confirm-not-issued';
};

export type PostApiV1PosSalesBySaleIdFiscalConfirmNotIssuedErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PosSalesBySaleIdFiscalConfirmNotIssuedError = PostApiV1PosSalesBySaleIdFiscalConfirmNotIssuedErrors[keyof PostApiV1PosSalesBySaleIdFiscalConfirmNotIssuedErrors];

export type PostApiV1PosSalesBySaleIdFiscalConfirmNotIssuedResponses = {
    /**
     * OK
     */
    200: FiscalReceiptStateDto;
};

export type PostApiV1PosSalesBySaleIdFiscalConfirmNotIssuedResponse = PostApiV1PosSalesBySaleIdFiscalConfirmNotIssuedResponses[keyof PostApiV1PosSalesBySaleIdFiscalConfirmNotIssuedResponses];

export type PostApiV1PosSalesBySaleIdFiscalPrepareData = {
    body?: never;
    path: {
        saleId: string;
    };
    query?: never;
    url: '/api/v1/pos/sales/{saleId}/fiscal/prepare';
};

export type PostApiV1PosSalesBySaleIdFiscalPrepareErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PosSalesBySaleIdFiscalPrepareError = PostApiV1PosSalesBySaleIdFiscalPrepareErrors[keyof PostApiV1PosSalesBySaleIdFiscalPrepareErrors];

export type PostApiV1PosSalesBySaleIdFiscalPrepareResponses = {
    /**
     * OK
     */
    200: PrepareFiscalReceiptResponse;
};

export type PostApiV1PosSalesBySaleIdFiscalPrepareResponse = PostApiV1PosSalesBySaleIdFiscalPrepareResponses[keyof PostApiV1PosSalesBySaleIdFiscalPrepareResponses];

export type PostApiV1PosSalesBySaleIdFiscalRequeryData = {
    body?: never;
    path: {
        saleId: string;
    };
    query?: never;
    url: '/api/v1/pos/sales/{saleId}/fiscal/requery';
};

export type PostApiV1PosSalesBySaleIdFiscalRequeryErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PosSalesBySaleIdFiscalRequeryError = PostApiV1PosSalesBySaleIdFiscalRequeryErrors[keyof PostApiV1PosSalesBySaleIdFiscalRequeryErrors];

export type PostApiV1PosSalesBySaleIdFiscalRequeryResponses = {
    /**
     * OK
     */
    200: FiscalReceiptStateDto;
};

export type PostApiV1PosSalesBySaleIdFiscalRequeryResponse = PostApiV1PosSalesBySaleIdFiscalRequeryResponses[keyof PostApiV1PosSalesBySaleIdFiscalRequeryResponses];

export type PostApiV1PosSalesBySaleIdFiscalResultData = {
    body: RecordFiscalResultRequest;
    path: {
        saleId: string;
    };
    query?: never;
    url: '/api/v1/pos/sales/{saleId}/fiscal/result';
};

export type PostApiV1PosSalesBySaleIdFiscalResultErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PosSalesBySaleIdFiscalResultError = PostApiV1PosSalesBySaleIdFiscalResultErrors[keyof PostApiV1PosSalesBySaleIdFiscalResultErrors];

export type PostApiV1PosSalesBySaleIdFiscalResultResponses = {
    /**
     * OK
     */
    200: FiscalReceiptStateDto;
};

export type PostApiV1PosSalesBySaleIdFiscalResultResponse = PostApiV1PosSalesBySaleIdFiscalResultResponses[keyof PostApiV1PosSalesBySaleIdFiscalResultResponses];

export type PostApiV1PosShiftsData = {
    body: OpenShiftPayload;
    path?: never;
    query?: never;
    url: '/api/v1/pos/shifts';
};

export type PostApiV1PosShiftsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PosShiftsError = PostApiV1PosShiftsErrors[keyof PostApiV1PosShiftsErrors];

export type PostApiV1PosShiftsResponses = {
    /**
     * Created
     */
    201: ShiftDto;
};

export type PostApiV1PosShiftsResponse = PostApiV1PosShiftsResponses[keyof PostApiV1PosShiftsResponses];

export type GetApiV1PosShiftsCurrentData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/pos/shifts/current';
};

export type GetApiV1PosShiftsCurrentErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PosShiftsCurrentError = GetApiV1PosShiftsCurrentErrors[keyof GetApiV1PosShiftsCurrentErrors];

export type GetApiV1PosShiftsCurrentResponses = {
    /**
     * OK
     */
    200: CurrentShiftResponse;
};

export type GetApiV1PosShiftsCurrentResponse = GetApiV1PosShiftsCurrentResponses[keyof GetApiV1PosShiftsCurrentResponses];

export type PatchApiV1PosShiftsCurrentCloseData = {
    body: CloseShiftPayload;
    path?: never;
    query?: never;
    url: '/api/v1/pos/shifts/current/close';
};

export type PatchApiV1PosShiftsCurrentCloseErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1PosShiftsCurrentCloseError = PatchApiV1PosShiftsCurrentCloseErrors[keyof PatchApiV1PosShiftsCurrentCloseErrors];

export type PatchApiV1PosShiftsCurrentCloseResponses = {
    /**
     * OK
     */
    200: ShiftDto;
};

export type PatchApiV1PosShiftsCurrentCloseResponse = PatchApiV1PosShiftsCurrentCloseResponses[keyof PatchApiV1PosShiftsCurrentCloseResponses];

export type GetApiV1PosShiftsCurrentUnfiscalisedData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/pos/shifts/current/unfiscalised';
};

export type GetApiV1PosShiftsCurrentUnfiscalisedErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PosShiftsCurrentUnfiscalisedError = GetApiV1PosShiftsCurrentUnfiscalisedErrors[keyof GetApiV1PosShiftsCurrentUnfiscalisedErrors];

export type GetApiV1PosShiftsCurrentUnfiscalisedResponses = {
    /**
     * OK
     */
    200: UnfiscalisedSalesResponse;
};

export type GetApiV1PosShiftsCurrentUnfiscalisedResponse = GetApiV1PosShiftsCurrentUnfiscalisedResponses[keyof GetApiV1PosShiftsCurrentUnfiscalisedResponses];

export type GetApiV1PosShiftsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/pos/shifts/{id}';
};

export type GetApiV1PosShiftsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PosShiftsByIdError = GetApiV1PosShiftsByIdErrors[keyof GetApiV1PosShiftsByIdErrors];

export type GetApiV1PosShiftsByIdResponses = {
    /**
     * OK
     */
    200: ShiftDetailResponse;
};

export type GetApiV1PosShiftsByIdResponse = GetApiV1PosShiftsByIdResponses[keyof GetApiV1PosShiftsByIdResponses];

export type PostApiV1PricingPreviewData = {
    body: PricingPreviewPayload;
    path?: never;
    query?: never;
    url: '/api/v1/pricing/preview';
};

export type PostApiV1PricingPreviewErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PricingPreviewError = PostApiV1PricingPreviewErrors[keyof PostApiV1PricingPreviewErrors];

export type PostApiV1PricingPreviewResponses = {
    /**
     * OK
     */
    200: PricingPreviewResponse;
};

export type PostApiV1PricingPreviewResponse = PostApiV1PricingPreviewResponses[keyof PostApiV1PricingPreviewResponses];

export type GetApiV1PromocodesData = {
    body?: never;
    path?: never;
    query?: {
        includeDisabled?: boolean;
        statuses?: string;
        kind?: string;
        from?: string;
        to?: string;
        code?: string;
        sort?: string;
        order?: string;
        page?: number;
        pageSize?: number;
    };
    url: '/api/v1/promocodes';
};

export type GetApiV1PromocodesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PromocodesError = GetApiV1PromocodesErrors[keyof GetApiV1PromocodesErrors];

export type GetApiV1PromocodesResponses = {
    /**
     * OK
     */
    200: PromocodeListResponse;
};

export type GetApiV1PromocodesResponse = GetApiV1PromocodesResponses[keyof GetApiV1PromocodesResponses];

export type PostApiV1PromocodesData = {
    body: CreatePromocodePayload;
    path?: never;
    query?: never;
    url: '/api/v1/promocodes';
};

export type PostApiV1PromocodesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PromocodesError = PostApiV1PromocodesErrors[keyof PostApiV1PromocodesErrors];

export type PostApiV1PromocodesResponses = {
    /**
     * Created
     */
    201: PromocodeDto;
};

export type PostApiV1PromocodesResponse = PostApiV1PromocodesResponses[keyof PostApiV1PromocodesResponses];

export type PostApiV1PromocodesByCodePreviewData = {
    body?: null | PromocodePreviewPayload;
    path: {
        code: string;
    };
    query?: never;
    url: '/api/v1/promocodes/{code}/preview';
};

export type PostApiV1PromocodesByCodePreviewErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PromocodesByCodePreviewError = PostApiV1PromocodesByCodePreviewErrors[keyof PostApiV1PromocodesByCodePreviewErrors];

export type PostApiV1PromocodesByCodePreviewResponses = {
    /**
     * OK
     */
    200: PreviewPromocodeResponse;
};

export type PostApiV1PromocodesByCodePreviewResponse = PostApiV1PromocodesByCodePreviewResponses[keyof PostApiV1PromocodesByCodePreviewResponses];

export type DeleteApiV1PromocodesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/promocodes/{id}';
};

export type DeleteApiV1PromocodesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1PromocodesByIdError = DeleteApiV1PromocodesByIdErrors[keyof DeleteApiV1PromocodesByIdErrors];

export type DeleteApiV1PromocodesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1PromocodesByIdResponse = DeleteApiV1PromocodesByIdResponses[keyof DeleteApiV1PromocodesByIdResponses];

export type PatchApiV1PromocodesByIdData = {
    body: UpdatePromocodePayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/promocodes/{id}';
};

export type PatchApiV1PromocodesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1PromocodesByIdError = PatchApiV1PromocodesByIdErrors[keyof PatchApiV1PromocodesByIdErrors];

export type PatchApiV1PromocodesByIdResponses = {
    /**
     * OK
     */
    200: PromocodeDto;
};

export type PatchApiV1PromocodesByIdResponse = PatchApiV1PromocodesByIdResponses[keyof PatchApiV1PromocodesByIdResponses];

export type GetApiV1PromocodesByIdRedemptionsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        limit?: number;
        cursor?: string;
    };
    url: '/api/v1/promocodes/{id}/redemptions';
};

export type GetApiV1PromocodesByIdRedemptionsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PromocodesByIdRedemptionsError = GetApiV1PromocodesByIdRedemptionsErrors[keyof GetApiV1PromocodesByIdRedemptionsErrors];

export type GetApiV1PromocodesByIdRedemptionsResponses = {
    /**
     * OK
     */
    200: PromocodeRedemptionListResponse;
};

export type GetApiV1PromocodesByIdRedemptionsResponse = GetApiV1PromocodesByIdRedemptionsResponses[keyof GetApiV1PromocodesByIdRedemptionsResponses];

export type GetApiV1PublicClubsByCodeByCodeData = {
    body?: never;
    path: {
        code: string;
    };
    query?: never;
    url: '/api/v1/public/clubs/by-code/{code}';
};

export type GetApiV1PublicClubsByCodeByCodeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PublicClubsByCodeByCodeError = GetApiV1PublicClubsByCodeByCodeErrors[keyof GetApiV1PublicClubsByCodeByCodeErrors];

export type GetApiV1PublicClubsByCodeByCodeResponses = {
    /**
     * OK
     */
    200: PublicClubResponse;
};

export type GetApiV1PublicClubsByCodeByCodeResponse = GetApiV1PublicClubsByCodeByCodeResponses[keyof GetApiV1PublicClubsByCodeByCodeResponses];

export type GetApiV1RatingsActivityLeaderboardData = {
    body?: never;
    path?: never;
    query: {
        sport: string;
        limit?: number;
    };
    url: '/api/v1/ratings/activity-leaderboard';
};

export type GetApiV1RatingsActivityLeaderboardErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1RatingsActivityLeaderboardError = GetApiV1RatingsActivityLeaderboardErrors[keyof GetApiV1RatingsActivityLeaderboardErrors];

export type GetApiV1RatingsActivityLeaderboardResponses = {
    /**
     * OK
     */
    200: Array<ActivityLeaderboardEntryDto>;
};

export type GetApiV1RatingsActivityLeaderboardResponse = GetApiV1RatingsActivityLeaderboardResponses[keyof GetApiV1RatingsActivityLeaderboardResponses];

export type GetApiV1RatingsClientsByClientIdData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/ratings/clients/{clientId}';
};

export type GetApiV1RatingsClientsByClientIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1RatingsClientsByClientIdError = GetApiV1RatingsClientsByClientIdErrors[keyof GetApiV1RatingsClientsByClientIdErrors];

export type GetApiV1RatingsClientsByClientIdResponses = {
    /**
     * OK
     */
    200: ClientRatingsDto;
};

export type GetApiV1RatingsClientsByClientIdResponse = GetApiV1RatingsClientsByClientIdResponses[keyof GetApiV1RatingsClientsByClientIdResponses];

export type PostApiV1RatingsClientsByClientIdSeedData = {
    body: SeedRatingPayload;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/ratings/clients/{clientId}/seed';
};

export type PostApiV1RatingsClientsByClientIdSeedErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1RatingsClientsByClientIdSeedError = PostApiV1RatingsClientsByClientIdSeedErrors[keyof PostApiV1RatingsClientsByClientIdSeedErrors];

export type PostApiV1RatingsClientsByClientIdSeedResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1RatingsClientsByClientIdSeedResponse = PostApiV1RatingsClientsByClientIdSeedResponses[keyof PostApiV1RatingsClientsByClientIdSeedResponses];

export type GetApiV1RatingsLeaderboardData = {
    body?: never;
    path?: never;
    query: {
        sport: string;
        limit?: number;
    };
    url: '/api/v1/ratings/leaderboard';
};

export type GetApiV1RatingsLeaderboardErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1RatingsLeaderboardError = GetApiV1RatingsLeaderboardErrors[keyof GetApiV1RatingsLeaderboardErrors];

export type GetApiV1RatingsLeaderboardResponses = {
    /**
     * OK
     */
    200: Array<RatingLeaderboardEntryDto>;
};

export type GetApiV1RatingsLeaderboardResponse = GetApiV1RatingsLeaderboardResponses[keyof GetApiV1RatingsLeaderboardResponses];

export type GetApiV1RatingsMeData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/ratings/me';
};

export type GetApiV1RatingsMeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1RatingsMeError = GetApiV1RatingsMeErrors[keyof GetApiV1RatingsMeErrors];

export type GetApiV1RatingsMeResponses = {
    /**
     * OK
     */
    200: ClientRatingsDto;
};

export type GetApiV1RatingsMeResponse = GetApiV1RatingsMeResponses[keyof GetApiV1RatingsMeResponses];

export type PostApiV1RatingsMeSeedData = {
    body: SeedRatingPayload;
    path?: never;
    query?: never;
    url: '/api/v1/ratings/me/seed';
};

export type PostApiV1RatingsMeSeedErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1RatingsMeSeedError = PostApiV1RatingsMeSeedErrors[keyof PostApiV1RatingsMeSeedErrors];

export type PostApiV1RatingsMeSeedResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1RatingsMeSeedResponse = PostApiV1RatingsMeSeedResponses[keyof PostApiV1RatingsMeSeedResponses];

export type GetApiV1RealtimeReplayData = {
    body?: never;
    path?: never;
    query?: {
        since?: string;
        max?: number;
    };
    url: '/api/v1/realtime/replay';
};

export type GetApiV1RealtimeReplayErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1RealtimeReplayError = GetApiV1RealtimeReplayErrors[keyof GetApiV1RealtimeReplayErrors];

export type GetApiV1RealtimeReplayResponses = {
    /**
     * OK
     */
    200: RealtimeReplayResponse;
};

export type GetApiV1RealtimeReplayResponse = GetApiV1RealtimeReplayResponses[keyof GetApiV1RealtimeReplayResponses];

export type GetApiV1RefundsData = {
    body?: never;
    path?: never;
    query?: {
        Status?: RefundStatus;
        PaymentId?: string;
        Source?: RefundSource;
        Page?: number;
        PageSize?: number;
    };
    url: '/api/v1/refunds';
};

export type GetApiV1RefundsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1RefundsError = GetApiV1RefundsErrors[keyof GetApiV1RefundsErrors];

export type GetApiV1RefundsResponses = {
    /**
     * OK
     */
    200: ListRefundsResponse;
};

export type GetApiV1RefundsResponse = GetApiV1RefundsResponses[keyof GetApiV1RefundsResponses];

export type PostApiV1RefundsData = {
    body: CreateLineRefundBody;
    path?: never;
    query?: never;
    url: '/api/v1/refunds';
};

export type PostApiV1RefundsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1RefundsError = PostApiV1RefundsErrors[keyof PostApiV1RefundsErrors];

export type PostApiV1RefundsResponses = {
    /**
     * Created
     */
    201: CreateLineRefundResponse;
};

export type PostApiV1RefundsResponse = PostApiV1RefundsResponses[keyof PostApiV1RefundsResponses];

export type GetApiV1RefundsObligationsData = {
    body?: never;
    path?: never;
    query?: {
        includeResolved?: boolean;
    };
    url: '/api/v1/refunds/obligations';
};

export type GetApiV1RefundsObligationsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1RefundsObligationsError = GetApiV1RefundsObligationsErrors[keyof GetApiV1RefundsObligationsErrors];

export type GetApiV1RefundsObligationsResponses = {
    /**
     * OK
     */
    200: ListRefundObligationsResponse;
};

export type GetApiV1RefundsObligationsResponse = GetApiV1RefundsObligationsResponses[keyof GetApiV1RefundsObligationsResponses];

export type PostApiV1RefundsObligationsByIdRefundData = {
    body?: null | ReturnTheObligationBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/refunds/obligations/{id}/refund';
};

export type PostApiV1RefundsObligationsByIdRefundErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1RefundsObligationsByIdRefundError = PostApiV1RefundsObligationsByIdRefundErrors[keyof PostApiV1RefundsObligationsByIdRefundErrors];

export type PostApiV1RefundsObligationsByIdRefundResponses = {
    /**
     * OK
     */
    200: ReturnTheObligationResponse;
};

export type PostApiV1RefundsObligationsByIdRefundResponse = PostApiV1RefundsObligationsByIdRefundResponses[keyof PostApiV1RefundsObligationsByIdRefundResponses];

export type PostApiV1RefundsObligationsByIdResolveData = {
    body: ResolveObligationPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/refunds/obligations/{id}/resolve';
};

export type PostApiV1RefundsObligationsByIdResolveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1RefundsObligationsByIdResolveError = PostApiV1RefundsObligationsByIdResolveErrors[keyof PostApiV1RefundsObligationsByIdResolveErrors];

export type PostApiV1RefundsObligationsByIdResolveResponses = {
    /**
     * OK
     */
    200: RefundObligationDto;
};

export type PostApiV1RefundsObligationsByIdResolveResponse = PostApiV1RefundsObligationsByIdResolveResponses[keyof PostApiV1RefundsObligationsByIdResolveResponses];

export type GetApiV1RefundsVerdictData = {
    body?: never;
    path?: never;
    query: {
        paymentId: string;
    };
    url: '/api/v1/refunds/verdict';
};

export type GetApiV1RefundsVerdictErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1RefundsVerdictError = GetApiV1RefundsVerdictErrors[keyof GetApiV1RefundsVerdictErrors];

export type GetApiV1RefundsVerdictResponses = {
    /**
     * OK
     */
    200: RefundVerdictResponse;
};

export type GetApiV1RefundsVerdictResponse = GetApiV1RefundsVerdictResponses[keyof GetApiV1RefundsVerdictResponses];

export type GetApiV1RefundsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/refunds/{id}';
};

export type GetApiV1RefundsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1RefundsByIdError = GetApiV1RefundsByIdErrors[keyof GetApiV1RefundsByIdErrors];

export type GetApiV1RefundsByIdResponses = {
    /**
     * OK
     */
    200: RefundDetailDto;
};

export type GetApiV1RefundsByIdResponse = GetApiV1RefundsByIdResponses[keyof GetApiV1RefundsByIdResponses];

export type PostApiV1RefundsByIdApproveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/refunds/{id}/approve';
};

export type PostApiV1RefundsByIdApproveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1RefundsByIdApproveError = PostApiV1RefundsByIdApproveErrors[keyof PostApiV1RefundsByIdApproveErrors];

export type PostApiV1RefundsByIdApproveResponses = {
    /**
     * OK
     */
    200: ApproveRefundResponse;
};

export type PostApiV1RefundsByIdApproveResponse = PostApiV1RefundsByIdApproveResponses[keyof PostApiV1RefundsByIdApproveResponses];

export type PostApiV1RefundsByIdExecuteData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/refunds/{id}/execute';
};

export type PostApiV1RefundsByIdExecuteErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1RefundsByIdExecuteError = PostApiV1RefundsByIdExecuteErrors[keyof PostApiV1RefundsByIdExecuteErrors];

export type PostApiV1RefundsByIdExecuteResponses = {
    /**
     * OK
     */
    200: ExecuteApprovedRefundResponse;
};

export type PostApiV1RefundsByIdExecuteResponse = PostApiV1RefundsByIdExecuteResponses[keyof PostApiV1RefundsByIdExecuteResponses];

export type PostApiV1RefundsByIdRejectData = {
    body: RejectRefundBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/refunds/{id}/reject';
};

export type PostApiV1RefundsByIdRejectErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1RefundsByIdRejectError = PostApiV1RefundsByIdRejectErrors[keyof PostApiV1RefundsByIdRejectErrors];

export type PostApiV1RefundsByIdRejectResponses = {
    /**
     * OK
     */
    200: RejectRefundResponse;
};

export type PostApiV1RefundsByIdRejectResponse = PostApiV1RefundsByIdRejectResponses[keyof PostApiV1RefundsByIdRejectResponses];

export type PostApiV1RefundsByIdResolveByStatementData = {
    body: ResolveRefundByStatementBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/refunds/{id}/resolve-by-statement';
};

export type PostApiV1RefundsByIdResolveByStatementErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1RefundsByIdResolveByStatementError = PostApiV1RefundsByIdResolveByStatementErrors[keyof PostApiV1RefundsByIdResolveByStatementErrors];

export type PostApiV1RefundsByIdResolveByStatementResponses = {
    /**
     * OK
     */
    200: ResolveRefundByStatementResponse;
};

export type PostApiV1RefundsByIdResolveByStatementResponse = PostApiV1RefundsByIdResolveByStatementResponses[keyof PostApiV1RefundsByIdResolveByStatementResponses];

export type GetApiV1ResourcesData = {
    body?: never;
    path?: never;
    query?: {
        Type?: ResourceType;
        SportType?: string;
        IsActive?: boolean;
    };
    url: '/api/v1/resources';
};

export type GetApiV1ResourcesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ResourcesError = GetApiV1ResourcesErrors[keyof GetApiV1ResourcesErrors];

export type GetApiV1ResourcesResponses = {
    /**
     * OK
     */
    200: Array<ResourceDto>;
};

export type GetApiV1ResourcesResponse = GetApiV1ResourcesResponses[keyof GetApiV1ResourcesResponses];

export type PostApiV1ResourcesData = {
    body: CreatePlaceCommand;
    path?: never;
    query?: never;
    url: '/api/v1/resources';
};

export type PostApiV1ResourcesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ResourcesError = PostApiV1ResourcesErrors[keyof PostApiV1ResourcesErrors];

export type PostApiV1ResourcesResponses = {
    /**
     * OK
     */
    200: PlaceDto;
};

export type PostApiV1ResourcesResponse = PostApiV1ResourcesResponses[keyof PostApiV1ResourcesResponses];

export type PutApiV1ResourcesByIdData = {
    body: UpdatePlaceBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/resources/{id}';
};

export type PutApiV1ResourcesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1ResourcesByIdError = PutApiV1ResourcesByIdErrors[keyof PutApiV1ResourcesByIdErrors];

export type PutApiV1ResourcesByIdResponses = {
    /**
     * OK
     */
    200: PlaceDto;
};

export type PutApiV1ResourcesByIdResponse = PutApiV1ResourcesByIdResponses[keyof PutApiV1ResourcesByIdResponses];

export type PostApiV1ScheduleAutoPickCourtsData = {
    body: AutoPickCourtsPayload;
    path?: never;
    query?: never;
    url: '/api/v1/schedule/auto-pick-courts';
};

export type PostApiV1ScheduleAutoPickCourtsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ScheduleAutoPickCourtsError = PostApiV1ScheduleAutoPickCourtsErrors[keyof PostApiV1ScheduleAutoPickCourtsErrors];

export type PostApiV1ScheduleAutoPickCourtsResponses = {
    /**
     * OK
     */
    200: AutoPickCourtsResponse;
};

export type PostApiV1ScheduleAutoPickCourtsResponse = PostApiV1ScheduleAutoPickCourtsResponses[keyof PostApiV1ScheduleAutoPickCourtsResponses];

export type PostApiV1ScheduleBlockData = {
    body: BlockSlotsPayload;
    path?: never;
    query?: never;
    url: '/api/v1/schedule/block';
};

export type PostApiV1ScheduleBlockErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ScheduleBlockError = PostApiV1ScheduleBlockErrors[keyof PostApiV1ScheduleBlockErrors];

export type PostApiV1ScheduleBlockResponses = {
    /**
     * Created
     */
    201: BlockSlotsResponse;
};

export type PostApiV1ScheduleBlockResponse = PostApiV1ScheduleBlockResponses[keyof PostApiV1ScheduleBlockResponses];

export type DeleteApiV1ScheduleBlocksByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/schedule/blocks/{id}';
};

export type DeleteApiV1ScheduleBlocksByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1ScheduleBlocksByIdError = DeleteApiV1ScheduleBlocksByIdErrors[keyof DeleteApiV1ScheduleBlocksByIdErrors];

export type DeleteApiV1ScheduleBlocksByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1ScheduleBlocksByIdResponse = DeleteApiV1ScheduleBlocksByIdResponses[keyof DeleteApiV1ScheduleBlocksByIdResponses];

export type PostApiV1ScheduleFindAvailabilityData = {
    body: FindAvailabilityPayload;
    path?: never;
    query?: never;
    url: '/api/v1/schedule/find-availability';
};

export type PostApiV1ScheduleFindAvailabilityErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ScheduleFindAvailabilityError = PostApiV1ScheduleFindAvailabilityErrors[keyof PostApiV1ScheduleFindAvailabilityErrors];

export type PostApiV1ScheduleFindAvailabilityResponses = {
    /**
     * OK
     */
    200: FindAvailabilityResponse;
};

export type PostApiV1ScheduleFindAvailabilityResponse = PostApiV1ScheduleFindAvailabilityResponses[keyof PostApiV1ScheduleFindAvailabilityResponses];

export type GetApiV1ScheduleGridData = {
    body?: never;
    path?: never;
    query: {
        date: string;
        sport?: string;
        includeCancelled?: boolean;
    };
    url: '/api/v1/schedule/grid';
};

export type GetApiV1ScheduleGridErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ScheduleGridError = GetApiV1ScheduleGridErrors[keyof GetApiV1ScheduleGridErrors];

export type GetApiV1ScheduleGridResponses = {
    /**
     * OK
     */
    200: ScheduleGridResponse;
};

export type GetApiV1ScheduleGridResponse = GetApiV1ScheduleGridResponses[keyof GetApiV1ScheduleGridResponses];

export type GetApiV1ScheduleRangeData = {
    body?: never;
    path?: never;
    query: {
        from: string;
        to: string;
        sport?: string;
        trainerId?: string;
    };
    url: '/api/v1/schedule/range';
};

export type GetApiV1ScheduleRangeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ScheduleRangeError = GetApiV1ScheduleRangeErrors[keyof GetApiV1ScheduleRangeErrors];

export type GetApiV1ScheduleRangeResponses = {
    /**
     * OK
     */
    200: ScheduleRangeResponse;
};

export type GetApiV1ScheduleRangeResponse = GetApiV1ScheduleRangeResponses[keyof GetApiV1ScheduleRangeResponses];

export type GetApiV1SettingsAuditData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
    };
    url: '/api/v1/settings/audit';
};

export type GetApiV1SettingsAuditErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsAuditError = GetApiV1SettingsAuditErrors[keyof GetApiV1SettingsAuditErrors];

export type GetApiV1SettingsAuditResponses = {
    /**
     * OK
     */
    200: ListSettingsAuditResponse;
};

export type GetApiV1SettingsAuditResponse = GetApiV1SettingsAuditResponses[keyof GetApiV1SettingsAuditResponses];

export type GetApiV1SettingsAuditEntityTypesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/audit/entity-types';
};

export type GetApiV1SettingsAuditEntityTypesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsAuditEntityTypesError = GetApiV1SettingsAuditEntityTypesErrors[keyof GetApiV1SettingsAuditEntityTypesErrors];

export type GetApiV1SettingsAuditEntityTypesResponses = {
    /**
     * OK
     */
    200: Array<AuditEntityTypeDto>;
};

export type GetApiV1SettingsAuditEntityTypesResponse = GetApiV1SettingsAuditEntityTypesResponses[keyof GetApiV1SettingsAuditEntityTypesResponses];

export type GetApiV1SettingsAuditEventsData = {
    body?: never;
    path?: never;
    query?: {
        entityType?: string;
        entityId?: string;
        userId?: string;
        from?: string;
        to?: string;
        cursor?: string;
        limit?: number;
    };
    url: '/api/v1/settings/audit/events';
};

export type GetApiV1SettingsAuditEventsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsAuditEventsError = GetApiV1SettingsAuditEventsErrors[keyof GetApiV1SettingsAuditEventsErrors];

export type GetApiV1SettingsAuditEventsResponses = {
    /**
     * OK
     */
    200: ListAuditEventsResponse;
};

export type GetApiV1SettingsAuditEventsResponse = GetApiV1SettingsAuditEventsResponses[keyof GetApiV1SettingsAuditEventsResponses];

export type GetApiV1SettingsChatQuickRepliesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/chat-quick-replies';
};

export type GetApiV1SettingsChatQuickRepliesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsChatQuickRepliesError = GetApiV1SettingsChatQuickRepliesErrors[keyof GetApiV1SettingsChatQuickRepliesErrors];

export type GetApiV1SettingsChatQuickRepliesResponses = {
    /**
     * OK
     */
    200: Array<string>;
};

export type GetApiV1SettingsChatQuickRepliesResponse = GetApiV1SettingsChatQuickRepliesResponses[keyof GetApiV1SettingsChatQuickRepliesResponses];

export type PutApiV1SettingsChatQuickRepliesData = {
    body: ChatQuickRepliesPayload;
    path?: never;
    query?: never;
    url: '/api/v1/settings/chat-quick-replies';
};

export type PutApiV1SettingsChatQuickRepliesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1SettingsChatQuickRepliesError = PutApiV1SettingsChatQuickRepliesErrors[keyof PutApiV1SettingsChatQuickRepliesErrors];

export type PutApiV1SettingsChatQuickRepliesResponses = {
    /**
     * OK
     */
    200: Array<string>;
};

export type PutApiV1SettingsChatQuickRepliesResponse = PutApiV1SettingsChatQuickRepliesResponses[keyof PutApiV1SettingsChatQuickRepliesResponses];

export type GetApiV1SettingsClientCategoryRulesData = {
    body?: never;
    path?: never;
    query?: {
        includeDisabled?: boolean;
    };
    url: '/api/v1/settings/client-category-rules';
};

export type GetApiV1SettingsClientCategoryRulesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsClientCategoryRulesError = GetApiV1SettingsClientCategoryRulesErrors[keyof GetApiV1SettingsClientCategoryRulesErrors];

export type GetApiV1SettingsClientCategoryRulesResponses = {
    /**
     * OK
     */
    200: ClientCategoryRuleListResponse;
};

export type GetApiV1SettingsClientCategoryRulesResponse = GetApiV1SettingsClientCategoryRulesResponses[keyof GetApiV1SettingsClientCategoryRulesResponses];

export type PostApiV1SettingsClientCategoryRulesData = {
    body: ClientCategoryRulePayload;
    path?: never;
    query?: never;
    url: '/api/v1/settings/client-category-rules';
};

export type PostApiV1SettingsClientCategoryRulesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SettingsClientCategoryRulesError = PostApiV1SettingsClientCategoryRulesErrors[keyof PostApiV1SettingsClientCategoryRulesErrors];

export type PostApiV1SettingsClientCategoryRulesResponses = {
    /**
     * Created
     */
    201: ClientCategoryRuleDto;
};

export type PostApiV1SettingsClientCategoryRulesResponse = PostApiV1SettingsClientCategoryRulesResponses[keyof PostApiV1SettingsClientCategoryRulesResponses];

export type DeleteApiV1SettingsClientCategoryRulesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/settings/client-category-rules/{id}';
};

export type DeleteApiV1SettingsClientCategoryRulesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1SettingsClientCategoryRulesByIdError = DeleteApiV1SettingsClientCategoryRulesByIdErrors[keyof DeleteApiV1SettingsClientCategoryRulesByIdErrors];

export type DeleteApiV1SettingsClientCategoryRulesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1SettingsClientCategoryRulesByIdResponse = DeleteApiV1SettingsClientCategoryRulesByIdResponses[keyof DeleteApiV1SettingsClientCategoryRulesByIdResponses];

export type PatchApiV1SettingsClientCategoryRulesByIdData = {
    body: ClientCategoryRulePayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/settings/client-category-rules/{id}';
};

export type PatchApiV1SettingsClientCategoryRulesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SettingsClientCategoryRulesByIdError = PatchApiV1SettingsClientCategoryRulesByIdErrors[keyof PatchApiV1SettingsClientCategoryRulesByIdErrors];

export type PatchApiV1SettingsClientCategoryRulesByIdResponses = {
    /**
     * OK
     */
    200: ClientCategoryRuleDto;
};

export type PatchApiV1SettingsClientCategoryRulesByIdResponse = PatchApiV1SettingsClientCategoryRulesByIdResponses[keyof PatchApiV1SettingsClientCategoryRulesByIdResponses];

export type PostApiV1SettingsClubJoinCodeData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/club/join-code';
};

export type PostApiV1SettingsClubJoinCodeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SettingsClubJoinCodeError = PostApiV1SettingsClubJoinCodeErrors[keyof PostApiV1SettingsClubJoinCodeErrors];

export type PostApiV1SettingsClubJoinCodeResponses = {
    /**
     * OK
     */
    200: ClubJoinCodeResponse;
};

export type PostApiV1SettingsClubJoinCodeResponse = PostApiV1SettingsClubJoinCodeResponses[keyof PostApiV1SettingsClubJoinCodeResponses];

export type GetApiV1SettingsClubJoinCodeIssuedData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/club/join-code/issued';
};

export type GetApiV1SettingsClubJoinCodeIssuedErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsClubJoinCodeIssuedError = GetApiV1SettingsClubJoinCodeIssuedErrors[keyof GetApiV1SettingsClubJoinCodeIssuedErrors];

export type GetApiV1SettingsClubJoinCodeIssuedResponses = {
    /**
     * OK
     */
    200: IssuedClubJoinCodeResponse;
};

export type GetApiV1SettingsClubJoinCodeIssuedResponse = GetApiV1SettingsClubJoinCodeIssuedResponses[keyof GetApiV1SettingsClubJoinCodeIssuedResponses];

export type GetApiV1SettingsClubProfileData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/club/profile';
};

export type GetApiV1SettingsClubProfileErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsClubProfileError = GetApiV1SettingsClubProfileErrors[keyof GetApiV1SettingsClubProfileErrors];

export type GetApiV1SettingsClubProfileResponses = {
    /**
     * OK
     */
    200: ClubProfileDto;
};

export type GetApiV1SettingsClubProfileResponse = GetApiV1SettingsClubProfileResponses[keyof GetApiV1SettingsClubProfileResponses];

export type PatchApiV1SettingsClubProfileData = {
    body: ClubProfilePayload;
    path?: never;
    query?: never;
    url: '/api/v1/settings/club/profile';
};

export type PatchApiV1SettingsClubProfileErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SettingsClubProfileError = PatchApiV1SettingsClubProfileErrors[keyof PatchApiV1SettingsClubProfileErrors];

export type PatchApiV1SettingsClubProfileResponses = {
    /**
     * OK
     */
    200: ClubProfileDto;
};

export type PatchApiV1SettingsClubProfileResponse = PatchApiV1SettingsClubProfileResponses[keyof PatchApiV1SettingsClubProfileResponses];

export type GetApiV1SettingsClubReceiptFormData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/club/receipt-form';
};

export type GetApiV1SettingsClubReceiptFormErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsClubReceiptFormError = GetApiV1SettingsClubReceiptFormErrors[keyof GetApiV1SettingsClubReceiptFormErrors];

export type GetApiV1SettingsClubReceiptFormResponses = {
    /**
     * OK
     */
    200: ReceiptFormDto;
};

export type GetApiV1SettingsClubReceiptFormResponse = GetApiV1SettingsClubReceiptFormResponses[keyof GetApiV1SettingsClubReceiptFormResponses];

export type GetApiV1SettingsClubScheduleData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/club/schedule';
};

export type GetApiV1SettingsClubScheduleErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsClubScheduleError = GetApiV1SettingsClubScheduleErrors[keyof GetApiV1SettingsClubScheduleErrors];

export type GetApiV1SettingsClubScheduleResponses = {
    /**
     * OK
     */
    200: ClubScheduleDto;
};

export type GetApiV1SettingsClubScheduleResponse = GetApiV1SettingsClubScheduleResponses[keyof GetApiV1SettingsClubScheduleResponses];

export type PatchApiV1SettingsClubScheduleData = {
    body: ClubSchedulePayload;
    path?: never;
    query?: never;
    url: '/api/v1/settings/club/schedule';
};

export type PatchApiV1SettingsClubScheduleErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SettingsClubScheduleError = PatchApiV1SettingsClubScheduleErrors[keyof PatchApiV1SettingsClubScheduleErrors];

export type PatchApiV1SettingsClubScheduleResponses = {
    /**
     * OK
     */
    200: ClubScheduleDto;
};

export type PatchApiV1SettingsClubScheduleResponse = PatchApiV1SettingsClubScheduleResponses[keyof PatchApiV1SettingsClubScheduleResponses];

export type GetApiV1SettingsCourtOptionsData = {
    body?: never;
    path?: never;
    query?: {
        includeDisabled?: boolean;
    };
    url: '/api/v1/settings/court-options';
};

export type GetApiV1SettingsCourtOptionsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsCourtOptionsError = GetApiV1SettingsCourtOptionsErrors[keyof GetApiV1SettingsCourtOptionsErrors];

export type GetApiV1SettingsCourtOptionsResponses = {
    /**
     * OK
     */
    200: CourtOptionListResponse;
};

export type GetApiV1SettingsCourtOptionsResponse = GetApiV1SettingsCourtOptionsResponses[keyof GetApiV1SettingsCourtOptionsResponses];

export type PostApiV1SettingsCourtOptionsData = {
    body: CreateCourtOptionPayload;
    path?: never;
    query?: never;
    url: '/api/v1/settings/court-options';
};

export type PostApiV1SettingsCourtOptionsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SettingsCourtOptionsError = PostApiV1SettingsCourtOptionsErrors[keyof PostApiV1SettingsCourtOptionsErrors];

export type PostApiV1SettingsCourtOptionsResponses = {
    /**
     * Created
     */
    201: CourtOptionDto;
};

export type PostApiV1SettingsCourtOptionsResponse = PostApiV1SettingsCourtOptionsResponses[keyof PostApiV1SettingsCourtOptionsResponses];

export type DeleteApiV1SettingsCourtOptionsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/settings/court-options/{id}';
};

export type DeleteApiV1SettingsCourtOptionsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1SettingsCourtOptionsByIdError = DeleteApiV1SettingsCourtOptionsByIdErrors[keyof DeleteApiV1SettingsCourtOptionsByIdErrors];

export type DeleteApiV1SettingsCourtOptionsByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1SettingsCourtOptionsByIdResponse = DeleteApiV1SettingsCourtOptionsByIdResponses[keyof DeleteApiV1SettingsCourtOptionsByIdResponses];

export type PatchApiV1SettingsCourtOptionsByIdData = {
    body: UpdateCourtOptionPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/settings/court-options/{id}';
};

export type PatchApiV1SettingsCourtOptionsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SettingsCourtOptionsByIdError = PatchApiV1SettingsCourtOptionsByIdErrors[keyof PatchApiV1SettingsCourtOptionsByIdErrors];

export type PatchApiV1SettingsCourtOptionsByIdResponses = {
    /**
     * OK
     */
    200: CourtOptionDto;
};

export type PatchApiV1SettingsCourtOptionsByIdResponse = PatchApiV1SettingsCourtOptionsByIdResponses[keyof PatchApiV1SettingsCourtOptionsByIdResponses];

export type GetApiV1SettingsCourtsData = {
    body?: never;
    path?: never;
    query?: {
        includeArchived?: boolean;
    };
    url: '/api/v1/settings/courts';
};

export type GetApiV1SettingsCourtsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsCourtsError = GetApiV1SettingsCourtsErrors[keyof GetApiV1SettingsCourtsErrors];

export type GetApiV1SettingsCourtsResponses = {
    /**
     * OK
     */
    200: CourtListResponse;
};

export type GetApiV1SettingsCourtsResponse = GetApiV1SettingsCourtsResponses[keyof GetApiV1SettingsCourtsResponses];

export type PostApiV1SettingsCourtsData = {
    body: CreateCourtPayload;
    path?: never;
    query?: never;
    url: '/api/v1/settings/courts';
};

export type PostApiV1SettingsCourtsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SettingsCourtsError = PostApiV1SettingsCourtsErrors[keyof PostApiV1SettingsCourtsErrors];

export type PostApiV1SettingsCourtsResponses = {
    /**
     * Created
     */
    201: CourtDto;
};

export type PostApiV1SettingsCourtsResponse = PostApiV1SettingsCourtsResponses[keyof PostApiV1SettingsCourtsResponses];

export type DeleteApiV1SettingsCourtsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/settings/courts/{id}';
};

export type DeleteApiV1SettingsCourtsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1SettingsCourtsByIdError = DeleteApiV1SettingsCourtsByIdErrors[keyof DeleteApiV1SettingsCourtsByIdErrors];

export type DeleteApiV1SettingsCourtsByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1SettingsCourtsByIdResponse = DeleteApiV1SettingsCourtsByIdResponses[keyof DeleteApiV1SettingsCourtsByIdResponses];

export type PatchApiV1SettingsCourtsByIdData = {
    body: UpdateCourtPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/settings/courts/{id}';
};

export type PatchApiV1SettingsCourtsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SettingsCourtsByIdError = PatchApiV1SettingsCourtsByIdErrors[keyof PatchApiV1SettingsCourtsByIdErrors];

export type PatchApiV1SettingsCourtsByIdResponses = {
    /**
     * OK
     */
    200: CourtDto;
};

export type PatchApiV1SettingsCourtsByIdResponse = PatchApiV1SettingsCourtsByIdResponses[keyof PatchApiV1SettingsCourtsByIdResponses];

export type GetApiV1SettingsFitnessData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/fitness';
};

export type GetApiV1SettingsFitnessErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsFitnessError = GetApiV1SettingsFitnessErrors[keyof GetApiV1SettingsFitnessErrors];

export type GetApiV1SettingsFitnessResponses = {
    /**
     * OK
     */
    200: FitnessPolicyDto;
};

export type GetApiV1SettingsFitnessResponse = GetApiV1SettingsFitnessResponses[keyof GetApiV1SettingsFitnessResponses];

export type PatchApiV1SettingsFitnessData = {
    body: FitnessPolicyPayload;
    path?: never;
    query?: never;
    url: '/api/v1/settings/fitness';
};

export type PatchApiV1SettingsFitnessErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SettingsFitnessError = PatchApiV1SettingsFitnessErrors[keyof PatchApiV1SettingsFitnessErrors];

export type PatchApiV1SettingsFitnessResponses = {
    /**
     * OK
     */
    200: FitnessPolicyDto;
};

export type PatchApiV1SettingsFitnessResponse = PatchApiV1SettingsFitnessResponses[keyof PatchApiV1SettingsFitnessResponses];

export type GetApiV1SettingsFriendsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/friends';
};

export type GetApiV1SettingsFriendsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsFriendsError = GetApiV1SettingsFriendsErrors[keyof GetApiV1SettingsFriendsErrors];

export type GetApiV1SettingsFriendsResponses = {
    /**
     * OK
     */
    200: FriendsPolicyDto;
};

export type GetApiV1SettingsFriendsResponse = GetApiV1SettingsFriendsResponses[keyof GetApiV1SettingsFriendsResponses];

export type PatchApiV1SettingsFriendsData = {
    body: FriendsPolicyPayload;
    path?: never;
    query?: never;
    url: '/api/v1/settings/friends';
};

export type PatchApiV1SettingsFriendsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SettingsFriendsError = PatchApiV1SettingsFriendsErrors[keyof PatchApiV1SettingsFriendsErrors];

export type PatchApiV1SettingsFriendsResponses = {
    /**
     * OK
     */
    200: FriendsPolicyDto;
};

export type PatchApiV1SettingsFriendsResponse = PatchApiV1SettingsFriendsResponses[keyof PatchApiV1SettingsFriendsResponses];

export type GetApiV1SettingsGridData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/grid';
};

export type GetApiV1SettingsGridErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsGridError = GetApiV1SettingsGridErrors[keyof GetApiV1SettingsGridErrors];

export type GetApiV1SettingsGridResponses = {
    /**
     * OK
     */
    200: GridConfigDto;
};

export type GetApiV1SettingsGridResponse = GetApiV1SettingsGridResponses[keyof GetApiV1SettingsGridResponses];

export type PatchApiV1SettingsGridData = {
    body: GridConfigPayload;
    path?: never;
    query?: never;
    url: '/api/v1/settings/grid';
};

export type PatchApiV1SettingsGridErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SettingsGridError = PatchApiV1SettingsGridErrors[keyof PatchApiV1SettingsGridErrors];

export type PatchApiV1SettingsGridResponses = {
    /**
     * OK
     */
    200: GridConfigDto;
};

export type PatchApiV1SettingsGridResponse = PatchApiV1SettingsGridResponses[keyof PatchApiV1SettingsGridResponses];

export type GetApiV1SettingsIntegrationsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/integrations';
};

export type GetApiV1SettingsIntegrationsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsIntegrationsError = GetApiV1SettingsIntegrationsErrors[keyof GetApiV1SettingsIntegrationsErrors];

export type GetApiV1SettingsIntegrationsResponses = {
    /**
     * OK
     */
    200: Array<IntegrationDto>;
};

export type GetApiV1SettingsIntegrationsResponse = GetApiV1SettingsIntegrationsResponses[keyof GetApiV1SettingsIntegrationsResponses];

export type PatchApiV1SettingsIntegrationsByKindData = {
    body: IntegrationPayload;
    path: {
        kind: string;
    };
    query?: never;
    url: '/api/v1/settings/integrations/{kind}';
};

export type PatchApiV1SettingsIntegrationsByKindErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SettingsIntegrationsByKindError = PatchApiV1SettingsIntegrationsByKindErrors[keyof PatchApiV1SettingsIntegrationsByKindErrors];

export type PatchApiV1SettingsIntegrationsByKindResponses = {
    /**
     * OK
     */
    200: IntegrationDto;
};

export type PatchApiV1SettingsIntegrationsByKindResponse = PatchApiV1SettingsIntegrationsByKindResponses[keyof PatchApiV1SettingsIntegrationsByKindResponses];

export type GetApiV1SettingsIntegrationsByKindSecretByKeyData = {
    body?: never;
    path: {
        kind: string;
        key: string;
    };
    query?: never;
    url: '/api/v1/settings/integrations/{kind}/secret/{key}';
};

export type GetApiV1SettingsIntegrationsByKindSecretByKeyErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsIntegrationsByKindSecretByKeyError = GetApiV1SettingsIntegrationsByKindSecretByKeyErrors[keyof GetApiV1SettingsIntegrationsByKindSecretByKeyErrors];

export type GetApiV1SettingsIntegrationsByKindSecretByKeyResponses = {
    /**
     * OK
     */
    200: IntegrationSecretDto;
};

export type GetApiV1SettingsIntegrationsByKindSecretByKeyResponse = GetApiV1SettingsIntegrationsByKindSecretByKeyResponses[keyof GetApiV1SettingsIntegrationsByKindSecretByKeyResponses];

export type GetApiV1SettingsPaymentProvidersData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/payment-providers';
};

export type GetApiV1SettingsPaymentProvidersErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsPaymentProvidersError = GetApiV1SettingsPaymentProvidersErrors[keyof GetApiV1SettingsPaymentProvidersErrors];

export type GetApiV1SettingsPaymentProvidersResponses = {
    /**
     * OK
     */
    200: Array<PaymentProviderDto>;
};

export type GetApiV1SettingsPaymentProvidersResponse = GetApiV1SettingsPaymentProvidersResponses[keyof GetApiV1SettingsPaymentProvidersResponses];

export type PatchApiV1SettingsPaymentProvidersByProviderData = {
    body: PatchPaymentProviderBody;
    path: {
        provider: string;
    };
    query?: never;
    url: '/api/v1/settings/payment-providers/{provider}';
};

export type PatchApiV1SettingsPaymentProvidersByProviderErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SettingsPaymentProvidersByProviderError = PatchApiV1SettingsPaymentProvidersByProviderErrors[keyof PatchApiV1SettingsPaymentProvidersByProviderErrors];

export type PatchApiV1SettingsPaymentProvidersByProviderResponses = {
    /**
     * OK
     */
    200: PaymentProviderDto;
};

export type PatchApiV1SettingsPaymentProvidersByProviderResponse = PatchApiV1SettingsPaymentProvidersByProviderResponses[keyof PatchApiV1SettingsPaymentProvidersByProviderResponses];

export type PostApiV1SettingsPaymentProvidersByProviderOnlineReceiptsData = {
    body: SetOnlineReceiptsBody;
    path: {
        provider: string;
    };
    query?: never;
    url: '/api/v1/settings/payment-providers/{provider}/online-receipts';
};

export type PostApiV1SettingsPaymentProvidersByProviderOnlineReceiptsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SettingsPaymentProvidersByProviderOnlineReceiptsError = PostApiV1SettingsPaymentProvidersByProviderOnlineReceiptsErrors[keyof PostApiV1SettingsPaymentProvidersByProviderOnlineReceiptsErrors];

export type PostApiV1SettingsPaymentProvidersByProviderOnlineReceiptsResponses = {
    /**
     * OK
     */
    200: PaymentProviderDto;
};

export type PostApiV1SettingsPaymentProvidersByProviderOnlineReceiptsResponse = PostApiV1SettingsPaymentProvidersByProviderOnlineReceiptsResponses[keyof PostApiV1SettingsPaymentProvidersByProviderOnlineReceiptsResponses];

export type PostApiV1SettingsPaymentProvidersByProviderWebhookAddressData = {
    body?: never;
    path: {
        provider: string;
    };
    query?: never;
    url: '/api/v1/settings/payment-providers/{provider}/webhook-address';
};

export type PostApiV1SettingsPaymentProvidersByProviderWebhookAddressErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SettingsPaymentProvidersByProviderWebhookAddressError = PostApiV1SettingsPaymentProvidersByProviderWebhookAddressErrors[keyof PostApiV1SettingsPaymentProvidersByProviderWebhookAddressErrors];

export type PostApiV1SettingsPaymentProvidersByProviderWebhookAddressResponses = {
    /**
     * OK
     */
    200: PaymentProviderDto;
};

export type PostApiV1SettingsPaymentProvidersByProviderWebhookAddressResponse = PostApiV1SettingsPaymentProvidersByProviderWebhookAddressResponses[keyof PostApiV1SettingsPaymentProvidersByProviderWebhookAddressResponses];

export type GetApiV1SettingsPermissionsCatalogueData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/permissions/catalogue';
};

export type GetApiV1SettingsPermissionsCatalogueErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsPermissionsCatalogueError = GetApiV1SettingsPermissionsCatalogueErrors[keyof GetApiV1SettingsPermissionsCatalogueErrors];

export type GetApiV1SettingsPermissionsCatalogueResponses = {
    /**
     * OK
     */
    200: PermissionCatalogueDto;
};

export type GetApiV1SettingsPermissionsCatalogueResponse = GetApiV1SettingsPermissionsCatalogueResponses[keyof GetApiV1SettingsPermissionsCatalogueResponses];

export type GetApiV1SettingsRatingPolicyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/rating-policy';
};

export type GetApiV1SettingsRatingPolicyErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsRatingPolicyError = GetApiV1SettingsRatingPolicyErrors[keyof GetApiV1SettingsRatingPolicyErrors];

export type GetApiV1SettingsRatingPolicyResponses = {
    /**
     * OK
     */
    200: RatingPolicyDto;
};

export type GetApiV1SettingsRatingPolicyResponse = GetApiV1SettingsRatingPolicyResponses[keyof GetApiV1SettingsRatingPolicyResponses];

export type PatchApiV1SettingsRatingPolicyData = {
    body: RatingPolicyPayload;
    path?: never;
    query?: never;
    url: '/api/v1/settings/rating-policy';
};

export type PatchApiV1SettingsRatingPolicyErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SettingsRatingPolicyError = PatchApiV1SettingsRatingPolicyErrors[keyof PatchApiV1SettingsRatingPolicyErrors];

export type PatchApiV1SettingsRatingPolicyResponses = {
    /**
     * OK
     */
    200: RatingPolicyDto;
};

export type PatchApiV1SettingsRatingPolicyResponse = PatchApiV1SettingsRatingPolicyResponses[keyof PatchApiV1SettingsRatingPolicyResponses];

export type GetApiV1SettingsRemindersData = {
    body?: never;
    path?: never;
    query?: {
        includeDisabled?: boolean;
    };
    url: '/api/v1/settings/reminders';
};

export type GetApiV1SettingsRemindersErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsRemindersError = GetApiV1SettingsRemindersErrors[keyof GetApiV1SettingsRemindersErrors];

export type GetApiV1SettingsRemindersResponses = {
    /**
     * OK
     */
    200: Array<ReminderScheduleDto>;
};

export type GetApiV1SettingsRemindersResponse = GetApiV1SettingsRemindersResponses[keyof GetApiV1SettingsRemindersResponses];

export type PostApiV1SettingsRemindersData = {
    body: CreateReminderPayload;
    path?: never;
    query?: never;
    url: '/api/v1/settings/reminders';
};

export type PostApiV1SettingsRemindersErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SettingsRemindersError = PostApiV1SettingsRemindersErrors[keyof PostApiV1SettingsRemindersErrors];

export type PostApiV1SettingsRemindersResponses = {
    /**
     * Created
     */
    201: ReminderScheduleDto;
};

export type PostApiV1SettingsRemindersResponse = PostApiV1SettingsRemindersResponses[keyof PostApiV1SettingsRemindersResponses];

export type DeleteApiV1SettingsRemindersByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/settings/reminders/{id}';
};

export type DeleteApiV1SettingsRemindersByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1SettingsRemindersByIdError = DeleteApiV1SettingsRemindersByIdErrors[keyof DeleteApiV1SettingsRemindersByIdErrors];

export type DeleteApiV1SettingsRemindersByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1SettingsRemindersByIdResponse = DeleteApiV1SettingsRemindersByIdResponses[keyof DeleteApiV1SettingsRemindersByIdResponses];

export type PatchApiV1SettingsRemindersByIdData = {
    body: UpdateReminderPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/settings/reminders/{id}';
};

export type PatchApiV1SettingsRemindersByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SettingsRemindersByIdError = PatchApiV1SettingsRemindersByIdErrors[keyof PatchApiV1SettingsRemindersByIdErrors];

export type PatchApiV1SettingsRemindersByIdResponses = {
    /**
     * OK
     */
    200: ReminderScheduleDto;
};

export type PatchApiV1SettingsRemindersByIdResponse = PatchApiV1SettingsRemindersByIdResponses[keyof PatchApiV1SettingsRemindersByIdResponses];

export type GetApiV1SettingsRolesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/roles';
};

export type GetApiV1SettingsRolesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsRolesError = GetApiV1SettingsRolesErrors[keyof GetApiV1SettingsRolesErrors];

export type GetApiV1SettingsRolesResponses = {
    /**
     * OK
     */
    200: Array<RoleConfigDto>;
};

export type GetApiV1SettingsRolesResponse = GetApiV1SettingsRolesResponses[keyof GetApiV1SettingsRolesResponses];

export type PostApiV1SettingsRolesData = {
    body: CreateClubRolePayload;
    path?: never;
    query?: never;
    url: '/api/v1/settings/roles';
};

export type PostApiV1SettingsRolesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SettingsRolesError = PostApiV1SettingsRolesErrors[keyof PostApiV1SettingsRolesErrors];

export type PostApiV1SettingsRolesResponses = {
    /**
     * OK
     */
    200: RoleConfigDto;
};

export type PostApiV1SettingsRolesResponse = PostApiV1SettingsRolesResponses[keyof PostApiV1SettingsRolesResponses];

export type DeleteApiV1SettingsRolesByCodeData = {
    body?: never;
    path: {
        code: string;
    };
    query?: never;
    url: '/api/v1/settings/roles/{code}';
};

export type DeleteApiV1SettingsRolesByCodeResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PatchApiV1SettingsRolesByCodeData = {
    body: RolePayload;
    path: {
        code: string;
    };
    query?: never;
    url: '/api/v1/settings/roles/{code}';
};

export type PatchApiV1SettingsRolesByCodeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SettingsRolesByCodeError = PatchApiV1SettingsRolesByCodeErrors[keyof PatchApiV1SettingsRolesByCodeErrors];

export type PatchApiV1SettingsRolesByCodeResponses = {
    /**
     * OK
     */
    200: RoleConfigDto;
};

export type PatchApiV1SettingsRolesByCodeResponse = PatchApiV1SettingsRolesByCodeResponses[keyof PatchApiV1SettingsRolesByCodeResponses];

export type GetApiV1SettingsSlotPolicyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/slot-policy';
};

export type GetApiV1SettingsSlotPolicyErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsSlotPolicyError = GetApiV1SettingsSlotPolicyErrors[keyof GetApiV1SettingsSlotPolicyErrors];

export type GetApiV1SettingsSlotPolicyResponses = {
    /**
     * OK
     */
    200: SlotPolicyDto;
};

export type GetApiV1SettingsSlotPolicyResponse = GetApiV1SettingsSlotPolicyResponses[keyof GetApiV1SettingsSlotPolicyResponses];

export type PatchApiV1SettingsSlotPolicyData = {
    body: SlotPolicyPayload;
    path?: never;
    query?: never;
    url: '/api/v1/settings/slot-policy';
};

export type PatchApiV1SettingsSlotPolicyErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SettingsSlotPolicyError = PatchApiV1SettingsSlotPolicyErrors[keyof PatchApiV1SettingsSlotPolicyErrors];

export type PatchApiV1SettingsSlotPolicyResponses = {
    /**
     * OK
     */
    200: SlotPolicyDto;
};

export type PatchApiV1SettingsSlotPolicyResponse = PatchApiV1SettingsSlotPolicyResponses[keyof PatchApiV1SettingsSlotPolicyResponses];

export type GetApiV1SettingsTaxData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/tax';
};

export type GetApiV1SettingsTaxErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsTaxError = GetApiV1SettingsTaxErrors[keyof GetApiV1SettingsTaxErrors];

export type GetApiV1SettingsTaxResponses = {
    /**
     * OK
     */
    200: TaxConfigDto;
};

export type GetApiV1SettingsTaxResponse = GetApiV1SettingsTaxResponses[keyof GetApiV1SettingsTaxResponses];

export type PatchApiV1SettingsTaxData = {
    body: TaxConfigPayload;
    path?: never;
    query?: never;
    url: '/api/v1/settings/tax';
};

export type PatchApiV1SettingsTaxErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SettingsTaxError = PatchApiV1SettingsTaxErrors[keyof PatchApiV1SettingsTaxErrors];

export type PatchApiV1SettingsTaxResponses = {
    /**
     * OK
     */
    200: TaxConfigDto;
};

export type PatchApiV1SettingsTaxResponse = PatchApiV1SettingsTaxResponses[keyof PatchApiV1SettingsTaxResponses];

export type GetApiV1SettingsUsersData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/settings/users';
};

export type GetApiV1SettingsUsersErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SettingsUsersError = GetApiV1SettingsUsersErrors[keyof GetApiV1SettingsUsersErrors];

export type GetApiV1SettingsUsersResponses = {
    /**
     * OK
     */
    200: ListUsersResponse;
};

export type GetApiV1SettingsUsersResponse = GetApiV1SettingsUsersResponses[keyof GetApiV1SettingsUsersResponses];

export type PostApiV1SplitDebtsBySplitIdClientsByClientIdPayFromAdvanceData = {
    body?: never;
    path: {
        splitId: string;
        clientId: string;
    };
    query?: never;
    url: '/api/v1/split-debts/{splitId}/clients/{clientId}/pay-from-advance';
};

export type PostApiV1SplitDebtsBySplitIdClientsByClientIdPayFromAdvanceErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SplitDebtsBySplitIdClientsByClientIdPayFromAdvanceError = PostApiV1SplitDebtsBySplitIdClientsByClientIdPayFromAdvanceErrors[keyof PostApiV1SplitDebtsBySplitIdClientsByClientIdPayFromAdvanceErrors];

export type PostApiV1SplitDebtsBySplitIdClientsByClientIdPayFromAdvanceResponses = {
    /**
     * OK
     */
    200: PaySplitDebtResponse;
};

export type PostApiV1SplitDebtsBySplitIdClientsByClientIdPayFromAdvanceResponse = PostApiV1SplitDebtsBySplitIdClientsByClientIdPayFromAdvanceResponses[keyof PostApiV1SplitDebtsBySplitIdClientsByClientIdPayFromAdvanceResponses];

export type PostApiV1SplitDebtsBySplitIdPayData = {
    body?: never;
    path: {
        splitId: string;
    };
    query?: never;
    url: '/api/v1/split-debts/{splitId}/pay';
};

export type PostApiV1SplitDebtsBySplitIdPayErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SplitDebtsBySplitIdPayError = PostApiV1SplitDebtsBySplitIdPayErrors[keyof PostApiV1SplitDebtsBySplitIdPayErrors];

export type PostApiV1SplitDebtsBySplitIdPayResponses = {
    /**
     * OK
     */
    200: PaySplitDebtResponse;
};

export type PostApiV1SplitDebtsBySplitIdPayResponse = PostApiV1SplitDebtsBySplitIdPayResponses[keyof PostApiV1SplitDebtsBySplitIdPayResponses];

export type GetApiV1SportsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/sports';
};

export type GetApiV1SportsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SportsError = GetApiV1SportsErrors[keyof GetApiV1SportsErrors];

export type GetApiV1SportsResponses = {
    /**
     * OK
     */
    200: SportListResponse;
};

export type GetApiV1SportsResponse = GetApiV1SportsResponses[keyof GetApiV1SportsResponses];

export type PostApiV1SportsData = {
    body: CreateSportPayload;
    path?: never;
    query?: never;
    url: '/api/v1/sports';
};

export type PostApiV1SportsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SportsError = PostApiV1SportsErrors[keyof PostApiV1SportsErrors];

export type PostApiV1SportsResponses = {
    /**
     * Created
     */
    201: SportDto;
};

export type PostApiV1SportsResponse = PostApiV1SportsResponses[keyof PostApiV1SportsResponses];

export type DeleteApiV1SportsByCodeData = {
    body?: never;
    path: {
        code: string;
    };
    query?: never;
    url: '/api/v1/sports/{code}';
};

export type DeleteApiV1SportsByCodeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1SportsByCodeError = DeleteApiV1SportsByCodeErrors[keyof DeleteApiV1SportsByCodeErrors];

export type DeleteApiV1SportsByCodeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1SportsByCodeResponse = DeleteApiV1SportsByCodeResponses[keyof DeleteApiV1SportsByCodeResponses];

export type PatchApiV1SportsByCodeData = {
    body: UpdateSportPayload;
    path: {
        code: string;
    };
    query?: never;
    url: '/api/v1/sports/{code}';
};

export type PatchApiV1SportsByCodeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SportsByCodeError = PatchApiV1SportsByCodeErrors[keyof PatchApiV1SportsByCodeErrors];

export type PatchApiV1SportsByCodeResponses = {
    /**
     * OK
     */
    200: SportDto;
};

export type PatchApiV1SportsByCodeResponse = PatchApiV1SportsByCodeResponses[keyof PatchApiV1SportsByCodeResponses];

export type GetApiV1SportsByCodeUnfinishedData = {
    body?: never;
    path: {
        code: string;
    };
    query?: never;
    url: '/api/v1/sports/{code}/unfinished';
};

export type GetApiV1SportsByCodeUnfinishedErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SportsByCodeUnfinishedError = GetApiV1SportsByCodeUnfinishedErrors[keyof GetApiV1SportsByCodeUnfinishedErrors];

export type GetApiV1SportsByCodeUnfinishedResponses = {
    /**
     * OK
     */
    200: SportUnfinishedResponse;
};

export type GetApiV1SportsByCodeUnfinishedResponse = GetApiV1SportsByCodeUnfinishedResponses[keyof GetApiV1SportsByCodeUnfinishedResponses];

export type GetApiV1StaffContentData = {
    body?: never;
    path?: never;
    query?: {
        kind?: NewsKind;
        topic?: string;
    };
    url: '/api/v1/staff/content';
};

export type GetApiV1StaffContentErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1StaffContentError = GetApiV1StaffContentErrors[keyof GetApiV1StaffContentErrors];

export type GetApiV1StaffContentResponses = {
    /**
     * OK
     */
    200: StaffContentListResponse;
};

export type GetApiV1StaffContentResponse = GetApiV1StaffContentResponses[keyof GetApiV1StaffContentResponses];

export type PostApiV1StaffContentData = {
    body: StaffContentInput;
    path?: never;
    query?: never;
    url: '/api/v1/staff/content';
};

export type PostApiV1StaffContentErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1StaffContentError = PostApiV1StaffContentErrors[keyof PostApiV1StaffContentErrors];

export type PostApiV1StaffContentResponses = {
    /**
     * Created
     */
    201: NewsAdminDto;
};

export type PostApiV1StaffContentResponse = PostApiV1StaffContentResponses[keyof PostApiV1StaffContentResponses];

export type GetApiV1StaffContentAnnouncementsPendingData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/staff/content/announcements/pending';
};

export type GetApiV1StaffContentAnnouncementsPendingErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1StaffContentAnnouncementsPendingError = GetApiV1StaffContentAnnouncementsPendingErrors[keyof GetApiV1StaffContentAnnouncementsPendingErrors];

export type GetApiV1StaffContentAnnouncementsPendingResponses = {
    /**
     * OK
     */
    200: StaffContentListResponse;
};

export type GetApiV1StaffContentAnnouncementsPendingResponse = GetApiV1StaffContentAnnouncementsPendingResponses[keyof GetApiV1StaffContentAnnouncementsPendingResponses];

export type GetApiV1StaffContentProposalsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/staff/content/proposals';
};

export type GetApiV1StaffContentProposalsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1StaffContentProposalsError = GetApiV1StaffContentProposalsErrors[keyof GetApiV1StaffContentProposalsErrors];

export type GetApiV1StaffContentProposalsResponses = {
    /**
     * OK
     */
    200: StaffProposalListResponse;
};

export type GetApiV1StaffContentProposalsResponse = GetApiV1StaffContentProposalsResponses[keyof GetApiV1StaffContentProposalsResponses];

export type PostApiV1StaffContentProposalsData = {
    body: StaffContentInput;
    path?: never;
    query?: never;
    url: '/api/v1/staff/content/proposals';
};

export type PostApiV1StaffContentProposalsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1StaffContentProposalsError = PostApiV1StaffContentProposalsErrors[keyof PostApiV1StaffContentProposalsErrors];

export type PostApiV1StaffContentProposalsResponses = {
    /**
     * Created
     */
    201: NewsAdminDto;
};

export type PostApiV1StaffContentProposalsResponse = PostApiV1StaffContentProposalsResponses[keyof PostApiV1StaffContentProposalsResponses];

export type GetApiV1StaffContentProposalsMineData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/staff/content/proposals/mine';
};

export type GetApiV1StaffContentProposalsMineErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1StaffContentProposalsMineError = GetApiV1StaffContentProposalsMineErrors[keyof GetApiV1StaffContentProposalsMineErrors];

export type GetApiV1StaffContentProposalsMineResponses = {
    /**
     * OK
     */
    200: StaffProposalListResponse;
};

export type GetApiV1StaffContentProposalsMineResponse = GetApiV1StaffContentProposalsMineResponses[keyof GetApiV1StaffContentProposalsMineResponses];

export type PutApiV1StaffContentProposalsByIdData = {
    body: StaffContentInput;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/staff/content/proposals/{id}';
};

export type PutApiV1StaffContentProposalsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1StaffContentProposalsByIdError = PutApiV1StaffContentProposalsByIdErrors[keyof PutApiV1StaffContentProposalsByIdErrors];

export type PutApiV1StaffContentProposalsByIdResponses = {
    /**
     * OK
     */
    200: NewsAdminDto;
};

export type PutApiV1StaffContentProposalsByIdResponse = PutApiV1StaffContentProposalsByIdResponses[keyof PutApiV1StaffContentProposalsByIdResponses];

export type GetApiV1StaffContentByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/staff/content/{id}';
};

export type GetApiV1StaffContentByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1StaffContentByIdError = GetApiV1StaffContentByIdErrors[keyof GetApiV1StaffContentByIdErrors];

export type GetApiV1StaffContentByIdResponses = {
    /**
     * OK
     */
    200: StaffContentDto;
};

export type GetApiV1StaffContentByIdResponse = GetApiV1StaffContentByIdResponses[keyof GetApiV1StaffContentByIdResponses];

export type PostApiV1StaffContentByIdAckData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/staff/content/{id}/ack';
};

export type PostApiV1StaffContentByIdAckErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1StaffContentByIdAckError = PostApiV1StaffContentByIdAckErrors[keyof PostApiV1StaffContentByIdAckErrors];

export type PostApiV1StaffContentByIdAckResponses = {
    /**
     * OK
     */
    200: StaffContentDto;
};

export type PostApiV1StaffContentByIdAckResponse = PostApiV1StaffContentByIdAckResponses[keyof PostApiV1StaffContentByIdAckResponses];

export type PostApiV1StaffContentByIdApproveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/staff/content/{id}/approve';
};

export type PostApiV1StaffContentByIdApproveErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1StaffContentByIdApproveError = PostApiV1StaffContentByIdApproveErrors[keyof PostApiV1StaffContentByIdApproveErrors];

export type PostApiV1StaffContentByIdApproveResponses = {
    /**
     * OK
     */
    200: NewsAdminDto;
};

export type PostApiV1StaffContentByIdApproveResponse = PostApiV1StaffContentByIdApproveResponses[keyof PostApiV1StaffContentByIdApproveResponses];

export type PostApiV1StaffContentByIdRejectData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/staff/content/{id}/reject';
};

export type PostApiV1StaffContentByIdRejectErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1StaffContentByIdRejectError = PostApiV1StaffContentByIdRejectErrors[keyof PostApiV1StaffContentByIdRejectErrors];

export type PostApiV1StaffContentByIdRejectResponses = {
    /**
     * OK
     */
    200: NewsAdminDto;
};

export type PostApiV1StaffContentByIdRejectResponse = PostApiV1StaffContentByIdRejectResponses[keyof PostApiV1StaffContentByIdRejectResponses];

export type GetApiV1SubscriptionTemplatesData = {
    body?: never;
    path?: never;
    query?: {
        includeDisabled?: boolean;
    };
    url: '/api/v1/subscription-templates';
};

export type GetApiV1SubscriptionTemplatesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SubscriptionTemplatesError = GetApiV1SubscriptionTemplatesErrors[keyof GetApiV1SubscriptionTemplatesErrors];

export type GetApiV1SubscriptionTemplatesResponses = {
    /**
     * OK
     */
    200: SubscriptionTemplateListResponse;
};

export type GetApiV1SubscriptionTemplatesResponse = GetApiV1SubscriptionTemplatesResponses[keyof GetApiV1SubscriptionTemplatesResponses];

export type PostApiV1SubscriptionTemplatesData = {
    body: CreateSubscriptionTemplatePayload;
    path?: never;
    query?: never;
    url: '/api/v1/subscription-templates';
};

export type PostApiV1SubscriptionTemplatesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SubscriptionTemplatesError = PostApiV1SubscriptionTemplatesErrors[keyof PostApiV1SubscriptionTemplatesErrors];

export type PostApiV1SubscriptionTemplatesResponses = {
    /**
     * Created
     */
    201: SubscriptionTemplateDto;
};

export type PostApiV1SubscriptionTemplatesResponse = PostApiV1SubscriptionTemplatesResponses[keyof PostApiV1SubscriptionTemplatesResponses];

export type GetApiV1SubscriptionTemplatesSalesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/subscription-templates/sales';
};

export type GetApiV1SubscriptionTemplatesSalesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SubscriptionTemplatesSalesError = GetApiV1SubscriptionTemplatesSalesErrors[keyof GetApiV1SubscriptionTemplatesSalesErrors];

export type GetApiV1SubscriptionTemplatesSalesResponses = {
    /**
     * OK
     */
    200: TemplateSalesResponse;
};

export type GetApiV1SubscriptionTemplatesSalesResponse = GetApiV1SubscriptionTemplatesSalesResponses[keyof GetApiV1SubscriptionTemplatesSalesResponses];

export type DeleteApiV1SubscriptionTemplatesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/subscription-templates/{id}';
};

export type DeleteApiV1SubscriptionTemplatesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1SubscriptionTemplatesByIdError = DeleteApiV1SubscriptionTemplatesByIdErrors[keyof DeleteApiV1SubscriptionTemplatesByIdErrors];

export type DeleteApiV1SubscriptionTemplatesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1SubscriptionTemplatesByIdResponse = DeleteApiV1SubscriptionTemplatesByIdResponses[keyof DeleteApiV1SubscriptionTemplatesByIdResponses];

export type PatchApiV1SubscriptionTemplatesByIdData = {
    body: UpdateSubscriptionTemplatePayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/subscription-templates/{id}';
};

export type PatchApiV1SubscriptionTemplatesByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SubscriptionTemplatesByIdError = PatchApiV1SubscriptionTemplatesByIdErrors[keyof PatchApiV1SubscriptionTemplatesByIdErrors];

export type PatchApiV1SubscriptionTemplatesByIdResponses = {
    /**
     * OK
     */
    200: SubscriptionTemplateDto;
};

export type PatchApiV1SubscriptionTemplatesByIdResponse = PatchApiV1SubscriptionTemplatesByIdResponses[keyof PatchApiV1SubscriptionTemplatesByIdResponses];

export type GetApiV1SubscriptionsData = {
    body?: never;
    path?: never;
    query?: {
        status?: string;
        direction?: string;
        templateId?: string;
        clientId?: string;
        clientIds?: string;
        sort?: string;
        order?: string;
        page?: number;
        pageSize?: number;
        purchasedFrom?: string;
        purchasedTo?: string;
    };
    url: '/api/v1/subscriptions';
};

export type GetApiV1SubscriptionsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SubscriptionsError = GetApiV1SubscriptionsErrors[keyof GetApiV1SubscriptionsErrors];

export type GetApiV1SubscriptionsResponses = {
    /**
     * OK
     */
    200: SubscriptionRegistryResponse;
};

export type GetApiV1SubscriptionsResponse = GetApiV1SubscriptionsResponses[keyof GetApiV1SubscriptionsResponses];

export type GetApiV1SubscriptionsAvailableData = {
    body?: never;
    path?: never;
    query?: {
        scope?: SubscriptionScope;
    };
    url: '/api/v1/subscriptions/available';
};

export type GetApiV1SubscriptionsAvailableErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SubscriptionsAvailableError = GetApiV1SubscriptionsAvailableErrors[keyof GetApiV1SubscriptionsAvailableErrors];

export type GetApiV1SubscriptionsAvailableResponses = {
    /**
     * OK
     */
    200: SubscriptionTemplateListResponse;
};

export type GetApiV1SubscriptionsAvailableResponse = GetApiV1SubscriptionsAvailableResponses[keyof GetApiV1SubscriptionsAvailableResponses];

export type PostApiV1SubscriptionsChargeData = {
    body: CreateSubscriptionChargeBody;
    path?: never;
    query?: never;
    url: '/api/v1/subscriptions/charge';
};

export type PostApiV1SubscriptionsChargeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SubscriptionsChargeError = PostApiV1SubscriptionsChargeErrors[keyof PostApiV1SubscriptionsChargeErrors];

export type PostApiV1SubscriptionsChargeResponses = {
    /**
     * Created
     */
    201: CreateSubscriptionChargeResponse;
};

export type PostApiV1SubscriptionsChargeResponse = PostApiV1SubscriptionsChargeResponses[keyof PostApiV1SubscriptionsChargeResponses];

export type GetApiV1SubscriptionsMeData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/subscriptions/me';
};

export type GetApiV1SubscriptionsMeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SubscriptionsMeError = GetApiV1SubscriptionsMeErrors[keyof GetApiV1SubscriptionsMeErrors];

export type GetApiV1SubscriptionsMeResponses = {
    /**
     * OK
     */
    200: MySubscriptionsResponse;
};

export type GetApiV1SubscriptionsMeResponse = GetApiV1SubscriptionsMeResponses[keyof GetApiV1SubscriptionsMeResponses];

export type PostApiV1SubscriptionsMeChargeData = {
    body: BuyOwnSubscriptionBody;
    path?: never;
    query?: never;
    url: '/api/v1/subscriptions/me/charge';
};

export type PostApiV1SubscriptionsMeChargeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SubscriptionsMeChargeError = PostApiV1SubscriptionsMeChargeErrors[keyof PostApiV1SubscriptionsMeChargeErrors];

export type PostApiV1SubscriptionsMeChargeResponses = {
    /**
     * Created
     */
    201: CreateSubscriptionChargeResponse;
};

export type PostApiV1SubscriptionsMeChargeResponse = PostApiV1SubscriptionsMeChargeResponses[keyof PostApiV1SubscriptionsMeChargeResponses];

export type PostApiV1SubscriptionsMeChildrenByChildIdChargeData = {
    body: BuyChildSubscriptionBody;
    path: {
        childId: string;
    };
    query?: never;
    url: '/api/v1/subscriptions/me/children/{childId}/charge';
};

export type PostApiV1SubscriptionsMeChildrenByChildIdChargeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SubscriptionsMeChildrenByChildIdChargeError = PostApiV1SubscriptionsMeChildrenByChildIdChargeErrors[keyof PostApiV1SubscriptionsMeChildrenByChildIdChargeErrors];

export type PostApiV1SubscriptionsMeChildrenByChildIdChargeResponses = {
    /**
     * Created
     */
    201: BuyChildSubscriptionResponse;
};

export type PostApiV1SubscriptionsMeChildrenByChildIdChargeResponse = PostApiV1SubscriptionsMeChildrenByChildIdChargeResponses[keyof PostApiV1SubscriptionsMeChildrenByChildIdChargeResponses];

export type GetApiV1SubscriptionsMePurchasePlanData = {
    body?: never;
    path?: never;
    query: {
        templateId: string;
        useBonuses?: boolean;
        bonusKopecks?: number;
    };
    url: '/api/v1/subscriptions/me/purchase-plan';
};

export type GetApiV1SubscriptionsMePurchasePlanErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SubscriptionsMePurchasePlanError = GetApiV1SubscriptionsMePurchasePlanErrors[keyof GetApiV1SubscriptionsMePurchasePlanErrors];

export type GetApiV1SubscriptionsMePurchasePlanResponses = {
    /**
     * OK
     */
    200: SubscriptionPurchasePlanDto;
};

export type GetApiV1SubscriptionsMePurchasePlanResponse = GetApiV1SubscriptionsMePurchasePlanResponses[keyof GetApiV1SubscriptionsMePurchasePlanResponses];

export type PostApiV1SubscriptionsMeByIdFreezeData = {
    body?: null | FreezeMySubscriptionBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/subscriptions/me/{id}/freeze';
};

export type PostApiV1SubscriptionsMeByIdFreezeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SubscriptionsMeByIdFreezeError = PostApiV1SubscriptionsMeByIdFreezeErrors[keyof PostApiV1SubscriptionsMeByIdFreezeErrors];

export type PostApiV1SubscriptionsMeByIdFreezeResponses = {
    /**
     * OK
     */
    200: MySubscriptionDto;
};

export type PostApiV1SubscriptionsMeByIdFreezeResponse = PostApiV1SubscriptionsMeByIdFreezeResponses[keyof PostApiV1SubscriptionsMeByIdFreezeResponses];

export type PostApiV1SubscriptionsMeByIdRenewData = {
    body: RenewOwnSubscriptionBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/subscriptions/me/{id}/renew';
};

export type PostApiV1SubscriptionsMeByIdRenewErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SubscriptionsMeByIdRenewError = PostApiV1SubscriptionsMeByIdRenewErrors[keyof PostApiV1SubscriptionsMeByIdRenewErrors];

export type PostApiV1SubscriptionsMeByIdRenewResponses = {
    /**
     * Created
     */
    201: CreateSubscriptionChargeResponse;
};

export type PostApiV1SubscriptionsMeByIdRenewResponse = PostApiV1SubscriptionsMeByIdRenewResponses[keyof PostApiV1SubscriptionsMeByIdRenewResponses];

export type GetApiV1SubscriptionsMeByIdRenewalPlanData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        useBonuses?: boolean;
        bonusKopecks?: number;
    };
    url: '/api/v1/subscriptions/me/{id}/renewal-plan';
};

export type GetApiV1SubscriptionsMeByIdRenewalPlanErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SubscriptionsMeByIdRenewalPlanError = GetApiV1SubscriptionsMeByIdRenewalPlanErrors[keyof GetApiV1SubscriptionsMeByIdRenewalPlanErrors];

export type GetApiV1SubscriptionsMeByIdRenewalPlanResponses = {
    /**
     * OK
     */
    200: SubscriptionPurchasePlanDto;
};

export type GetApiV1SubscriptionsMeByIdRenewalPlanResponse = GetApiV1SubscriptionsMeByIdRenewalPlanResponses[keyof GetApiV1SubscriptionsMeByIdRenewalPlanResponses];

export type PostApiV1SubscriptionsMeByIdUnfreezeData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/subscriptions/me/{id}/unfreeze';
};

export type PostApiV1SubscriptionsMeByIdUnfreezeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SubscriptionsMeByIdUnfreezeError = PostApiV1SubscriptionsMeByIdUnfreezeErrors[keyof PostApiV1SubscriptionsMeByIdUnfreezeErrors];

export type PostApiV1SubscriptionsMeByIdUnfreezeResponses = {
    /**
     * OK
     */
    200: MySubscriptionDto;
};

export type PostApiV1SubscriptionsMeByIdUnfreezeResponse = PostApiV1SubscriptionsMeByIdUnfreezeResponses[keyof PostApiV1SubscriptionsMeByIdUnfreezeResponses];

export type PatchApiV1SubscriptionsByIdData = {
    body: SubscriptionPatchPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/subscriptions/{id}';
};

export type PatchApiV1SubscriptionsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1SubscriptionsByIdError = PatchApiV1SubscriptionsByIdErrors[keyof PatchApiV1SubscriptionsByIdErrors];

export type PatchApiV1SubscriptionsByIdResponses = {
    /**
     * OK
     */
    200: SubscriptionDto;
};

export type PatchApiV1SubscriptionsByIdResponse = PatchApiV1SubscriptionsByIdResponses[keyof PatchApiV1SubscriptionsByIdResponses];

export type GetApiV1SubscriptionsByIdHistoryData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        limit?: number;
    };
    url: '/api/v1/subscriptions/{id}/history';
};

export type GetApiV1SubscriptionsByIdHistoryErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1SubscriptionsByIdHistoryError = GetApiV1SubscriptionsByIdHistoryErrors[keyof GetApiV1SubscriptionsByIdHistoryErrors];

export type GetApiV1SubscriptionsByIdHistoryResponses = {
    /**
     * OK
     */
    200: SubscriptionHistoryResponse;
};

export type GetApiV1SubscriptionsByIdHistoryResponse = GetApiV1SubscriptionsByIdHistoryResponses[keyof GetApiV1SubscriptionsByIdHistoryResponses];

export type PostApiV1SubscriptionsByIdRedeemData = {
    body?: null | RedeemPayload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/subscriptions/{id}/redeem';
};

export type PostApiV1SubscriptionsByIdRedeemErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1SubscriptionsByIdRedeemError = PostApiV1SubscriptionsByIdRedeemErrors[keyof PostApiV1SubscriptionsByIdRedeemErrors];

export type PostApiV1SubscriptionsByIdRedeemResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1SubscriptionsByIdRedeemResponse = PostApiV1SubscriptionsByIdRedeemResponses[keyof PostApiV1SubscriptionsByIdRedeemResponses];

export type GetApiV1TournamentsData = {
    body?: never;
    path?: never;
    query?: {
        status?: TournamentStatus;
        sport?: string;
    };
    url: '/api/v1/tournaments';
};

export type GetApiV1TournamentsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TournamentsError = GetApiV1TournamentsErrors[keyof GetApiV1TournamentsErrors];

export type GetApiV1TournamentsResponses = {
    /**
     * OK
     */
    200: ListTournamentsResponse;
};

export type GetApiV1TournamentsResponse = GetApiV1TournamentsResponses[keyof GetApiV1TournamentsResponses];

export type PostApiV1TournamentsData = {
    body: CreateTournamentBody;
    path?: never;
    query?: never;
    url: '/api/v1/tournaments';
};

export type PostApiV1TournamentsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TournamentsError = PostApiV1TournamentsErrors[keyof PostApiV1TournamentsErrors];

export type PostApiV1TournamentsResponses = {
    /**
     * Created
     */
    201: CreateTournamentResponse;
};

export type PostApiV1TournamentsResponse = PostApiV1TournamentsResponses[keyof PostApiV1TournamentsResponses];

export type GetApiV1TournamentsClientsLookupData = {
    body?: never;
    path?: never;
    query?: {
        q?: string;
        limit?: number;
    };
    url: '/api/v1/tournaments/clients-lookup';
};

export type GetApiV1TournamentsClientsLookupErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TournamentsClientsLookupError = GetApiV1TournamentsClientsLookupErrors[keyof GetApiV1TournamentsClientsLookupErrors];

export type GetApiV1TournamentsClientsLookupResponses = {
    /**
     * OK
     */
    200: ClientsLookupResponse;
};

export type GetApiV1TournamentsClientsLookupResponse = GetApiV1TournamentsClientsLookupResponses[keyof GetApiV1TournamentsClientsLookupResponses];

export type GetApiV1TournamentsNormsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/tournaments/norms';
};

export type GetApiV1TournamentsNormsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TournamentsNormsError = GetApiV1TournamentsNormsErrors[keyof GetApiV1TournamentsNormsErrors];

export type GetApiV1TournamentsNormsResponses = {
    /**
     * OK
     */
    200: TournamentNormsResponse;
};

export type GetApiV1TournamentsNormsResponse = GetApiV1TournamentsNormsResponses[keyof GetApiV1TournamentsNormsResponses];

export type PutApiV1TournamentsNormsData = {
    body: PutTournamentNormsBody;
    path?: never;
    query?: never;
    url: '/api/v1/tournaments/norms';
};

export type PutApiV1TournamentsNormsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1TournamentsNormsError = PutApiV1TournamentsNormsErrors[keyof PutApiV1TournamentsNormsErrors];

export type PutApiV1TournamentsNormsResponses = {
    /**
     * OK
     */
    200: TournamentNormsResponse;
};

export type PutApiV1TournamentsNormsResponse = PutApiV1TournamentsNormsResponses[keyof PutApiV1TournamentsNormsResponses];

export type PostApiV1TournamentsPlanData = {
    body: PlanTournamentBody;
    path?: never;
    query?: never;
    url: '/api/v1/tournaments/plan';
};

export type PostApiV1TournamentsPlanErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TournamentsPlanError = PostApiV1TournamentsPlanErrors[keyof PostApiV1TournamentsPlanErrors];

export type PostApiV1TournamentsPlanResponses = {
    /**
     * OK
     */
    200: TournamentPlanDto;
};

export type PostApiV1TournamentsPlanResponse = PostApiV1TournamentsPlanResponses[keyof PostApiV1TournamentsPlanResponses];

export type GetApiV1TournamentsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}';
};

export type GetApiV1TournamentsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TournamentsByIdError = GetApiV1TournamentsByIdErrors[keyof GetApiV1TournamentsByIdErrors];

export type GetApiV1TournamentsByIdResponses = {
    /**
     * OK
     */
    200: TournamentDetailResponse;
};

export type GetApiV1TournamentsByIdResponse = GetApiV1TournamentsByIdResponses[keyof GetApiV1TournamentsByIdResponses];

export type PatchApiV1TournamentsByIdData = {
    body: UpdateTournamentBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}';
};

export type PatchApiV1TournamentsByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1TournamentsByIdError = PatchApiV1TournamentsByIdErrors[keyof PatchApiV1TournamentsByIdErrors];

export type PatchApiV1TournamentsByIdResponses = {
    /**
     * OK
     */
    200: UpdateTournamentResponse;
};

export type PatchApiV1TournamentsByIdResponse = PatchApiV1TournamentsByIdResponses[keyof PatchApiV1TournamentsByIdResponses];

export type PostApiV1TournamentsByIdBracketResetData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}/bracket/reset';
};

export type PostApiV1TournamentsByIdBracketResetErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TournamentsByIdBracketResetError = PostApiV1TournamentsByIdBracketResetErrors[keyof PostApiV1TournamentsByIdBracketResetErrors];

export type PostApiV1TournamentsByIdBracketResetResponses = {
    /**
     * OK
     */
    200: ResetBracketResponse;
};

export type PostApiV1TournamentsByIdBracketResetResponse = PostApiV1TournamentsByIdBracketResetResponses[keyof PostApiV1TournamentsByIdBracketResetResponses];

export type PostApiV1TournamentsByIdCancelData = {
    body?: null | CancelTournamentBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}/cancel';
};

export type PostApiV1TournamentsByIdCancelErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TournamentsByIdCancelError = PostApiV1TournamentsByIdCancelErrors[keyof PostApiV1TournamentsByIdCancelErrors];

export type PostApiV1TournamentsByIdCancelResponses = {
    /**
     * OK
     */
    200: CancelTournamentResponse;
};

export type PostApiV1TournamentsByIdCancelResponse = PostApiV1TournamentsByIdCancelResponses[keyof PostApiV1TournamentsByIdCancelResponses];

export type PostApiV1TournamentsByIdCloseRegistrationData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}/close-registration';
};

export type PostApiV1TournamentsByIdCloseRegistrationErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TournamentsByIdCloseRegistrationError = PostApiV1TournamentsByIdCloseRegistrationErrors[keyof PostApiV1TournamentsByIdCloseRegistrationErrors];

export type PostApiV1TournamentsByIdCloseRegistrationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1TournamentsByIdCloseRegistrationResponse = PostApiV1TournamentsByIdCloseRegistrationResponses[keyof PostApiV1TournamentsByIdCloseRegistrationResponses];

export type PutApiV1TournamentsByIdCoachData = {
    body: AssignTournamentCoachBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}/coach';
};

export type PutApiV1TournamentsByIdCoachErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1TournamentsByIdCoachError = PutApiV1TournamentsByIdCoachErrors[keyof PutApiV1TournamentsByIdCoachErrors];

export type PutApiV1TournamentsByIdCoachResponses = {
    /**
     * OK
     */
    200: TournamentCoachDto;
};

export type PutApiV1TournamentsByIdCoachResponse = PutApiV1TournamentsByIdCoachResponses[keyof PutApiV1TournamentsByIdCoachResponses];

export type PostApiV1TournamentsByIdFinishData = {
    body?: null | FinishTournamentBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}/finish';
};

export type PostApiV1TournamentsByIdFinishErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TournamentsByIdFinishError = PostApiV1TournamentsByIdFinishErrors[keyof PostApiV1TournamentsByIdFinishErrors];

export type PostApiV1TournamentsByIdFinishResponses = {
    /**
     * OK
     */
    200: FinishTournamentResponse;
};

export type PostApiV1TournamentsByIdFinishResponse = PostApiV1TournamentsByIdFinishResponses[keyof PostApiV1TournamentsByIdFinishResponses];

export type PostApiV1TournamentsByIdGenerateBracketData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}/generate-bracket';
};

export type PostApiV1TournamentsByIdGenerateBracketErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TournamentsByIdGenerateBracketError = PostApiV1TournamentsByIdGenerateBracketErrors[keyof PostApiV1TournamentsByIdGenerateBracketErrors];

export type PostApiV1TournamentsByIdGenerateBracketResponses = {
    /**
     * OK
     */
    200: GenerateBracketResponse;
};

export type PostApiV1TournamentsByIdGenerateBracketResponse = PostApiV1TournamentsByIdGenerateBracketResponses[keyof PostApiV1TournamentsByIdGenerateBracketResponses];

export type GetApiV1TournamentsByIdLeaderboardData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}/leaderboard';
};

export type GetApiV1TournamentsByIdLeaderboardErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TournamentsByIdLeaderboardError = GetApiV1TournamentsByIdLeaderboardErrors[keyof GetApiV1TournamentsByIdLeaderboardErrors];

export type GetApiV1TournamentsByIdLeaderboardResponses = {
    /**
     * OK
     */
    200: LeaderboardResponse;
};

export type GetApiV1TournamentsByIdLeaderboardResponse = GetApiV1TournamentsByIdLeaderboardResponses[keyof GetApiV1TournamentsByIdLeaderboardResponses];

export type PostApiV1TournamentsByIdMatchesByMatchIdResultData = {
    body: SubmitMatchScoreBody;
    path: {
        id: string;
        matchId: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}/matches/{matchId}/result';
};

export type PostApiV1TournamentsByIdMatchesByMatchIdResultErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TournamentsByIdMatchesByMatchIdResultError = PostApiV1TournamentsByIdMatchesByMatchIdResultErrors[keyof PostApiV1TournamentsByIdMatchesByMatchIdResultErrors];

export type PostApiV1TournamentsByIdMatchesByMatchIdResultResponses = {
    /**
     * OK
     */
    200: SubmitMatchScoreResponse;
};

export type PostApiV1TournamentsByIdMatchesByMatchIdResultResponse = PostApiV1TournamentsByIdMatchesByMatchIdResultResponses[keyof PostApiV1TournamentsByIdMatchesByMatchIdResultResponses];

export type GetApiV1TournamentsByIdPaymentPlanData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        useBonuses?: boolean;
        bonusKopecks?: number;
    };
    url: '/api/v1/tournaments/{id}/payment-plan';
};

export type GetApiV1TournamentsByIdPaymentPlanErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TournamentsByIdPaymentPlanError = GetApiV1TournamentsByIdPaymentPlanErrors[keyof GetApiV1TournamentsByIdPaymentPlanErrors];

export type GetApiV1TournamentsByIdPaymentPlanResponses = {
    /**
     * OK
     */
    200: EntryPaymentPlanDto;
};

export type GetApiV1TournamentsByIdPaymentPlanResponse = GetApiV1TournamentsByIdPaymentPlanResponses[keyof GetApiV1TournamentsByIdPaymentPlanResponses];

export type PostApiV1TournamentsByIdRegisterData = {
    body: RegisterForTournamentBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}/register';
};

export type PostApiV1TournamentsByIdRegisterErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TournamentsByIdRegisterError = PostApiV1TournamentsByIdRegisterErrors[keyof PostApiV1TournamentsByIdRegisterErrors];

export type PostApiV1TournamentsByIdRegisterResponses = {
    /**
     * OK
     */
    200: RegisterForTournamentResponse;
};

export type PostApiV1TournamentsByIdRegisterResponse = PostApiV1TournamentsByIdRegisterResponses[keyof PostApiV1TournamentsByIdRegisterResponses];

export type DeleteApiV1TournamentsByIdRegisterByRegistrationIdData = {
    body?: never;
    path: {
        id: string;
        registrationId: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}/register/{registrationId}';
};

export type DeleteApiV1TournamentsByIdRegisterByRegistrationIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1TournamentsByIdRegisterByRegistrationIdError = DeleteApiV1TournamentsByIdRegisterByRegistrationIdErrors[keyof DeleteApiV1TournamentsByIdRegisterByRegistrationIdErrors];

export type DeleteApiV1TournamentsByIdRegisterByRegistrationIdResponses = {
    /**
     * OK
     */
    200: UnregisterFromTournamentResponse;
};

export type DeleteApiV1TournamentsByIdRegisterByRegistrationIdResponse = DeleteApiV1TournamentsByIdRegisterByRegistrationIdResponses[keyof DeleteApiV1TournamentsByIdRegisterByRegistrationIdResponses];

export type PostApiV1TournamentsByIdRegistrationsByRegistrationIdAttendanceData = {
    body: MarkTournamentAttendanceBody;
    path: {
        id: string;
        registrationId: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}/registrations/{registrationId}/attendance';
};

export type PostApiV1TournamentsByIdRegistrationsByRegistrationIdAttendanceErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TournamentsByIdRegistrationsByRegistrationIdAttendanceError = PostApiV1TournamentsByIdRegistrationsByRegistrationIdAttendanceErrors[keyof PostApiV1TournamentsByIdRegistrationsByRegistrationIdAttendanceErrors];

export type PostApiV1TournamentsByIdRegistrationsByRegistrationIdAttendanceResponses = {
    /**
     * OK
     */
    200: MarkTournamentAttendanceResponse;
};

export type PostApiV1TournamentsByIdRegistrationsByRegistrationIdAttendanceResponse = PostApiV1TournamentsByIdRegistrationsByRegistrationIdAttendanceResponses[keyof PostApiV1TournamentsByIdRegistrationsByRegistrationIdAttendanceResponses];

export type PostApiV1TournamentsByIdReopenData = {
    body?: null | ReopenTournamentBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}/reopen';
};

export type PostApiV1TournamentsByIdReopenErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TournamentsByIdReopenError = PostApiV1TournamentsByIdReopenErrors[keyof PostApiV1TournamentsByIdReopenErrors];

export type PostApiV1TournamentsByIdReopenResponses = {
    /**
     * OK
     */
    200: ReopenTournamentResponse;
};

export type PostApiV1TournamentsByIdReopenResponse = PostApiV1TournamentsByIdReopenResponses[keyof PostApiV1TournamentsByIdReopenResponses];

export type GetApiV1TournamentsByIdReopenPreviewData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}/reopen/preview';
};

export type GetApiV1TournamentsByIdReopenPreviewErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TournamentsByIdReopenPreviewError = GetApiV1TournamentsByIdReopenPreviewErrors[keyof GetApiV1TournamentsByIdReopenPreviewErrors];

export type GetApiV1TournamentsByIdReopenPreviewResponses = {
    /**
     * OK
     */
    200: ReopenPreviewResponse;
};

export type GetApiV1TournamentsByIdReopenPreviewResponse = GetApiV1TournamentsByIdReopenPreviewResponses[keyof GetApiV1TournamentsByIdReopenPreviewResponses];

export type PatchApiV1TournamentsByIdRescheduleData = {
    body: RescheduleTournamentBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}/reschedule';
};

export type PatchApiV1TournamentsByIdRescheduleErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1TournamentsByIdRescheduleError = PatchApiV1TournamentsByIdRescheduleErrors[keyof PatchApiV1TournamentsByIdRescheduleErrors];

export type PatchApiV1TournamentsByIdRescheduleResponses = {
    /**
     * OK
     */
    200: RescheduleTournamentResponse;
};

export type PatchApiV1TournamentsByIdRescheduleResponse = PatchApiV1TournamentsByIdRescheduleResponses[keyof PatchApiV1TournamentsByIdRescheduleResponses];

export type PostApiV1TournamentsByIdRoundsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tournaments/{id}/rounds';
};

export type PostApiV1TournamentsByIdRoundsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TournamentsByIdRoundsError = PostApiV1TournamentsByIdRoundsErrors[keyof PostApiV1TournamentsByIdRoundsErrors];

export type PostApiV1TournamentsByIdRoundsResponses = {
    /**
     * OK
     */
    200: AddRoundResponse;
};

export type PostApiV1TournamentsByIdRoundsResponse = PostApiV1TournamentsByIdRoundsResponses[keyof PostApiV1TournamentsByIdRoundsResponses];

export type GetApiV1TrainerReviewsData = {
    body?: never;
    path?: never;
    query: {
        trainerId: string;
        limit?: number;
        cursor?: string;
    };
    url: '/api/v1/trainer-reviews';
};

export type GetApiV1TrainerReviewsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainerReviewsError = GetApiV1TrainerReviewsErrors[keyof GetApiV1TrainerReviewsErrors];

export type GetApiV1TrainerReviewsResponses = {
    /**
     * OK
     */
    200: StaffTrainerReviewsResponse;
};

export type GetApiV1TrainerReviewsResponse = GetApiV1TrainerReviewsResponses[keyof GetApiV1TrainerReviewsResponses];

export type PostApiV1TrainerReviewsByIdHideData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/trainer-reviews/{id}/hide';
};

export type PostApiV1TrainerReviewsByIdHideErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TrainerReviewsByIdHideError = PostApiV1TrainerReviewsByIdHideErrors[keyof PostApiV1TrainerReviewsByIdHideErrors];

export type PostApiV1TrainerReviewsByIdHideResponses = {
    /**
     * OK
     */
    200: StaffTrainerReviewDto;
};

export type PostApiV1TrainerReviewsByIdHideResponse = PostApiV1TrainerReviewsByIdHideResponses[keyof PostApiV1TrainerReviewsByIdHideResponses];

export type PostApiV1TrainerReviewsByIdUnhideData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/trainer-reviews/{id}/unhide';
};

export type PostApiV1TrainerReviewsByIdUnhideErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TrainerReviewsByIdUnhideError = PostApiV1TrainerReviewsByIdUnhideErrors[keyof PostApiV1TrainerReviewsByIdUnhideErrors];

export type PostApiV1TrainerReviewsByIdUnhideResponses = {
    /**
     * OK
     */
    200: StaffTrainerReviewDto;
};

export type PostApiV1TrainerReviewsByIdUnhideResponse = PostApiV1TrainerReviewsByIdUnhideResponses[keyof PostApiV1TrainerReviewsByIdUnhideResponses];

export type GetApiV1TrainersData = {
    body?: never;
    path?: never;
    query?: {
        Q?: string;
        Sport?: string;
        Direction?: string;
        ClassId?: string;
        MinRating?: number;
        Sort?: string;
        Order?: string;
    };
    url: '/api/v1/trainers';
};

export type GetApiV1TrainersErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersError = GetApiV1TrainersErrors[keyof GetApiV1TrainersErrors];

export type GetApiV1TrainersResponses = {
    /**
     * OK
     */
    200: ListTrainersResponse;
};

export type GetApiV1TrainersResponse = GetApiV1TrainersResponses[keyof GetApiV1TrainersResponses];

export type PostApiV1TrainersData = {
    body: CreateTrainerCommand;
    path?: never;
    query?: never;
    url: '/api/v1/trainers';
};

export type PostApiV1TrainersErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TrainersError = PostApiV1TrainersErrors[keyof PostApiV1TrainersErrors];

export type PostApiV1TrainersResponses = {
    /**
     * Created
     */
    201: EntityIdResponse;
};

export type PostApiV1TrainersResponse = PostApiV1TrainersResponses[keyof PostApiV1TrainersResponses];

export type GetApiV1TrainersAvailableData = {
    body?: never;
    path?: never;
    query: {
        CourtId: string;
        StartAt: string;
        EndAt: string;
        ExcludeBookingId?: string;
        IncludeOffSchedule?: boolean;
    };
    url: '/api/v1/trainers/available';
};

export type GetApiV1TrainersAvailableErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersAvailableError = GetApiV1TrainersAvailableErrors[keyof GetApiV1TrainersAvailableErrors];

export type GetApiV1TrainersAvailableResponses = {
    /**
     * OK
     */
    200: AvailableTrainersResponse;
};

export type GetApiV1TrainersAvailableResponse = GetApiV1TrainersAvailableResponses[keyof GetApiV1TrainersAvailableResponses];

export type GetApiV1TrainersBookableData = {
    body?: never;
    path?: never;
    query?: {
        sport?: string;
        date?: string;
        startTime?: string;
        endTime?: string;
    };
    url: '/api/v1/trainers/bookable';
};

export type GetApiV1TrainersBookableErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersBookableError = GetApiV1TrainersBookableErrors[keyof GetApiV1TrainersBookableErrors];

export type GetApiV1TrainersBookableResponses = {
    /**
     * OK
     */
    200: BookableTrainersResponse;
};

export type GetApiV1TrainersBookableResponse = GetApiV1TrainersBookableResponses[keyof GetApiV1TrainersBookableResponses];

export type GetApiV1TrainersBookingsByIdClientBriefsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/trainers/bookings/{id}/client-briefs';
};

export type GetApiV1TrainersBookingsByIdClientBriefsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersBookingsByIdClientBriefsError = GetApiV1TrainersBookingsByIdClientBriefsErrors[keyof GetApiV1TrainersBookingsByIdClientBriefsErrors];

export type GetApiV1TrainersBookingsByIdClientBriefsResponses = {
    /**
     * OK
     */
    200: ClientBriefsResponse;
};

export type GetApiV1TrainersBookingsByIdClientBriefsResponse = GetApiV1TrainersBookingsByIdClientBriefsResponses[keyof GetApiV1TrainersBookingsByIdClientBriefsResponses];

export type GetApiV1TrainersFloorData = {
    body?: never;
    path?: never;
    query: {
        date: string;
    };
    url: '/api/v1/trainers/floor';
};

export type GetApiV1TrainersFloorErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersFloorError = GetApiV1TrainersFloorErrors[keyof GetApiV1TrainersFloorErrors];

export type GetApiV1TrainersFloorResponses = {
    /**
     * OK
     */
    200: TrainerFloorResponse;
};

export type GetApiV1TrainersFloorResponse = GetApiV1TrainersFloorResponses[keyof GetApiV1TrainersFloorResponses];

export type GetApiV1TrainersMeData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/trainers/me';
};

export type GetApiV1TrainersMeErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersMeError = GetApiV1TrainersMeErrors[keyof GetApiV1TrainersMeErrors];

export type GetApiV1TrainersMeResponses = {
    /**
     * OK
     */
    200: MyTrainerDto;
};

export type GetApiV1TrainersMeResponse = GetApiV1TrainersMeResponses[keyof GetApiV1TrainersMeResponses];

export type GetApiV1TrainersMeAnalyticsData = {
    body?: never;
    path?: never;
    query: {
        from: string;
        to: string;
    };
    url: '/api/v1/trainers/me/analytics';
};

export type GetApiV1TrainersMeAnalyticsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersMeAnalyticsError = GetApiV1TrainersMeAnalyticsErrors[keyof GetApiV1TrainersMeAnalyticsErrors];

export type GetApiV1TrainersMeAnalyticsResponses = {
    /**
     * OK
     */
    200: TrainerAnalyticsResponse;
};

export type GetApiV1TrainersMeAnalyticsResponse = GetApiV1TrainersMeAnalyticsResponses[keyof GetApiV1TrainersMeAnalyticsResponses];

export type DeleteApiV1TrainersMeAvatarData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/trainers/me/avatar';
};

export type DeleteApiV1TrainersMeAvatarErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1TrainersMeAvatarError = DeleteApiV1TrainersMeAvatarErrors[keyof DeleteApiV1TrainersMeAvatarErrors];

export type DeleteApiV1TrainersMeAvatarResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1TrainersMeAvatarResponse = DeleteApiV1TrainersMeAvatarResponses[keyof DeleteApiV1TrainersMeAvatarResponses];

export type PutApiV1TrainersMeAvatarData = {
    body: {
        file?: IFormFile;
    };
    path?: never;
    query?: never;
    url: '/api/v1/trainers/me/avatar';
};

export type PutApiV1TrainersMeAvatarErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1TrainersMeAvatarError = PutApiV1TrainersMeAvatarErrors[keyof PutApiV1TrainersMeAvatarErrors];

export type PutApiV1TrainersMeAvatarResponses = {
    /**
     * OK
     */
    200: TrainerProfilePhotoResponse;
};

export type PutApiV1TrainersMeAvatarResponse = PutApiV1TrainersMeAvatarResponses[keyof PutApiV1TrainersMeAvatarResponses];

export type GetApiV1TrainersMeBusyData = {
    body?: never;
    path?: never;
    query: {
        from: string;
        to: string;
    };
    url: '/api/v1/trainers/me/busy';
};

export type GetApiV1TrainersMeBusyErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersMeBusyError = GetApiV1TrainersMeBusyErrors[keyof GetApiV1TrainersMeBusyErrors];

export type GetApiV1TrainersMeBusyResponses = {
    /**
     * OK
     */
    200: Array<TrainerBusyIntervalDto>;
};

export type GetApiV1TrainersMeBusyResponse = GetApiV1TrainersMeBusyResponses[keyof GetApiV1TrainersMeBusyResponses];

export type PostApiV1TrainersMeBusyData = {
    body: MarkMyBusyTimeBody;
    path?: never;
    query?: never;
    url: '/api/v1/trainers/me/busy';
};

export type PostApiV1TrainersMeBusyErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TrainersMeBusyError = PostApiV1TrainersMeBusyErrors[keyof PostApiV1TrainersMeBusyErrors];

export type PostApiV1TrainersMeBusyResponses = {
    /**
     * OK
     */
    200: MyBusyTimeMarkedDto;
};

export type PostApiV1TrainersMeBusyResponse = PostApiV1TrainersMeBusyResponses[keyof PostApiV1TrainersMeBusyResponses];

export type DeleteApiV1TrainersMeBusyByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/trainers/me/busy/{id}';
};

export type DeleteApiV1TrainersMeBusyByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1TrainersMeBusyByIdError = DeleteApiV1TrainersMeBusyByIdErrors[keyof DeleteApiV1TrainersMeBusyByIdErrors];

export type DeleteApiV1TrainersMeBusyByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1TrainersMeBusyByIdResponse = DeleteApiV1TrainersMeBusyByIdResponses[keyof DeleteApiV1TrainersMeBusyByIdResponses];

export type GetApiV1TrainersMeClientLookupData = {
    body?: never;
    path?: never;
    query?: {
        q?: string;
        limit?: number;
    };
    url: '/api/v1/trainers/me/client-lookup';
};

export type GetApiV1TrainersMeClientLookupErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersMeClientLookupError = GetApiV1TrainersMeClientLookupErrors[keyof GetApiV1TrainersMeClientLookupErrors];

export type GetApiV1TrainersMeClientLookupResponses = {
    /**
     * OK
     */
    200: TrainerClientLookupResponse;
};

export type GetApiV1TrainersMeClientLookupResponse = GetApiV1TrainersMeClientLookupResponses[keyof GetApiV1TrainersMeClientLookupResponses];

export type GetApiV1TrainersMeClientsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/trainers/me/clients';
};

export type GetApiV1TrainersMeClientsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersMeClientsError = GetApiV1TrainersMeClientsErrors[keyof GetApiV1TrainersMeClientsErrors];

export type GetApiV1TrainersMeClientsResponses = {
    /**
     * OK
     */
    200: Array<TrainerClientSummaryDto>;
};

export type GetApiV1TrainersMeClientsResponse = GetApiV1TrainersMeClientsResponses[keyof GetApiV1TrainersMeClientsResponses];

export type GetApiV1TrainersMeClientsByClientIdData = {
    body?: never;
    path: {
        clientId: string;
    };
    query?: never;
    url: '/api/v1/trainers/me/clients/{clientId}';
};

export type GetApiV1TrainersMeClientsByClientIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersMeClientsByClientIdError = GetApiV1TrainersMeClientsByClientIdErrors[keyof GetApiV1TrainersMeClientsByClientIdErrors];

export type GetApiV1TrainersMeClientsByClientIdResponses = {
    /**
     * OK
     */
    200: TrainerClientDetailDto;
};

export type GetApiV1TrainersMeClientsByClientIdResponse = GetApiV1TrainersMeClientsByClientIdResponses[keyof GetApiV1TrainersMeClientsByClientIdResponses];

export type GetApiV1TrainersMeReviewsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
        cursor?: string;
    };
    url: '/api/v1/trainers/me/reviews';
};

export type GetApiV1TrainersMeReviewsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersMeReviewsError = GetApiV1TrainersMeReviewsErrors[keyof GetApiV1TrainersMeReviewsErrors];

export type GetApiV1TrainersMeReviewsResponses = {
    /**
     * OK
     */
    200: TrainerReviewsResponse;
};

export type GetApiV1TrainersMeReviewsResponse = GetApiV1TrainersMeReviewsResponses[keyof GetApiV1TrainersMeReviewsResponses];

export type GetApiV1TrainersMeSalaryPeriodsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
    };
    url: '/api/v1/trainers/me/salary/periods';
};

export type GetApiV1TrainersMeSalaryPeriodsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersMeSalaryPeriodsError = GetApiV1TrainersMeSalaryPeriodsErrors[keyof GetApiV1TrainersMeSalaryPeriodsErrors];

export type GetApiV1TrainersMeSalaryPeriodsResponses = {
    /**
     * OK
     */
    200: Array<MySalaryPeriodDto>;
};

export type GetApiV1TrainersMeSalaryPeriodsResponse = GetApiV1TrainersMeSalaryPeriodsResponses[keyof GetApiV1TrainersMeSalaryPeriodsResponses];

export type GetApiV1TrainersMeSalaryPeriodsByIdItemsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/trainers/me/salary/periods/{id}/items';
};

export type GetApiV1TrainersMeSalaryPeriodsByIdItemsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersMeSalaryPeriodsByIdItemsError = GetApiV1TrainersMeSalaryPeriodsByIdItemsErrors[keyof GetApiV1TrainersMeSalaryPeriodsByIdItemsErrors];

export type GetApiV1TrainersMeSalaryPeriodsByIdItemsResponses = {
    /**
     * OK
     */
    200: SalaryBreakdownResponse;
};

export type GetApiV1TrainersMeSalaryPeriodsByIdItemsResponse = GetApiV1TrainersMeSalaryPeriodsByIdItemsResponses[keyof GetApiV1TrainersMeSalaryPeriodsByIdItemsResponses];

export type PostApiV1TrainersMeSalaryPreviewData = {
    body: PreviewTrainerSalaryRequest;
    path?: never;
    query?: never;
    url: '/api/v1/trainers/me/salary/preview';
};

export type PostApiV1TrainersMeSalaryPreviewErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TrainersMeSalaryPreviewError = PostApiV1TrainersMeSalaryPreviewErrors[keyof PostApiV1TrainersMeSalaryPreviewErrors];

export type PostApiV1TrainersMeSalaryPreviewResponses = {
    /**
     * OK
     */
    200: TrainerSalaryPreviewDto;
};

export type PostApiV1TrainersMeSalaryPreviewResponse = PostApiV1TrainersMeSalaryPreviewResponses[keyof PostApiV1TrainersMeSalaryPreviewResponses];

export type GetApiV1TrainersMeScheduleData = {
    body?: never;
    path?: never;
    query: {
        from: string;
        to: string;
    };
    url: '/api/v1/trainers/me/schedule';
};

export type GetApiV1TrainersMeScheduleErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersMeScheduleError = GetApiV1TrainersMeScheduleErrors[keyof GetApiV1TrainersMeScheduleErrors];

export type GetApiV1TrainersMeScheduleResponses = {
    /**
     * OK
     */
    200: TrainerScheduleResponse;
};

export type GetApiV1TrainersMeScheduleResponse = GetApiV1TrainersMeScheduleResponses[keyof GetApiV1TrainersMeScheduleResponses];

export type PostApiV1TrainersMeScheduleChangesData = {
    body: TrainerScheduleChangeBody;
    path?: never;
    query?: never;
    url: '/api/v1/trainers/me/schedule/changes';
};

export type PostApiV1TrainersMeScheduleChangesErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TrainersMeScheduleChangesError = PostApiV1TrainersMeScheduleChangesErrors[keyof PostApiV1TrainersMeScheduleChangesErrors];

export type PostApiV1TrainersMeScheduleChangesResponses = {
    /**
     * OK
     */
    200: TrainerScheduleChangeResult;
};

export type PostApiV1TrainersMeScheduleChangesResponse = PostApiV1TrainersMeScheduleChangesResponses[keyof PostApiV1TrainersMeScheduleChangesResponses];

export type GetApiV1TrainersMeScheduleTemplateData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/trainers/me/schedule/template';
};

export type GetApiV1TrainersMeScheduleTemplateErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersMeScheduleTemplateError = GetApiV1TrainersMeScheduleTemplateErrors[keyof GetApiV1TrainersMeScheduleTemplateErrors];

export type GetApiV1TrainersMeScheduleTemplateResponses = {
    /**
     * OK
     */
    200: MyScheduleTemplateDto;
};

export type GetApiV1TrainersMeScheduleTemplateResponse = GetApiV1TrainersMeScheduleTemplateResponses[keyof GetApiV1TrainersMeScheduleTemplateResponses];

export type PostApiV1TrainersMeSubstitutionsData = {
    body: RequestSubstitutionBody;
    path?: never;
    query?: never;
    url: '/api/v1/trainers/me/substitutions';
};

export type PostApiV1TrainersMeSubstitutionsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TrainersMeSubstitutionsError = PostApiV1TrainersMeSubstitutionsErrors[keyof PostApiV1TrainersMeSubstitutionsErrors];

export type PostApiV1TrainersMeSubstitutionsResponses = {
    /**
     * Created
     */
    201: EntityIdResponse;
};

export type PostApiV1TrainersMeSubstitutionsResponse = PostApiV1TrainersMeSubstitutionsResponses[keyof PostApiV1TrainersMeSubstitutionsResponses];

export type GetApiV1TrainersMeSubstitutionsInboxData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/trainers/me/substitutions/inbox';
};

export type GetApiV1TrainersMeSubstitutionsInboxErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersMeSubstitutionsInboxError = GetApiV1TrainersMeSubstitutionsInboxErrors[keyof GetApiV1TrainersMeSubstitutionsInboxErrors];

export type GetApiV1TrainersMeSubstitutionsInboxResponses = {
    /**
     * OK
     */
    200: Array<SubstitutionInboxItemDto>;
};

export type GetApiV1TrainersMeSubstitutionsInboxResponse = GetApiV1TrainersMeSubstitutionsInboxResponses[keyof GetApiV1TrainersMeSubstitutionsInboxResponses];

export type PostApiV1TrainersMeSubstitutionsByIdAcceptData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/trainers/me/substitutions/{id}/accept';
};

export type PostApiV1TrainersMeSubstitutionsByIdAcceptErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TrainersMeSubstitutionsByIdAcceptError = PostApiV1TrainersMeSubstitutionsByIdAcceptErrors[keyof PostApiV1TrainersMeSubstitutionsByIdAcceptErrors];

export type PostApiV1TrainersMeSubstitutionsByIdAcceptResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1TrainersMeSubstitutionsByIdAcceptResponse = PostApiV1TrainersMeSubstitutionsByIdAcceptResponses[keyof PostApiV1TrainersMeSubstitutionsByIdAcceptResponses];

export type PostApiV1TrainersMeSubstitutionsByIdDeclineData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/trainers/me/substitutions/{id}/decline';
};

export type PostApiV1TrainersMeSubstitutionsByIdDeclineErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TrainersMeSubstitutionsByIdDeclineError = PostApiV1TrainersMeSubstitutionsByIdDeclineErrors[keyof PostApiV1TrainersMeSubstitutionsByIdDeclineErrors];

export type PostApiV1TrainersMeSubstitutionsByIdDeclineResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1TrainersMeSubstitutionsByIdDeclineResponse = PostApiV1TrainersMeSubstitutionsByIdDeclineResponses[keyof PostApiV1TrainersMeSubstitutionsByIdDeclineResponses];

export type GetApiV1TrainersByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/trainers/{id}';
};

export type GetApiV1TrainersByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersByIdError = GetApiV1TrainersByIdErrors[keyof GetApiV1TrainersByIdErrors];

export type GetApiV1TrainersByIdResponses = {
    /**
     * OK
     */
    200: TrainerDetailDto;
};

export type GetApiV1TrainersByIdResponse = GetApiV1TrainersByIdResponses[keyof GetApiV1TrainersByIdResponses];

export type PatchApiV1TrainersByIdData = {
    body: UpdateTrainerBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/trainers/{id}';
};

export type PatchApiV1TrainersByIdErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PatchApiV1TrainersByIdError = PatchApiV1TrainersByIdErrors[keyof PatchApiV1TrainersByIdErrors];

export type PatchApiV1TrainersByIdResponses = {
    /**
     * OK
     */
    200: EntityIdResponse;
};

export type PatchApiV1TrainersByIdResponse = PatchApiV1TrainersByIdResponses[keyof PatchApiV1TrainersByIdResponses];

export type GetApiV1TrainersByIdAnalyticsData = {
    body?: never;
    path: {
        id: string;
    };
    query: {
        from: string;
        to: string;
    };
    url: '/api/v1/trainers/{id}/analytics';
};

export type GetApiV1TrainersByIdAnalyticsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersByIdAnalyticsError = GetApiV1TrainersByIdAnalyticsErrors[keyof GetApiV1TrainersByIdAnalyticsErrors];

export type GetApiV1TrainersByIdAnalyticsResponses = {
    /**
     * OK
     */
    200: TrainerAnalyticsResponse;
};

export type GetApiV1TrainersByIdAnalyticsResponse = GetApiV1TrainersByIdAnalyticsResponses[keyof GetApiV1TrainersByIdAnalyticsResponses];

export type GetApiV1TrainersByIdAvailabilityData = {
    body?: never;
    path: {
        id: string;
    };
    query: {
        date: string;
    };
    url: '/api/v1/trainers/{id}/availability';
};

export type GetApiV1TrainersByIdAvailabilityErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersByIdAvailabilityError = GetApiV1TrainersByIdAvailabilityErrors[keyof GetApiV1TrainersByIdAvailabilityErrors];

export type GetApiV1TrainersByIdAvailabilityResponses = {
    /**
     * OK
     */
    200: TrainerAvailabilityResponse;
};

export type GetApiV1TrainersByIdAvailabilityResponse = GetApiV1TrainersByIdAvailabilityResponses[keyof GetApiV1TrainersByIdAvailabilityResponses];

export type DeleteApiV1TrainersByIdAvatarData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/trainers/{id}/avatar';
};

export type DeleteApiV1TrainersByIdAvatarErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1TrainersByIdAvatarError = DeleteApiV1TrainersByIdAvatarErrors[keyof DeleteApiV1TrainersByIdAvatarErrors];

export type DeleteApiV1TrainersByIdAvatarResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1TrainersByIdAvatarResponse = DeleteApiV1TrainersByIdAvatarResponses[keyof DeleteApiV1TrainersByIdAvatarResponses];

export type GetApiV1TrainersByIdCalendarData = {
    body?: never;
    path: {
        id: string;
    };
    query: {
        from: string;
        to: string;
    };
    url: '/api/v1/trainers/{id}/calendar';
};

export type GetApiV1TrainersByIdCalendarErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersByIdCalendarError = GetApiV1TrainersByIdCalendarErrors[keyof GetApiV1TrainersByIdCalendarErrors];

export type GetApiV1TrainersByIdCalendarResponses = {
    /**
     * OK
     */
    200: TrainerCalendarDto;
};

export type GetApiV1TrainersByIdCalendarResponse = GetApiV1TrainersByIdCalendarResponses[keyof GetApiV1TrainersByIdCalendarResponses];

export type GetApiV1TrainersByIdCardData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/trainers/{id}/card';
};

export type GetApiV1TrainersByIdCardErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersByIdCardError = GetApiV1TrainersByIdCardErrors[keyof GetApiV1TrainersByIdCardErrors];

export type GetApiV1TrainersByIdCardResponses = {
    /**
     * OK
     */
    200: TrainerCardDto;
};

export type GetApiV1TrainersByIdCardResponse = GetApiV1TrainersByIdCardResponses[keyof GetApiV1TrainersByIdCardResponses];

export type GetApiV1TrainersByIdReviewsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        limit?: number;
        cursor?: string;
    };
    url: '/api/v1/trainers/{id}/reviews';
};

export type GetApiV1TrainersByIdReviewsErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersByIdReviewsError = GetApiV1TrainersByIdReviewsErrors[keyof GetApiV1TrainersByIdReviewsErrors];

export type GetApiV1TrainersByIdReviewsResponses = {
    /**
     * OK
     */
    200: TrainerReviewsResponse;
};

export type GetApiV1TrainersByIdReviewsResponse = GetApiV1TrainersByIdReviewsResponses[keyof GetApiV1TrainersByIdReviewsResponses];

export type PostApiV1TrainersByIdSalaryCalculateData = {
    body: PreviewTrainerSalaryRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/trainers/{id}/salary/calculate';
};

export type PostApiV1TrainersByIdSalaryCalculateErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1TrainersByIdSalaryCalculateError = PostApiV1TrainersByIdSalaryCalculateErrors[keyof PostApiV1TrainersByIdSalaryCalculateErrors];

export type PostApiV1TrainersByIdSalaryCalculateResponses = {
    /**
     * OK
     */
    200: TrainerSalaryPreviewDto;
};

export type PostApiV1TrainersByIdSalaryCalculateResponse = PostApiV1TrainersByIdSalaryCalculateResponses[keyof PostApiV1TrainersByIdSalaryCalculateResponses];

export type GetApiV1TrainersByIdScheduleData = {
    body?: never;
    path: {
        id: string;
    };
    query: {
        from: string;
        to: string;
    };
    url: '/api/v1/trainers/{id}/schedule';
};

export type GetApiV1TrainersByIdScheduleErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1TrainersByIdScheduleError = GetApiV1TrainersByIdScheduleErrors[keyof GetApiV1TrainersByIdScheduleErrors];

export type GetApiV1TrainersByIdScheduleResponses = {
    /**
     * OK
     */
    200: TrainerScheduleResponse;
};

export type GetApiV1TrainersByIdScheduleResponse = GetApiV1TrainersByIdScheduleResponses[keyof GetApiV1TrainersByIdScheduleResponses];

export type GetApiV1WalletMeSpendingData = {
    body?: never;
    path?: never;
    query?: {
        month?: string;
    };
    url: '/api/v1/wallet/me/spending';
};

export type GetApiV1WalletMeSpendingErrors = {
    /**
     * Bad Request
     */
    400: HttpValidationProblemDetails;
    /**
     * Unauthorized
     */
    401: ProblemDetails;
    /**
     * Forbidden
     */
    403: ProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Conflict
     */
    409: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1WalletMeSpendingError = GetApiV1WalletMeSpendingErrors[keyof GetApiV1WalletMeSpendingErrors];

export type GetApiV1WalletMeSpendingResponses = {
    /**
     * OK
     */
    200: WalletSpendingDto;
};

export type GetApiV1WalletMeSpendingResponse = GetApiV1WalletMeSpendingResponses[keyof GetApiV1WalletMeSpendingResponses];
